import { useQuery, UseQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch("https://cg.optimizely.com/content/v2", {
    method: "POST",
    ...({"headers":{"Authorization":"Basic Y2U1ajJVUUxYemxTUXBPNGJ5WE5lWXNieERJMHhpM0RhTm9USGZVYktKcGdMc1N4OnQzMWxMNGNwTUZrYmNjV1g0UC9kL3R3Mkc1b1ZQUmZHRjYxZmZnN2xOOUxlYkdJb2xCSWhOQk1oSWVVeWVGVkU="}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Bool: { input: any; output: any; }
  Date: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/publications-and-standards/standards/ecma-404/). */
  JSON: { input: any; output: any; }
};

export type ActivationPageModel = IContent & IData & {
  __typename?: 'ActivationPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ActivationPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ActivationPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ActivationPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ActivationPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ActivationPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ActivationPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ActivationPageModelAutocomplete = {
  __typename?: 'ActivationPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ActivationPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ActivationPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ActivationPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ActivationPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ActivationPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ActivationPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ActivationPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ActivationPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ActivationPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ActivationPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ActivationPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ActivationPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ActivationPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ActivationPageModelFacet = {
  __typename?: 'ActivationPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ActivationPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivationPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivationPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivationPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivationPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ActivationPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ActivationPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ActivationPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ActivationPageModelOutput = {
  __typename?: 'ActivationPageModelOutput';
  autocomplete?: Maybe<ActivationPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ActivationPageModelFacet>;
  item?: Maybe<ActivationPageModel>;
  items?: Maybe<Array<Maybe<ActivationPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ActivationPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivationPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ActivationPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ActivationPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ActivationPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type AgreementPageModel = IContent & IData & {
  __typename?: 'AgreementPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainBody?: Maybe<MixedHtmlModelSearch>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  ReadonlyPropertyUrlParameters?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type AgreementPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AgreementPageModelMainBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AgreementPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AgreementPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AgreementPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AgreementPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AgreementPageModelReadonlyPropertyUrlParametersArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AgreementPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AgreementPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AgreementPageModelAutocomplete = {
  __typename?: 'AgreementPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AgreementPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AgreementPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AgreementPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AgreementPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AgreementPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AgreementPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AgreementPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AgreementPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AgreementPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AgreementPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AgreementPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AgreementPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AgreementPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AgreementPageModelFacet = {
  __typename?: 'AgreementPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainBody?: Maybe<MixedHtmlModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  ReadonlyPropertyUrlParameters?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AgreementPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AgreementPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AgreementPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetReadonlyPropertyUrlParametersArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AgreementPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AgreementPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AgreementPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AgreementPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AgreementPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ReadonlyPropertyUrlParameters?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type AgreementPageModelOutput = {
  __typename?: 'AgreementPageModelOutput';
  autocomplete?: Maybe<AgreementPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AgreementPageModelFacet>;
  item?: Maybe<AgreementPageModel>;
  items?: Maybe<Array<Maybe<AgreementPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type AgreementPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgreementPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ReadonlyPropertyUrlParameters?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AgreementPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AgreementPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AgreementPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type AssociationBattleBlockModel = IContent & IData & {
  __typename?: 'AssociationBattleBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WideLayout?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type AssociationBattleBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssociationBattleBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssociationBattleBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AssociationBattleBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AssociationBattleBlockModelAutocomplete = {
  __typename?: 'AssociationBattleBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AssociationBattleBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AssociationBattleBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AssociationBattleBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AssociationBattleBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AssociationBattleBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AssociationBattleBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AssociationBattleBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AssociationBattleBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AssociationBattleBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AssociationBattleBlockModelFacet = {
  __typename?: 'AssociationBattleBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WideLayout?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AssociationBattleBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssociationBattleBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AssociationBattleBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssociationBattleBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AssociationBattleBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssociationBattleBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssociationBattleBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssociationBattleBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssociationBattleBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssociationBattleBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AssociationBattleBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssociationBattleBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssociationBattleBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AssociationBattleBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssociationBattleBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AssociationBattleBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssociationBattleBlockModelFacetWideLayoutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AssociationBattleBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AssociationBattleBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WideLayout?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type AssociationBattleBlockModelOutput = {
  __typename?: 'AssociationBattleBlockModelOutput';
  autocomplete?: Maybe<AssociationBattleBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AssociationBattleBlockModelFacet>;
  item?: Maybe<AssociationBattleBlockModel>;
  items?: Maybe<Array<Maybe<AssociationBattleBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type AssociationBattleBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssociationBattleBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WideLayout?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AssociationBattleBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AssociationBattleBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AssociationBattleBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type AtoZPageModel = IContent & IData & {
  __typename?: 'AtoZPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainBody?: Maybe<MixedHtmlModelSearch>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type AtoZPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AtoZPageModelMainBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AtoZPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AtoZPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AtoZPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AtoZPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AtoZPageModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AtoZPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type AtoZPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type AtoZPageModelAutocomplete = {
  __typename?: 'AtoZPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AtoZPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AtoZPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AtoZPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AtoZPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AtoZPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AtoZPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AtoZPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AtoZPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AtoZPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AtoZPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AtoZPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AtoZPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type AtoZPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type AtoZPageModelFacet = {
  __typename?: 'AtoZPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainBody?: Maybe<MixedHtmlModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type AtoZPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AtoZPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AtoZPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AtoZPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AtoZPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type AtoZPageModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type AtoZPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type AtoZPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type AtoZPageModelOutput = {
  __typename?: 'AtoZPageModelOutput';
  autocomplete?: Maybe<AtoZPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<AtoZPageModelFacet>;
  item?: Maybe<AtoZPageModel>;
  items?: Maybe<Array<Maybe<AtoZPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type AtoZPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AtoZPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<AtoZPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<AtoZPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<AtoZPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type BlobModel = {
  __typename?: 'BlobModel';
  Id?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
};

export type BlobModelAutocomplete = {
  __typename?: 'BlobModelAutocomplete';
  Id?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type BlobModelAutocompleteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type BlobModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type BlobModelFacet = {
  __typename?: 'BlobModelFacet';
  Id?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
};


export type BlobModelFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type BlobModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type BlobModelOrderByInput = {
  Id?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
};

export type BlobModelWhereInput = {
  Id?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
};

export type BoolFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonLinkBlockModel = IContent & IData & {
  __typename?: 'ButtonLinkBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ButtonClass?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DocumentLink?: Maybe<ContentModelReference>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalLink?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  Link?: Maybe<ContentModelReference>;
  LinkText?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PopupContent?: Maybe<MixedHtmlModelSearch>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VideoUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ButtonLinkBlockModelExternalLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ButtonLinkBlockModelLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ButtonLinkBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ButtonLinkBlockModelPopupContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ButtonLinkBlockModelTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ButtonLinkBlockModelVideoUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ButtonLinkBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ButtonLinkBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ButtonLinkBlockModelAutocomplete = {
  __typename?: 'ButtonLinkBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DocumentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Link?: Maybe<ContentModelReferenceAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ButtonLinkBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLinkBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLinkBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLinkBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLinkBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLinkBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLinkBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLinkBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ButtonLinkBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ButtonLinkBlockModelFacet = {
  __typename?: 'ButtonLinkBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ButtonClass?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DocumentLink?: Maybe<ContentModelReferenceFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalLink?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Link?: Maybe<ContentModelReferenceFacet>;
  LinkText?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PopupContent?: Maybe<MixedHtmlModelSearchFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VideoUrl?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ButtonLinkBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacetButtonClassArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ButtonLinkBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkBlockModelFacetExternalLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacetLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ButtonLinkBlockModelFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacetVideoUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ButtonLinkBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ButtonLinkBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  ButtonClass?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DocumentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalLink?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Link?: InputMaybe<ContentModelReferenceOrderByInput>;
  LinkText?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PopupContent?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VideoUrl?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ButtonLinkBlockModelOutput = {
  __typename?: 'ButtonLinkBlockModelOutput';
  autocomplete?: Maybe<ButtonLinkBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ButtonLinkBlockModelFacet>;
  item?: Maybe<ButtonLinkBlockModel>;
  items?: Maybe<Array<Maybe<ButtonLinkBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ButtonLinkBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonLinkBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  ButtonClass?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DocumentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalLink?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Link?: InputMaybe<ContentModelReferenceWhereInput>;
  LinkText?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PopupContent?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VideoUrl?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ButtonLinkBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ButtonLinkBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ButtonLinkBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type CampaignBlock = IContent & IData & {
  __typename?: 'CampaignBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Campaign?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image1?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WideLayout?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type CampaignBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CampaignBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CampaignBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CampaignBlockAutocomplete = {
  __typename?: 'CampaignBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Campaign?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Heading?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Image1?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CampaignBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignBlockAutocompleteCampaignArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignBlockAutocompleteHeadingArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CampaignBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CampaignBlockFacet = {
  __typename?: 'CampaignBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Campaign?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image1?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WideLayout?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CampaignBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignBlockFacetCampaignArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignBlockFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignBlockFacetWideLayoutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CampaignBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CampaignBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Campaign?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image1?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WideLayout?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type CampaignBlockOutput = {
  __typename?: 'CampaignBlockOutput';
  autocomplete?: Maybe<CampaignBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CampaignBlockFacet>;
  item?: Maybe<CampaignBlock>;
  items?: Maybe<Array<Maybe<CampaignBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CampaignBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Campaign?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<StringFilterInput>;
  Image1?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WideLayout?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CampaignBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CampaignBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CampaignBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type CaptchaElementBlock = IContent & IData & {
  __typename?: 'CaptchaElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ImageHeight?: Maybe<Scalars['Int']['output']>;
  ImageWidth?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TextLength?: Maybe<Scalars['Int']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type CaptchaElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CaptchaElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CaptchaElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CaptchaElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CaptchaElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CaptchaElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CaptchaElementBlockAutocomplete = {
  __typename?: 'CaptchaElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CaptchaElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CaptchaElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CaptchaElementBlockFacet = {
  __typename?: 'CaptchaElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageHeight?: Maybe<Array<Maybe<NumberFacet>>>;
  ImageWidth?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TextLength?: Maybe<Array<Maybe<NumberFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CaptchaElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CaptchaElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CaptchaElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CaptchaElementBlockFacetImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CaptchaElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CaptchaElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CaptchaElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CaptchaElementBlockFacetTextLengthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CaptchaElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CaptchaElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CaptchaElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageHeight?: InputMaybe<OrderBy>;
  ImageWidth?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TextLength?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type CaptchaElementBlockOutput = {
  __typename?: 'CaptchaElementBlockOutput';
  autocomplete?: Maybe<CaptchaElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CaptchaElementBlockFacet>;
  item?: Maybe<CaptchaElementBlock>;
  items?: Maybe<Array<Maybe<CaptchaElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CaptchaElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CaptchaElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageHeight?: InputMaybe<IntFilterInput>;
  ImageWidth?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TextLength?: InputMaybe<IntFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CaptchaElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CaptchaElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CaptchaElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type CategoryModel = {
  __typename?: 'CategoryModel';
  Description?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export type CategoryModelAutocomplete = {
  __typename?: 'CategoryModelAutocomplete';
  Description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CategoryModelAutocompleteDescriptionArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CategoryModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CategoryModelFacet = {
  __typename?: 'CategoryModelFacet';
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CategoryModelFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CategoryModelFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CategoryModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CategoryModelOrderByInput = {
  Description?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type CategoryModelWhereInput = {
  Description?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
};

export type ChoiceElementBlock = IContent & IData & {
  __typename?: 'ChoiceElementBlock';
  AllowMultiSelect?: Maybe<Scalars['Bool']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Feed?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ChoiceElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlockFeedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ChoiceElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ChoiceElementBlockAutocomplete = {
  __typename?: 'ChoiceElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ChoiceElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ChoiceElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ChoiceElementBlockFacet = {
  __typename?: 'ChoiceElementBlockFacet';
  AllowMultiSelect?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Feed?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ChoiceElementBlockFacetAllowMultiSelectArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ChoiceElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ChoiceElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ChoiceElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetFeedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ChoiceElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ChoiceElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ChoiceElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ChoiceElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ChoiceElementBlockOrderByInput = {
  AllowMultiSelect?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Feed?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ChoiceElementBlockOutput = {
  __typename?: 'ChoiceElementBlockOutput';
  autocomplete?: Maybe<ChoiceElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ChoiceElementBlockFacet>;
  item?: Maybe<ChoiceElementBlock>;
  items?: Maybe<Array<Maybe<ChoiceElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ChoiceElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChoiceElementBlockWhereInput = {
  AllowMultiSelect?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Feed?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ChoiceElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ChoiceElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ChoiceElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type CompanyRegistrationsBlockModel = IContent & IData & {
  __typename?: 'CompanyRegistrationsBlockModel';
  AlternativeTermsAndConditions?: Maybe<MixedHtmlModelSearch>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ButtonText?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  CustomTermsAndConditions?: Maybe<MixedHtmlModelSearch>;
  CustomTermsAndConditionsButton?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Extra1?: Maybe<MixedHtmlModelSearch>;
  Extra2?: Maybe<MixedHtmlModelSearch>;
  Extra3?: Maybe<MixedHtmlModelSearch>;
  Extra4?: Maybe<MixedHtmlModelSearch>;
  Extra5?: Maybe<MixedHtmlModelSearch>;
  Form?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HelpText?: Maybe<MixedHtmlModelSearch>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type CompanyRegistrationsBlockModelAlternativeTermsAndConditionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModelButtonTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModelCustomTermsAndConditionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModelCustomTermsAndConditionsButtonArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModelExtra1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModelExtra2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModelExtra3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModelExtra4Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModelExtra5Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModelFormArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModelHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompanyRegistrationsBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CompanyRegistrationsBlockModelAutocomplete = {
  __typename?: 'CompanyRegistrationsBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompanyRegistrationsBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRegistrationsBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRegistrationsBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRegistrationsBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRegistrationsBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRegistrationsBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRegistrationsBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRegistrationsBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompanyRegistrationsBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompanyRegistrationsBlockModelFacet = {
  __typename?: 'CompanyRegistrationsBlockModelFacet';
  AlternativeTermsAndConditions?: Maybe<MixedHtmlModelSearchFacet>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  ButtonText?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CustomTermsAndConditions?: Maybe<MixedHtmlModelSearchFacet>;
  CustomTermsAndConditionsButton?: Maybe<ContentAreaItemModelSearchFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Extra1?: Maybe<MixedHtmlModelSearchFacet>;
  Extra2?: Maybe<MixedHtmlModelSearchFacet>;
  Extra3?: Maybe<MixedHtmlModelSearchFacet>;
  Extra4?: Maybe<MixedHtmlModelSearchFacet>;
  Extra5?: Maybe<MixedHtmlModelSearchFacet>;
  Form?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HelpText?: Maybe<MixedHtmlModelSearchFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompanyRegistrationsBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacetButtonTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyRegistrationsBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyRegistrationsBlockModelFacetFormArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyRegistrationsBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyRegistrationsBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyRegistrationsBlockModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompanyRegistrationsBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompanyRegistrationsBlockModelOrderByInput = {
  AlternativeTermsAndConditions?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Ancestors?: InputMaybe<OrderBy>;
  ButtonText?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CustomTermsAndConditions?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  CustomTermsAndConditionsButton?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Extra1?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Extra2?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Extra3?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Extra4?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Extra5?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Form?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HelpText?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type CompanyRegistrationsBlockModelOutput = {
  __typename?: 'CompanyRegistrationsBlockModelOutput';
  autocomplete?: Maybe<CompanyRegistrationsBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CompanyRegistrationsBlockModelFacet>;
  item?: Maybe<CompanyRegistrationsBlockModel>;
  items?: Maybe<Array<Maybe<CompanyRegistrationsBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CompanyRegistrationsBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyRegistrationsBlockModelWhereInput = {
  AlternativeTermsAndConditions?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  ButtonText?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CustomTermsAndConditions?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  CustomTermsAndConditionsButton?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Extra1?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Extra2?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Extra3?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Extra4?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Extra5?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Form?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HelpText?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CompanyRegistrationsBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CompanyRegistrationsBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CompanyRegistrationsBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type CompensationBlockModel = IContent & IData & {
  __typename?: 'CompensationBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConfirmationText?: Maybe<MixedHtmlModelSearch>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Payments?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type CompensationBlockModelConfirmationTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompensationBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompensationBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompensationBlockModelPaymentsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompensationBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CompensationBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CompensationBlockModelAutocomplete = {
  __typename?: 'CompensationBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CompensationBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompensationBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompensationBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompensationBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompensationBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompensationBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompensationBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompensationBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CompensationBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CompensationBlockModelFacet = {
  __typename?: 'CompensationBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmationText?: Maybe<MixedHtmlModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Payments?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CompensationBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompensationBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompensationBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompensationBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompensationBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompensationBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompensationBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompensationBlockModelFacetPaymentsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompensationBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompensationBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompensationBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompensationBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompensationBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompensationBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompensationBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompensationBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CompensationBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CompensationBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CompensationBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmationText?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Payments?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type CompensationBlockModelOutput = {
  __typename?: 'CompensationBlockModelOutput';
  autocomplete?: Maybe<CompensationBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CompensationBlockModelFacet>;
  item?: Maybe<CompensationBlockModel>;
  items?: Maybe<Array<Maybe<CompensationBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CompensationBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompensationBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmationText?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Payments?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CompensationBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CompensationBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CompensationBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type ConnectedProducersListBlockModel = IContent & IData & {
  __typename?: 'ConnectedProducersListBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ConnectedProducersListBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConnectedProducersListBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConnectedProducersListBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ConnectedProducersListBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ConnectedProducersListBlockModelAutocomplete = {
  __typename?: 'ConnectedProducersListBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ConnectedProducersListBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConnectedProducersListBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConnectedProducersListBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConnectedProducersListBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConnectedProducersListBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConnectedProducersListBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConnectedProducersListBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConnectedProducersListBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ConnectedProducersListBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConnectedProducersListBlockModelFacet = {
  __typename?: 'ConnectedProducersListBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ConnectedProducersListBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConnectedProducersListBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConnectedProducersListBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConnectedProducersListBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConnectedProducersListBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConnectedProducersListBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConnectedProducersListBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConnectedProducersListBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConnectedProducersListBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConnectedProducersListBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConnectedProducersListBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConnectedProducersListBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConnectedProducersListBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConnectedProducersListBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConnectedProducersListBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ConnectedProducersListBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ConnectedProducersListBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ConnectedProducersListBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ConnectedProducersListBlockModelOutput = {
  __typename?: 'ConnectedProducersListBlockModelOutput';
  autocomplete?: Maybe<ConnectedProducersListBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ConnectedProducersListBlockModelFacet>;
  item?: Maybe<ConnectedProducersListBlockModel>;
  items?: Maybe<Array<Maybe<ConnectedProducersListBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ConnectedProducersListBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConnectedProducersListBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ConnectedProducersListBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ConnectedProducersListBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ConnectedProducersListBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type Content = IContent & IData & {
  __typename?: 'Content';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Content_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Content_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ContentAreaItemModelSearch = {
  __typename?: 'ContentAreaItemModelSearch';
  ContentLink?: Maybe<ContentModelReferenceSearch>;
  DisplayOption?: Maybe<Scalars['String']['output']>;
  InlineBlock?: Maybe<InlineBlockPropertyModelSearch>;
  Tag?: Maybe<Scalars['String']['output']>;
};


export type ContentAreaItemModelSearchContentLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentAreaItemModelSearchDisplayOptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentAreaItemModelSearchInlineBlockArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentAreaItemModelSearchTagArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentAreaItemModelSearchFacet = {
  __typename?: 'ContentAreaItemModelSearchFacet';
  ContentLink?: Maybe<ContentModelReferenceSearchFacet>;
  DisplayOption?: Maybe<Array<Maybe<StringFacet>>>;
  InlineBlock?: Maybe<InlineBlockPropertyModelSearchFacet>;
  Tag?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ContentAreaItemModelSearchFacetDisplayOptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentAreaItemModelSearchFacetTagArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentAreaItemModelSearchOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceSearchOrderByInput>;
  DisplayOption?: InputMaybe<OrderBy>;
  InlineBlock?: InputMaybe<InlineBlockPropertyModelSearchOrderByInput>;
  Tag?: InputMaybe<OrderBy>;
};

export type ContentAreaItemModelSearchWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceSearchWhereInput>;
  DisplayOption?: InputMaybe<SearchableStringFilterInput>;
  InlineBlock?: InputMaybe<InlineBlockPropertyModelSearchWhereInput>;
  Tag?: InputMaybe<SearchableStringFilterInput>;
};

export type ContentAutocomplete = {
  __typename?: 'ContentAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContentAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentFacet = {
  __typename?: 'ContentFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ContentFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModel = {
  __typename?: 'ContentLanguageModel';
  DisplayName?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export type ContentLanguageModelAutocomplete = {
  __typename?: 'ContentLanguageModelAutocomplete';
  DisplayName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Link?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContentLanguageModelAutocompleteDisplayNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentLanguageModelAutocompleteLinkArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentLanguageModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentLanguageModelFacet = {
  __typename?: 'ContentLanguageModelFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ContentLanguageModelFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelFacetLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  Link?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type ContentLanguageModelSearch = {
  __typename?: 'ContentLanguageModelSearch';
  DisplayName?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};


export type ContentLanguageModelSearchDisplayNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentLanguageModelSearchLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentLanguageModelSearchNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentLanguageModelSearchFacet = {
  __typename?: 'ContentLanguageModelSearchFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ContentLanguageModelSearchFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelSearchFacetLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentLanguageModelSearchFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ContentLanguageModelSearchOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  Link?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
};

export type ContentLanguageModelSearchWhereInput = {
  DisplayName?: InputMaybe<SearchableStringFilterInput>;
  Link?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
};

export type ContentLanguageModelWhereInput = {
  DisplayName?: InputMaybe<StringFilterInput>;
  Link?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
};

export type ContentModelReference = {
  __typename?: 'ContentModelReference';
  Expanded?: Maybe<IContent>;
  GuidValue?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  ProviderName?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WorkId?: Maybe<Scalars['Int']['output']>;
};

export type ContentModelReferenceAutocomplete = {
  __typename?: 'ContentModelReferenceAutocomplete';
  GuidValue?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  ProviderName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ContentModelReferenceAutocompleteGuidValueArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentModelReferenceAutocompleteProviderNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ContentModelReferenceAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ContentModelReferenceFacet = {
  __typename?: 'ContentModelReferenceFacet';
  GuidValue?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  ProviderName?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WorkId?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContentModelReferenceFacetGuidValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContentModelReferenceFacetProviderNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceFacetWorkIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentModelReferenceOrderByInput = {
  GuidValue?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  ProviderName?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WorkId?: InputMaybe<OrderBy>;
};

export type ContentModelReferenceSearch = {
  __typename?: 'ContentModelReferenceSearch';
  Expanded?: Maybe<IContent>;
  GuidValue?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  Language?: Maybe<ContentLanguageModelSearch>;
  ProviderName?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WorkId?: Maybe<Scalars['Int']['output']>;
};


export type ContentModelReferenceSearchExpandedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentModelReferenceSearchLanguageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentModelReferenceSearchProviderNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ContentModelReferenceSearchUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ContentModelReferenceSearchFacet = {
  __typename?: 'ContentModelReferenceSearchFacet';
  GuidValue?: Maybe<Array<Maybe<StringFacet>>>;
  Id?: Maybe<Array<Maybe<NumberFacet>>>;
  Language?: Maybe<ContentLanguageModelSearchFacet>;
  ProviderName?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WorkId?: Maybe<Array<Maybe<NumberFacet>>>;
};


export type ContentModelReferenceSearchFacetGuidValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceSearchFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ContentModelReferenceSearchFacetProviderNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceSearchFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ContentModelReferenceSearchFacetWorkIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};

export type ContentModelReferenceSearchOrderByInput = {
  GuidValue?: InputMaybe<OrderBy>;
  Id?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelSearchOrderByInput>;
  ProviderName?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WorkId?: InputMaybe<OrderBy>;
};

export type ContentModelReferenceSearchWhereInput = {
  GuidValue?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelSearchWhereInput>;
  ProviderName?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<SearchableStringFilterInput>;
  WorkId?: InputMaybe<IntFilterInput>;
};

export type ContentModelReferenceWhereInput = {
  GuidValue?: InputMaybe<StringFilterInput>;
  Id?: InputMaybe<IntFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  ProviderName?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WorkId?: InputMaybe<IntFilterInput>;
};

export type ContentOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ContentOutput = {
  __typename?: 'ContentOutput';
  autocomplete?: Maybe<ContentAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ContentFacet>;
  item?: Maybe<IContent>;
  items?: Maybe<Array<Maybe<IContent>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ContentOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentRootsModel = {
  __typename?: 'ContentRootsModel';
  ContentAssetsRoot?: Maybe<ContentModelReference>;
  GlobalAssetsRoot?: Maybe<ContentModelReference>;
  RootPage?: Maybe<ContentModelReference>;
  SiteAssetsRoot?: Maybe<ContentModelReference>;
  StartPage?: Maybe<ContentModelReference>;
  WasteBasket?: Maybe<ContentModelReference>;
};

export type ContentRootsModelAutocomplete = {
  __typename?: 'ContentRootsModelAutocomplete';
  ContentAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  GlobalAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  RootPage?: Maybe<ContentModelReferenceAutocomplete>;
  SiteAssetsRoot?: Maybe<ContentModelReferenceAutocomplete>;
  StartPage?: Maybe<ContentModelReferenceAutocomplete>;
  WasteBasket?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ContentRootsModelFacet = {
  __typename?: 'ContentRootsModelFacet';
  ContentAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  GlobalAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  RootPage?: Maybe<ContentModelReferenceFacet>;
  SiteAssetsRoot?: Maybe<ContentModelReferenceFacet>;
  StartPage?: Maybe<ContentModelReferenceFacet>;
  WasteBasket?: Maybe<ContentModelReferenceFacet>;
};

export type ContentRootsModelOrderByInput = {
  ContentAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  GlobalAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  RootPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  SiteAssetsRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  StartPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  WasteBasket?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type ContentRootsModelWhereInput = {
  ContentAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  GlobalAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  RootPage?: InputMaybe<ContentModelReferenceWhereInput>;
  SiteAssetsRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  StartPage?: InputMaybe<ContentModelReferenceWhereInput>;
  WasteBasket?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type ContentWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ContentWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type CsvMediaModel = IContent & IData & {
  __typename?: 'CsvMediaModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['Int']['output']>;
  HeadingEn?: Maybe<Scalars['String']['output']>;
  HeadingSv?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreambleEn?: Maybe<Scalars['String']['output']>;
  PreambleSv?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type CsvMediaModelContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CsvMediaModelDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CsvMediaModelHeadingEnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CsvMediaModelHeadingSvArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CsvMediaModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CsvMediaModelPreambleEnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CsvMediaModelPreambleSvArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CsvMediaModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type CsvMediaModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type CsvMediaModelAutocomplete = {
  __typename?: 'CsvMediaModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type CsvMediaModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CsvMediaModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CsvMediaModelAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CsvMediaModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CsvMediaModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CsvMediaModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CsvMediaModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CsvMediaModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CsvMediaModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type CsvMediaModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type CsvMediaModelFacet = {
  __typename?: 'CsvMediaModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<NumberFacet>>>;
  HeadingEn?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingSv?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreambleEn?: Maybe<Array<Maybe<StringFacet>>>;
  PreambleSv?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type CsvMediaModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CsvMediaModelFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CsvMediaModelFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type CsvMediaModelFacetHeadingEnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetHeadingSvArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetPreambleEnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetPreambleSvArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CsvMediaModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CsvMediaModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type CsvMediaModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type CsvMediaModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type CsvMediaModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  HeadingEn?: InputMaybe<OrderBy>;
  HeadingSv?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreambleEn?: InputMaybe<OrderBy>;
  PreambleSv?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type CsvMediaModelOutput = {
  __typename?: 'CsvMediaModelOutput';
  autocomplete?: Maybe<CsvMediaModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<CsvMediaModelFacet>;
  item?: Maybe<CsvMediaModel>;
  items?: Maybe<Array<Maybe<CsvMediaModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type CsvMediaModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CsvMediaModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<IntFilterInput>;
  HeadingEn?: InputMaybe<SearchableStringFilterInput>;
  HeadingSv?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreambleEn?: InputMaybe<SearchableStringFilterInput>;
  PreambleSv?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<CsvMediaModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<CsvMediaModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<CsvMediaModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type Data = IData & {
  __typename?: 'Data';
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type Data_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type Data_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DataOrderByInput = {
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type DataOutput = {
  __typename?: 'DataOutput';
  cursor?: Maybe<Scalars['String']['output']>;
  item?: Maybe<IData>;
  items?: Maybe<Array<Maybe<IData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DataWhereInput = {
  _and?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DataWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type DateFacet = {
  __typename?: 'DateFacet';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum DateFacetUnit {
  /** Defined as 24 hours (86,400,000 milliseconds). All days begin at the earliest possible time, which is usually 00:00:00 (midnight). */
  Day = 'DAY',
  /** Defined as 60 minutes each (3,600,000 milliseconds). All hours begin at 00 minutes and 00 seconds. */
  Hour = 'HOUR',
  /** Defined as 1000 milliseconds each. */
  Minute = 'MINUTE'
}

export type DateFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `decay` influences the weight of the score with a decay function. For example, results that have a more recent datetime will be ranked higher. */
  decay?: InputMaybe<Decay>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Date']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** `gt` retrieves results with matches that have a value which is `greater than` it. */
  gt?: InputMaybe<Scalars['Date']['input']>;
  /** `gte` retrieves results with matches that have a value which is `greater than or equal to` it. */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** `lt` retrieves results with matches that have a value which is `lower than` it. */
  lt?: InputMaybe<Scalars['Date']['input']>;
  /** `lte` retrieves results with matches that have a value which is `lower than or equal to` it. */
  lte?: InputMaybe<Scalars['Date']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Date']['input']>;
};

/** Decay influences the weight of the score based on field values with a decay function */
export type Decay = {
  /** Reference point the decay is measured from. Defaults to `now()`. */
  origin?: InputMaybe<Scalars['Date']['input']>;
  /** Score at `scale` distance from `origin`. Defaults to 0.5; must be in the range (0..1). */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** Decay distance in days. Defaults to 10. */
  scale?: InputMaybe<Scalars['Int']['input']>;
};

export type DepositLabelOrderBlockModel = IContent & IData & {
  __typename?: 'DepositLabelOrderBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Button?: Maybe<DepositLabelOrderBlockModelButtonLinkBlockModel>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  CustomTermsAndConditions?: Maybe<MixedHtmlModelSearch>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  HelpText?: Maybe<MixedHtmlModelSearch>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainBody?: Maybe<MixedHtmlModelSearch>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PriceInformation?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  ShippingInformation?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type DepositLabelOrderBlockModelCustomTermsAndConditionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderBlockModelHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderBlockModelMainBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderBlockModelPriceInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderBlockModelShippingInformationArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DepositLabelOrderBlockModelAutocomplete = {
  __typename?: 'DepositLabelOrderBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Button?: Maybe<DepositLabelOrderBlockModelButtonLinkBlockModelAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DepositLabelOrderBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DepositLabelOrderBlockModelButtonLinkBlockModel = {
  __typename?: 'DepositLabelOrderBlockModelButtonLinkBlockModel';
  ButtonClass?: Maybe<Scalars['Int']['output']>;
  DocumentLink?: Maybe<ContentModelReference>;
  ExternalLink?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<ContentModelReference>;
  LinkText?: Maybe<Scalars['String']['output']>;
  PopupContent?: Maybe<MixedHtmlModelSearch>;
  Title?: Maybe<Scalars['String']['output']>;
  VideoUrl?: Maybe<Scalars['String']['output']>;
};


export type DepositLabelOrderBlockModelButtonLinkBlockModelExternalLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderBlockModelButtonLinkBlockModelLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderBlockModelButtonLinkBlockModelPopupContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderBlockModelButtonLinkBlockModelTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderBlockModelButtonLinkBlockModelVideoUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DepositLabelOrderBlockModelButtonLinkBlockModelAutocomplete = {
  __typename?: 'DepositLabelOrderBlockModelButtonLinkBlockModelAutocomplete';
  DocumentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Link?: Maybe<ContentModelReferenceAutocomplete>;
};

export type DepositLabelOrderBlockModelButtonLinkBlockModelFacet = {
  __typename?: 'DepositLabelOrderBlockModelButtonLinkBlockModelFacet';
  ButtonClass?: Maybe<Array<Maybe<NumberFacet>>>;
  DocumentLink?: Maybe<ContentModelReferenceFacet>;
  ExternalLink?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<ContentModelReferenceFacet>;
  LinkText?: Maybe<Array<Maybe<StringFacet>>>;
  PopupContent?: Maybe<MixedHtmlModelSearchFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  VideoUrl?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DepositLabelOrderBlockModelButtonLinkBlockModelFacetButtonClassArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type DepositLabelOrderBlockModelButtonLinkBlockModelFacetExternalLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelButtonLinkBlockModelFacetLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelButtonLinkBlockModelFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelButtonLinkBlockModelFacetVideoUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DepositLabelOrderBlockModelButtonLinkBlockModelOrderByInput = {
  ButtonClass?: InputMaybe<OrderBy>;
  DocumentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExternalLink?: InputMaybe<OrderBy>;
  Link?: InputMaybe<ContentModelReferenceOrderByInput>;
  LinkText?: InputMaybe<OrderBy>;
  PopupContent?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  VideoUrl?: InputMaybe<OrderBy>;
};

export type DepositLabelOrderBlockModelButtonLinkBlockModelWhereInput = {
  ButtonClass?: InputMaybe<IntFilterInput>;
  DocumentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ExternalLink?: InputMaybe<SearchableStringFilterInput>;
  Link?: InputMaybe<ContentModelReferenceWhereInput>;
  LinkText?: InputMaybe<SearchableStringFilterInput>;
  PopupContent?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  VideoUrl?: InputMaybe<SearchableStringFilterInput>;
};

export type DepositLabelOrderBlockModelFacet = {
  __typename?: 'DepositLabelOrderBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Button?: Maybe<DepositLabelOrderBlockModelButtonLinkBlockModelFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CustomTermsAndConditions?: Maybe<MixedHtmlModelSearchFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HelpText?: Maybe<MixedHtmlModelSearchFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainBody?: Maybe<MixedHtmlModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PriceInformation?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ShippingInformation?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DepositLabelOrderBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DepositLabelOrderBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DepositLabelOrderBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelFacetPriceInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DepositLabelOrderBlockModelFacetShippingInformationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DepositLabelOrderBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DepositLabelOrderBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DepositLabelOrderBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Button?: InputMaybe<DepositLabelOrderBlockModelButtonLinkBlockModelOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CustomTermsAndConditions?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  HelpText?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PriceInformation?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ShippingInformation?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type DepositLabelOrderBlockModelOutput = {
  __typename?: 'DepositLabelOrderBlockModelOutput';
  autocomplete?: Maybe<DepositLabelOrderBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DepositLabelOrderBlockModelFacet>;
  item?: Maybe<DepositLabelOrderBlockModel>;
  items?: Maybe<Array<Maybe<DepositLabelOrderBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DepositLabelOrderBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DepositLabelOrderBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Button?: InputMaybe<DepositLabelOrderBlockModelButtonLinkBlockModelWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CustomTermsAndConditions?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HelpText?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PriceInformation?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ShippingInformation?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DepositLabelOrderBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DepositLabelOrderBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DepositLabelOrderBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type DepositLabelOrderHistoryBlockModel = IContent & IData & {
  __typename?: 'DepositLabelOrderHistoryBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainBody?: Maybe<MixedHtmlModelSearch>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type DepositLabelOrderHistoryBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderHistoryBlockModelMainBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderHistoryBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderHistoryBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DepositLabelOrderHistoryBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DepositLabelOrderHistoryBlockModelAutocomplete = {
  __typename?: 'DepositLabelOrderHistoryBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DepositLabelOrderHistoryBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderHistoryBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderHistoryBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderHistoryBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderHistoryBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderHistoryBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderHistoryBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderHistoryBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DepositLabelOrderHistoryBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DepositLabelOrderHistoryBlockModelFacet = {
  __typename?: 'DepositLabelOrderHistoryBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainBody?: Maybe<MixedHtmlModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DepositLabelOrderHistoryBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderHistoryBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DepositLabelOrderHistoryBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderHistoryBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DepositLabelOrderHistoryBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderHistoryBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderHistoryBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderHistoryBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderHistoryBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderHistoryBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DepositLabelOrderHistoryBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderHistoryBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderHistoryBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DepositLabelOrderHistoryBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderHistoryBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DepositLabelOrderHistoryBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DepositLabelOrderHistoryBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DepositLabelOrderHistoryBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type DepositLabelOrderHistoryBlockModelOutput = {
  __typename?: 'DepositLabelOrderHistoryBlockModelOutput';
  autocomplete?: Maybe<DepositLabelOrderHistoryBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DepositLabelOrderHistoryBlockModelFacet>;
  item?: Maybe<DepositLabelOrderHistoryBlockModel>;
  items?: Maybe<Array<Maybe<DepositLabelOrderHistoryBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DepositLabelOrderHistoryBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DepositLabelOrderHistoryBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DepositLabelOrderHistoryBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DepositLabelOrderHistoryBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DepositLabelOrderHistoryBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type DownloadAssetLocalBlockModel = IContent & IData & {
  __typename?: 'DownloadAssetLocalBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Variants?: Maybe<Array<Maybe<DownloadAssetLocalBlockModelDownloadAssetVariant>>>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type DownloadAssetLocalBlockModelDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetLocalBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetLocalBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetLocalBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetLocalBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DownloadAssetLocalBlockModelAutocomplete = {
  __typename?: 'DownloadAssetLocalBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Variants?: Maybe<DownloadAssetLocalBlockModelDownloadAssetVariantAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DownloadAssetLocalBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetLocalBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetLocalBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetLocalBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetLocalBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetLocalBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetLocalBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetLocalBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetLocalBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DownloadAssetLocalBlockModelDownloadAssetVariant = {
  __typename?: 'DownloadAssetLocalBlockModelDownloadAssetVariant';
  Asset?: Maybe<ContentModelReference>;
  LinkText?: Maybe<Scalars['String']['output']>;
};


export type DownloadAssetLocalBlockModelDownloadAssetVariantLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type DownloadAssetLocalBlockModelDownloadAssetVariantAutocomplete = {
  __typename?: 'DownloadAssetLocalBlockModelDownloadAssetVariantAutocomplete';
  Asset?: Maybe<ContentModelReferenceAutocomplete>;
};

export type DownloadAssetLocalBlockModelDownloadAssetVariantFacet = {
  __typename?: 'DownloadAssetLocalBlockModelDownloadAssetVariantFacet';
  Asset?: Maybe<ContentModelReferenceFacet>;
  LinkText?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DownloadAssetLocalBlockModelDownloadAssetVariantFacetLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DownloadAssetLocalBlockModelDownloadAssetVariantOrderByInput = {
  Asset?: InputMaybe<ContentModelReferenceOrderByInput>;
  LinkText?: InputMaybe<OrderBy>;
};

export type DownloadAssetLocalBlockModelDownloadAssetVariantWhereInput = {
  Asset?: InputMaybe<ContentModelReferenceWhereInput>;
  LinkText?: InputMaybe<SearchableStringFilterInput>;
};

export type DownloadAssetLocalBlockModelFacet = {
  __typename?: 'DownloadAssetLocalBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Variants?: Maybe<DownloadAssetLocalBlockModelDownloadAssetVariantFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DownloadAssetLocalBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetLocalBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetLocalBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetLocalBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetLocalBlockModelFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetLocalBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetLocalBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetLocalBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetLocalBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetLocalBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetLocalBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetLocalBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetLocalBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetLocalBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetLocalBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetLocalBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetLocalBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetLocalBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DownloadAssetLocalBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Variants?: InputMaybe<DownloadAssetLocalBlockModelDownloadAssetVariantOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type DownloadAssetLocalBlockModelOutput = {
  __typename?: 'DownloadAssetLocalBlockModelOutput';
  autocomplete?: Maybe<DownloadAssetLocalBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DownloadAssetLocalBlockModelFacet>;
  item?: Maybe<DownloadAssetLocalBlockModel>;
  items?: Maybe<Array<Maybe<DownloadAssetLocalBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DownloadAssetLocalBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DownloadAssetLocalBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Variants?: InputMaybe<DownloadAssetLocalBlockModelDownloadAssetVariantWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<DownloadAssetLocalBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DownloadAssetLocalBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DownloadAssetLocalBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type DownloadAssetVariant = IContent & IData & {
  __typename?: 'DownloadAssetVariant';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Asset?: Maybe<ContentModelReference>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkText?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type DownloadAssetVariantLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetVariantNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetVariant_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetVariant_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DownloadAssetVariantAutocomplete = {
  __typename?: 'DownloadAssetVariantAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Asset?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DownloadAssetVariantAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetVariantAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetVariantAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetVariantAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetVariantAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetVariantAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetVariantAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetVariantAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetVariantAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DownloadAssetVariantFacet = {
  __typename?: 'DownloadAssetVariantFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Asset?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkText?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DownloadAssetVariantFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetVariantFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetVariantFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetVariantFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetVariantFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetVariantFacetLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetVariantFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetVariantFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetVariantFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetVariantFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetVariantFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetVariantFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetVariantFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetVariantFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetVariantFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetVariantFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetVariantFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DownloadAssetVariantOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Asset?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkText?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type DownloadAssetVariantOutput = {
  __typename?: 'DownloadAssetVariantOutput';
  autocomplete?: Maybe<DownloadAssetVariantAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DownloadAssetVariantFacet>;
  item?: Maybe<DownloadAssetVariant>;
  items?: Maybe<Array<Maybe<DownloadAssetVariant>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DownloadAssetVariantOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DownloadAssetVariantWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Asset?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkText?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DownloadAssetVariantWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DownloadAssetVariantWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DownloadAssetVariantWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type DownloadAssetsBlockModel = IContent & IData & {
  __typename?: 'DownloadAssetsBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackgroundColor?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DownloadAssets?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  ItemsPerRow?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Preamble?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Test?: Maybe<Scalars['Bool']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type DownloadAssetsBlockModelBackgroundColorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetsBlockModelDownloadAssetsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetsBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetsBlockModelItemsPerRowArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetsBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetsBlockModelPreambleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetsBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type DownloadAssetsBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type DownloadAssetsBlockModelAutocomplete = {
  __typename?: 'DownloadAssetsBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type DownloadAssetsBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetsBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetsBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetsBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetsBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetsBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetsBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetsBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type DownloadAssetsBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type DownloadAssetsBlockModelFacet = {
  __typename?: 'DownloadAssetsBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackgroundColor?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DownloadAssets?: Maybe<ContentAreaItemModelSearchFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  ItemsPerRow?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Preamble?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Test?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type DownloadAssetsBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetBackgroundColorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetsBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetsBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetItemsPerRowArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetPreambleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetsBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetsBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type DownloadAssetsBlockModelFacetTestArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type DownloadAssetsBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type DownloadAssetsBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackgroundColor?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DownloadAssets?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  ItemsPerRow?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Preamble?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Test?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type DownloadAssetsBlockModelOutput = {
  __typename?: 'DownloadAssetsBlockModelOutput';
  autocomplete?: Maybe<DownloadAssetsBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<DownloadAssetsBlockModelFacet>;
  item?: Maybe<DownloadAssetsBlockModel>;
  items?: Maybe<Array<Maybe<DownloadAssetsBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type DownloadAssetsBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DownloadAssetsBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackgroundColor?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DownloadAssets?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  ItemsPerRow?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Preamble?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Test?: InputMaybe<BoolFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<DownloadAssetsBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<DownloadAssetsBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<DownloadAssetsBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type EanCheckBlockModel = IContent & IData & {
  __typename?: 'EanCheckBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type EanCheckBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EanCheckBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EanCheckBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EanCheckBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EanCheckBlockModelAutocomplete = {
  __typename?: 'EanCheckBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EanCheckBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EanCheckBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EanCheckBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EanCheckBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EanCheckBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EanCheckBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EanCheckBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EanCheckBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EanCheckBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EanCheckBlockModelFacet = {
  __typename?: 'EanCheckBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EanCheckBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EanCheckBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EanCheckBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EanCheckBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EanCheckBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EanCheckBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EanCheckBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EanCheckBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EanCheckBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EanCheckBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EanCheckBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EanCheckBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EanCheckBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EanCheckBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EanCheckBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EanCheckBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EanCheckBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EanCheckBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type EanCheckBlockModelOutput = {
  __typename?: 'EanCheckBlockModelOutput';
  autocomplete?: Maybe<EanCheckBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EanCheckBlockModelFacet>;
  item?: Maybe<EanCheckBlockModel>;
  items?: Maybe<Array<Maybe<EanCheckBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EanCheckBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EanCheckBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EanCheckBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EanCheckBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EanCheckBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type EmbedVideoBlockModel = IContent & IData & {
  __typename?: 'EmbedVideoBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  EmbedUrl?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreviewImage?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VideoDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type EmbedVideoBlockModelEmbedUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EmbedVideoBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EmbedVideoBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EmbedVideoBlockModelVideoDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EmbedVideoBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type EmbedVideoBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type EmbedVideoBlockModelAutocomplete = {
  __typename?: 'EmbedVideoBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type EmbedVideoBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmbedVideoBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmbedVideoBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmbedVideoBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmbedVideoBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmbedVideoBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmbedVideoBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmbedVideoBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type EmbedVideoBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type EmbedVideoBlockModelFacet = {
  __typename?: 'EmbedVideoBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  EmbedUrl?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VideoDescription?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type EmbedVideoBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmbedVideoBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EmbedVideoBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmbedVideoBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EmbedVideoBlockModelFacetEmbedUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmbedVideoBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmbedVideoBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmbedVideoBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmbedVideoBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmbedVideoBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmbedVideoBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EmbedVideoBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmbedVideoBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmbedVideoBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EmbedVideoBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmbedVideoBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type EmbedVideoBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmbedVideoBlockModelFacetVideoDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type EmbedVideoBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type EmbedVideoBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  EmbedUrl?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VideoDescription?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type EmbedVideoBlockModelOutput = {
  __typename?: 'EmbedVideoBlockModelOutput';
  autocomplete?: Maybe<EmbedVideoBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<EmbedVideoBlockModelFacet>;
  item?: Maybe<EmbedVideoBlockModel>;
  items?: Maybe<Array<Maybe<EmbedVideoBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type EmbedVideoBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmbedVideoBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  EmbedUrl?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VideoDescription?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<EmbedVideoBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<EmbedVideoBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<EmbedVideoBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type ErrorPageModel = IContent & IData & {
  __typename?: 'ErrorPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ErrorPageType?: Maybe<Scalars['String']['output']>;
  ErrorText?: Maybe<MixedHtmlModelSearch>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ErrorPageModelErrorPageTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageModelErrorTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ErrorPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ErrorPageModelAutocomplete = {
  __typename?: 'ErrorPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ErrorPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ErrorPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ErrorPageModelFacet = {
  __typename?: 'ErrorPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorPageType?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorText?: Maybe<MixedHtmlModelSearchFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ErrorPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetErrorPageTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ErrorPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ErrorPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ErrorPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ErrorPageType?: InputMaybe<OrderBy>;
  ErrorText?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ErrorPageModelOutput = {
  __typename?: 'ErrorPageModelOutput';
  autocomplete?: Maybe<ErrorPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ErrorPageModelFacet>;
  item?: Maybe<ErrorPageModel>;
  items?: Maybe<Array<Maybe<ErrorPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ErrorPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ErrorPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ErrorPageType?: InputMaybe<SearchableStringFilterInput>;
  ErrorText?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ErrorPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ErrorPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ErrorPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type ExcelMediaModel = IContent & IData & {
  __typename?: 'ExcelMediaModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['Int']['output']>;
  HeadingEn?: Maybe<Scalars['String']['output']>;
  HeadingSv?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreambleEn?: Maybe<Scalars['String']['output']>;
  PreambleSv?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ExcelMediaModelContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExcelMediaModelDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExcelMediaModelHeadingEnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExcelMediaModelHeadingSvArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExcelMediaModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExcelMediaModelPreambleEnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExcelMediaModelPreambleSvArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExcelMediaModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExcelMediaModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ExcelMediaModelAutocomplete = {
  __typename?: 'ExcelMediaModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ExcelMediaModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExcelMediaModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExcelMediaModelAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExcelMediaModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExcelMediaModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExcelMediaModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExcelMediaModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExcelMediaModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExcelMediaModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExcelMediaModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExcelMediaModelFacet = {
  __typename?: 'ExcelMediaModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<NumberFacet>>>;
  HeadingEn?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingSv?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreambleEn?: Maybe<Array<Maybe<StringFacet>>>;
  PreambleSv?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ExcelMediaModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExcelMediaModelFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExcelMediaModelFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ExcelMediaModelFacetHeadingEnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetHeadingSvArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetPreambleEnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetPreambleSvArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExcelMediaModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExcelMediaModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExcelMediaModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExcelMediaModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExcelMediaModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  HeadingEn?: InputMaybe<OrderBy>;
  HeadingSv?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreambleEn?: InputMaybe<OrderBy>;
  PreambleSv?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ExcelMediaModelOutput = {
  __typename?: 'ExcelMediaModelOutput';
  autocomplete?: Maybe<ExcelMediaModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ExcelMediaModelFacet>;
  item?: Maybe<ExcelMediaModel>;
  items?: Maybe<Array<Maybe<ExcelMediaModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ExcelMediaModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExcelMediaModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<IntFilterInput>;
  HeadingEn?: InputMaybe<SearchableStringFilterInput>;
  HeadingSv?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreambleEn?: InputMaybe<SearchableStringFilterInput>;
  PreambleSv?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ExcelMediaModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ExcelMediaModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ExcelMediaModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type ExtendedLinkBlockModel = IContent & IData & {
  __typename?: 'ExtendedLinkBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FormReference?: Maybe<ContentModelReference>;
  Heading?: Maybe<Scalars['String']['output']>;
  InvertIcon?: Maybe<Scalars['Bool']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinkUrl?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MenuIcon?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ExtendedLinkBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExtendedLinkBlockModelMenuIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExtendedLinkBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExtendedLinkBlockModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExtendedLinkBlockModelTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExtendedLinkBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExtendedLinkBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ExtendedLinkBlockModelAutocomplete = {
  __typename?: 'ExtendedLinkBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FormReference?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  LinkUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ExtendedLinkBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtendedLinkBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtendedLinkBlockModelAutocompleteLinkUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtendedLinkBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtendedLinkBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtendedLinkBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtendedLinkBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtendedLinkBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtendedLinkBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtendedLinkBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExtendedLinkBlockModelFacet = {
  __typename?: 'ExtendedLinkBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormReference?: Maybe<ContentModelReferenceFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  InvertIcon?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinkUrl?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MenuIcon?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ExtendedLinkBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExtendedLinkBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExtendedLinkBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetInvertIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetLinkUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetMenuIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExtendedLinkBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExtendedLinkBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExtendedLinkBlockModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtendedLinkBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExtendedLinkBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  InvertIcon?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinkUrl?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MenuIcon?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ExtendedLinkBlockModelOutput = {
  __typename?: 'ExtendedLinkBlockModelOutput';
  autocomplete?: Maybe<ExtendedLinkBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ExtendedLinkBlockModelFacet>;
  item?: Maybe<ExtendedLinkBlockModel>;
  items?: Maybe<Array<Maybe<ExtendedLinkBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ExtendedLinkBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExtendedLinkBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormReference?: InputMaybe<ContentModelReferenceWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  InvertIcon?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinkUrl?: InputMaybe<StringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MenuIcon?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ExtendedLinkBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ExtendedLinkBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ExtendedLinkBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type ExtraPickupFormBlockModel = IContent & IData & {
  __typename?: 'ExtraPickupFormBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConfirmationText?: Maybe<MixedHtmlModelSearch>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ExtraPickupFormBlockModelConfirmationTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExtraPickupFormBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExtraPickupFormBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExtraPickupFormBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ExtraPickupFormBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ExtraPickupFormBlockModelAutocomplete = {
  __typename?: 'ExtraPickupFormBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ExtraPickupFormBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtraPickupFormBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtraPickupFormBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtraPickupFormBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtraPickupFormBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtraPickupFormBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtraPickupFormBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtraPickupFormBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ExtraPickupFormBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ExtraPickupFormBlockModelFacet = {
  __typename?: 'ExtraPickupFormBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmationText?: Maybe<MixedHtmlModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ExtraPickupFormBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtraPickupFormBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExtraPickupFormBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtraPickupFormBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExtraPickupFormBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtraPickupFormBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtraPickupFormBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtraPickupFormBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtraPickupFormBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtraPickupFormBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExtraPickupFormBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtraPickupFormBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtraPickupFormBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExtraPickupFormBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtraPickupFormBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ExtraPickupFormBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ExtraPickupFormBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ExtraPickupFormBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmationText?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ExtraPickupFormBlockModelOutput = {
  __typename?: 'ExtraPickupFormBlockModelOutput';
  autocomplete?: Maybe<ExtraPickupFormBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ExtraPickupFormBlockModelFacet>;
  item?: Maybe<ExtraPickupFormBlockModel>;
  items?: Maybe<Array<Maybe<ExtraPickupFormBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ExtraPickupFormBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExtraPickupFormBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmationText?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ExtraPickupFormBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ExtraPickupFormBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ExtraPickupFormBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export enum FactorModifier {
  /** Add 1 to the field value and take the natural logarithm */
  Log = 'LOG',
  /** Do not apply any multiplier to the field value */
  None = 'NONE',
  /** Reciprocate the field value, same as 1/x where x is the field's value */
  Reciprocal = 'RECIPROCAL',
  /** Take the square root of the field value */
  Sqrt = 'SQRT',
  /** Square the field value (multiply it by itself) */
  Square = 'SQUARE'
}

export type FaqCategoryPageModel = IContent & IData & {
  __typename?: 'FaqCategoryPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type FaqCategoryPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqCategoryPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqCategoryPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqCategoryPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqCategoryPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqCategoryPageModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqCategoryPageModelTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqCategoryPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqCategoryPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FaqCategoryPageModelAutocomplete = {
  __typename?: 'FaqCategoryPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FaqCategoryPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqCategoryPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqCategoryPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqCategoryPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqCategoryPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqCategoryPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqCategoryPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqCategoryPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqCategoryPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqCategoryPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqCategoryPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqCategoryPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqCategoryPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqCategoryPageModelFacet = {
  __typename?: 'FaqCategoryPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type FaqCategoryPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqCategoryPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqCategoryPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqCategoryPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqCategoryPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqCategoryPageModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqCategoryPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqCategoryPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type FaqCategoryPageModelOutput = {
  __typename?: 'FaqCategoryPageModelOutput';
  autocomplete?: Maybe<FaqCategoryPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FaqCategoryPageModelFacet>;
  item?: Maybe<FaqCategoryPageModel>;
  items?: Maybe<Array<Maybe<FaqCategoryPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FaqCategoryPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FaqCategoryPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FaqCategoryPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FaqCategoryPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FaqCategoryPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type FaqItemPageModel = IContent & IData & {
  __typename?: 'FaqItemPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Answer?: Maybe<MixedHtmlModelSearch>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Question?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type FaqItemPageModelAnswerArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqItemPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqItemPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqItemPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqItemPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqItemPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqItemPageModelQuestionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqItemPageModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqItemPageModelTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqItemPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqItemPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FaqItemPageModelAutocomplete = {
  __typename?: 'FaqItemPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FaqItemPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqItemPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqItemPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqItemPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqItemPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqItemPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqItemPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqItemPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqItemPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqItemPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqItemPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqItemPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqItemPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqItemPageModelFacet = {
  __typename?: 'FaqItemPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Answer?: Maybe<MixedHtmlModelSearchFacet>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Question?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type FaqItemPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqItemPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqItemPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetQuestionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqItemPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqItemPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqItemPageModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqItemPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqItemPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Answer?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Question?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type FaqItemPageModelOutput = {
  __typename?: 'FaqItemPageModelOutput';
  autocomplete?: Maybe<FaqItemPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FaqItemPageModelFacet>;
  item?: Maybe<FaqItemPageModel>;
  items?: Maybe<Array<Maybe<FaqItemPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FaqItemPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FaqItemPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Answer?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Question?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FaqItemPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FaqItemPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FaqItemPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type FaqListPageModel = IContent & IData & {
  __typename?: 'FaqListPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  Hero?: Maybe<ContentModelReference>;
  HeroDisplayMode?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainBody?: Maybe<MixedHtmlModelSearch>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MenuIcon?: Maybe<Scalars['String']['output']>;
  MenuTagLine?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInFooter?: Maybe<Scalars['Bool']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type FaqListPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqListPageModelMainBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqListPageModelMenuIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqListPageModelMenuTagLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqListPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqListPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqListPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqListPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqListPageModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqListPageModelTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqListPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FaqListPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FaqListPageModelAutocomplete = {
  __typename?: 'FaqListPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Hero?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FaqListPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqListPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqListPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqListPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqListPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqListPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqListPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqListPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqListPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqListPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqListPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqListPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FaqListPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FaqListPageModelFacet = {
  __typename?: 'FaqListPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  Hero?: Maybe<ContentModelReferenceFacet>;
  HeroDisplayMode?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainBody?: Maybe<MixedHtmlModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MenuIcon?: Maybe<Array<Maybe<StringFacet>>>;
  MenuTagLine?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInFooter?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type FaqListPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqListPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqListPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetHeroDisplayModeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type FaqListPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetMenuIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetMenuTagLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqListPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqListPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqListPageModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetVisibleInFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FaqListPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FaqListPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  Hero?: InputMaybe<ContentModelReferenceOrderByInput>;
  HeroDisplayMode?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MenuIcon?: InputMaybe<OrderBy>;
  MenuTagLine?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInFooter?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type FaqListPageModelOutput = {
  __typename?: 'FaqListPageModelOutput';
  autocomplete?: Maybe<FaqListPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FaqListPageModelFacet>;
  item?: Maybe<FaqListPageModel>;
  items?: Maybe<Array<Maybe<FaqListPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FaqListPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FaqListPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  Hero?: InputMaybe<ContentModelReferenceWhereInput>;
  HeroDisplayMode?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MenuIcon?: InputMaybe<SearchableStringFilterInput>;
  MenuTagLine?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInFooter?: InputMaybe<BoolFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FaqListPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FaqListPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FaqListPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type FeatureBlockModel = IContent & IData & {
  __typename?: 'FeatureBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackGround?: Maybe<ContentModelReference>;
  Buttons?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ColorTheme?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentTextPosition?: Maybe<Scalars['Int']['output']>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IncludedFeature?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type FeatureBlockModelButtonsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FeatureBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FeatureBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FeatureBlockModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FeatureBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FeatureBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FeatureBlockModelAutocomplete = {
  __typename?: 'FeatureBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackGround?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  IncludedFeature?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FeatureBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FeatureBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FeatureBlockModelAutocompleteIncludedFeatureArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FeatureBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FeatureBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FeatureBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FeatureBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FeatureBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FeatureBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FeatureBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FeatureBlockModelFacet = {
  __typename?: 'FeatureBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackGround?: Maybe<ContentModelReferenceFacet>;
  Buttons?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ColorTheme?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentTextPosition?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IncludedFeature?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type FeatureBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FeatureBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FeatureBlockModelFacetColorThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type FeatureBlockModelFacetContentTextPositionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type FeatureBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FeatureBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FeatureBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FeatureBlockModelFacetIncludedFeatureArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FeatureBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FeatureBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FeatureBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FeatureBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FeatureBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FeatureBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FeatureBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FeatureBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FeatureBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FeatureBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FeatureBlockModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FeatureBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FeatureBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FeatureBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackGround?: InputMaybe<ContentModelReferenceOrderByInput>;
  Buttons?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ColorTheme?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentTextPosition?: InputMaybe<OrderBy>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IncludedFeature?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type FeatureBlockModelOutput = {
  __typename?: 'FeatureBlockModelOutput';
  autocomplete?: Maybe<FeatureBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FeatureBlockModelFacet>;
  item?: Maybe<FeatureBlockModel>;
  items?: Maybe<Array<Maybe<FeatureBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FeatureBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeatureBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackGround?: InputMaybe<ContentModelReferenceWhereInput>;
  Buttons?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ColorTheme?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentTextPosition?: InputMaybe<IntFilterInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IncludedFeature?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FeatureBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FeatureBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FeatureBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type FileUploadElementBlock = IContent & IData & {
  __typename?: 'FileUploadElementBlock';
  AllowMultiple?: Maybe<Scalars['Bool']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['Int']['output']>;
  FileTypes?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type FileUploadElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlockFileTypesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FileUploadElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FileUploadElementBlockAutocomplete = {
  __typename?: 'FileUploadElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FileUploadElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FileUploadElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FileUploadElementBlockFacet = {
  __typename?: 'FileUploadElementBlockFacet';
  AllowMultiple?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<NumberFacet>>>;
  FileTypes?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type FileUploadElementBlockFacetAllowMultipleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FileUploadElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type FileUploadElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FileUploadElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type FileUploadElementBlockFacetFileTypesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FileUploadElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FileUploadElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FileUploadElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FileUploadElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FileUploadElementBlockOrderByInput = {
  AllowMultiple?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  FileTypes?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type FileUploadElementBlockOutput = {
  __typename?: 'FileUploadElementBlockOutput';
  autocomplete?: Maybe<FileUploadElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FileUploadElementBlockFacet>;
  item?: Maybe<FileUploadElementBlock>;
  items?: Maybe<Array<Maybe<FileUploadElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FileUploadElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileUploadElementBlockWhereInput = {
  AllowMultiple?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<IntFilterInput>;
  FileTypes?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FileUploadElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FileUploadElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FileUploadElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type FormContainerBlock = IContent & IData & {
  __typename?: 'FormContainerBlock';
  AllowAnonymousSubmission?: Maybe<Scalars['Bool']['output']>;
  AllowExposingDataFeeds?: Maybe<Scalars['Bool']['output']>;
  AllowMultipleSubmission?: Maybe<Scalars['Bool']['output']>;
  AllowToStoreSubmissionData?: Maybe<Scalars['Bool']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConfirmationMessage?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ElementsArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FinalizedSubmissionRetentionPeriod?: Maybe<Scalars['String']['output']>;
  FocusOnForm?: Maybe<Scalars['Bool']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetadataAttribute?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PartialSubmissionRetentionPeriod?: Maybe<Scalars['String']['output']>;
  RedirectToPage?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  ResetConfirmationMessage?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  ShowNavigationBar?: Maybe<Scalars['Bool']['output']>;
  ShowSummarizedData?: Maybe<Scalars['Bool']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  SubmitSuccessMessage?: Maybe<MixedHtmlModelSearch>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type FormContainerBlockConfirmationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockElementsAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockFinalizedSubmissionRetentionPeriodArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockMetadataAttributeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockPartialSubmissionRetentionPeriodArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockResetConfirmationMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockSubmitSuccessMessageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlockTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormContainerBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FormContainerBlockAutocomplete = {
  __typename?: 'FormContainerBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RedirectToPage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FormContainerBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteRedirectToPageArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormContainerBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormContainerBlockFacet = {
  __typename?: 'FormContainerBlockFacet';
  AllowAnonymousSubmission?: Maybe<Array<Maybe<StringFacet>>>;
  AllowExposingDataFeeds?: Maybe<Array<Maybe<StringFacet>>>;
  AllowMultipleSubmission?: Maybe<Array<Maybe<StringFacet>>>;
  AllowToStoreSubmissionData?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConfirmationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ElementsArea?: Maybe<ContentAreaItemModelSearchFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FinalizedSubmissionRetentionPeriod?: Maybe<Array<Maybe<StringFacet>>>;
  FocusOnForm?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetadataAttribute?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PartialSubmissionRetentionPeriod?: Maybe<Array<Maybe<StringFacet>>>;
  RedirectToPage?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  ResetConfirmationMessage?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowNavigationBar?: Maybe<Array<Maybe<StringFacet>>>;
  ShowSummarizedData?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  SubmitSuccessMessage?: Maybe<MixedHtmlModelSearchFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type FormContainerBlockFacetAllowAnonymousSubmissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetAllowExposingDataFeedsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetAllowMultipleSubmissionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetAllowToStoreSubmissionDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormContainerBlockFacetConfirmationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormContainerBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetFinalizedSubmissionRetentionPeriodArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetFocusOnFormArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetMetadataAttributeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetPartialSubmissionRetentionPeriodArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetRedirectToPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetResetConfirmationMessageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormContainerBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetShowNavigationBarArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetShowSummarizedDataArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormContainerBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormContainerBlockFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormContainerBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormContainerBlockOrderByInput = {
  AllowAnonymousSubmission?: InputMaybe<OrderBy>;
  AllowExposingDataFeeds?: InputMaybe<OrderBy>;
  AllowMultipleSubmission?: InputMaybe<OrderBy>;
  AllowToStoreSubmissionData?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConfirmationMessage?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ElementsArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FinalizedSubmissionRetentionPeriod?: InputMaybe<OrderBy>;
  FocusOnForm?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetadataAttribute?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PartialSubmissionRetentionPeriod?: InputMaybe<OrderBy>;
  RedirectToPage?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  ResetConfirmationMessage?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowNavigationBar?: InputMaybe<OrderBy>;
  ShowSummarizedData?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  SubmitSuccessMessage?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type FormContainerBlockOutput = {
  __typename?: 'FormContainerBlockOutput';
  autocomplete?: Maybe<FormContainerBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FormContainerBlockFacet>;
  item?: Maybe<FormContainerBlock>;
  items?: Maybe<Array<Maybe<FormContainerBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FormContainerBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormContainerBlockWhereInput = {
  AllowAnonymousSubmission?: InputMaybe<BoolFilterInput>;
  AllowExposingDataFeeds?: InputMaybe<BoolFilterInput>;
  AllowMultipleSubmission?: InputMaybe<BoolFilterInput>;
  AllowToStoreSubmissionData?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConfirmationMessage?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ElementsArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FinalizedSubmissionRetentionPeriod?: InputMaybe<SearchableStringFilterInput>;
  FocusOnForm?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetadataAttribute?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PartialSubmissionRetentionPeriod?: InputMaybe<SearchableStringFilterInput>;
  RedirectToPage?: InputMaybe<StringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  ResetConfirmationMessage?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowNavigationBar?: InputMaybe<BoolFilterInput>;
  ShowSummarizedData?: InputMaybe<BoolFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  SubmitSuccessMessage?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FormContainerBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FormContainerBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FormContainerBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type FormStepBlock = IContent & IData & {
  __typename?: 'FormStepBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AttachedContentLink?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DependCondition?: Maybe<Scalars['Int']['output']>;
  DependField?: Maybe<ContentModelReference>;
  DependValue?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type FormStepBlockDependValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormStepBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormStepBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormStepBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormStepBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type FormStepBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type FormStepBlockAutocomplete = {
  __typename?: 'FormStepBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AttachedContentLink?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  DependField?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type FormStepBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteAttachedContentLinkArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type FormStepBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type FormStepBlockFacet = {
  __typename?: 'FormStepBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AttachedContentLink?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DependCondition?: Maybe<Array<Maybe<NumberFacet>>>;
  DependField?: Maybe<ContentModelReferenceFacet>;
  DependValue?: Maybe<Array<Maybe<StringFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type FormStepBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetAttachedContentLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormStepBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormStepBlockFacetDependConditionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type FormStepBlockFacetDependValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormStepBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormStepBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type FormStepBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type FormStepBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type FormStepBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AttachedContentLink?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DependCondition?: InputMaybe<OrderBy>;
  DependField?: InputMaybe<ContentModelReferenceOrderByInput>;
  DependValue?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type FormStepBlockOutput = {
  __typename?: 'FormStepBlockOutput';
  autocomplete?: Maybe<FormStepBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<FormStepBlockFacet>;
  item?: Maybe<FormStepBlock>;
  items?: Maybe<Array<Maybe<FormStepBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type FormStepBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormStepBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AttachedContentLink?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DependCondition?: InputMaybe<IntFilterInput>;
  DependField?: InputMaybe<ContentModelReferenceWhereInput>;
  DependValue?: InputMaybe<SearchableStringFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<FormStepBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<FormStepBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<FormStepBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type HeroBlockModel = IContent & IData & {
  __typename?: 'HeroBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Background?: Maybe<ContentModelReference>;
  Buttons?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ColorTheme?: Maybe<Scalars['Int']['output']>;
  ContentImagePosition?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentTextAlignment?: Maybe<Scalars['Int']['output']>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ContentModelReference>;
  ImageMobile?: Maybe<ContentModelReference>;
  IncludedFeature?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreHeading?: Maybe<Scalars['String']['output']>;
  PreHeadingFont?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  TeaserTextFont?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type HeroBlockModelButtonsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HeroBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HeroBlockModelIncludedFeatureArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HeroBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HeroBlockModelPreHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HeroBlockModelPreHeadingFontArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HeroBlockModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HeroBlockModelTeaserTextFontArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HeroBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type HeroBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type HeroBlockModelAutocomplete = {
  __typename?: 'HeroBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Background?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  ImageMobile?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HeroBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HeroBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HeroBlockModelFacet = {
  __typename?: 'HeroBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Background?: Maybe<ContentModelReferenceFacet>;
  Buttons?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ColorTheme?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentImagePosition?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentTextAlignment?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  ImageMobile?: Maybe<ContentModelReferenceFacet>;
  IncludedFeature?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PreHeadingFont?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  TeaserTextFont?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HeroBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroBlockModelFacetColorThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HeroBlockModelFacetContentImagePositionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HeroBlockModelFacetContentTextAlignmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type HeroBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetIncludedFeatureArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetPreHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetPreHeadingFontArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type HeroBlockModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetTeaserTextFontArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HeroBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HeroBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Background?: InputMaybe<ContentModelReferenceOrderByInput>;
  Buttons?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ColorTheme?: InputMaybe<OrderBy>;
  ContentImagePosition?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentTextAlignment?: InputMaybe<OrderBy>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageMobile?: InputMaybe<ContentModelReferenceOrderByInput>;
  IncludedFeature?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreHeading?: InputMaybe<OrderBy>;
  PreHeadingFont?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  TeaserTextFont?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type HeroBlockModelOutput = {
  __typename?: 'HeroBlockModelOutput';
  autocomplete?: Maybe<HeroBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<HeroBlockModelFacet>;
  item?: Maybe<HeroBlockModel>;
  items?: Maybe<Array<Maybe<HeroBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type HeroBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Background?: InputMaybe<ContentModelReferenceWhereInput>;
  Buttons?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ColorTheme?: InputMaybe<IntFilterInput>;
  ContentImagePosition?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentTextAlignment?: InputMaybe<IntFilterInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageMobile?: InputMaybe<ContentModelReferenceWhereInput>;
  IncludedFeature?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreHeading?: InputMaybe<SearchableStringFilterInput>;
  PreHeadingFont?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  TeaserTextFont?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<HeroBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<HeroBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<HeroBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

/** Options for highlighting */
export type HighlightOptions = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endToken?: InputMaybe<Scalars['String']['input']>;
  startToken?: InputMaybe<Scalars['String']['input']>;
};

export type HostDefinitionModel = {
  __typename?: 'HostDefinitionModel';
  Language?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

export type HostDefinitionModelAutocomplete = {
  __typename?: 'HostDefinitionModelAutocomplete';
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Type?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type HostDefinitionModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type HostDefinitionModelAutocompleteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type HostDefinitionModelFacet = {
  __typename?: 'HostDefinitionModelFacet';
  Language?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Type?: Maybe<Array<Maybe<StringFacet>>>;
};


export type HostDefinitionModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type HostDefinitionModelFacetTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type HostDefinitionModelOrderByInput = {
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  Type?: InputMaybe<OrderBy>;
};

export type HostDefinitionModelWhereInput = {
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<StringFilterInput>;
  Type?: InputMaybe<StringFilterInput>;
};

export type IContent = {
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type IContentNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IContent_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IContent_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IData = {
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type IData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IFramePageModel = IContent & IData & {
  __typename?: 'IFramePageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  IFrameSource?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MenuIcon?: Maybe<Scalars['String']['output']>;
  MenuTagLine?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInFooter?: Maybe<Scalars['Bool']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type IFramePageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IFramePageModelIFrameSourceArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IFramePageModelMenuIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IFramePageModelMenuTagLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IFramePageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IFramePageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IFramePageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IFramePageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IFramePageModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IFramePageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type IFramePageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type IFramePageModelAutocomplete = {
  __typename?: 'IFramePageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type IFramePageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IFramePageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IFramePageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IFramePageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IFramePageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IFramePageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IFramePageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IFramePageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IFramePageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IFramePageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IFramePageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IFramePageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type IFramePageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type IFramePageModelFacet = {
  __typename?: 'IFramePageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IFrameSource?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MenuIcon?: Maybe<Array<Maybe<StringFacet>>>;
  MenuTagLine?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInFooter?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type IFramePageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IFramePageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IFramePageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetIFrameSourceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetMenuIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetMenuTagLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IFramePageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IFramePageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type IFramePageModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetVisibleInFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type IFramePageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type IFramePageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IFrameSource?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MenuIcon?: InputMaybe<OrderBy>;
  MenuTagLine?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInFooter?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type IFramePageModelOutput = {
  __typename?: 'IFramePageModelOutput';
  autocomplete?: Maybe<IFramePageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<IFramePageModelFacet>;
  item?: Maybe<IFramePageModel>;
  items?: Maybe<Array<Maybe<IFramePageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type IFramePageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IFramePageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IFrameSource?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MenuIcon?: InputMaybe<SearchableStringFilterInput>;
  MenuTagLine?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInFooter?: InputMaybe<BoolFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<IFramePageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<IFramePageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<IFramePageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type ImageAndTextBlockModel = IContent & IData & {
  __typename?: 'ImageAndTextBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ImageBlock?: Maybe<ImageAndTextBlockModelImageBlockModel>;
  ImageWidth?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceImageRight?: Maybe<Scalars['Bool']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TextBlock?: Maybe<ImageAndTextBlockModelTextBlockModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ImageAndTextBlockModelImageWidthArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageAndTextBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageAndTextBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageAndTextBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageAndTextBlockModelAutocomplete = {
  __typename?: 'ImageAndTextBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ImageBlock?: Maybe<ImageAndTextBlockModelImageBlockModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TextBlock?: Maybe<ImageAndTextBlockModelTextBlockModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageAndTextBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAndTextBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAndTextBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAndTextBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAndTextBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAndTextBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAndTextBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAndTextBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageAndTextBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageAndTextBlockModelFacet = {
  __typename?: 'ImageAndTextBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageBlock?: Maybe<ImageAndTextBlockModelImageBlockModelFacet>;
  ImageWidth?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceImageRight?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TextBlock?: Maybe<ImageAndTextBlockModelTextBlockModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageAndTextBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAndTextBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAndTextBlockModelFacetImageWidthArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelFacetPlaceImageRightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAndTextBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAndTextBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageAndTextBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageAndTextBlockModelImageBlockModel = {
  __typename?: 'ImageAndTextBlockModelImageBlockModel';
  DecorativeImage?: Maybe<Scalars['Bool']['output']>;
  FixImageHeight?: Maybe<Scalars['Bool']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HeadingLevel?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModel>;
  TopAlignContent?: Maybe<Scalars['Bool']['output']>;
};


export type ImageAndTextBlockModelImageBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageAndTextBlockModelImageBlockModelHeadingLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageAndTextBlockModelImageBlockModelAutocomplete = {
  __typename?: 'ImageAndTextBlockModelImageBlockModelAutocomplete';
  Image?: Maybe<ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModelAutocomplete>;
};

export type ImageAndTextBlockModelImageBlockModelFacet = {
  __typename?: 'ImageAndTextBlockModelImageBlockModelFacet';
  DecorativeImage?: Maybe<Array<Maybe<StringFacet>>>;
  FixImageHeight?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingLevel?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModelFacet>;
  TopAlignContent?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageAndTextBlockModelImageBlockModelFacetDecorativeImageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelImageBlockModelFacetFixImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelImageBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelImageBlockModelFacetHeadingLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelImageBlockModelFacetTopAlignContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageAndTextBlockModelImageBlockModelOrderByInput = {
  DecorativeImage?: InputMaybe<OrderBy>;
  FixImageHeight?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HeadingLevel?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModelOrderByInput>;
  TopAlignContent?: InputMaybe<OrderBy>;
};

export type ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModel = {
  __typename?: 'ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModel';
  Alt?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  SmallDeviceImageReference?: Maybe<ContentModelReference>;
};


export type ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModelAltArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModelAutocomplete = {
  __typename?: 'ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModelAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  SmallDeviceImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModelFacet = {
  __typename?: 'ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModelFacet';
  Alt?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  SmallDeviceImageReference?: Maybe<ContentModelReferenceFacet>;
};


export type ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModelFacetAltArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModelOrderByInput = {
  Alt?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  SmallDeviceImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModelWhereInput = {
  Alt?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  SmallDeviceImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type ImageAndTextBlockModelImageBlockModelWhereInput = {
  DecorativeImage?: InputMaybe<BoolFilterInput>;
  FixImageHeight?: InputMaybe<BoolFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HeadingLevel?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ImageAndTextBlockModelImageBlockModelResponsiveImageBlockModelWhereInput>;
  TopAlignContent?: InputMaybe<BoolFilterInput>;
};

export type ImageAndTextBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageBlock?: InputMaybe<ImageAndTextBlockModelImageBlockModelOrderByInput>;
  ImageWidth?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceImageRight?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TextBlock?: InputMaybe<ImageAndTextBlockModelTextBlockModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ImageAndTextBlockModelOutput = {
  __typename?: 'ImageAndTextBlockModelOutput';
  autocomplete?: Maybe<ImageAndTextBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageAndTextBlockModelFacet>;
  item?: Maybe<ImageAndTextBlockModel>;
  items?: Maybe<Array<Maybe<ImageAndTextBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ImageAndTextBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageAndTextBlockModelTextBlockModel = {
  __typename?: 'ImageAndTextBlockModelTextBlockModel';
  Body?: Maybe<MixedHtmlModelSearch>;
  Button?: Maybe<ImageAndTextBlockModelTextBlockModelButtonLinkBlockModel>;
  Heading?: Maybe<Scalars['String']['output']>;
  HeadingLevel?: Maybe<Scalars['String']['output']>;
  TopAlignContent?: Maybe<Scalars['Bool']['output']>;
};


export type ImageAndTextBlockModelTextBlockModelBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageAndTextBlockModelTextBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageAndTextBlockModelTextBlockModelAutocomplete = {
  __typename?: 'ImageAndTextBlockModelTextBlockModelAutocomplete';
  Button?: Maybe<ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelAutocomplete>;
  HeadingLevel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageAndTextBlockModelTextBlockModelAutocompleteHeadingLevelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModel = {
  __typename?: 'ImageAndTextBlockModelTextBlockModelButtonLinkBlockModel';
  ButtonClass?: Maybe<Scalars['Int']['output']>;
  DocumentLink?: Maybe<ContentModelReference>;
  ExternalLink?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<ContentModelReference>;
  LinkText?: Maybe<Scalars['String']['output']>;
  PopupContent?: Maybe<MixedHtmlModelSearch>;
  Title?: Maybe<Scalars['String']['output']>;
  VideoUrl?: Maybe<Scalars['String']['output']>;
};


export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelExternalLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelPopupContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelVideoUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelAutocomplete = {
  __typename?: 'ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelAutocomplete';
  DocumentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Link?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelFacet = {
  __typename?: 'ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelFacet';
  ButtonClass?: Maybe<Array<Maybe<NumberFacet>>>;
  DocumentLink?: Maybe<ContentModelReferenceFacet>;
  ExternalLink?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<ContentModelReferenceFacet>;
  LinkText?: Maybe<Array<Maybe<StringFacet>>>;
  PopupContent?: Maybe<MixedHtmlModelSearchFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  VideoUrl?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelFacetButtonClassArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelFacetExternalLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelFacetLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelFacetVideoUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelOrderByInput = {
  ButtonClass?: InputMaybe<OrderBy>;
  DocumentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExternalLink?: InputMaybe<OrderBy>;
  Link?: InputMaybe<ContentModelReferenceOrderByInput>;
  LinkText?: InputMaybe<OrderBy>;
  PopupContent?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  VideoUrl?: InputMaybe<OrderBy>;
};

export type ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelWhereInput = {
  ButtonClass?: InputMaybe<IntFilterInput>;
  DocumentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ExternalLink?: InputMaybe<SearchableStringFilterInput>;
  Link?: InputMaybe<ContentModelReferenceWhereInput>;
  LinkText?: InputMaybe<SearchableStringFilterInput>;
  PopupContent?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  VideoUrl?: InputMaybe<SearchableStringFilterInput>;
};

export type ImageAndTextBlockModelTextBlockModelFacet = {
  __typename?: 'ImageAndTextBlockModelTextBlockModelFacet';
  Body?: Maybe<MixedHtmlModelSearchFacet>;
  Button?: Maybe<ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingLevel?: Maybe<Array<Maybe<StringFacet>>>;
  TopAlignContent?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageAndTextBlockModelTextBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelTextBlockModelFacetHeadingLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageAndTextBlockModelTextBlockModelFacetTopAlignContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageAndTextBlockModelTextBlockModelOrderByInput = {
  Body?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Button?: InputMaybe<ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  HeadingLevel?: InputMaybe<OrderBy>;
  TopAlignContent?: InputMaybe<OrderBy>;
};

export type ImageAndTextBlockModelTextBlockModelWhereInput = {
  Body?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Button?: InputMaybe<ImageAndTextBlockModelTextBlockModelButtonLinkBlockModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HeadingLevel?: InputMaybe<StringFilterInput>;
  TopAlignContent?: InputMaybe<BoolFilterInput>;
};

export type ImageAndTextBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageBlock?: InputMaybe<ImageAndTextBlockModelImageBlockModelWhereInput>;
  ImageWidth?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceImageRight?: InputMaybe<BoolFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TextBlock?: InputMaybe<ImageAndTextBlockModelTextBlockModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageAndTextBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageAndTextBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageAndTextBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type ImageBlockModel = IContent & IData & {
  __typename?: 'ImageBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DecorativeImage?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FixImageHeight?: Maybe<Scalars['Bool']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HeadingLevel?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ImageBlockModelResponsiveImageBlockModel>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TopAlignContent?: Maybe<Scalars['Bool']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ImageBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageBlockModelHeadingLevelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageBlockModelAutocomplete = {
  __typename?: 'ImageBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ImageBlockModelResponsiveImageBlockModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageBlockModelFacet = {
  __typename?: 'ImageBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DecorativeImage?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FixImageHeight?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingLevel?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ImageBlockModelResponsiveImageBlockModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TopAlignContent?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageBlockModelFacetDecorativeImageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetFixImageHeightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetHeadingLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageBlockModelFacetTopAlignContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DecorativeImage?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FixImageHeight?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HeadingLevel?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ImageBlockModelResponsiveImageBlockModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TopAlignContent?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ImageBlockModelOutput = {
  __typename?: 'ImageBlockModelOutput';
  autocomplete?: Maybe<ImageBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageBlockModelFacet>;
  item?: Maybe<ImageBlockModel>;
  items?: Maybe<Array<Maybe<ImageBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ImageBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageBlockModelResponsiveImageBlockModel = {
  __typename?: 'ImageBlockModelResponsiveImageBlockModel';
  Alt?: Maybe<Scalars['String']['output']>;
  ImageReference?: Maybe<ContentModelReference>;
  SmallDeviceImageReference?: Maybe<ContentModelReference>;
};


export type ImageBlockModelResponsiveImageBlockModelAltArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type ImageBlockModelResponsiveImageBlockModelAutocomplete = {
  __typename?: 'ImageBlockModelResponsiveImageBlockModelAutocomplete';
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  SmallDeviceImageReference?: Maybe<ContentModelReferenceAutocomplete>;
};

export type ImageBlockModelResponsiveImageBlockModelFacet = {
  __typename?: 'ImageBlockModelResponsiveImageBlockModelFacet';
  Alt?: Maybe<Array<Maybe<StringFacet>>>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  SmallDeviceImageReference?: Maybe<ContentModelReferenceFacet>;
};


export type ImageBlockModelResponsiveImageBlockModelFacetAltArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageBlockModelResponsiveImageBlockModelOrderByInput = {
  Alt?: InputMaybe<OrderBy>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  SmallDeviceImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type ImageBlockModelResponsiveImageBlockModelWhereInput = {
  Alt?: InputMaybe<SearchableStringFilterInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  SmallDeviceImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type ImageBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DecorativeImage?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FixImageHeight?: InputMaybe<BoolFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HeadingLevel?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ImageBlockModelResponsiveImageBlockModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TopAlignContent?: InputMaybe<BoolFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type ImageChoiceElementBlock = IContent & IData & {
  __typename?: 'ImageChoiceElementBlock';
  AllowMultiSelect?: Maybe<Scalars['Bool']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Items?: Maybe<Array<Maybe<LinkItemNode>>>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  ShowSelectionInputControl?: Maybe<Scalars['Bool']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ImageChoiceElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageChoiceElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageChoiceElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageChoiceElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageChoiceElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageChoiceElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ImageChoiceElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ImageChoiceElementBlockAutocomplete = {
  __typename?: 'ImageChoiceElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Items?: Maybe<LinkItemNodeAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ImageChoiceElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ImageChoiceElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ImageChoiceElementBlockFacet = {
  __typename?: 'ImageChoiceElementBlockFacet';
  AllowMultiSelect?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Items?: Maybe<LinkItemNodeFacet>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowSelectionInputControl?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ImageChoiceElementBlockFacetAllowMultiSelectArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageChoiceElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ImageChoiceElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageChoiceElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageChoiceElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetShowSelectionInputControlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageChoiceElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageChoiceElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ImageChoiceElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ImageChoiceElementBlockOrderByInput = {
  AllowMultiSelect?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Items?: InputMaybe<LinkItemNodeOrderByInput>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowSelectionInputControl?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ImageChoiceElementBlockOutput = {
  __typename?: 'ImageChoiceElementBlockOutput';
  autocomplete?: Maybe<ImageChoiceElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ImageChoiceElementBlockFacet>;
  item?: Maybe<ImageChoiceElementBlock>;
  items?: Maybe<Array<Maybe<ImageChoiceElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ImageChoiceElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageChoiceElementBlockWhereInput = {
  AllowMultiSelect?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Items?: InputMaybe<LinkItemNodeWhereInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowSelectionInputControl?: InputMaybe<BoolFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ImageChoiceElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ImageChoiceElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ImageChoiceElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type InlineBlockPropertyModelSearch = {
  __typename?: 'InlineBlockPropertyModelSearch';
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type InlineBlockPropertyModelSearchContentTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type InlineBlockPropertyModelSearchFacet = {
  __typename?: 'InlineBlockPropertyModelSearchFacet';
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type InlineBlockPropertyModelSearchFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type InlineBlockPropertyModelSearchOrderByInput = {
  ContentType?: InputMaybe<OrderBy>;
};

export type InlineBlockPropertyModelSearchWhereInput = {
  ContentType?: InputMaybe<SearchableStringFilterInput>;
};

export type IntFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** `Factor` allows you to use a number value in a field to influence the `_score` directly. If used on a multi-valued field, then only the lowest value of the field is used in calculations. Default for `value` is `1`. Default for `modifier` is `NONE`. */
  factor?: InputMaybe<NumberFactor>;
  /** `gt` retrieves results with matches that have a value which is `greater than` it. */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** `gte` retrieves results with matches that have a value which is `greater than or equal to` it. */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** `lt` retrieves results with matches that have a value which is `lower than` it. */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** `lte` retrieves results with matches that have a value which is `lower than or equal to` it. */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['Int']['input']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type LinkConfig = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type LinkItemNode = {
  __typename?: 'LinkItemNode';
  ContentLink?: Maybe<ContentModelReference>;
  Href?: Maybe<Scalars['String']['output']>;
  Target?: Maybe<Scalars['String']['output']>;
  Text?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type LinkItemNodeAutocomplete = {
  __typename?: 'LinkItemNodeAutocomplete';
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Href?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Target?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Text?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Title?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type LinkItemNodeAutocompleteHrefArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkItemNodeAutocompleteTargetArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkItemNodeAutocompleteTextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type LinkItemNodeAutocompleteTitleArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type LinkItemNodeFacet = {
  __typename?: 'LinkItemNodeFacet';
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  Href?: Maybe<Array<Maybe<StringFacet>>>;
  Target?: Maybe<Array<Maybe<StringFacet>>>;
  Text?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
};


export type LinkItemNodeFacetHrefArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkItemNodeFacetTargetArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkItemNodeFacetTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type LinkItemNodeFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type LinkItemNodeOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Href?: InputMaybe<OrderBy>;
  Target?: InputMaybe<OrderBy>;
  Text?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
};

export type LinkItemNodeWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Href?: InputMaybe<StringFilterInput>;
  Target?: InputMaybe<StringFilterInput>;
  Text?: InputMaybe<StringFilterInput>;
  Title?: InputMaybe<StringFilterInput>;
};

export enum LinkTypes {
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `Ancestors` |
   * | *to*        |        | `ContentLink.GuidValue`   |
   */
  Ancestors = 'ANCESTORS',
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `ContentLink.GuidValue` |
   * | *to*        |        | `ParentLink.GuidValue`   |
   */
  Children = 'CHILDREN',
  /**
   *
   * | *Direction* | &nbsp; | *Field*     |
   * | ----------: | ------ | :---------- |
   * | *from*      |        | `ContentLink.GuidValue` |
   * | *to*        |        | `ParentLink.GuidValue`   |
   */
  Default = 'DEFAULT'
}

export enum Locales {
  All = 'ALL',
  Neutral = 'NEUTRAL',
  En = 'en',
  Sv = 'sv'
}

export type MainImageBlockModel = IContent & IData & {
  __typename?: 'MainImageBlockModel';
  Alt?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ImageReference?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type MainImageBlockModelAltArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainImageBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainImageBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainImageBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MainImageBlockModelAutocomplete = {
  __typename?: 'MainImageBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MainImageBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainImageBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainImageBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainImageBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainImageBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainImageBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainImageBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainImageBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainImageBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MainImageBlockModelFacet = {
  __typename?: 'MainImageBlockModelFacet';
  Alt?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MainImageBlockModelFacetAltArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainImageBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainImageBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MainImageBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainImageBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MainImageBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainImageBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainImageBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainImageBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainImageBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MainImageBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainImageBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainImageBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MainImageBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainImageBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MainImageBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainImageBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MainImageBlockModelOrderByInput = {
  Alt?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type MainImageBlockModelOutput = {
  __typename?: 'MainImageBlockModelOutput';
  autocomplete?: Maybe<MainImageBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MainImageBlockModelFacet>;
  item?: Maybe<MainImageBlockModel>;
  items?: Maybe<Array<Maybe<MainImageBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MainImageBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MainImageBlockModelWhereInput = {
  Alt?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MainImageBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MainImageBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MainImageBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type MainMenuPageModel = IContent & IData & {
  __typename?: 'MainMenuPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  Hero?: Maybe<ContentModelReference>;
  HeroDisplayMode?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinksContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  LinksContentAreaColorTheme?: Maybe<Scalars['Int']['output']>;
  MainBody?: Maybe<MixedHtmlModelSearch>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MainContentAreaDisplayMode?: Maybe<Scalars['Int']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MegaMenuTeaser?: Maybe<ContentModelReference>;
  MenuIcon?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInFooter?: Maybe<Scalars['Bool']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type MainMenuPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainMenuPageModelLinksContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainMenuPageModelMainBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainMenuPageModelMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainMenuPageModelMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainMenuPageModelMenuIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainMenuPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainMenuPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainMenuPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainMenuPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainMenuPageModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainMenuPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MainMenuPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MainMenuPageModelAutocomplete = {
  __typename?: 'MainMenuPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Hero?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MegaMenuTeaser?: Maybe<ContentModelReferenceAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MainMenuPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainMenuPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainMenuPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainMenuPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainMenuPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainMenuPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainMenuPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainMenuPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainMenuPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainMenuPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainMenuPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainMenuPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MainMenuPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MainMenuPageModelFacet = {
  __typename?: 'MainMenuPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  Hero?: Maybe<ContentModelReferenceFacet>;
  HeroDisplayMode?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinksContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  LinksContentAreaColorTheme?: Maybe<Array<Maybe<NumberFacet>>>;
  MainBody?: Maybe<MixedHtmlModelSearchFacet>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MainContentAreaDisplayMode?: Maybe<Array<Maybe<NumberFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MegaMenuTeaser?: Maybe<ContentModelReferenceFacet>;
  MenuIcon?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInFooter?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MainMenuPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MainMenuPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MainMenuPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetHeroDisplayModeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MainMenuPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetLinksContentAreaColorThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MainMenuPageModelFacetMainContentAreaDisplayModeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type MainMenuPageModelFacetMenuIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MainMenuPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MainMenuPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MainMenuPageModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetVisibleInFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MainMenuPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MainMenuPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  Hero?: InputMaybe<ContentModelReferenceOrderByInput>;
  HeroDisplayMode?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinksContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  LinksContentAreaColorTheme?: InputMaybe<OrderBy>;
  MainBody?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MainContentAreaDisplayMode?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MegaMenuTeaser?: InputMaybe<ContentModelReferenceOrderByInput>;
  MenuIcon?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInFooter?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type MainMenuPageModelOutput = {
  __typename?: 'MainMenuPageModelOutput';
  autocomplete?: Maybe<MainMenuPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MainMenuPageModelFacet>;
  item?: Maybe<MainMenuPageModel>;
  items?: Maybe<Array<Maybe<MainMenuPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MainMenuPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MainMenuPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  Hero?: InputMaybe<ContentModelReferenceWhereInput>;
  HeroDisplayMode?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinksContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  LinksContentAreaColorTheme?: InputMaybe<IntFilterInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MainContentAreaDisplayMode?: InputMaybe<IntFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MegaMenuTeaser?: InputMaybe<ContentModelReferenceWhereInput>;
  MenuIcon?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInFooter?: InputMaybe<BoolFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MainMenuPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MainMenuPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MainMenuPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type MixedHtmlModel = {
  __typename?: 'MixedHtmlModel';
  Html?: Maybe<Scalars['String']['output']>;
  Structure?: Maybe<Scalars['String']['output']>;
};

export type MixedHtmlModelAutocomplete = {
  __typename?: 'MixedHtmlModelAutocomplete';
  Html?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Structure?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MixedHtmlModelAutocompleteHtmlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MixedHtmlModelAutocompleteStructureArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MixedHtmlModelFacet = {
  __typename?: 'MixedHtmlModelFacet';
  Html?: Maybe<Array<Maybe<StringFacet>>>;
  Structure?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MixedHtmlModelFacetHtmlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MixedHtmlModelFacetStructureArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MixedHtmlModelOrderByInput = {
  Html?: InputMaybe<OrderBy>;
  Structure?: InputMaybe<OrderBy>;
};

export type MixedHtmlModelSearch = {
  __typename?: 'MixedHtmlModelSearch';
  Html?: Maybe<Scalars['String']['output']>;
  Structure?: Maybe<Scalars['String']['output']>;
};


export type MixedHtmlModelSearchHtmlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MixedHtmlModelSearchStructureArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type MixedHtmlModelSearchFacet = {
  __typename?: 'MixedHtmlModelSearchFacet';
  Html?: Maybe<Array<Maybe<StringFacet>>>;
  Structure?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MixedHtmlModelSearchFacetHtmlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MixedHtmlModelSearchFacetStructureArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MixedHtmlModelSearchOrderByInput = {
  Html?: InputMaybe<OrderBy>;
  Structure?: InputMaybe<OrderBy>;
};

export type MixedHtmlModelSearchWhereInput = {
  Html?: InputMaybe<SearchableStringFilterInput>;
  Structure?: InputMaybe<SearchableStringFilterInput>;
};

export type MixedHtmlModelWhereInput = {
  Html?: InputMaybe<StringFilterInput>;
  Structure?: InputMaybe<StringFilterInput>;
};

export type MyPagesAdminPageModel = IContent & IData & {
  __typename?: 'MyPagesAdminPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type MyPagesAdminPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesAdminPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesAdminPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesAdminPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesAdminPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesAdminPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesAdminPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MyPagesAdminPageModelAutocomplete = {
  __typename?: 'MyPagesAdminPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MyPagesAdminPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesAdminPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesAdminPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesAdminPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesAdminPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesAdminPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesAdminPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesAdminPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesAdminPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesAdminPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesAdminPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesAdminPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesAdminPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MyPagesAdminPageModelFacet = {
  __typename?: 'MyPagesAdminPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MyPagesAdminPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesAdminPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesAdminPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesAdminPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesAdminPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesAdminPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesAdminPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MyPagesAdminPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type MyPagesAdminPageModelOutput = {
  __typename?: 'MyPagesAdminPageModelOutput';
  autocomplete?: Maybe<MyPagesAdminPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MyPagesAdminPageModelFacet>;
  item?: Maybe<MyPagesAdminPageModel>;
  items?: Maybe<Array<Maybe<MyPagesAdminPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MyPagesAdminPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MyPagesAdminPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MyPagesAdminPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MyPagesAdminPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MyPagesAdminPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type MyPagesBlockModel = IContent & IData & {
  __typename?: 'MyPagesBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Component?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  CustomTermsAndConditions?: Maybe<MixedHtmlModelSearch>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Extra1?: Maybe<MixedHtmlModelSearch>;
  Extra2?: Maybe<MixedHtmlModelSearch>;
  Extra3?: Maybe<MixedHtmlModelSearch>;
  Extra4?: Maybe<MixedHtmlModelSearch>;
  Extra5?: Maybe<MixedHtmlModelSearch>;
  GeneralTabHeading?: Maybe<Scalars['String']['output']>;
  GeneralTabText?: Maybe<Scalars['String']['output']>;
  Heading?: Maybe<Scalars['String']['output']>;
  HelpText?: Maybe<MixedHtmlModelSearch>;
  IncludedFeature?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  UseGeneralTab?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type MyPagesBlockModelComponentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModelCustomTermsAndConditionsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModelExtra1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModelExtra2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModelExtra3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModelExtra4Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModelExtra5Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModelGeneralTabHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModelGeneralTabTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModelHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModelIncludedFeatureArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MyPagesBlockModelAutocomplete = {
  __typename?: 'MyPagesBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MyPagesBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MyPagesBlockModelFacet = {
  __typename?: 'MyPagesBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Component?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CustomTermsAndConditions?: Maybe<MixedHtmlModelSearchFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Extra1?: Maybe<MixedHtmlModelSearchFacet>;
  Extra2?: Maybe<MixedHtmlModelSearchFacet>;
  Extra3?: Maybe<MixedHtmlModelSearchFacet>;
  Extra4?: Maybe<MixedHtmlModelSearchFacet>;
  Extra5?: Maybe<MixedHtmlModelSearchFacet>;
  GeneralTabHeading?: Maybe<Array<Maybe<StringFacet>>>;
  GeneralTabText?: Maybe<Array<Maybe<StringFacet>>>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HelpText?: Maybe<MixedHtmlModelSearchFacet>;
  IncludedFeature?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UseGeneralTab?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MyPagesBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesBlockModelFacetComponentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesBlockModelFacetGeneralTabHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetGeneralTabTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetIncludedFeatureArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesBlockModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacetUseGeneralTabArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MyPagesBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Component?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CustomTermsAndConditions?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Extra1?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Extra2?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Extra3?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Extra4?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Extra5?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  GeneralTabHeading?: InputMaybe<OrderBy>;
  GeneralTabText?: InputMaybe<OrderBy>;
  Heading?: InputMaybe<OrderBy>;
  HelpText?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  IncludedFeature?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UseGeneralTab?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type MyPagesBlockModelOutput = {
  __typename?: 'MyPagesBlockModelOutput';
  autocomplete?: Maybe<MyPagesBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MyPagesBlockModelFacet>;
  item?: Maybe<MyPagesBlockModel>;
  items?: Maybe<Array<Maybe<MyPagesBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MyPagesBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MyPagesBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Component?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CustomTermsAndConditions?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Extra1?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Extra2?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Extra3?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Extra4?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Extra5?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  GeneralTabHeading?: InputMaybe<SearchableStringFilterInput>;
  GeneralTabText?: InputMaybe<SearchableStringFilterInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HelpText?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  IncludedFeature?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UseGeneralTab?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MyPagesBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MyPagesBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MyPagesBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type MyPagesContainerPageModel = IContent & IData & {
  __typename?: 'MyPagesContainerPageModel';
  AddConfirmDialog?: Maybe<MixedHtmlModelSearch>;
  AddCustomerDialogHeader?: Maybe<Scalars['String']['output']>;
  AddCustomerDialogText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConnectContent?: Maybe<MixedHtmlModelSearch>;
  ConnectFooter?: Maybe<MixedHtmlModelSearch>;
  ConnectHeader?: Maybe<Scalars['String']['output']>;
  ConnectLinksContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MenuIcon?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PopUpContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type MyPagesContainerPageModelAddConfirmDialogArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelAddCustomerDialogHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelAddCustomerDialogTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelConnectContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelConnectFooterArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelConnectHeaderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelConnectLinksContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelMenuIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelPopUpContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesContainerPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MyPagesContainerPageModelAutocomplete = {
  __typename?: 'MyPagesContainerPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MyPagesContainerPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesContainerPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesContainerPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesContainerPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesContainerPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesContainerPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesContainerPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesContainerPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesContainerPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesContainerPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesContainerPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesContainerPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesContainerPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MyPagesContainerPageModelFacet = {
  __typename?: 'MyPagesContainerPageModelFacet';
  AddConfirmDialog?: Maybe<MixedHtmlModelSearchFacet>;
  AddCustomerDialogHeader?: Maybe<Array<Maybe<StringFacet>>>;
  AddCustomerDialogText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConnectContent?: Maybe<MixedHtmlModelSearchFacet>;
  ConnectFooter?: Maybe<MixedHtmlModelSearchFacet>;
  ConnectHeader?: Maybe<Array<Maybe<StringFacet>>>;
  ConnectLinksContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MenuIcon?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PopUpContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MyPagesContainerPageModelFacetAddCustomerDialogHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetAddCustomerDialogTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesContainerPageModelFacetConnectHeaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesContainerPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetMenuIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesContainerPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesContainerPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesContainerPageModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesContainerPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MyPagesContainerPageModelOrderByInput = {
  AddConfirmDialog?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  AddCustomerDialogHeader?: InputMaybe<OrderBy>;
  AddCustomerDialogText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConnectContent?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  ConnectFooter?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  ConnectHeader?: InputMaybe<OrderBy>;
  ConnectLinksContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MenuIcon?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PopUpContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type MyPagesContainerPageModelOutput = {
  __typename?: 'MyPagesContainerPageModelOutput';
  autocomplete?: Maybe<MyPagesContainerPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MyPagesContainerPageModelFacet>;
  item?: Maybe<MyPagesContainerPageModel>;
  items?: Maybe<Array<Maybe<MyPagesContainerPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MyPagesContainerPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MyPagesContainerPageModelWhereInput = {
  AddConfirmDialog?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  AddCustomerDialogHeader?: InputMaybe<SearchableStringFilterInput>;
  AddCustomerDialogText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConnectContent?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  ConnectFooter?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  ConnectHeader?: InputMaybe<SearchableStringFilterInput>;
  ConnectLinksContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MenuIcon?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PopUpContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MyPagesContainerPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MyPagesContainerPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MyPagesContainerPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type MyPagesPageModel = IContent & IData & {
  __typename?: 'MyPagesPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  GeneralTabCheck?: Maybe<Scalars['Bool']['output']>;
  GeneralTabHeading?: Maybe<Scalars['String']['output']>;
  GeneralTabText?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  IncludedFeature?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainBody?: Maybe<MixedHtmlModelSearch>;
  MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MenuIcon?: Maybe<Scalars['String']['output']>;
  MenuTagLine?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RequiredUserRole?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type MyPagesPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModelIncludedFeatureArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModelMainBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModelMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModelMenuIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModelMenuTagLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModelRequiredUserRoleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModelTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MyPagesPageModelAutocomplete = {
  __typename?: 'MyPagesPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  GeneralTabHeading?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  GeneralTabText?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MyPagesPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocompleteGeneralTabHeadingArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocompleteGeneralTabTextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MyPagesPageModelFacet = {
  __typename?: 'MyPagesPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  GeneralTabCheck?: Maybe<Array<Maybe<StringFacet>>>;
  GeneralTabHeading?: Maybe<Array<Maybe<StringFacet>>>;
  GeneralTabText?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IncludedFeature?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainBody?: Maybe<MixedHtmlModelSearchFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MenuIcon?: Maybe<Array<Maybe<StringFacet>>>;
  MenuTagLine?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RequiredUserRole?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MyPagesPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetGeneralTabCheckArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetGeneralTabHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetGeneralTabTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetIncludedFeatureArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetMenuIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetMenuTagLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetRequiredUserRoleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesPageModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MyPagesPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  GeneralTabCheck?: InputMaybe<OrderBy>;
  GeneralTabHeading?: InputMaybe<OrderBy>;
  GeneralTabText?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IncludedFeature?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MenuIcon?: InputMaybe<OrderBy>;
  MenuTagLine?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RequiredUserRole?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type MyPagesPageModelOutput = {
  __typename?: 'MyPagesPageModelOutput';
  autocomplete?: Maybe<MyPagesPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MyPagesPageModelFacet>;
  item?: Maybe<MyPagesPageModel>;
  items?: Maybe<Array<Maybe<MyPagesPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MyPagesPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MyPagesPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  GeneralTabCheck?: InputMaybe<BoolFilterInput>;
  GeneralTabHeading?: InputMaybe<StringFilterInput>;
  GeneralTabText?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IncludedFeature?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MenuIcon?: InputMaybe<SearchableStringFilterInput>;
  MenuTagLine?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RequiredUserRole?: InputMaybe<SearchableStringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MyPagesPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MyPagesPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MyPagesPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type MyPagesStartPageModel = IContent & IData & {
  __typename?: 'MyPagesStartPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  CustomerType?: Maybe<Scalars['String']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinksContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MainBody?: Maybe<MixedHtmlModelSearch>;
  MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MenuIcon?: Maybe<Scalars['String']['output']>;
  MenuName?: Maybe<Scalars['String']['output']>;
  MenuTagLine?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NewsContainer?: Maybe<ContentModelReference>;
  OngoingRegistrationHeader1?: Maybe<Scalars['String']['output']>;
  OngoingRegistrationHeader2?: Maybe<Scalars['String']['output']>;
  OngoingRegistrationHeader3?: Maybe<Scalars['String']['output']>;
  OngoingRegistrationHeader4?: Maybe<Scalars['String']['output']>;
  OngoingRegistrationHeader5?: Maybe<Scalars['String']['output']>;
  OngoingRegistrationStep1?: Maybe<MixedHtmlModelSearch>;
  OngoingRegistrationStep2?: Maybe<MixedHtmlModelSearch>;
  OngoingRegistrationStep3?: Maybe<MixedHtmlModelSearch>;
  OngoingRegistrationStep4?: Maybe<MixedHtmlModelSearch>;
  OngoingRegistrationStep5?: Maybe<MixedHtmlModelSearch>;
  ParentLink?: Maybe<ContentModelReference>;
  PaymentsPage?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SecondaryContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type MyPagesStartPageModelCustomerTypeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelLinksContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelMainBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelMenuIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelMenuNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelMenuTagLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelOngoingRegistrationHeader1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelOngoingRegistrationHeader2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelOngoingRegistrationHeader3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelOngoingRegistrationHeader4Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelOngoingRegistrationHeader5Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelOngoingRegistrationStep1Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelOngoingRegistrationStep2Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelOngoingRegistrationStep3Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelOngoingRegistrationStep4Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelOngoingRegistrationStep5Args = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelSecondaryContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type MyPagesStartPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type MyPagesStartPageModelAutocomplete = {
  __typename?: 'MyPagesStartPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  NewsContainer?: Maybe<ContentModelReferenceAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PaymentsPage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MyPagesStartPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesStartPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesStartPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesStartPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesStartPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesStartPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesStartPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesStartPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesStartPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesStartPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesStartPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesStartPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MyPagesStartPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type MyPagesStartPageModelFacet = {
  __typename?: 'MyPagesStartPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CustomerType?: Maybe<Array<Maybe<StringFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinksContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MainBody?: Maybe<MixedHtmlModelSearchFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MenuIcon?: Maybe<Array<Maybe<StringFacet>>>;
  MenuName?: Maybe<Array<Maybe<StringFacet>>>;
  MenuTagLine?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NewsContainer?: Maybe<ContentModelReferenceFacet>;
  OngoingRegistrationHeader1?: Maybe<Array<Maybe<StringFacet>>>;
  OngoingRegistrationHeader2?: Maybe<Array<Maybe<StringFacet>>>;
  OngoingRegistrationHeader3?: Maybe<Array<Maybe<StringFacet>>>;
  OngoingRegistrationHeader4?: Maybe<Array<Maybe<StringFacet>>>;
  OngoingRegistrationHeader5?: Maybe<Array<Maybe<StringFacet>>>;
  OngoingRegistrationStep1?: Maybe<MixedHtmlModelSearchFacet>;
  OngoingRegistrationStep2?: Maybe<MixedHtmlModelSearchFacet>;
  OngoingRegistrationStep3?: Maybe<MixedHtmlModelSearchFacet>;
  OngoingRegistrationStep4?: Maybe<MixedHtmlModelSearchFacet>;
  OngoingRegistrationStep5?: Maybe<MixedHtmlModelSearchFacet>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PaymentsPage?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  SecondaryContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type MyPagesStartPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesStartPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesStartPageModelFacetCustomerTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetMenuIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetMenuNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetMenuTagLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetOngoingRegistrationHeader1Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetOngoingRegistrationHeader2Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetOngoingRegistrationHeader3Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetOngoingRegistrationHeader4Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetOngoingRegistrationHeader5Args = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesStartPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesStartPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type MyPagesStartPageModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type MyPagesStartPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type MyPagesStartPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CustomerType?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinksContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MenuIcon?: InputMaybe<OrderBy>;
  MenuName?: InputMaybe<OrderBy>;
  MenuTagLine?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NewsContainer?: InputMaybe<ContentModelReferenceOrderByInput>;
  OngoingRegistrationHeader1?: InputMaybe<OrderBy>;
  OngoingRegistrationHeader2?: InputMaybe<OrderBy>;
  OngoingRegistrationHeader3?: InputMaybe<OrderBy>;
  OngoingRegistrationHeader4?: InputMaybe<OrderBy>;
  OngoingRegistrationHeader5?: InputMaybe<OrderBy>;
  OngoingRegistrationStep1?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  OngoingRegistrationStep2?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  OngoingRegistrationStep3?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  OngoingRegistrationStep4?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  OngoingRegistrationStep5?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PaymentsPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  SecondaryContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type MyPagesStartPageModelOutput = {
  __typename?: 'MyPagesStartPageModelOutput';
  autocomplete?: Maybe<MyPagesStartPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<MyPagesStartPageModelFacet>;
  item?: Maybe<MyPagesStartPageModel>;
  items?: Maybe<Array<Maybe<MyPagesStartPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type MyPagesStartPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MyPagesStartPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CustomerType?: InputMaybe<SearchableStringFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinksContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MenuIcon?: InputMaybe<SearchableStringFilterInput>;
  MenuName?: InputMaybe<SearchableStringFilterInput>;
  MenuTagLine?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NewsContainer?: InputMaybe<ContentModelReferenceWhereInput>;
  OngoingRegistrationHeader1?: InputMaybe<SearchableStringFilterInput>;
  OngoingRegistrationHeader2?: InputMaybe<SearchableStringFilterInput>;
  OngoingRegistrationHeader3?: InputMaybe<SearchableStringFilterInput>;
  OngoingRegistrationHeader4?: InputMaybe<SearchableStringFilterInput>;
  OngoingRegistrationHeader5?: InputMaybe<SearchableStringFilterInput>;
  OngoingRegistrationStep1?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  OngoingRegistrationStep2?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  OngoingRegistrationStep3?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  OngoingRegistrationStep4?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  OngoingRegistrationStep5?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PaymentsPage?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  SecondaryContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<MyPagesStartPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<MyPagesStartPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<MyPagesStartPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type NewsContainerPageModel = IContent & IData & {
  __typename?: 'NewsContainerPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Button?: Maybe<NewsContainerPageModelButtonLinkBlockModel>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  NewsPagesLinksColorTheme?: Maybe<Scalars['Int']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type NewsContainerPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsContainerPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsContainerPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsContainerPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsContainerPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsContainerPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsContainerPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NewsContainerPageModelAutocomplete = {
  __typename?: 'NewsContainerPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Button?: Maybe<NewsContainerPageModelButtonLinkBlockModelAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NewsContainerPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsContainerPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsContainerPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsContainerPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsContainerPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsContainerPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsContainerPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsContainerPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsContainerPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsContainerPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsContainerPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsContainerPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsContainerPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsContainerPageModelButtonLinkBlockModel = {
  __typename?: 'NewsContainerPageModelButtonLinkBlockModel';
  ButtonClass?: Maybe<Scalars['Int']['output']>;
  DocumentLink?: Maybe<ContentModelReference>;
  ExternalLink?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<ContentModelReference>;
  LinkText?: Maybe<Scalars['String']['output']>;
  PopupContent?: Maybe<MixedHtmlModelSearch>;
  Title?: Maybe<Scalars['String']['output']>;
  VideoUrl?: Maybe<Scalars['String']['output']>;
};


export type NewsContainerPageModelButtonLinkBlockModelExternalLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsContainerPageModelButtonLinkBlockModelLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsContainerPageModelButtonLinkBlockModelPopupContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsContainerPageModelButtonLinkBlockModelTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsContainerPageModelButtonLinkBlockModelVideoUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type NewsContainerPageModelButtonLinkBlockModelAutocomplete = {
  __typename?: 'NewsContainerPageModelButtonLinkBlockModelAutocomplete';
  DocumentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Link?: Maybe<ContentModelReferenceAutocomplete>;
};

export type NewsContainerPageModelButtonLinkBlockModelFacet = {
  __typename?: 'NewsContainerPageModelButtonLinkBlockModelFacet';
  ButtonClass?: Maybe<Array<Maybe<NumberFacet>>>;
  DocumentLink?: Maybe<ContentModelReferenceFacet>;
  ExternalLink?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<ContentModelReferenceFacet>;
  LinkText?: Maybe<Array<Maybe<StringFacet>>>;
  PopupContent?: Maybe<MixedHtmlModelSearchFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  VideoUrl?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NewsContainerPageModelButtonLinkBlockModelFacetButtonClassArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NewsContainerPageModelButtonLinkBlockModelFacetExternalLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelButtonLinkBlockModelFacetLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelButtonLinkBlockModelFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelButtonLinkBlockModelFacetVideoUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsContainerPageModelButtonLinkBlockModelOrderByInput = {
  ButtonClass?: InputMaybe<OrderBy>;
  DocumentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExternalLink?: InputMaybe<OrderBy>;
  Link?: InputMaybe<ContentModelReferenceOrderByInput>;
  LinkText?: InputMaybe<OrderBy>;
  PopupContent?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  VideoUrl?: InputMaybe<OrderBy>;
};

export type NewsContainerPageModelButtonLinkBlockModelWhereInput = {
  ButtonClass?: InputMaybe<IntFilterInput>;
  DocumentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ExternalLink?: InputMaybe<SearchableStringFilterInput>;
  Link?: InputMaybe<ContentModelReferenceWhereInput>;
  LinkText?: InputMaybe<SearchableStringFilterInput>;
  PopupContent?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  VideoUrl?: InputMaybe<SearchableStringFilterInput>;
};

export type NewsContainerPageModelFacet = {
  __typename?: 'NewsContainerPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Button?: Maybe<NewsContainerPageModelButtonLinkBlockModelFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NewsPagesLinksColorTheme?: Maybe<Array<Maybe<NumberFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NewsContainerPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewsContainerPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewsContainerPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetNewsPagesLinksColorThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NewsContainerPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewsContainerPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewsContainerPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewsContainerPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsContainerPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsContainerPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Button?: InputMaybe<NewsContainerPageModelButtonLinkBlockModelOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  NewsPagesLinksColorTheme?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type NewsContainerPageModelOutput = {
  __typename?: 'NewsContainerPageModelOutput';
  autocomplete?: Maybe<NewsContainerPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NewsContainerPageModelFacet>;
  item?: Maybe<NewsContainerPageModel>;
  items?: Maybe<Array<Maybe<NewsContainerPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NewsContainerPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewsContainerPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Button?: InputMaybe<NewsContainerPageModelButtonLinkBlockModelWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NewsPagesLinksColorTheme?: InputMaybe<IntFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NewsContainerPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NewsContainerPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NewsContainerPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type NewsPageModel = IContent & IData & {
  __typename?: 'NewsPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Date?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FaqContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  IncludedFeature?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MainBody?: Maybe<MixedHtmlModelSearch>;
  MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MenuIcon?: Maybe<Scalars['String']['output']>;
  MenuTagLine?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type NewsPageModelFaqContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsPageModelMainBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsPageModelMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsPageModelMenuIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsPageModelMenuTagLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsPageModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NewsPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NewsPageModelAutocomplete = {
  __typename?: 'NewsPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  IncludedFeature?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NewsPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsPageModelAutocompleteIncludedFeatureArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NewsPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NewsPageModelFacet = {
  __typename?: 'NewsPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Date?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FaqContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IncludedFeature?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MainBody?: Maybe<MixedHtmlModelSearchFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MenuIcon?: Maybe<Array<Maybe<StringFacet>>>;
  MenuTagLine?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NewsPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewsPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewsPageModelFacetDateArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewsPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetIncludedFeatureArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetMenuIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetMenuTagLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewsPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewsPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NewsPageModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NewsPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NewsPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Date?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FaqContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IncludedFeature?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MenuIcon?: InputMaybe<OrderBy>;
  MenuTagLine?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type NewsPageModelOutput = {
  __typename?: 'NewsPageModelOutput';
  autocomplete?: Maybe<NewsPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NewsPageModelFacet>;
  item?: Maybe<NewsPageModel>;
  items?: Maybe<Array<Maybe<NewsPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NewsPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewsPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Date?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FaqContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IncludedFeature?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MenuIcon?: InputMaybe<SearchableStringFilterInput>;
  MenuTagLine?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NewsPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NewsPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NewsPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type NominationBlockModel = IContent & IData & {
  __typename?: 'NominationBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NominationDescription?: Maybe<MixedHtmlModelSearch>;
  NominationPreamble?: Maybe<MixedHtmlModelSearch>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SecondaryDescription?: Maybe<MixedHtmlModelSearch>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type NominationBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NominationBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NominationBlockModelNominationDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NominationBlockModelNominationPreambleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NominationBlockModelSecondaryDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NominationBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NominationBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NominationBlockModelAutocomplete = {
  __typename?: 'NominationBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Type?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NominationBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NominationBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NominationBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NominationBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NominationBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NominationBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NominationBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NominationBlockModelAutocompleteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NominationBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NominationBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NominationBlockModelFacet = {
  __typename?: 'NominationBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NominationDescription?: Maybe<MixedHtmlModelSearchFacet>;
  NominationPreamble?: Maybe<MixedHtmlModelSearchFacet>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SecondaryDescription?: Maybe<MixedHtmlModelSearchFacet>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Type?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NominationBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NominationBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NominationBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NominationBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NominationBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NominationBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NominationBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NominationBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NominationBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NominationBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NominationBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NominationBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NominationBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NominationBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NominationBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NominationBlockModelFacetTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NominationBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NominationBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NominationBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NominationDescription?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  NominationPreamble?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SecondaryDescription?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Type?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type NominationBlockModelOutput = {
  __typename?: 'NominationBlockModelOutput';
  autocomplete?: Maybe<NominationBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NominationBlockModelFacet>;
  item?: Maybe<NominationBlockModel>;
  items?: Maybe<Array<Maybe<NominationBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NominationBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NominationBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NominationDescription?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  NominationPreamble?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SecondaryDescription?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Type?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NominationBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NominationBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NominationBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type NumberElementBlock = IContent & IData & {
  __typename?: 'NumberElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AutoComplete?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type NumberElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type NumberElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type NumberElementBlockAutocomplete = {
  __typename?: 'NumberElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type NumberElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type NumberElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type NumberElementBlockFacet = {
  __typename?: 'NumberElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type NumberElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NumberElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type NumberElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type NumberElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type NumberElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type NumberElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type NumberElementBlockOutput = {
  __typename?: 'NumberElementBlockOutput';
  autocomplete?: Maybe<NumberElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<NumberElementBlockFacet>;
  item?: Maybe<NumberElementBlock>;
  items?: Maybe<Array<Maybe<NumberElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type NumberElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<NumberElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<NumberElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<NumberElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type NumberFacet = {
  __typename?: 'NumberFacet';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Factor influences the score based of number values with a factor function */
export type NumberFactor = {
  modifier?: InputMaybe<FactorModifier>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type OrderAssetLocalBlockModel = IContent & IData & {
  __typename?: 'OrderAssetLocalBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type OrderAssetLocalBlockModelDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type OrderAssetLocalBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type OrderAssetLocalBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type OrderAssetLocalBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type OrderAssetLocalBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type OrderAssetLocalBlockModelAutocomplete = {
  __typename?: 'OrderAssetLocalBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type OrderAssetLocalBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type OrderAssetLocalBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type OrderAssetLocalBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type OrderAssetLocalBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type OrderAssetLocalBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type OrderAssetLocalBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type OrderAssetLocalBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type OrderAssetLocalBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type OrderAssetLocalBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type OrderAssetLocalBlockModelFacet = {
  __typename?: 'OrderAssetLocalBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type OrderAssetLocalBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type OrderAssetLocalBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type OrderAssetLocalBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type OrderAssetLocalBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type OrderAssetLocalBlockModelFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type OrderAssetLocalBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type OrderAssetLocalBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type OrderAssetLocalBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type OrderAssetLocalBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type OrderAssetLocalBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type OrderAssetLocalBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type OrderAssetLocalBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type OrderAssetLocalBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type OrderAssetLocalBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type OrderAssetLocalBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type OrderAssetLocalBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type OrderAssetLocalBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type OrderAssetLocalBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type OrderAssetLocalBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type OrderAssetLocalBlockModelOutput = {
  __typename?: 'OrderAssetLocalBlockModelOutput';
  autocomplete?: Maybe<OrderAssetLocalBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<OrderAssetLocalBlockModelFacet>;
  item?: Maybe<OrderAssetLocalBlockModel>;
  items?: Maybe<Array<Maybe<OrderAssetLocalBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type OrderAssetLocalBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderAssetLocalBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<OrderAssetLocalBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<OrderAssetLocalBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<OrderAssetLocalBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export enum OrderBy {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderByFacetType {
  Count = 'COUNT',
  Value = 'VALUE'
}

export type ParagraphTextElementBlock = IContent & IData & {
  __typename?: 'ParagraphTextElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisablePlaceholdersReplacement?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FormSubmissionId?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParagraphText?: Maybe<MixedHtmlModelSearch>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ParagraphTextElementBlockFormSubmissionIdArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ParagraphTextElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ParagraphTextElementBlockParagraphTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ParagraphTextElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ParagraphTextElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ParagraphTextElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ParagraphTextElementBlockAutocomplete = {
  __typename?: 'ParagraphTextElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ParagraphTextElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ParagraphTextElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ParagraphTextElementBlockFacet = {
  __typename?: 'ParagraphTextElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisablePlaceholdersReplacement?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormSubmissionId?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParagraphText?: Maybe<MixedHtmlModelSearchFacet>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ParagraphTextElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ParagraphTextElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type ParagraphTextElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ParagraphTextElementBlockFacetDisablePlaceholdersReplacementArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetFormSubmissionIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ParagraphTextElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ParagraphTextElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ParagraphTextElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ParagraphTextElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ParagraphTextElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisablePlaceholdersReplacement?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormSubmissionId?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParagraphText?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ParagraphTextElementBlockOutput = {
  __typename?: 'ParagraphTextElementBlockOutput';
  autocomplete?: Maybe<ParagraphTextElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ParagraphTextElementBlockFacet>;
  item?: Maybe<ParagraphTextElementBlock>;
  items?: Maybe<Array<Maybe<ParagraphTextElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ParagraphTextElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParagraphTextElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisablePlaceholdersReplacement?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormSubmissionId?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParagraphText?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ParagraphTextElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ParagraphTextElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ParagraphTextElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type PexMapBlockModel = IContent & IData & {
  __typename?: 'PexMapBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AvailableRecyclingAlternatives?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreSelectedRecyclingAlternatives?: Maybe<Scalars['String']['output']>;
  RecycleAlternativesDialogContent?: Maybe<MixedHtmlModelSearch>;
  RecycleAlternativesLabel?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  ShowSearch?: Maybe<Scalars['Bool']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type PexMapBlockModelAvailableRecyclingAlternativesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PexMapBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PexMapBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PexMapBlockModelPreSelectedRecyclingAlternativesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PexMapBlockModelRecycleAlternativesDialogContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PexMapBlockModelRecycleAlternativesLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PexMapBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PexMapBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PexMapBlockModelAutocomplete = {
  __typename?: 'PexMapBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PexMapBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PexMapBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PexMapBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PexMapBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PexMapBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PexMapBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PexMapBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PexMapBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PexMapBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PexMapBlockModelFacet = {
  __typename?: 'PexMapBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AvailableRecyclingAlternatives?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreSelectedRecyclingAlternatives?: Maybe<Array<Maybe<StringFacet>>>;
  RecycleAlternativesDialogContent?: Maybe<MixedHtmlModelSearchFacet>;
  RecycleAlternativesLabel?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  ShowSearch?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PexMapBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetAvailableRecyclingAlternativesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PexMapBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PexMapBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetPreSelectedRecyclingAlternativesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetRecycleAlternativesLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PexMapBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetShowSearchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PexMapBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PexMapBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PexMapBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PexMapBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AvailableRecyclingAlternatives?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreSelectedRecyclingAlternatives?: InputMaybe<OrderBy>;
  RecycleAlternativesDialogContent?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  RecycleAlternativesLabel?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  ShowSearch?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type PexMapBlockModelOutput = {
  __typename?: 'PexMapBlockModelOutput';
  autocomplete?: Maybe<PexMapBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PexMapBlockModelFacet>;
  item?: Maybe<PexMapBlockModel>;
  items?: Maybe<Array<Maybe<PexMapBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PexMapBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PexMapBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AvailableRecyclingAlternatives?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreSelectedRecyclingAlternatives?: InputMaybe<SearchableStringFilterInput>;
  RecycleAlternativesDialogContent?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  RecycleAlternativesLabel?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  ShowSearch?: InputMaybe<BoolFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PexMapBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PexMapBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PexMapBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type PinnedInput = {
  /** Pinned collection keys */
  collections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phrase?: InputMaybe<Scalars['String']['input']>;
};

export type PopupBlockModel = IContent & IData & {
  __typename?: 'PopupBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Text?: Maybe<MixedHtmlModelSearch>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type PopupBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PopupBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PopupBlockModelTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PopupBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PopupBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PopupBlockModelAutocomplete = {
  __typename?: 'PopupBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PopupBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PopupBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PopupBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PopupBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PopupBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PopupBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PopupBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PopupBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PopupBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PopupBlockModelFacet = {
  __typename?: 'PopupBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Text?: Maybe<MixedHtmlModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PopupBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PopupBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PopupBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PopupBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PopupBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PopupBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PopupBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PopupBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PopupBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PopupBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PopupBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PopupBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PopupBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PopupBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PopupBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PopupBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PopupBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PopupBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Text?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type PopupBlockModelOutput = {
  __typename?: 'PopupBlockModelOutput';
  autocomplete?: Maybe<PopupBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PopupBlockModelFacet>;
  item?: Maybe<PopupBlockModel>;
  items?: Maybe<Array<Maybe<PopupBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PopupBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PopupBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Text?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PopupBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PopupBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PopupBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type PptMediaModel = IContent & IData & {
  __typename?: 'PptMediaModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['Int']['output']>;
  HeadingEn?: Maybe<Scalars['String']['output']>;
  HeadingSv?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreambleEn?: Maybe<Scalars['String']['output']>;
  PreambleSv?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type PptMediaModelContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PptMediaModelDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PptMediaModelHeadingEnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PptMediaModelHeadingSvArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PptMediaModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PptMediaModelPreambleEnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PptMediaModelPreambleSvArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PptMediaModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PptMediaModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PptMediaModelAutocomplete = {
  __typename?: 'PptMediaModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PptMediaModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PptMediaModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PptMediaModelAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PptMediaModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PptMediaModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PptMediaModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PptMediaModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PptMediaModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PptMediaModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PptMediaModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PptMediaModelFacet = {
  __typename?: 'PptMediaModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<NumberFacet>>>;
  HeadingEn?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingSv?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreambleEn?: Maybe<Array<Maybe<StringFacet>>>;
  PreambleSv?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PptMediaModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PptMediaModelFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PptMediaModelFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type PptMediaModelFacetHeadingEnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetHeadingSvArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetPreambleEnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetPreambleSvArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PptMediaModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PptMediaModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PptMediaModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PptMediaModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PptMediaModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  HeadingEn?: InputMaybe<OrderBy>;
  HeadingSv?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreambleEn?: InputMaybe<OrderBy>;
  PreambleSv?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type PptMediaModelOutput = {
  __typename?: 'PptMediaModelOutput';
  autocomplete?: Maybe<PptMediaModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PptMediaModelFacet>;
  item?: Maybe<PptMediaModel>;
  items?: Maybe<Array<Maybe<PptMediaModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PptMediaModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PptMediaModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<IntFilterInput>;
  HeadingEn?: InputMaybe<SearchableStringFilterInput>;
  HeadingSv?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreambleEn?: InputMaybe<SearchableStringFilterInput>;
  PreambleSv?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PptMediaModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PptMediaModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PptMediaModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type PredefinedHiddenElementBlock = IContent & IData & {
  __typename?: 'PredefinedHiddenElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PredefinedValue?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type PredefinedHiddenElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PredefinedHiddenElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PredefinedHiddenElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PredefinedHiddenElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PredefinedHiddenElementBlockAutocomplete = {
  __typename?: 'PredefinedHiddenElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PredefinedHiddenElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PredefinedHiddenElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PredefinedHiddenElementBlockFacet = {
  __typename?: 'PredefinedHiddenElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PredefinedHiddenElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PredefinedHiddenElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PredefinedHiddenElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PredefinedHiddenElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PredefinedHiddenElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PredefinedHiddenElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PredefinedHiddenElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PredefinedHiddenElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type PredefinedHiddenElementBlockOutput = {
  __typename?: 'PredefinedHiddenElementBlockOutput';
  autocomplete?: Maybe<PredefinedHiddenElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PredefinedHiddenElementBlockFacet>;
  item?: Maybe<PredefinedHiddenElementBlock>;
  items?: Maybe<Array<Maybe<PredefinedHiddenElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PredefinedHiddenElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PredefinedHiddenElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PredefinedHiddenElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PredefinedHiddenElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PredefinedHiddenElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type PrizePoolBlockModel = IContent & IData & {
  __typename?: 'PrizePoolBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  CurrentPrizePool?: Maybe<PrizePoolBlockModelPrizePoolNumbersLocalBlockModel>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  NumberOfCansAndBottlesDeposited?: Maybe<PrizePoolBlockModelPrizePoolNumbersLocalBlockModel>;
  ParentLink?: Maybe<ContentModelReference>;
  PrizePoolDistributionBackgroundImage?: Maybe<ContentModelReference>;
  PrizePoolDistributionHeading?: Maybe<Scalars['String']['output']>;
  PrizePoolPercentagePart1?: Maybe<PrizePoolBlockModelPrizePoolDistributionLocalBlockModel>;
  PrizePoolPercentagePart2?: Maybe<PrizePoolBlockModelPrizePoolDistributionLocalBlockModel>;
  PrizePoolPercentagePart3?: Maybe<PrizePoolBlockModelPrizePoolDistributionLocalBlockModel>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  WideLayout?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type PrizePoolBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrizePoolBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrizePoolBlockModelPrizePoolDistributionHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrizePoolBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrizePoolBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrizePoolBlockModelAutocomplete = {
  __typename?: 'PrizePoolBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CurrentPrizePool?: Maybe<PrizePoolBlockModelPrizePoolNumbersLocalBlockModelAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  NumberOfCansAndBottlesDeposited?: Maybe<PrizePoolBlockModelPrizePoolNumbersLocalBlockModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PrizePoolDistributionBackgroundImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrizePoolBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrizePoolBlockModelFacet = {
  __typename?: 'PrizePoolBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  CurrentPrizePool?: Maybe<PrizePoolBlockModelPrizePoolNumbersLocalBlockModelFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NumberOfCansAndBottlesDeposited?: Maybe<PrizePoolBlockModelPrizePoolNumbersLocalBlockModelFacet>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PrizePoolDistributionBackgroundImage?: Maybe<ContentModelReferenceFacet>;
  PrizePoolDistributionHeading?: Maybe<Array<Maybe<StringFacet>>>;
  PrizePoolPercentagePart1?: Maybe<PrizePoolBlockModelPrizePoolDistributionLocalBlockModelFacet>;
  PrizePoolPercentagePart2?: Maybe<PrizePoolBlockModelPrizePoolDistributionLocalBlockModelFacet>;
  PrizePoolPercentagePart3?: Maybe<PrizePoolBlockModelPrizePoolDistributionLocalBlockModelFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WideLayout?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrizePoolBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelFacetPrizePoolDistributionHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelFacetWideLayoutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrizePoolBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  CurrentPrizePool?: InputMaybe<PrizePoolBlockModelPrizePoolNumbersLocalBlockModelOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NumberOfCansAndBottlesDeposited?: InputMaybe<PrizePoolBlockModelPrizePoolNumbersLocalBlockModelOrderByInput>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PrizePoolDistributionBackgroundImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PrizePoolDistributionHeading?: InputMaybe<OrderBy>;
  PrizePoolPercentagePart1?: InputMaybe<PrizePoolBlockModelPrizePoolDistributionLocalBlockModelOrderByInput>;
  PrizePoolPercentagePart2?: InputMaybe<PrizePoolBlockModelPrizePoolDistributionLocalBlockModelOrderByInput>;
  PrizePoolPercentagePart3?: InputMaybe<PrizePoolBlockModelPrizePoolDistributionLocalBlockModelOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  WideLayout?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type PrizePoolBlockModelOutput = {
  __typename?: 'PrizePoolBlockModelOutput';
  autocomplete?: Maybe<PrizePoolBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrizePoolBlockModelFacet>;
  item?: Maybe<PrizePoolBlockModel>;
  items?: Maybe<Array<Maybe<PrizePoolBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrizePoolBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrizePoolBlockModelPrizePoolDistributionLocalBlockModel = {
  __typename?: 'PrizePoolBlockModelPrizePoolDistributionLocalBlockModel';
  ExplanatoryText?: Maybe<Scalars['String']['output']>;
  Percentage?: Maybe<Scalars['String']['output']>;
};


export type PrizePoolBlockModelPrizePoolDistributionLocalBlockModelExplanatoryTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrizePoolBlockModelPrizePoolDistributionLocalBlockModelPercentageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrizePoolBlockModelPrizePoolDistributionLocalBlockModelFacet = {
  __typename?: 'PrizePoolBlockModelPrizePoolDistributionLocalBlockModelFacet';
  ExplanatoryText?: Maybe<Array<Maybe<StringFacet>>>;
  Percentage?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrizePoolBlockModelPrizePoolDistributionLocalBlockModelFacetExplanatoryTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolBlockModelPrizePoolDistributionLocalBlockModelFacetPercentageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrizePoolBlockModelPrizePoolDistributionLocalBlockModelOrderByInput = {
  ExplanatoryText?: InputMaybe<OrderBy>;
  Percentage?: InputMaybe<OrderBy>;
};

export type PrizePoolBlockModelPrizePoolDistributionLocalBlockModelWhereInput = {
  ExplanatoryText?: InputMaybe<SearchableStringFilterInput>;
  Percentage?: InputMaybe<SearchableStringFilterInput>;
};

export type PrizePoolBlockModelPrizePoolNumbersLocalBlockModel = {
  __typename?: 'PrizePoolBlockModelPrizePoolNumbersLocalBlockModel';
  BackgroundImage?: Maybe<ContentModelReference>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ContentModelReference>;
};


export type PrizePoolBlockModelPrizePoolNumbersLocalBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type PrizePoolBlockModelPrizePoolNumbersLocalBlockModelAutocomplete = {
  __typename?: 'PrizePoolBlockModelPrizePoolNumbersLocalBlockModelAutocomplete';
  BackgroundImage?: Maybe<ContentModelReferenceAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
};

export type PrizePoolBlockModelPrizePoolNumbersLocalBlockModelFacet = {
  __typename?: 'PrizePoolBlockModelPrizePoolNumbersLocalBlockModelFacet';
  BackgroundImage?: Maybe<ContentModelReferenceFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
};


export type PrizePoolBlockModelPrizePoolNumbersLocalBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrizePoolBlockModelPrizePoolNumbersLocalBlockModelOrderByInput = {
  BackgroundImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
};

export type PrizePoolBlockModelPrizePoolNumbersLocalBlockModelWhereInput = {
  BackgroundImage?: InputMaybe<ContentModelReferenceWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
};

export type PrizePoolBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  CurrentPrizePool?: InputMaybe<PrizePoolBlockModelPrizePoolNumbersLocalBlockModelWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NumberOfCansAndBottlesDeposited?: InputMaybe<PrizePoolBlockModelPrizePoolNumbersLocalBlockModelWhereInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PrizePoolDistributionBackgroundImage?: InputMaybe<ContentModelReferenceWhereInput>;
  PrizePoolDistributionHeading?: InputMaybe<SearchableStringFilterInput>;
  PrizePoolPercentagePart1?: InputMaybe<PrizePoolBlockModelPrizePoolDistributionLocalBlockModelWhereInput>;
  PrizePoolPercentagePart2?: InputMaybe<PrizePoolBlockModelPrizePoolDistributionLocalBlockModelWhereInput>;
  PrizePoolPercentagePart3?: InputMaybe<PrizePoolBlockModelPrizePoolDistributionLocalBlockModelWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  WideLayout?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrizePoolBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrizePoolBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrizePoolBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type PrizePoolDistributionLocalBlockModel = IContent & IData & {
  __typename?: 'PrizePoolDistributionLocalBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExplanatoryText?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Percentage?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type PrizePoolDistributionLocalBlockModelExplanatoryTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrizePoolDistributionLocalBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrizePoolDistributionLocalBlockModelPercentageArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrizePoolDistributionLocalBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrizePoolDistributionLocalBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrizePoolDistributionLocalBlockModelAutocomplete = {
  __typename?: 'PrizePoolDistributionLocalBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrizePoolDistributionLocalBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolDistributionLocalBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolDistributionLocalBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolDistributionLocalBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolDistributionLocalBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolDistributionLocalBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolDistributionLocalBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolDistributionLocalBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolDistributionLocalBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrizePoolDistributionLocalBlockModelFacet = {
  __typename?: 'PrizePoolDistributionLocalBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExplanatoryText?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Percentage?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrizePoolDistributionLocalBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolDistributionLocalBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolDistributionLocalBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolDistributionLocalBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolDistributionLocalBlockModelFacetExplanatoryTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolDistributionLocalBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolDistributionLocalBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolDistributionLocalBlockModelFacetPercentageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolDistributionLocalBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolDistributionLocalBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolDistributionLocalBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolDistributionLocalBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolDistributionLocalBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolDistributionLocalBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolDistributionLocalBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolDistributionLocalBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolDistributionLocalBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolDistributionLocalBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrizePoolDistributionLocalBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExplanatoryText?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Percentage?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type PrizePoolDistributionLocalBlockModelOutput = {
  __typename?: 'PrizePoolDistributionLocalBlockModelOutput';
  autocomplete?: Maybe<PrizePoolDistributionLocalBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrizePoolDistributionLocalBlockModelFacet>;
  item?: Maybe<PrizePoolDistributionLocalBlockModel>;
  items?: Maybe<Array<Maybe<PrizePoolDistributionLocalBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrizePoolDistributionLocalBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrizePoolDistributionLocalBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExplanatoryText?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Percentage?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrizePoolDistributionLocalBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrizePoolDistributionLocalBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrizePoolDistributionLocalBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type PrizePoolNumbersLocalBlockModel = IContent & IData & {
  __typename?: 'PrizePoolNumbersLocalBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackgroundImage?: Maybe<ContentModelReference>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type PrizePoolNumbersLocalBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrizePoolNumbersLocalBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrizePoolNumbersLocalBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type PrizePoolNumbersLocalBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type PrizePoolNumbersLocalBlockModelAutocomplete = {
  __typename?: 'PrizePoolNumbersLocalBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackgroundImage?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type PrizePoolNumbersLocalBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolNumbersLocalBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolNumbersLocalBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolNumbersLocalBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolNumbersLocalBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolNumbersLocalBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolNumbersLocalBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolNumbersLocalBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type PrizePoolNumbersLocalBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type PrizePoolNumbersLocalBlockModelFacet = {
  __typename?: 'PrizePoolNumbersLocalBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackgroundImage?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type PrizePoolNumbersLocalBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolNumbersLocalBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolNumbersLocalBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolNumbersLocalBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolNumbersLocalBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolNumbersLocalBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolNumbersLocalBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolNumbersLocalBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolNumbersLocalBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolNumbersLocalBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolNumbersLocalBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolNumbersLocalBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolNumbersLocalBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolNumbersLocalBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolNumbersLocalBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type PrizePoolNumbersLocalBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type PrizePoolNumbersLocalBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type PrizePoolNumbersLocalBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackgroundImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type PrizePoolNumbersLocalBlockModelOutput = {
  __typename?: 'PrizePoolNumbersLocalBlockModelOutput';
  autocomplete?: Maybe<PrizePoolNumbersLocalBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<PrizePoolNumbersLocalBlockModelFacet>;
  item?: Maybe<PrizePoolNumbersLocalBlockModel>;
  items?: Maybe<Array<Maybe<PrizePoolNumbersLocalBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type PrizePoolNumbersLocalBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrizePoolNumbersLocalBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackgroundImage?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<PrizePoolNumbersLocalBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<PrizePoolNumbersLocalBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<PrizePoolNumbersLocalBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type Query = {
  __typename?: 'Query';
  ActivationPageModel?: Maybe<ActivationPageModelOutput>;
  AgreementPageModel?: Maybe<AgreementPageModelOutput>;
  AssociationBattleBlockModel?: Maybe<AssociationBattleBlockModelOutput>;
  AtoZPageModel?: Maybe<AtoZPageModelOutput>;
  ButtonLinkBlockModel?: Maybe<ButtonLinkBlockModelOutput>;
  CampaignBlock?: Maybe<CampaignBlockOutput>;
  CaptchaElementBlock?: Maybe<CaptchaElementBlockOutput>;
  ChoiceElementBlock?: Maybe<ChoiceElementBlockOutput>;
  CompanyRegistrationsBlockModel?: Maybe<CompanyRegistrationsBlockModelOutput>;
  CompensationBlockModel?: Maybe<CompensationBlockModelOutput>;
  ConnectedProducersListBlockModel?: Maybe<ConnectedProducersListBlockModelOutput>;
  Content?: Maybe<ContentOutput>;
  CsvMediaModel?: Maybe<CsvMediaModelOutput>;
  Data?: Maybe<DataOutput>;
  DepositLabelOrderBlockModel?: Maybe<DepositLabelOrderBlockModelOutput>;
  DepositLabelOrderHistoryBlockModel?: Maybe<DepositLabelOrderHistoryBlockModelOutput>;
  DownloadAssetLocalBlockModel?: Maybe<DownloadAssetLocalBlockModelOutput>;
  DownloadAssetVariant?: Maybe<DownloadAssetVariantOutput>;
  DownloadAssetsBlockModel?: Maybe<DownloadAssetsBlockModelOutput>;
  EanCheckBlockModel?: Maybe<EanCheckBlockModelOutput>;
  EmbedVideoBlockModel?: Maybe<EmbedVideoBlockModelOutput>;
  ErrorPageModel?: Maybe<ErrorPageModelOutput>;
  ExcelMediaModel?: Maybe<ExcelMediaModelOutput>;
  ExtendedLinkBlockModel?: Maybe<ExtendedLinkBlockModelOutput>;
  ExtraPickupFormBlockModel?: Maybe<ExtraPickupFormBlockModelOutput>;
  FaqCategoryPageModel?: Maybe<FaqCategoryPageModelOutput>;
  FaqItemPageModel?: Maybe<FaqItemPageModelOutput>;
  FaqListPageModel?: Maybe<FaqListPageModelOutput>;
  FeatureBlockModel?: Maybe<FeatureBlockModelOutput>;
  FileUploadElementBlock?: Maybe<FileUploadElementBlockOutput>;
  FormContainerBlock?: Maybe<FormContainerBlockOutput>;
  FormStepBlock?: Maybe<FormStepBlockOutput>;
  HeroBlockModel?: Maybe<HeroBlockModelOutput>;
  IFramePageModel?: Maybe<IFramePageModelOutput>;
  ImageAndTextBlockModel?: Maybe<ImageAndTextBlockModelOutput>;
  ImageBlockModel?: Maybe<ImageBlockModelOutput>;
  ImageChoiceElementBlock?: Maybe<ImageChoiceElementBlockOutput>;
  MainImageBlockModel?: Maybe<MainImageBlockModelOutput>;
  MainMenuPageModel?: Maybe<MainMenuPageModelOutput>;
  MyPagesAdminPageModel?: Maybe<MyPagesAdminPageModelOutput>;
  MyPagesBlockModel?: Maybe<MyPagesBlockModelOutput>;
  MyPagesContainerPageModel?: Maybe<MyPagesContainerPageModelOutput>;
  MyPagesPageModel?: Maybe<MyPagesPageModelOutput>;
  MyPagesStartPageModel?: Maybe<MyPagesStartPageModelOutput>;
  NewsContainerPageModel?: Maybe<NewsContainerPageModelOutput>;
  NewsPageModel?: Maybe<NewsPageModelOutput>;
  NominationBlockModel?: Maybe<NominationBlockModelOutput>;
  NumberElementBlock?: Maybe<NumberElementBlockOutput>;
  OrderAssetLocalBlockModel?: Maybe<OrderAssetLocalBlockModelOutput>;
  ParagraphTextElementBlock?: Maybe<ParagraphTextElementBlockOutput>;
  PexMapBlockModel?: Maybe<PexMapBlockModelOutput>;
  PopupBlockModel?: Maybe<PopupBlockModelOutput>;
  PptMediaModel?: Maybe<PptMediaModelOutput>;
  PredefinedHiddenElementBlock?: Maybe<PredefinedHiddenElementBlockOutput>;
  PrizePoolBlockModel?: Maybe<PrizePoolBlockModelOutput>;
  PrizePoolDistributionLocalBlockModel?: Maybe<PrizePoolDistributionLocalBlockModelOutput>;
  PrizePoolNumbersLocalBlockModel?: Maybe<PrizePoolNumbersLocalBlockModelOutput>;
  RangeElementBlock?: Maybe<RangeElementBlockOutput>;
  RecyclingStoreTopListBlockModel?: Maybe<RecyclingStoreTopListBlockModelOutput>;
  RelatedLinksBlockModel?: Maybe<RelatedLinksBlockModelOutput>;
  ResetButtonElementBlock?: Maybe<ResetButtonElementBlockOutput>;
  ResponsiveImageBlockModel?: Maybe<ResponsiveImageBlockModelOutput>;
  ScriptBlock?: Maybe<ScriptBlockOutput>;
  ScriptImportBlockModel?: Maybe<ScriptImportBlockModelOutput>;
  SearchResultPageModel?: Maybe<SearchResultPageModelOutput>;
  SectionBlockModel?: Maybe<SectionBlockModelOutput>;
  SelectionElementBlock?: Maybe<SelectionElementBlockOutput>;
  SeoBlockModel?: Maybe<SeoBlockModelOutput>;
  SiteContextSettingsBlockModel?: Maybe<SiteContextSettingsBlockModelOutput>;
  SiteDefinition?: Maybe<SiteDefinitionOutput>;
  SiteDocumentMediaData?: Maybe<SiteDocumentMediaDataOutput>;
  SiteImageData?: Maybe<SiteImageDataOutput>;
  SiteMediaData?: Maybe<SiteMediaDataOutput>;
  SiteVideoData?: Maybe<SiteVideoDataOutput>;
  StandardBlockModel?: Maybe<StandardBlockModelOutput>;
  StandardPageModel?: Maybe<StandardPageModelOutput>;
  StartPageModel?: Maybe<StartPageModelOutput>;
  StoreFlyersBlockModel?: Maybe<StoreFlyersBlockModelOutput>;
  SubmitButtonElementBlock?: Maybe<SubmitButtonElementBlockOutput>;
  SwishCertificateBlockModel?: Maybe<SwishCertificateBlockModelOutput>;
  SwishFormBlockModel?: Maybe<SwishFormBlockModelOutput>;
  SwishRegistrationBlockModel?: Maybe<SwishRegistrationBlockModelOutput>;
  SwishStoreRegistrationBlockModel?: Maybe<SwishStoreRegistrationBlockModelOutput>;
  TabBlockModel?: Maybe<TabBlockModelOutput>;
  TabItem?: Maybe<TabItemOutput>;
  TeaserLinkBlockModel?: Maybe<TeaserLinkBlockModelOutput>;
  TextBlockModel?: Maybe<TextBlockModelOutput>;
  TextareaElementBlock?: Maybe<TextareaElementBlockOutput>;
  TextboxElementBlock?: Maybe<TextboxElementBlockOutput>;
  UrlElementBlock?: Maybe<UrlElementBlockOutput>;
  VisitorDataHiddenElementBlock?: Maybe<VisitorDataHiddenElementBlockOutput>;
  WebShopLinkBlockModel?: Maybe<WebShopLinkBlockModelOutput>;
  WordMediaModel?: Maybe<WordMediaModelOutput>;
};


export type QueryActivationPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ActivationPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ActivationPageModelWhereInput>;
};


export type QueryAgreementPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AgreementPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<AgreementPageModelWhereInput>;
};


export type QueryAssociationBattleBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AssociationBattleBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<AssociationBattleBlockModelWhereInput>;
};


export type QueryAtoZPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AtoZPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<AtoZPageModelWhereInput>;
};


export type QueryButtonLinkBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ButtonLinkBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ButtonLinkBlockModelWhereInput>;
};


export type QueryCampaignBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CampaignBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CampaignBlockWhereInput>;
};


export type QueryCaptchaElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CaptchaElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CaptchaElementBlockWhereInput>;
};


export type QueryChoiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ChoiceElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ChoiceElementBlockWhereInput>;
};


export type QueryCompanyRegistrationsBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyRegistrationsBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CompanyRegistrationsBlockModelWhereInput>;
};


export type QueryCompensationBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompensationBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CompensationBlockModelWhereInput>;
};


export type QueryConnectedProducersListBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ConnectedProducersListBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ConnectedProducersListBlockModelWhereInput>;
};


export type QueryContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryCsvMediaModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CsvMediaModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CsvMediaModelWhereInput>;
};


export type QueryDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<System_Locales>>>;
  orderBy?: InputMaybe<DataOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DataWhereInput>;
};


export type QueryDepositLabelOrderBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DepositLabelOrderBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DepositLabelOrderBlockModelWhereInput>;
};


export type QueryDepositLabelOrderHistoryBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DepositLabelOrderHistoryBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DepositLabelOrderHistoryBlockModelWhereInput>;
};


export type QueryDownloadAssetLocalBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DownloadAssetLocalBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DownloadAssetLocalBlockModelWhereInput>;
};


export type QueryDownloadAssetVariantArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DownloadAssetVariantOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DownloadAssetVariantWhereInput>;
};


export type QueryDownloadAssetsBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DownloadAssetsBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DownloadAssetsBlockModelWhereInput>;
};


export type QueryEanCheckBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EanCheckBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<EanCheckBlockModelWhereInput>;
};


export type QueryEmbedVideoBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EmbedVideoBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<EmbedVideoBlockModelWhereInput>;
};


export type QueryErrorPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ErrorPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ErrorPageModelWhereInput>;
};


export type QueryExcelMediaModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ExcelMediaModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ExcelMediaModelWhereInput>;
};


export type QueryExtendedLinkBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ExtendedLinkBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ExtendedLinkBlockModelWhereInput>;
};


export type QueryExtraPickupFormBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ExtraPickupFormBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ExtraPickupFormBlockModelWhereInput>;
};


export type QueryFaqCategoryPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FaqCategoryPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FaqCategoryPageModelWhereInput>;
};


export type QueryFaqItemPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FaqItemPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FaqItemPageModelWhereInput>;
};


export type QueryFaqListPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FaqListPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FaqListPageModelWhereInput>;
};


export type QueryFeatureBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FeatureBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FeatureBlockModelWhereInput>;
};


export type QueryFileUploadElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FileUploadElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FileUploadElementBlockWhereInput>;
};


export type QueryFormContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormContainerBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FormContainerBlockWhereInput>;
};


export type QueryFormStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormStepBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FormStepBlockWhereInput>;
};


export type QueryHeroBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HeroBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HeroBlockModelWhereInput>;
};


export type QueryIFramePageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IFramePageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IFramePageModelWhereInput>;
};


export type QueryImageAndTextBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageAndTextBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ImageAndTextBlockModelWhereInput>;
};


export type QueryImageBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ImageBlockModelWhereInput>;
};


export type QueryImageChoiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageChoiceElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ImageChoiceElementBlockWhereInput>;
};


export type QueryMainImageBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MainImageBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MainImageBlockModelWhereInput>;
};


export type QueryMainMenuPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MainMenuPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MainMenuPageModelWhereInput>;
};


export type QueryMyPagesAdminPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MyPagesAdminPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MyPagesAdminPageModelWhereInput>;
};


export type QueryMyPagesBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MyPagesBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MyPagesBlockModelWhereInput>;
};


export type QueryMyPagesContainerPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MyPagesContainerPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MyPagesContainerPageModelWhereInput>;
};


export type QueryMyPagesPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MyPagesPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MyPagesPageModelWhereInput>;
};


export type QueryMyPagesStartPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MyPagesStartPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MyPagesStartPageModelWhereInput>;
};


export type QueryNewsContainerPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NewsContainerPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<NewsContainerPageModelWhereInput>;
};


export type QueryNewsPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NewsPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<NewsPageModelWhereInput>;
};


export type QueryNominationBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NominationBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<NominationBlockModelWhereInput>;
};


export type QueryNumberElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NumberElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<NumberElementBlockWhereInput>;
};


export type QueryOrderAssetLocalBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<OrderAssetLocalBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<OrderAssetLocalBlockModelWhereInput>;
};


export type QueryParagraphTextElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ParagraphTextElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ParagraphTextElementBlockWhereInput>;
};


export type QueryPexMapBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PexMapBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PexMapBlockModelWhereInput>;
};


export type QueryPopupBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PopupBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PopupBlockModelWhereInput>;
};


export type QueryPptMediaModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PptMediaModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PptMediaModelWhereInput>;
};


export type QueryPredefinedHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PredefinedHiddenElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PredefinedHiddenElementBlockWhereInput>;
};


export type QueryPrizePoolBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrizePoolBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PrizePoolBlockModelWhereInput>;
};


export type QueryPrizePoolDistributionLocalBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrizePoolDistributionLocalBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PrizePoolDistributionLocalBlockModelWhereInput>;
};


export type QueryPrizePoolNumbersLocalBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrizePoolNumbersLocalBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PrizePoolNumbersLocalBlockModelWhereInput>;
};


export type QueryRangeElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RangeElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<RangeElementBlockWhereInput>;
};


export type QueryRecyclingStoreTopListBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RecyclingStoreTopListBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<RecyclingStoreTopListBlockModelWhereInput>;
};


export type QueryRelatedLinksBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RelatedLinksBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<RelatedLinksBlockModelWhereInput>;
};


export type QueryResetButtonElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ResetButtonElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ResetButtonElementBlockWhereInput>;
};


export type QueryResponsiveImageBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ResponsiveImageBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ResponsiveImageBlockModelWhereInput>;
};


export type QueryScriptBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ScriptBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ScriptBlockWhereInput>;
};


export type QueryScriptImportBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ScriptImportBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ScriptImportBlockModelWhereInput>;
};


export type QuerySearchResultPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SearchResultPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SearchResultPageModelWhereInput>;
};


export type QuerySectionBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SectionBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SectionBlockModelWhereInput>;
};


export type QuerySelectionElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SelectionElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SelectionElementBlockWhereInput>;
};


export type QuerySeoBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SeoBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SeoBlockModelWhereInput>;
};


export type QuerySiteContextSettingsBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteContextSettingsBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteContextSettingsBlockModelWhereInput>;
};


export type QuerySiteDefinitionArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteDefinitionOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteDefinitionWhereInput>;
};


export type QuerySiteDocumentMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteDocumentMediaDataOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteDocumentMediaDataWhereInput>;
};


export type QuerySiteImageDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteImageDataOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteImageDataWhereInput>;
};


export type QuerySiteMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteMediaDataOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteMediaDataWhereInput>;
};


export type QuerySiteVideoDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteVideoDataOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteVideoDataWhereInput>;
};


export type QueryStandardBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StandardBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<StandardBlockModelWhereInput>;
};


export type QueryStandardPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StandardPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<StandardPageModelWhereInput>;
};


export type QueryStartPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StartPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<StartPageModelWhereInput>;
};


export type QueryStoreFlyersBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StoreFlyersBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<StoreFlyersBlockModelWhereInput>;
};


export type QuerySubmitButtonElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SubmitButtonElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SubmitButtonElementBlockWhereInput>;
};


export type QuerySwishCertificateBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SwishCertificateBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SwishCertificateBlockModelWhereInput>;
};


export type QuerySwishFormBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SwishFormBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SwishFormBlockModelWhereInput>;
};


export type QuerySwishRegistrationBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SwishRegistrationBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SwishRegistrationBlockModelWhereInput>;
};


export type QuerySwishStoreRegistrationBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SwishStoreRegistrationBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SwishStoreRegistrationBlockModelWhereInput>;
};


export type QueryTabBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TabBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TabBlockModelWhereInput>;
};


export type QueryTabItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TabItemOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TabItemWhereInput>;
};


export type QueryTeaserLinkBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TeaserLinkBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TeaserLinkBlockModelWhereInput>;
};


export type QueryTextBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TextBlockModelWhereInput>;
};


export type QueryTextareaElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextareaElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TextareaElementBlockWhereInput>;
};


export type QueryTextboxElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextboxElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TextboxElementBlockWhereInput>;
};


export type QueryUrlElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<UrlElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<UrlElementBlockWhereInput>;
};


export type QueryVisitorDataHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VisitorDataHiddenElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<VisitorDataHiddenElementBlockWhereInput>;
};


export type QueryWebShopLinkBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<WebShopLinkBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<WebShopLinkBlockModelWhereInput>;
};


export type QueryWordMediaModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<WordMediaModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<WordMediaModelWhereInput>;
};

export type QueryRef = {
  __typename?: 'QueryRef';
  ActivationPageModel?: Maybe<ActivationPageModelOutput>;
  AgreementPageModel?: Maybe<AgreementPageModelOutput>;
  AssociationBattleBlockModel?: Maybe<AssociationBattleBlockModelOutput>;
  AtoZPageModel?: Maybe<AtoZPageModelOutput>;
  ButtonLinkBlockModel?: Maybe<ButtonLinkBlockModelOutput>;
  CampaignBlock?: Maybe<CampaignBlockOutput>;
  CaptchaElementBlock?: Maybe<CaptchaElementBlockOutput>;
  ChoiceElementBlock?: Maybe<ChoiceElementBlockOutput>;
  CompanyRegistrationsBlockModel?: Maybe<CompanyRegistrationsBlockModelOutput>;
  CompensationBlockModel?: Maybe<CompensationBlockModelOutput>;
  ConnectedProducersListBlockModel?: Maybe<ConnectedProducersListBlockModelOutput>;
  Content?: Maybe<ContentOutput>;
  CsvMediaModel?: Maybe<CsvMediaModelOutput>;
  Data?: Maybe<DataOutput>;
  DepositLabelOrderBlockModel?: Maybe<DepositLabelOrderBlockModelOutput>;
  DepositLabelOrderHistoryBlockModel?: Maybe<DepositLabelOrderHistoryBlockModelOutput>;
  DownloadAssetLocalBlockModel?: Maybe<DownloadAssetLocalBlockModelOutput>;
  DownloadAssetVariant?: Maybe<DownloadAssetVariantOutput>;
  DownloadAssetsBlockModel?: Maybe<DownloadAssetsBlockModelOutput>;
  EanCheckBlockModel?: Maybe<EanCheckBlockModelOutput>;
  EmbedVideoBlockModel?: Maybe<EmbedVideoBlockModelOutput>;
  ErrorPageModel?: Maybe<ErrorPageModelOutput>;
  ExcelMediaModel?: Maybe<ExcelMediaModelOutput>;
  ExtendedLinkBlockModel?: Maybe<ExtendedLinkBlockModelOutput>;
  ExtraPickupFormBlockModel?: Maybe<ExtraPickupFormBlockModelOutput>;
  FaqCategoryPageModel?: Maybe<FaqCategoryPageModelOutput>;
  FaqItemPageModel?: Maybe<FaqItemPageModelOutput>;
  FaqListPageModel?: Maybe<FaqListPageModelOutput>;
  FeatureBlockModel?: Maybe<FeatureBlockModelOutput>;
  FileUploadElementBlock?: Maybe<FileUploadElementBlockOutput>;
  FormContainerBlock?: Maybe<FormContainerBlockOutput>;
  FormStepBlock?: Maybe<FormStepBlockOutput>;
  HeroBlockModel?: Maybe<HeroBlockModelOutput>;
  IFramePageModel?: Maybe<IFramePageModelOutput>;
  ImageAndTextBlockModel?: Maybe<ImageAndTextBlockModelOutput>;
  ImageBlockModel?: Maybe<ImageBlockModelOutput>;
  ImageChoiceElementBlock?: Maybe<ImageChoiceElementBlockOutput>;
  MainImageBlockModel?: Maybe<MainImageBlockModelOutput>;
  MainMenuPageModel?: Maybe<MainMenuPageModelOutput>;
  MyPagesAdminPageModel?: Maybe<MyPagesAdminPageModelOutput>;
  MyPagesBlockModel?: Maybe<MyPagesBlockModelOutput>;
  MyPagesContainerPageModel?: Maybe<MyPagesContainerPageModelOutput>;
  MyPagesPageModel?: Maybe<MyPagesPageModelOutput>;
  MyPagesStartPageModel?: Maybe<MyPagesStartPageModelOutput>;
  NewsContainerPageModel?: Maybe<NewsContainerPageModelOutput>;
  NewsPageModel?: Maybe<NewsPageModelOutput>;
  NominationBlockModel?: Maybe<NominationBlockModelOutput>;
  NumberElementBlock?: Maybe<NumberElementBlockOutput>;
  OrderAssetLocalBlockModel?: Maybe<OrderAssetLocalBlockModelOutput>;
  ParagraphTextElementBlock?: Maybe<ParagraphTextElementBlockOutput>;
  PexMapBlockModel?: Maybe<PexMapBlockModelOutput>;
  PopupBlockModel?: Maybe<PopupBlockModelOutput>;
  PptMediaModel?: Maybe<PptMediaModelOutput>;
  PredefinedHiddenElementBlock?: Maybe<PredefinedHiddenElementBlockOutput>;
  PrizePoolBlockModel?: Maybe<PrizePoolBlockModelOutput>;
  PrizePoolDistributionLocalBlockModel?: Maybe<PrizePoolDistributionLocalBlockModelOutput>;
  PrizePoolNumbersLocalBlockModel?: Maybe<PrizePoolNumbersLocalBlockModelOutput>;
  RangeElementBlock?: Maybe<RangeElementBlockOutput>;
  RecyclingStoreTopListBlockModel?: Maybe<RecyclingStoreTopListBlockModelOutput>;
  RelatedLinksBlockModel?: Maybe<RelatedLinksBlockModelOutput>;
  ResetButtonElementBlock?: Maybe<ResetButtonElementBlockOutput>;
  ResponsiveImageBlockModel?: Maybe<ResponsiveImageBlockModelOutput>;
  ScriptBlock?: Maybe<ScriptBlockOutput>;
  ScriptImportBlockModel?: Maybe<ScriptImportBlockModelOutput>;
  SearchResultPageModel?: Maybe<SearchResultPageModelOutput>;
  SectionBlockModel?: Maybe<SectionBlockModelOutput>;
  SelectionElementBlock?: Maybe<SelectionElementBlockOutput>;
  SeoBlockModel?: Maybe<SeoBlockModelOutput>;
  SiteContextSettingsBlockModel?: Maybe<SiteContextSettingsBlockModelOutput>;
  SiteDefinition?: Maybe<SiteDefinitionOutput>;
  SiteDocumentMediaData?: Maybe<SiteDocumentMediaDataOutput>;
  SiteImageData?: Maybe<SiteImageDataOutput>;
  SiteMediaData?: Maybe<SiteMediaDataOutput>;
  SiteVideoData?: Maybe<SiteVideoDataOutput>;
  StandardBlockModel?: Maybe<StandardBlockModelOutput>;
  StandardPageModel?: Maybe<StandardPageModelOutput>;
  StartPageModel?: Maybe<StartPageModelOutput>;
  StoreFlyersBlockModel?: Maybe<StoreFlyersBlockModelOutput>;
  SubmitButtonElementBlock?: Maybe<SubmitButtonElementBlockOutput>;
  SwishCertificateBlockModel?: Maybe<SwishCertificateBlockModelOutput>;
  SwishFormBlockModel?: Maybe<SwishFormBlockModelOutput>;
  SwishRegistrationBlockModel?: Maybe<SwishRegistrationBlockModelOutput>;
  SwishStoreRegistrationBlockModel?: Maybe<SwishStoreRegistrationBlockModelOutput>;
  TabBlockModel?: Maybe<TabBlockModelOutput>;
  TabItem?: Maybe<TabItemOutput>;
  TeaserLinkBlockModel?: Maybe<TeaserLinkBlockModelOutput>;
  TextBlockModel?: Maybe<TextBlockModelOutput>;
  TextareaElementBlock?: Maybe<TextareaElementBlockOutput>;
  TextboxElementBlock?: Maybe<TextboxElementBlockOutput>;
  UrlElementBlock?: Maybe<UrlElementBlockOutput>;
  VisitorDataHiddenElementBlock?: Maybe<VisitorDataHiddenElementBlockOutput>;
  WebShopLinkBlockModel?: Maybe<WebShopLinkBlockModelOutput>;
  WordMediaModel?: Maybe<WordMediaModelOutput>;
};


export type QueryRefActivationPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ActivationPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ActivationPageModelWhereInput>;
};


export type QueryRefAgreementPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AgreementPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<AgreementPageModelWhereInput>;
};


export type QueryRefAssociationBattleBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AssociationBattleBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<AssociationBattleBlockModelWhereInput>;
};


export type QueryRefAtoZPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<AtoZPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<AtoZPageModelWhereInput>;
};


export type QueryRefButtonLinkBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ButtonLinkBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ButtonLinkBlockModelWhereInput>;
};


export type QueryRefCampaignBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CampaignBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CampaignBlockWhereInput>;
};


export type QueryRefCaptchaElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CaptchaElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CaptchaElementBlockWhereInput>;
};


export type QueryRefChoiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ChoiceElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ChoiceElementBlockWhereInput>;
};


export type QueryRefCompanyRegistrationsBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompanyRegistrationsBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CompanyRegistrationsBlockModelWhereInput>;
};


export type QueryRefCompensationBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CompensationBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CompensationBlockModelWhereInput>;
};


export type QueryRefConnectedProducersListBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ConnectedProducersListBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ConnectedProducersListBlockModelWhereInput>;
};


export type QueryRefContentArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ContentOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryRefCsvMediaModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<CsvMediaModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<CsvMediaModelWhereInput>;
};


export type QueryRefDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<System_Locales>>>;
  orderBy?: InputMaybe<DataOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DataWhereInput>;
};


export type QueryRefDepositLabelOrderBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DepositLabelOrderBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DepositLabelOrderBlockModelWhereInput>;
};


export type QueryRefDepositLabelOrderHistoryBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DepositLabelOrderHistoryBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DepositLabelOrderHistoryBlockModelWhereInput>;
};


export type QueryRefDownloadAssetLocalBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DownloadAssetLocalBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DownloadAssetLocalBlockModelWhereInput>;
};


export type QueryRefDownloadAssetVariantArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DownloadAssetVariantOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DownloadAssetVariantWhereInput>;
};


export type QueryRefDownloadAssetsBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<DownloadAssetsBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<DownloadAssetsBlockModelWhereInput>;
};


export type QueryRefEanCheckBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EanCheckBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<EanCheckBlockModelWhereInput>;
};


export type QueryRefEmbedVideoBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<EmbedVideoBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<EmbedVideoBlockModelWhereInput>;
};


export type QueryRefErrorPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ErrorPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ErrorPageModelWhereInput>;
};


export type QueryRefExcelMediaModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ExcelMediaModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ExcelMediaModelWhereInput>;
};


export type QueryRefExtendedLinkBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ExtendedLinkBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ExtendedLinkBlockModelWhereInput>;
};


export type QueryRefExtraPickupFormBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ExtraPickupFormBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ExtraPickupFormBlockModelWhereInput>;
};


export type QueryRefFaqCategoryPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FaqCategoryPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FaqCategoryPageModelWhereInput>;
};


export type QueryRefFaqItemPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FaqItemPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FaqItemPageModelWhereInput>;
};


export type QueryRefFaqListPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FaqListPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FaqListPageModelWhereInput>;
};


export type QueryRefFeatureBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FeatureBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FeatureBlockModelWhereInput>;
};


export type QueryRefFileUploadElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FileUploadElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FileUploadElementBlockWhereInput>;
};


export type QueryRefFormContainerBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormContainerBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FormContainerBlockWhereInput>;
};


export type QueryRefFormStepBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<FormStepBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<FormStepBlockWhereInput>;
};


export type QueryRefHeroBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<HeroBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<HeroBlockModelWhereInput>;
};


export type QueryRefIFramePageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<IFramePageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<IFramePageModelWhereInput>;
};


export type QueryRefImageAndTextBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageAndTextBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ImageAndTextBlockModelWhereInput>;
};


export type QueryRefImageBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ImageBlockModelWhereInput>;
};


export type QueryRefImageChoiceElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ImageChoiceElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ImageChoiceElementBlockWhereInput>;
};


export type QueryRefMainImageBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MainImageBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MainImageBlockModelWhereInput>;
};


export type QueryRefMainMenuPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MainMenuPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MainMenuPageModelWhereInput>;
};


export type QueryRefMyPagesAdminPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MyPagesAdminPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MyPagesAdminPageModelWhereInput>;
};


export type QueryRefMyPagesBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MyPagesBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MyPagesBlockModelWhereInput>;
};


export type QueryRefMyPagesContainerPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MyPagesContainerPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MyPagesContainerPageModelWhereInput>;
};


export type QueryRefMyPagesPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MyPagesPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MyPagesPageModelWhereInput>;
};


export type QueryRefMyPagesStartPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<MyPagesStartPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<MyPagesStartPageModelWhereInput>;
};


export type QueryRefNewsContainerPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NewsContainerPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<NewsContainerPageModelWhereInput>;
};


export type QueryRefNewsPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NewsPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<NewsPageModelWhereInput>;
};


export type QueryRefNominationBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NominationBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<NominationBlockModelWhereInput>;
};


export type QueryRefNumberElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<NumberElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<NumberElementBlockWhereInput>;
};


export type QueryRefOrderAssetLocalBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<OrderAssetLocalBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<OrderAssetLocalBlockModelWhereInput>;
};


export type QueryRefParagraphTextElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ParagraphTextElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ParagraphTextElementBlockWhereInput>;
};


export type QueryRefPexMapBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PexMapBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PexMapBlockModelWhereInput>;
};


export type QueryRefPopupBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PopupBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PopupBlockModelWhereInput>;
};


export type QueryRefPptMediaModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PptMediaModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PptMediaModelWhereInput>;
};


export type QueryRefPredefinedHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PredefinedHiddenElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PredefinedHiddenElementBlockWhereInput>;
};


export type QueryRefPrizePoolBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrizePoolBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PrizePoolBlockModelWhereInput>;
};


export type QueryRefPrizePoolDistributionLocalBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrizePoolDistributionLocalBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PrizePoolDistributionLocalBlockModelWhereInput>;
};


export type QueryRefPrizePoolNumbersLocalBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<PrizePoolNumbersLocalBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<PrizePoolNumbersLocalBlockModelWhereInput>;
};


export type QueryRefRangeElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RangeElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<RangeElementBlockWhereInput>;
};


export type QueryRefRecyclingStoreTopListBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RecyclingStoreTopListBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<RecyclingStoreTopListBlockModelWhereInput>;
};


export type QueryRefRelatedLinksBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<RelatedLinksBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<RelatedLinksBlockModelWhereInput>;
};


export type QueryRefResetButtonElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ResetButtonElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ResetButtonElementBlockWhereInput>;
};


export type QueryRefResponsiveImageBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ResponsiveImageBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ResponsiveImageBlockModelWhereInput>;
};


export type QueryRefScriptBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ScriptBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ScriptBlockWhereInput>;
};


export type QueryRefScriptImportBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<ScriptImportBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<ScriptImportBlockModelWhereInput>;
};


export type QueryRefSearchResultPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SearchResultPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SearchResultPageModelWhereInput>;
};


export type QueryRefSectionBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SectionBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SectionBlockModelWhereInput>;
};


export type QueryRefSelectionElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SelectionElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SelectionElementBlockWhereInput>;
};


export type QueryRefSeoBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SeoBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SeoBlockModelWhereInput>;
};


export type QueryRefSiteContextSettingsBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteContextSettingsBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteContextSettingsBlockModelWhereInput>;
};


export type QueryRefSiteDefinitionArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteDefinitionOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteDefinitionWhereInput>;
};


export type QueryRefSiteDocumentMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteDocumentMediaDataOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteDocumentMediaDataWhereInput>;
};


export type QueryRefSiteImageDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteImageDataOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteImageDataWhereInput>;
};


export type QueryRefSiteMediaDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteMediaDataOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteMediaDataWhereInput>;
};


export type QueryRefSiteVideoDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SiteVideoDataOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SiteVideoDataWhereInput>;
};


export type QueryRefStandardBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StandardBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<StandardBlockModelWhereInput>;
};


export type QueryRefStandardPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StandardPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<StandardPageModelWhereInput>;
};


export type QueryRefStartPageModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StartPageModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<StartPageModelWhereInput>;
};


export type QueryRefStoreFlyersBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<StoreFlyersBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<StoreFlyersBlockModelWhereInput>;
};


export type QueryRefSubmitButtonElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SubmitButtonElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SubmitButtonElementBlockWhereInput>;
};


export type QueryRefSwishCertificateBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SwishCertificateBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SwishCertificateBlockModelWhereInput>;
};


export type QueryRefSwishFormBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SwishFormBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SwishFormBlockModelWhereInput>;
};


export type QueryRefSwishRegistrationBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SwishRegistrationBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SwishRegistrationBlockModelWhereInput>;
};


export type QueryRefSwishStoreRegistrationBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<SwishStoreRegistrationBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<SwishStoreRegistrationBlockModelWhereInput>;
};


export type QueryRefTabBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TabBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TabBlockModelWhereInput>;
};


export type QueryRefTabItemArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TabItemOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TabItemWhereInput>;
};


export type QueryRefTeaserLinkBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TeaserLinkBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TeaserLinkBlockModelWhereInput>;
};


export type QueryRefTextBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TextBlockModelWhereInput>;
};


export type QueryRefTextareaElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextareaElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TextareaElementBlockWhereInput>;
};


export type QueryRefTextboxElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<TextboxElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<TextboxElementBlockWhereInput>;
};


export type QueryRefUrlElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<UrlElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<UrlElementBlockWhereInput>;
};


export type QueryRefVisitorDataHiddenElementBlockArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<VisitorDataHiddenElementBlockOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<VisitorDataHiddenElementBlockWhereInput>;
};


export type QueryRefWebShopLinkBlockModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<WebShopLinkBlockModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<WebShopLinkBlockModelWhereInput>;
};


export type QueryRefWordMediaModelArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: Scalars['Int']['input'];
  locale?: InputMaybe<Array<InputMaybe<Locales>>>;
  orderBy?: InputMaybe<WordMediaModelOrderByInput>;
  pinned?: InputMaybe<PinnedInput>;
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<Array<InputMaybe<Sources>>>;
  tracking?: InputMaybe<TrackingInput>;
  variation?: InputMaybe<VariationInput>;
  where?: InputMaybe<WordMediaModelWhereInput>;
};

export type RangeElementBlock = IContent & IData & {
  __typename?: 'RangeElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Max?: Maybe<Scalars['Int']['output']>;
  Min?: Maybe<Scalars['Int']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PredefinedValue?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Step?: Maybe<Scalars['Int']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type RangeElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RangeElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RangeElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RangeElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RangeElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RangeElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RangeElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type RangeElementBlockAutocomplete = {
  __typename?: 'RangeElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type RangeElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RangeElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RangeElementBlockFacet = {
  __typename?: 'RangeElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Max?: Maybe<Array<Maybe<NumberFacet>>>;
  Min?: Maybe<Array<Maybe<NumberFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  Step?: Maybe<Array<Maybe<NumberFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type RangeElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RangeElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RangeElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RangeElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetMaxArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RangeElementBlockFacetMinArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RangeElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RangeElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RangeElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacetStepArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RangeElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RangeElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RangeElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RangeElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Max?: InputMaybe<OrderBy>;
  Min?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  Step?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type RangeElementBlockOutput = {
  __typename?: 'RangeElementBlockOutput';
  autocomplete?: Maybe<RangeElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<RangeElementBlockFacet>;
  item?: Maybe<RangeElementBlock>;
  items?: Maybe<Array<Maybe<RangeElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type RangeElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RangeElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Max?: InputMaybe<IntFilterInput>;
  Min?: InputMaybe<IntFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  Step?: InputMaybe<IntFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<RangeElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<RangeElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<RangeElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type RangeFacetsInput = {
  from?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
};

export enum Ranking {
  BoostOnly = 'BOOST_ONLY',
  Doc = 'DOC',
  Id = 'ID',
  Relevance = 'RELEVANCE',
  Semantic = 'SEMANTIC'
}

export type RecyclingStoreTopListBlockModel = IContent & IData & {
  __typename?: 'RecyclingStoreTopListBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TopListDescription?: Maybe<MixedHtmlModelSearch>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type RecyclingStoreTopListBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RecyclingStoreTopListBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RecyclingStoreTopListBlockModelTopListDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RecyclingStoreTopListBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RecyclingStoreTopListBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type RecyclingStoreTopListBlockModelAutocomplete = {
  __typename?: 'RecyclingStoreTopListBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type RecyclingStoreTopListBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecyclingStoreTopListBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecyclingStoreTopListBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecyclingStoreTopListBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecyclingStoreTopListBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecyclingStoreTopListBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecyclingStoreTopListBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecyclingStoreTopListBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RecyclingStoreTopListBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RecyclingStoreTopListBlockModelFacet = {
  __typename?: 'RecyclingStoreTopListBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TopListDescription?: Maybe<MixedHtmlModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type RecyclingStoreTopListBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecyclingStoreTopListBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RecyclingStoreTopListBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecyclingStoreTopListBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RecyclingStoreTopListBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecyclingStoreTopListBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecyclingStoreTopListBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecyclingStoreTopListBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecyclingStoreTopListBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecyclingStoreTopListBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RecyclingStoreTopListBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecyclingStoreTopListBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecyclingStoreTopListBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RecyclingStoreTopListBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecyclingStoreTopListBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RecyclingStoreTopListBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RecyclingStoreTopListBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RecyclingStoreTopListBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TopListDescription?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type RecyclingStoreTopListBlockModelOutput = {
  __typename?: 'RecyclingStoreTopListBlockModelOutput';
  autocomplete?: Maybe<RecyclingStoreTopListBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<RecyclingStoreTopListBlockModelFacet>;
  item?: Maybe<RecyclingStoreTopListBlockModel>;
  items?: Maybe<Array<Maybe<RecyclingStoreTopListBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type RecyclingStoreTopListBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecyclingStoreTopListBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TopListDescription?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<RecyclingStoreTopListBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<RecyclingStoreTopListBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<RecyclingStoreTopListBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type RelatedLinksBlockModel = IContent & IData & {
  __typename?: 'RelatedLinksBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinksContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  LinksContentAreaColorTheme?: Maybe<Scalars['Int']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type RelatedLinksBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RelatedLinksBlockModelLinksContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RelatedLinksBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RelatedLinksBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type RelatedLinksBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type RelatedLinksBlockModelAutocomplete = {
  __typename?: 'RelatedLinksBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type RelatedLinksBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RelatedLinksBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RelatedLinksBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RelatedLinksBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RelatedLinksBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RelatedLinksBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RelatedLinksBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RelatedLinksBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type RelatedLinksBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type RelatedLinksBlockModelFacet = {
  __typename?: 'RelatedLinksBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinksContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  LinksContentAreaColorTheme?: Maybe<Array<Maybe<NumberFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type RelatedLinksBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RelatedLinksBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RelatedLinksBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RelatedLinksBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RelatedLinksBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RelatedLinksBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RelatedLinksBlockModelFacetLinksContentAreaColorThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type RelatedLinksBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RelatedLinksBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RelatedLinksBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RelatedLinksBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RelatedLinksBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RelatedLinksBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RelatedLinksBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RelatedLinksBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RelatedLinksBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type RelatedLinksBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type RelatedLinksBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type RelatedLinksBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinksContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  LinksContentAreaColorTheme?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type RelatedLinksBlockModelOutput = {
  __typename?: 'RelatedLinksBlockModelOutput';
  autocomplete?: Maybe<RelatedLinksBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<RelatedLinksBlockModelFacet>;
  item?: Maybe<RelatedLinksBlockModel>;
  items?: Maybe<Array<Maybe<RelatedLinksBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type RelatedLinksBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RelatedLinksBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinksContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  LinksContentAreaColorTheme?: InputMaybe<IntFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<RelatedLinksBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<RelatedLinksBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<RelatedLinksBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type ResetButtonElementBlock = IContent & IData & {
  __typename?: 'ResetButtonElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ResetButtonElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ResetButtonElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ResetButtonElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ResetButtonElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ResetButtonElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ResetButtonElementBlockAutocomplete = {
  __typename?: 'ResetButtonElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ResetButtonElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResetButtonElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResetButtonElementBlockFacet = {
  __typename?: 'ResetButtonElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ResetButtonElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResetButtonElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResetButtonElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResetButtonElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResetButtonElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResetButtonElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResetButtonElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResetButtonElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ResetButtonElementBlockOutput = {
  __typename?: 'ResetButtonElementBlockOutput';
  autocomplete?: Maybe<ResetButtonElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ResetButtonElementBlockFacet>;
  item?: Maybe<ResetButtonElementBlock>;
  items?: Maybe<Array<Maybe<ResetButtonElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ResetButtonElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResetButtonElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ResetButtonElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ResetButtonElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ResetButtonElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type ResponsiveImageBlockModel = IContent & IData & {
  __typename?: 'ResponsiveImageBlockModel';
  Alt?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ImageReference?: Maybe<ContentModelReference>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SmallDeviceImageReference?: Maybe<ContentModelReference>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ResponsiveImageBlockModelAltArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ResponsiveImageBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ResponsiveImageBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ResponsiveImageBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ResponsiveImageBlockModelAutocomplete = {
  __typename?: 'ResponsiveImageBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SmallDeviceImageReference?: Maybe<ContentModelReferenceAutocomplete>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ResponsiveImageBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResponsiveImageBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResponsiveImageBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResponsiveImageBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResponsiveImageBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResponsiveImageBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResponsiveImageBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResponsiveImageBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ResponsiveImageBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ResponsiveImageBlockModelFacet = {
  __typename?: 'ResponsiveImageBlockModelFacet';
  Alt?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ImageReference?: Maybe<ContentModelReferenceFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SmallDeviceImageReference?: Maybe<ContentModelReferenceFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ResponsiveImageBlockModelFacetAltArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResponsiveImageBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResponsiveImageBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResponsiveImageBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResponsiveImageBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResponsiveImageBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResponsiveImageBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResponsiveImageBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResponsiveImageBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResponsiveImageBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResponsiveImageBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResponsiveImageBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResponsiveImageBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResponsiveImageBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResponsiveImageBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ResponsiveImageBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ResponsiveImageBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ResponsiveImageBlockModelOrderByInput = {
  Alt?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SmallDeviceImageReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ResponsiveImageBlockModelOutput = {
  __typename?: 'ResponsiveImageBlockModelOutput';
  autocomplete?: Maybe<ResponsiveImageBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ResponsiveImageBlockModelFacet>;
  item?: Maybe<ResponsiveImageBlockModel>;
  items?: Maybe<Array<Maybe<ResponsiveImageBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ResponsiveImageBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResponsiveImageBlockModelWhereInput = {
  Alt?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SmallDeviceImageReference?: InputMaybe<ContentModelReferenceWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ResponsiveImageBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ResponsiveImageBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ResponsiveImageBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type ScriptBlock = IContent & IData & {
  __typename?: 'ScriptBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  ScriptText?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ScriptBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ScriptBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ScriptBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ScriptBlockAutocomplete = {
  __typename?: 'ScriptBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ScriptText?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ScriptBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptBlockAutocompleteScriptTextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ScriptBlockFacet = {
  __typename?: 'ScriptBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ScriptText?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ScriptBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ScriptBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ScriptBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ScriptBlockFacetScriptTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ScriptBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ScriptBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ScriptBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ScriptText?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ScriptBlockOutput = {
  __typename?: 'ScriptBlockOutput';
  autocomplete?: Maybe<ScriptBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ScriptBlockFacet>;
  item?: Maybe<ScriptBlock>;
  items?: Maybe<Array<Maybe<ScriptBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ScriptBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScriptBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ScriptText?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ScriptBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ScriptBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ScriptBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type ScriptImportBlockModel = IContent & IData & {
  __typename?: 'ScriptImportBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  ScriptImportBottom?: Maybe<Scalars['String']['output']>;
  ScriptImportHead?: Maybe<Scalars['String']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type ScriptImportBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ScriptImportBlockModelScriptImportBottomArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ScriptImportBlockModelScriptImportHeadArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ScriptImportBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type ScriptImportBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type ScriptImportBlockModelAutocomplete = {
  __typename?: 'ScriptImportBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type ScriptImportBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptImportBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptImportBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptImportBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptImportBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptImportBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptImportBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptImportBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type ScriptImportBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ScriptImportBlockModelFacet = {
  __typename?: 'ScriptImportBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  ScriptImportBottom?: Maybe<Array<Maybe<StringFacet>>>;
  ScriptImportHead?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type ScriptImportBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptImportBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ScriptImportBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptImportBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ScriptImportBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptImportBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptImportBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptImportBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptImportBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ScriptImportBlockModelFacetScriptImportBottomArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptImportBlockModelFacetScriptImportHeadArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptImportBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptImportBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptImportBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ScriptImportBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptImportBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type ScriptImportBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type ScriptImportBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type ScriptImportBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  ScriptImportBottom?: InputMaybe<OrderBy>;
  ScriptImportHead?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type ScriptImportBlockModelOutput = {
  __typename?: 'ScriptImportBlockModelOutput';
  autocomplete?: Maybe<ScriptImportBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<ScriptImportBlockModelFacet>;
  item?: Maybe<ScriptImportBlockModel>;
  items?: Maybe<Array<Maybe<ScriptImportBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type ScriptImportBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScriptImportBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  ScriptImportBottom?: InputMaybe<SearchableStringFilterInput>;
  ScriptImportHead?: InputMaybe<SearchableStringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<ScriptImportBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<ScriptImportBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<ScriptImportBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SearchResultPageModel = IContent & IData & {
  __typename?: 'SearchResultPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SearchResultPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchResultPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchResultPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchResultPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchResultPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchResultPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SearchResultPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SearchResultPageModelAutocomplete = {
  __typename?: 'SearchResultPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SearchResultPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchResultPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchResultPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchResultPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchResultPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchResultPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchResultPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchResultPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchResultPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchResultPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchResultPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchResultPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SearchResultPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SearchResultPageModelFacet = {
  __typename?: 'SearchResultPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SearchResultPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchResultPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchResultPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchResultPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchResultPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchResultPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SearchResultPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SearchResultPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SearchResultPageModelOutput = {
  __typename?: 'SearchResultPageModelOutput';
  autocomplete?: Maybe<SearchResultPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SearchResultPageModelFacet>;
  item?: Maybe<SearchResultPageModel>;
  items?: Maybe<Array<Maybe<SearchResultPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SearchResultPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchResultPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SearchResultPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SearchResultPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SearchResultPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SearchableStringFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `contains` performs full-text search on a word or phrase. */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** enables supporting fuzzy matching on the query terms (keywords), which returns items that contain terms in the content similar to the keywords, as measured by a _Levenshtein edit distance_. An edit distance is the number of one-character changes needed to turn one term into another. The edit distance is based on the length of the term.  */
  fuzzy?: InputMaybe<Scalars['Boolean']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `like` matches on substrings with wildcard support: `%` to match on 0 or more characters, `_` to match on any character.  */
  like?: InputMaybe<Scalars['String']['input']>;
  /** `match` performs full-text search on a word or phrase where less relevant items are also returned. The `match` operator is only supported for `searchable` fields. It will improve fulltext search by making it easier to match on words. More exact matches will be ranked higher, less exact matches will be ranked lower. The `match` operator is supported with synonyms and fuzzy search. */
  match?: InputMaybe<Scalars['String']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `starts_with` retrieves matches that start with a certain value (prefix). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** expands query value with synonyms. Example: if `H2O` is a synonym of `water`, then querying for `water` will also return results with `H2O`. */
  synonyms?: InputMaybe<Array<InputMaybe<SynonymSlot>>>;
};

export type SectionBlockModel = IContent & IData & {
  __typename?: 'SectionBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackgroundColor?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  CenterHeading?: Maybe<Scalars['Bool']['output']>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  HeadingOnlyForScreenReader?: Maybe<Scalars['Bool']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SitePagePartialColorTheme?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SectionBlockModelBackgroundColorArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionBlockModelContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionBlockModelSitePagePartialColorThemeArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SectionBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SectionBlockModelAutocomplete = {
  __typename?: 'SectionBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SectionBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SectionBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SectionBlockModelFacet = {
  __typename?: 'SectionBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackgroundColor?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  CenterHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingOnlyForScreenReader?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SitePagePartialColorTheme?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SectionBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetBackgroundColorArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetCenterHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetHeadingOnlyForScreenReaderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetSitePagePartialColorThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SectionBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SectionBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackgroundColor?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  CenterHeading?: InputMaybe<OrderBy>;
  Changed?: InputMaybe<OrderBy>;
  ContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  HeadingOnlyForScreenReader?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SitePagePartialColorTheme?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SectionBlockModelOutput = {
  __typename?: 'SectionBlockModelOutput';
  autocomplete?: Maybe<SectionBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SectionBlockModelFacet>;
  item?: Maybe<SectionBlockModel>;
  items?: Maybe<Array<Maybe<SectionBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SectionBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SectionBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackgroundColor?: InputMaybe<SearchableStringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  CenterHeading?: InputMaybe<BoolFilterInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HeadingOnlyForScreenReader?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SitePagePartialColorTheme?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SectionBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SectionBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SectionBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SelectionElementBlock = IContent & IData & {
  __typename?: 'SelectionElementBlock';
  AllowMultiSelect?: Maybe<Scalars['Bool']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AutoComplete?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Feed?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SelectionElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlockFeedArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SelectionElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SelectionElementBlockAutocomplete = {
  __typename?: 'SelectionElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SelectionElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SelectionElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SelectionElementBlockFacet = {
  __typename?: 'SelectionElementBlockFacet';
  AllowMultiSelect?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Feed?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SelectionElementBlockFacetAllowMultiSelectArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SelectionElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelectionElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SelectionElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelectionElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetFeedArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelectionElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelectionElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SelectionElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SelectionElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SelectionElementBlockOrderByInput = {
  AllowMultiSelect?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Feed?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SelectionElementBlockOutput = {
  __typename?: 'SelectionElementBlockOutput';
  autocomplete?: Maybe<SelectionElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SelectionElementBlockFacet>;
  item?: Maybe<SelectionElementBlock>;
  items?: Maybe<Array<Maybe<SelectionElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SelectionElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SelectionElementBlockWhereInput = {
  AllowMultiSelect?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Feed?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SelectionElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SelectionElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SelectionElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SeoBlockModel = IContent & IData & {
  __typename?: 'SeoBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SeoBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SeoBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SeoBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SeoBlockModelAutocomplete = {
  __typename?: 'SeoBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SeoBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SeoBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SeoBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SeoBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SeoBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SeoBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SeoBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SeoBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SeoBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SeoBlockModelFacet = {
  __typename?: 'SeoBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SeoBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SeoBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SeoBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SeoBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SeoBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SeoBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SeoBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SeoBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SeoBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SeoBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SeoBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SeoBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SeoBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SeoBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SeoBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SeoBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SeoBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SeoBlockModelOutput = {
  __typename?: 'SeoBlockModelOutput';
  autocomplete?: Maybe<SeoBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SeoBlockModelFacet>;
  item?: Maybe<SeoBlockModel>;
  items?: Maybe<Array<Maybe<SeoBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SeoBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SeoBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SeoBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SeoBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SeoBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SiteContextSettingsBlockModel = IContent & IData & {
  __typename?: 'SiteContextSettingsBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SiteSelection?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SiteContextSettingsBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteContextSettingsBlockModelSiteSelectionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteContextSettingsBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteContextSettingsBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SiteContextSettingsBlockModelAutocomplete = {
  __typename?: 'SiteContextSettingsBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteContextSettingsBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteContextSettingsBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteContextSettingsBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteContextSettingsBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteContextSettingsBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteContextSettingsBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteContextSettingsBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteContextSettingsBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteContextSettingsBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteContextSettingsBlockModelFacet = {
  __typename?: 'SiteContextSettingsBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SiteSelection?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteContextSettingsBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteContextSettingsBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteContextSettingsBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteContextSettingsBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteContextSettingsBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteContextSettingsBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteContextSettingsBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteContextSettingsBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteContextSettingsBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteContextSettingsBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteContextSettingsBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteContextSettingsBlockModelFacetSiteSelectionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteContextSettingsBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteContextSettingsBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteContextSettingsBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteContextSettingsBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteContextSettingsBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteContextSettingsBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SiteSelection?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SiteContextSettingsBlockModelOutput = {
  __typename?: 'SiteContextSettingsBlockModelOutput';
  autocomplete?: Maybe<SiteContextSettingsBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SiteContextSettingsBlockModelFacet>;
  item?: Maybe<SiteContextSettingsBlockModel>;
  items?: Maybe<Array<Maybe<SiteContextSettingsBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SiteContextSettingsBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteContextSettingsBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SiteSelection?: InputMaybe<SearchableStringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SiteContextSettingsBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SiteContextSettingsBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SiteContextSettingsBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SiteDefinition = IData & {
  __typename?: 'SiteDefinition';
  ContentLink?: Maybe<ContentModelReference>;
  ContentRoots?: Maybe<ContentRootsModel>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EditLocation?: Maybe<Scalars['String']['output']>;
  Hosts?: Maybe<Array<Maybe<HostDefinitionModel>>>;
  Id?: Maybe<Scalars['String']['output']>;
  Languages?: Maybe<Array<Maybe<SiteDefinitionLanguageModel>>>;
  Name?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SiteDefinitionNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDefinition_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDefinition_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SiteDefinitionAutocomplete = {
  __typename?: 'SiteDefinitionAutocomplete';
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentRoots?: Maybe<ContentRootsModelAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  EditLocation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Hosts?: Maybe<HostDefinitionModelAutocomplete>;
  Id?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Languages?: Maybe<SiteDefinitionLanguageModelAutocomplete>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteDefinitionAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionAutocompleteEditLocationArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionAutocompleteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionFacet = {
  __typename?: 'SiteDefinitionFacet';
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentRoots?: Maybe<ContentRootsModelFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  EditLocation?: Maybe<Array<Maybe<StringFacet>>>;
  Hosts?: Maybe<HostDefinitionModelFacet>;
  Id?: Maybe<Array<Maybe<StringFacet>>>;
  Languages?: Maybe<SiteDefinitionLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteDefinitionFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetEditLocationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModel = {
  __typename?: 'SiteDefinitionLanguageModel';
  DisplayName?: Maybe<Scalars['String']['output']>;
  IsMasterLanguage?: Maybe<Scalars['Bool']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  UrlSegment?: Maybe<Scalars['String']['output']>;
};

export type SiteDefinitionLanguageModelAutocomplete = {
  __typename?: 'SiteDefinitionLanguageModelAutocomplete';
  DisplayName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  UrlSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteDefinitionLanguageModelAutocompleteDisplayNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionLanguageModelAutocompleteNameArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionLanguageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDefinitionLanguageModelAutocompleteUrlSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDefinitionLanguageModelFacet = {
  __typename?: 'SiteDefinitionLanguageModelFacet';
  DisplayName?: Maybe<Array<Maybe<StringFacet>>>;
  IsMasterLanguage?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  UrlSegment?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteDefinitionLanguageModelFacetDisplayNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetIsMasterLanguageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDefinitionLanguageModelFacetUrlSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDefinitionLanguageModelOrderByInput = {
  DisplayName?: InputMaybe<OrderBy>;
  IsMasterLanguage?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  UrlSegment?: InputMaybe<OrderBy>;
};

export type SiteDefinitionLanguageModelWhereInput = {
  DisplayName?: InputMaybe<StringFilterInput>;
  IsMasterLanguage?: InputMaybe<BoolFilterInput>;
  Name?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  UrlSegment?: InputMaybe<StringFilterInput>;
};

export type SiteDefinitionOrderByInput = {
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentRoots?: InputMaybe<ContentRootsModelOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  EditLocation?: InputMaybe<OrderBy>;
  Hosts?: InputMaybe<HostDefinitionModelOrderByInput>;
  Id?: InputMaybe<OrderBy>;
  Languages?: InputMaybe<SiteDefinitionLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SiteDefinitionOutput = {
  __typename?: 'SiteDefinitionOutput';
  autocomplete?: Maybe<SiteDefinitionAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SiteDefinitionFacet>;
  item?: Maybe<SiteDefinition>;
  items?: Maybe<Array<Maybe<SiteDefinition>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SiteDefinitionOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteDefinitionWhereInput = {
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentRoots?: InputMaybe<ContentRootsModelWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  EditLocation?: InputMaybe<StringFilterInput>;
  Hosts?: InputMaybe<HostDefinitionModelWhereInput>;
  Id?: InputMaybe<StringFilterInput>;
  Languages?: InputMaybe<SiteDefinitionLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SiteDefinitionWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SiteDocumentMediaData = IContent & IData & {
  __typename?: 'SiteDocumentMediaData';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LanguageBranch?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SiteDocumentMediaDataContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDocumentMediaDataDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDocumentMediaDataLanguageBranchArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDocumentMediaDataMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDocumentMediaDataNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDocumentMediaData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteDocumentMediaData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SiteDocumentMediaDataAutocomplete = {
  __typename?: 'SiteDocumentMediaDataAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteDocumentMediaDataAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDocumentMediaDataAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDocumentMediaDataAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDocumentMediaDataAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDocumentMediaDataAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDocumentMediaDataAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDocumentMediaDataAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDocumentMediaDataAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDocumentMediaDataAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteDocumentMediaDataAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteDocumentMediaDataFacet = {
  __typename?: 'SiteDocumentMediaDataFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LanguageBranch?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteDocumentMediaDataFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteDocumentMediaDataFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteDocumentMediaDataFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetLanguageBranchArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteDocumentMediaDataFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteDocumentMediaDataFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteDocumentMediaDataFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteDocumentMediaDataFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteDocumentMediaDataOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LanguageBranch?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SiteDocumentMediaDataOutput = {
  __typename?: 'SiteDocumentMediaDataOutput';
  autocomplete?: Maybe<SiteDocumentMediaDataAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SiteDocumentMediaDataFacet>;
  item?: Maybe<SiteDocumentMediaData>;
  items?: Maybe<Array<Maybe<SiteDocumentMediaData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SiteDocumentMediaDataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteDocumentMediaDataWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LanguageBranch?: InputMaybe<SearchableStringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SiteDocumentMediaDataWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SiteDocumentMediaDataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SiteDocumentMediaDataWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SiteImageData = IContent & IData & {
  __typename?: 'SiteImageData';
  AltText?: Maybe<Scalars['String']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Copyright?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  Portrait320x720?: Maybe<BlobModel>;
  Portrait375x833?: Maybe<BlobModel>;
  Portrait414x920?: Maybe<BlobModel>;
  Portrait828x1845?: Maybe<BlobModel>;
  Portrait1170x2606?: Maybe<BlobModel>;
  Portrait1242x2787?: Maybe<BlobModel>;
  Portrait1284x2856?: Maybe<BlobModel>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  Width384w?: Maybe<BlobModel>;
  Width480w?: Maybe<BlobModel>;
  Width576w?: Maybe<BlobModel>;
  Width640w?: Maybe<BlobModel>;
  Width704w?: Maybe<BlobModel>;
  Width768w?: Maybe<BlobModel>;
  Width832w?: Maybe<BlobModel>;
  Width896w?: Maybe<BlobModel>;
  Width960w?: Maybe<BlobModel>;
  Width992w?: Maybe<BlobModel>;
  Width1056w?: Maybe<BlobModel>;
  Width1200w?: Maybe<BlobModel>;
  Width1344w?: Maybe<BlobModel>;
  Width1400w?: Maybe<BlobModel>;
  Width1488w?: Maybe<BlobModel>;
  Width1632w?: Maybe<BlobModel>;
  Width1776w?: Maybe<BlobModel>;
  Width1920w?: Maybe<BlobModel>;
  Width2800w?: Maybe<BlobModel>;
  Width3840w?: Maybe<BlobModel>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SiteImageDataAltTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteImageDataContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteImageDataCopyrightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteImageDataNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteImageData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteImageData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SiteImageDataAutocomplete = {
  __typename?: 'SiteImageDataAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Portrait320x720?: Maybe<BlobModelAutocomplete>;
  Portrait375x833?: Maybe<BlobModelAutocomplete>;
  Portrait414x920?: Maybe<BlobModelAutocomplete>;
  Portrait828x1845?: Maybe<BlobModelAutocomplete>;
  Portrait1170x2606?: Maybe<BlobModelAutocomplete>;
  Portrait1242x2787?: Maybe<BlobModelAutocomplete>;
  Portrait1284x2856?: Maybe<BlobModelAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Width384w?: Maybe<BlobModelAutocomplete>;
  Width480w?: Maybe<BlobModelAutocomplete>;
  Width576w?: Maybe<BlobModelAutocomplete>;
  Width640w?: Maybe<BlobModelAutocomplete>;
  Width704w?: Maybe<BlobModelAutocomplete>;
  Width768w?: Maybe<BlobModelAutocomplete>;
  Width832w?: Maybe<BlobModelAutocomplete>;
  Width896w?: Maybe<BlobModelAutocomplete>;
  Width960w?: Maybe<BlobModelAutocomplete>;
  Width992w?: Maybe<BlobModelAutocomplete>;
  Width1056w?: Maybe<BlobModelAutocomplete>;
  Width1200w?: Maybe<BlobModelAutocomplete>;
  Width1344w?: Maybe<BlobModelAutocomplete>;
  Width1400w?: Maybe<BlobModelAutocomplete>;
  Width1488w?: Maybe<BlobModelAutocomplete>;
  Width1632w?: Maybe<BlobModelAutocomplete>;
  Width1776w?: Maybe<BlobModelAutocomplete>;
  Width1920w?: Maybe<BlobModelAutocomplete>;
  Width2800w?: Maybe<BlobModelAutocomplete>;
  Width3840w?: Maybe<BlobModelAutocomplete>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteImageDataAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteImageDataAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteImageDataAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteImageDataAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteImageDataAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteImageDataAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteImageDataAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteImageDataAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteImageDataAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteImageDataAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteImageDataFacet = {
  __typename?: 'SiteImageDataFacet';
  AltText?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Copyright?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  Portrait320x720?: Maybe<BlobModelFacet>;
  Portrait375x833?: Maybe<BlobModelFacet>;
  Portrait414x920?: Maybe<BlobModelFacet>;
  Portrait828x1845?: Maybe<BlobModelFacet>;
  Portrait1170x2606?: Maybe<BlobModelFacet>;
  Portrait1242x2787?: Maybe<BlobModelFacet>;
  Portrait1284x2856?: Maybe<BlobModelFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Width384w?: Maybe<BlobModelFacet>;
  Width480w?: Maybe<BlobModelFacet>;
  Width576w?: Maybe<BlobModelFacet>;
  Width640w?: Maybe<BlobModelFacet>;
  Width704w?: Maybe<BlobModelFacet>;
  Width768w?: Maybe<BlobModelFacet>;
  Width832w?: Maybe<BlobModelFacet>;
  Width896w?: Maybe<BlobModelFacet>;
  Width960w?: Maybe<BlobModelFacet>;
  Width992w?: Maybe<BlobModelFacet>;
  Width1056w?: Maybe<BlobModelFacet>;
  Width1200w?: Maybe<BlobModelFacet>;
  Width1344w?: Maybe<BlobModelFacet>;
  Width1400w?: Maybe<BlobModelFacet>;
  Width1488w?: Maybe<BlobModelFacet>;
  Width1632w?: Maybe<BlobModelFacet>;
  Width1776w?: Maybe<BlobModelFacet>;
  Width1920w?: Maybe<BlobModelFacet>;
  Width2800w?: Maybe<BlobModelFacet>;
  Width3840w?: Maybe<BlobModelFacet>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteImageDataFacetAltTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteImageDataFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacetCopyrightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteImageDataFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SiteImageDataFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteImageDataFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteImageDataFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteImageDataFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteImageDataFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteImageDataOrderByInput = {
  AltText?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Copyright?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  Portrait320x720?: InputMaybe<BlobModelOrderByInput>;
  Portrait375x833?: InputMaybe<BlobModelOrderByInput>;
  Portrait414x920?: InputMaybe<BlobModelOrderByInput>;
  Portrait828x1845?: InputMaybe<BlobModelOrderByInput>;
  Portrait1170x2606?: InputMaybe<BlobModelOrderByInput>;
  Portrait1242x2787?: InputMaybe<BlobModelOrderByInput>;
  Portrait1284x2856?: InputMaybe<BlobModelOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  Width384w?: InputMaybe<BlobModelOrderByInput>;
  Width480w?: InputMaybe<BlobModelOrderByInput>;
  Width576w?: InputMaybe<BlobModelOrderByInput>;
  Width640w?: InputMaybe<BlobModelOrderByInput>;
  Width704w?: InputMaybe<BlobModelOrderByInput>;
  Width768w?: InputMaybe<BlobModelOrderByInput>;
  Width832w?: InputMaybe<BlobModelOrderByInput>;
  Width896w?: InputMaybe<BlobModelOrderByInput>;
  Width960w?: InputMaybe<BlobModelOrderByInput>;
  Width992w?: InputMaybe<BlobModelOrderByInput>;
  Width1056w?: InputMaybe<BlobModelOrderByInput>;
  Width1200w?: InputMaybe<BlobModelOrderByInput>;
  Width1344w?: InputMaybe<BlobModelOrderByInput>;
  Width1400w?: InputMaybe<BlobModelOrderByInput>;
  Width1488w?: InputMaybe<BlobModelOrderByInput>;
  Width1632w?: InputMaybe<BlobModelOrderByInput>;
  Width1776w?: InputMaybe<BlobModelOrderByInput>;
  Width1920w?: InputMaybe<BlobModelOrderByInput>;
  Width2800w?: InputMaybe<BlobModelOrderByInput>;
  Width3840w?: InputMaybe<BlobModelOrderByInput>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SiteImageDataOutput = {
  __typename?: 'SiteImageDataOutput';
  autocomplete?: Maybe<SiteImageDataAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SiteImageDataFacet>;
  item?: Maybe<SiteImageData>;
  items?: Maybe<Array<Maybe<SiteImageData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SiteImageDataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteImageDataWhereInput = {
  AltText?: InputMaybe<SearchableStringFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Copyright?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  Portrait320x720?: InputMaybe<BlobModelWhereInput>;
  Portrait375x833?: InputMaybe<BlobModelWhereInput>;
  Portrait414x920?: InputMaybe<BlobModelWhereInput>;
  Portrait828x1845?: InputMaybe<BlobModelWhereInput>;
  Portrait1170x2606?: InputMaybe<BlobModelWhereInput>;
  Portrait1242x2787?: InputMaybe<BlobModelWhereInput>;
  Portrait1284x2856?: InputMaybe<BlobModelWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  Width384w?: InputMaybe<BlobModelWhereInput>;
  Width480w?: InputMaybe<BlobModelWhereInput>;
  Width576w?: InputMaybe<BlobModelWhereInput>;
  Width640w?: InputMaybe<BlobModelWhereInput>;
  Width704w?: InputMaybe<BlobModelWhereInput>;
  Width768w?: InputMaybe<BlobModelWhereInput>;
  Width832w?: InputMaybe<BlobModelWhereInput>;
  Width896w?: InputMaybe<BlobModelWhereInput>;
  Width960w?: InputMaybe<BlobModelWhereInput>;
  Width992w?: InputMaybe<BlobModelWhereInput>;
  Width1056w?: InputMaybe<BlobModelWhereInput>;
  Width1200w?: InputMaybe<BlobModelWhereInput>;
  Width1344w?: InputMaybe<BlobModelWhereInput>;
  Width1400w?: InputMaybe<BlobModelWhereInput>;
  Width1488w?: InputMaybe<BlobModelWhereInput>;
  Width1632w?: InputMaybe<BlobModelWhereInput>;
  Width1776w?: InputMaybe<BlobModelWhereInput>;
  Width1920w?: InputMaybe<BlobModelWhereInput>;
  Width2800w?: InputMaybe<BlobModelWhereInput>;
  Width3840w?: InputMaybe<BlobModelWhereInput>;
  _and?: InputMaybe<Array<InputMaybe<SiteImageDataWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SiteImageDataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SiteImageDataWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SiteMediaData = IContent & IData & {
  __typename?: 'SiteMediaData';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['Int']['output']>;
  HeadingEn?: Maybe<Scalars['String']['output']>;
  HeadingSv?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreambleEn?: Maybe<Scalars['String']['output']>;
  PreambleSv?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SiteMediaDataContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteMediaDataDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteMediaDataHeadingEnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteMediaDataHeadingSvArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteMediaDataNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteMediaDataPreambleEnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteMediaDataPreambleSvArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteMediaData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteMediaData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SiteMediaDataAutocomplete = {
  __typename?: 'SiteMediaDataAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteMediaDataAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteMediaDataAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteMediaDataAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteMediaDataAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteMediaDataAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteMediaDataAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteMediaDataAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteMediaDataAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteMediaDataAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteMediaDataAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteMediaDataFacet = {
  __typename?: 'SiteMediaDataFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<NumberFacet>>>;
  HeadingEn?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingSv?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreambleEn?: Maybe<Array<Maybe<StringFacet>>>;
  PreambleSv?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteMediaDataFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteMediaDataFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteMediaDataFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SiteMediaDataFacetHeadingEnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetHeadingSvArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetPreambleEnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetPreambleSvArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteMediaDataFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteMediaDataFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteMediaDataFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteMediaDataFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteMediaDataOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  HeadingEn?: InputMaybe<OrderBy>;
  HeadingSv?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreambleEn?: InputMaybe<OrderBy>;
  PreambleSv?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SiteMediaDataOutput = {
  __typename?: 'SiteMediaDataOutput';
  autocomplete?: Maybe<SiteMediaDataAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SiteMediaDataFacet>;
  item?: Maybe<SiteMediaData>;
  items?: Maybe<Array<Maybe<SiteMediaData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SiteMediaDataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteMediaDataWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<IntFilterInput>;
  HeadingEn?: InputMaybe<SearchableStringFilterInput>;
  HeadingSv?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreambleEn?: InputMaybe<SearchableStringFilterInput>;
  PreambleSv?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SiteMediaDataWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SiteMediaDataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SiteMediaDataWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SiteVideoData = IContent & IData & {
  __typename?: 'SiteVideoData';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Copyright?: Maybe<Scalars['String']['output']>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['Int']['output']>;
  HeadingEn?: Maybe<Scalars['String']['output']>;
  HeadingSv?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreambleEn?: Maybe<Scalars['String']['output']>;
  PreambleSv?: Maybe<Scalars['String']['output']>;
  PreviewImage?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SiteVideoDataContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteVideoDataCopyrightArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteVideoDataHeadingEnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteVideoDataHeadingSvArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteVideoDataNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteVideoDataPreambleEnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteVideoDataPreambleSvArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteVideoData_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SiteVideoData_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SiteVideoDataAutocomplete = {
  __typename?: 'SiteVideoDataAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PreviewImage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SiteVideoDataAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteVideoDataAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteVideoDataAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteVideoDataAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteVideoDataAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteVideoDataAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteVideoDataAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteVideoDataAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteVideoDataAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SiteVideoDataAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SiteVideoDataFacet = {
  __typename?: 'SiteVideoDataFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Copyright?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<NumberFacet>>>;
  HeadingEn?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingSv?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreambleEn?: Maybe<Array<Maybe<StringFacet>>>;
  PreambleSv?: Maybe<Array<Maybe<StringFacet>>>;
  PreviewImage?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SiteVideoDataFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteVideoDataFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetCopyrightArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteVideoDataFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SiteVideoDataFacetHeadingEnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetHeadingSvArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetPreambleEnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetPreambleSvArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteVideoDataFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteVideoDataFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteVideoDataFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SiteVideoDataFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SiteVideoDataOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Copyright?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  HeadingEn?: InputMaybe<OrderBy>;
  HeadingSv?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreambleEn?: InputMaybe<OrderBy>;
  PreambleSv?: InputMaybe<OrderBy>;
  PreviewImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SiteVideoDataOutput = {
  __typename?: 'SiteVideoDataOutput';
  autocomplete?: Maybe<SiteVideoDataAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SiteVideoDataFacet>;
  item?: Maybe<SiteVideoData>;
  items?: Maybe<Array<Maybe<SiteVideoData>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SiteVideoDataOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteVideoDataWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Copyright?: InputMaybe<SearchableStringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<IntFilterInput>;
  HeadingEn?: InputMaybe<SearchableStringFilterInput>;
  HeadingSv?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreambleEn?: InputMaybe<SearchableStringFilterInput>;
  PreambleSv?: InputMaybe<SearchableStringFilterInput>;
  PreviewImage?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SiteVideoDataWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SiteVideoDataWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SiteVideoDataWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SourceFilterInput = {
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Sources {
  Default = 'DEFAULT'
}

export type StandardBlockModel = IContent & IData & {
  __typename?: 'StandardBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackgroundImage?: Maybe<ContentModelReference>;
  Buttons?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ColorTheme?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ContentModelReference>;
  ImageAlignment?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Text?: Maybe<MixedHtmlModelSearch>;
  Url?: Maybe<Scalars['String']['output']>;
  WideLayout?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type StandardBlockModelButtonsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardBlockModelImageAlignmentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardBlockModelTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type StandardBlockModelAutocomplete = {
  __typename?: 'StandardBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackgroundImage?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type StandardBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardBlockModelFacet = {
  __typename?: 'StandardBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackgroundImage?: Maybe<ContentModelReferenceFacet>;
  Buttons?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ColorTheme?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  ImageAlignment?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Text?: Maybe<MixedHtmlModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  WideLayout?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type StandardBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StandardBlockModelFacetColorThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StandardBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StandardBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardBlockModelFacetImageAlignmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StandardBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StandardBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StandardBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardBlockModelFacetWideLayoutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackgroundImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  Buttons?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ColorTheme?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageAlignment?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Text?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  WideLayout?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type StandardBlockModelOutput = {
  __typename?: 'StandardBlockModelOutput';
  autocomplete?: Maybe<StandardBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<StandardBlockModelFacet>;
  item?: Maybe<StandardBlockModel>;
  items?: Maybe<Array<Maybe<StandardBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type StandardBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StandardBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackgroundImage?: InputMaybe<ContentModelReferenceWhereInput>;
  Buttons?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ColorTheme?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageAlignment?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Text?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  WideLayout?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<StandardBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<StandardBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<StandardBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type StandardPageModel = IContent & IData & {
  __typename?: 'StandardPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FaqContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  Hero?: Maybe<ContentModelReference>;
  HeroDisplayMode?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinksAreaDisplayMode?: Maybe<Scalars['Int']['output']>;
  LinksContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  LinksContentAreaColorTheme?: Maybe<Scalars['Int']['output']>;
  MainBody?: Maybe<MixedHtmlModelSearch>;
  MainBodyContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MainBodyContentAreaDisplayMode?: Maybe<Scalars['Int']['output']>;
  MainContent?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MainContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MainContentAreaDisplayMode?: Maybe<Scalars['Int']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MenuIcon?: Maybe<Scalars['String']['output']>;
  MenuTagLine?: Maybe<Scalars['String']['output']>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelatedLinksContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  RelatedLinksContentAreaColorTheme?: Maybe<Scalars['Int']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SecondaryBody?: Maybe<MixedHtmlModelSearch>;
  SecondaryContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  SecondaryContentAreaDisplayMode?: Maybe<Scalars['Int']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInFooter?: Maybe<Scalars['Bool']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  WidePage?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type StandardPageModelFaqContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelLinksContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelMainBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelMainBodyContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelMainContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelMainContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelMenuIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelMenuTagLineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelRelatedLinksContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelSecondaryBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelSecondaryContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StandardPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type StandardPageModelAutocomplete = {
  __typename?: 'StandardPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Hero?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type StandardPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StandardPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StandardPageModelFacet = {
  __typename?: 'StandardPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FaqContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  Hero?: Maybe<ContentModelReferenceFacet>;
  HeroDisplayMode?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinksAreaDisplayMode?: Maybe<Array<Maybe<NumberFacet>>>;
  LinksContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  LinksContentAreaColorTheme?: Maybe<Array<Maybe<NumberFacet>>>;
  MainBody?: Maybe<MixedHtmlModelSearchFacet>;
  MainBodyContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MainBodyContentAreaDisplayMode?: Maybe<Array<Maybe<NumberFacet>>>;
  MainContent?: Maybe<ContentAreaItemModelSearchFacet>;
  MainContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  MainContentAreaDisplayMode?: Maybe<Array<Maybe<NumberFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MenuIcon?: Maybe<Array<Maybe<StringFacet>>>;
  MenuTagLine?: Maybe<Array<Maybe<StringFacet>>>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelatedLinksContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  RelatedLinksContentAreaColorTheme?: Maybe<Array<Maybe<NumberFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  SecondaryBody?: Maybe<MixedHtmlModelSearchFacet>;
  SecondaryContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  SecondaryContentAreaDisplayMode?: Maybe<Array<Maybe<NumberFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInFooter?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  WidePage?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type StandardPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StandardPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StandardPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetHeroDisplayModeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StandardPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetLinksAreaDisplayModeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StandardPageModelFacetLinksContentAreaColorThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StandardPageModelFacetMainBodyContentAreaDisplayModeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StandardPageModelFacetMainContentAreaDisplayModeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StandardPageModelFacetMenuIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetMenuTagLineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetRelatedLinksContentAreaColorThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StandardPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StandardPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetSecondaryContentAreaDisplayModeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StandardPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StandardPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StandardPageModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetVisibleInFooterArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacetWidePageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StandardPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StandardPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FaqContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  Hero?: InputMaybe<ContentModelReferenceOrderByInput>;
  HeroDisplayMode?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinksAreaDisplayMode?: InputMaybe<OrderBy>;
  LinksContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  LinksContentAreaColorTheme?: InputMaybe<OrderBy>;
  MainBody?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  MainBodyContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MainBodyContentAreaDisplayMode?: InputMaybe<OrderBy>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MainContentAreaDisplayMode?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MenuIcon?: InputMaybe<OrderBy>;
  MenuTagLine?: InputMaybe<OrderBy>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelatedLinksContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  RelatedLinksContentAreaColorTheme?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  SecondaryBody?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  SecondaryContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  SecondaryContentAreaDisplayMode?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInFooter?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  WidePage?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type StandardPageModelOutput = {
  __typename?: 'StandardPageModelOutput';
  autocomplete?: Maybe<StandardPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<StandardPageModelFacet>;
  item?: Maybe<StandardPageModel>;
  items?: Maybe<Array<Maybe<StandardPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type StandardPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StandardPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FaqContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  Hero?: InputMaybe<ContentModelReferenceWhereInput>;
  HeroDisplayMode?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinksAreaDisplayMode?: InputMaybe<IntFilterInput>;
  LinksContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  LinksContentAreaColorTheme?: InputMaybe<IntFilterInput>;
  MainBody?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  MainBodyContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MainBodyContentAreaDisplayMode?: InputMaybe<IntFilterInput>;
  MainContent?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MainContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MainContentAreaDisplayMode?: InputMaybe<IntFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MenuIcon?: InputMaybe<SearchableStringFilterInput>;
  MenuTagLine?: InputMaybe<SearchableStringFilterInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelatedLinksContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  RelatedLinksContentAreaColorTheme?: InputMaybe<IntFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  SecondaryBody?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  SecondaryContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  SecondaryContentAreaDisplayMode?: InputMaybe<IntFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInFooter?: InputMaybe<BoolFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  WidePage?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<StandardPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<StandardPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<StandardPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type StartPageModel = IContent & IData & {
  __typename?: 'StartPageModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Scalars['String']['output']>;
  BottomContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CookieBannerContent?: Maybe<MixedHtmlModel>;
  Created?: Maybe<Scalars['Date']['output']>;
  DisableIndexing?: Maybe<Scalars['Bool']['output']>;
  EService?: Maybe<Scalars['Bool']['output']>;
  ErrorPage?: Maybe<ContentModelReference>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  ExternalURL?: Maybe<Scalars['String']['output']>;
  FeaturedImage?: Maybe<ContentModelReference>;
  FooterScripts?: Maybe<Scalars['String']['output']>;
  GlobalBodyScripts?: Maybe<Scalars['String']['output']>;
  GlobalFooterScripts?: Maybe<Scalars['String']['output']>;
  GlobalHeaderScripts?: Maybe<Scalars['String']['output']>;
  HeaderScripts?: Maybe<Scalars['String']['output']>;
  Headline?: Maybe<Scalars['String']['output']>;
  Hero?: Maybe<ContentModelReference>;
  InformationBannerContent?: Maybe<Scalars['String']['output']>;
  InformationBannerStyle?: Maybe<Scalars['Int']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  LinksContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  LinksContentAreaColorTheme?: Maybe<Scalars['Int']['output']>;
  Logo?: Maybe<ContentModelReference>;
  LogoYellow?: Maybe<ContentModelReference>;
  LowerFooterLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  MapsApiKey?: Maybe<Scalars['String']['output']>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MetaDescription?: Maybe<Scalars['String']['output']>;
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  MyPagesRoot?: Maybe<ContentModelReference>;
  Name?: Maybe<Scalars['String']['output']>;
  NotFoundPage?: Maybe<ContentModelReference>;
  NoticeBlock?: Maybe<ContentModelReference>;
  ParentLink?: Maybe<ContentModelReference>;
  PermissionDeniedPage?: Maybe<ContentModelReference>;
  PopularSearchTerms?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  SearchPage?: Maybe<ContentModelReference>;
  SearchResultPage?: Maybe<ContentModelReference>;
  ServicesContentArea?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  ServicesContentAreaColorTheme?: Maybe<Scalars['Int']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  SocialMediaLinks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  StandardTermsAndConditions?: Maybe<MixedHtmlModel>;
  StandardTermsAndConditionsButtons?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisibleInMenu?: Maybe<Scalars['Bool']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type StartPageModelBottomContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StartPageModelHeadlineArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StartPageModelLinksContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StartPageModelLowerFooterLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StartPageModelMetaDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StartPageModelMetaKeywordsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StartPageModelMetaTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StartPageModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StartPageModelPopularSearchTermsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StartPageModelServicesContentAreaArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StartPageModelSocialMediaLinksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StartPageModelStandardTermsAndConditionsButtonsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StartPageModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StartPageModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type StartPageModelAutocomplete = {
  __typename?: 'StartPageModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  CookieBannerContent?: Maybe<MixedHtmlModelAutocomplete>;
  ErrorPage?: Maybe<ContentModelReferenceAutocomplete>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  ExternalURL?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  FeaturedImage?: Maybe<ContentModelReferenceAutocomplete>;
  FooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  GlobalBodyScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  GlobalFooterScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  GlobalHeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  HeaderScripts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Hero?: Maybe<ContentModelReferenceAutocomplete>;
  InformationBannerContent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Logo?: Maybe<ContentModelReferenceAutocomplete>;
  LogoYellow?: Maybe<ContentModelReferenceAutocomplete>;
  MapsApiKey?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MyPagesRoot?: Maybe<ContentModelReferenceAutocomplete>;
  NotFoundPage?: Maybe<ContentModelReferenceAutocomplete>;
  NoticeBlock?: Maybe<ContentModelReferenceAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  PermissionDeniedPage?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SearchPage?: Maybe<ContentModelReferenceAutocomplete>;
  SearchResultPage?: Maybe<ContentModelReferenceAutocomplete>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  StandardTermsAndConditions?: Maybe<MixedHtmlModelAutocomplete>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  TeaserText?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type StartPageModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteExternalUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteGlobalBodyScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteGlobalFooterScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteGlobalHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteHeaderScriptsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteInformationBannerContentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteMapsApiKeyArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteTeaserTextArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StartPageModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StartPageModelFacet = {
  __typename?: 'StartPageModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  BottomContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  CookieBannerContent?: Maybe<MixedHtmlModelFacet>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  DisableIndexing?: Maybe<Array<Maybe<StringFacet>>>;
  EService?: Maybe<Array<Maybe<StringFacet>>>;
  ErrorPage?: Maybe<ContentModelReferenceFacet>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  ExternalURL?: Maybe<Array<Maybe<StringFacet>>>;
  FeaturedImage?: Maybe<ContentModelReferenceFacet>;
  FooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  GlobalBodyScripts?: Maybe<Array<Maybe<StringFacet>>>;
  GlobalFooterScripts?: Maybe<Array<Maybe<StringFacet>>>;
  GlobalHeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  HeaderScripts?: Maybe<Array<Maybe<StringFacet>>>;
  Headline?: Maybe<Array<Maybe<StringFacet>>>;
  Hero?: Maybe<ContentModelReferenceFacet>;
  InformationBannerContent?: Maybe<Array<Maybe<StringFacet>>>;
  InformationBannerStyle?: Maybe<Array<Maybe<NumberFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  LinksContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  LinksContentAreaColorTheme?: Maybe<Array<Maybe<NumberFacet>>>;
  Logo?: Maybe<ContentModelReferenceFacet>;
  LogoYellow?: Maybe<ContentModelReferenceFacet>;
  LowerFooterLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  MapsApiKey?: Maybe<Array<Maybe<StringFacet>>>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MetaDescription?: Maybe<Array<Maybe<StringFacet>>>;
  MetaKeywords?: Maybe<Array<Maybe<StringFacet>>>;
  MetaTitle?: Maybe<Array<Maybe<StringFacet>>>;
  MyPagesRoot?: Maybe<ContentModelReferenceFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  NotFoundPage?: Maybe<ContentModelReferenceFacet>;
  NoticeBlock?: Maybe<ContentModelReferenceFacet>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PermissionDeniedPage?: Maybe<ContentModelReferenceFacet>;
  PopularSearchTerms?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  SearchEngineOptimization?: Maybe<Array<Maybe<StringFacet>>>;
  SearchPage?: Maybe<ContentModelReferenceFacet>;
  SearchResultPage?: Maybe<ContentModelReferenceFacet>;
  ServicesContentArea?: Maybe<ContentAreaItemModelSearchFacet>;
  ServicesContentAreaColorTheme?: Maybe<Array<Maybe<NumberFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  SocialMediaLinks?: Maybe<ContentAreaItemModelSearchFacet>;
  StandardTermsAndConditions?: Maybe<MixedHtmlModelFacet>;
  StandardTermsAndConditionsButtons?: Maybe<ContentAreaItemModelSearchFacet>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisibleInMenu?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type StartPageModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StartPageModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StartPageModelFacetDisableIndexingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetEServiceArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetExternalUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetGlobalBodyScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetGlobalFooterScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetGlobalHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetHeaderScriptsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetHeadlineArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetInformationBannerContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetInformationBannerStyleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StartPageModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetLinksContentAreaColorThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StartPageModelFacetMapsApiKeyArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetMetaDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetMetaKeywordsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetMetaTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetPopularSearchTermsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StartPageModelFacetSearchEngineOptimizationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetServicesContentAreaColorThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type StartPageModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StartPageModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StartPageModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacetVisibleInMenuArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StartPageModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StartPageModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BodyScripts?: InputMaybe<OrderBy>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  CookieBannerContent?: InputMaybe<MixedHtmlModelOrderByInput>;
  Created?: InputMaybe<OrderBy>;
  DisableIndexing?: InputMaybe<OrderBy>;
  EService?: InputMaybe<OrderBy>;
  ErrorPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  ExternalURL?: InputMaybe<OrderBy>;
  FeaturedImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  FooterScripts?: InputMaybe<OrderBy>;
  GlobalBodyScripts?: InputMaybe<OrderBy>;
  GlobalFooterScripts?: InputMaybe<OrderBy>;
  GlobalHeaderScripts?: InputMaybe<OrderBy>;
  HeaderScripts?: InputMaybe<OrderBy>;
  Headline?: InputMaybe<OrderBy>;
  Hero?: InputMaybe<ContentModelReferenceOrderByInput>;
  InformationBannerContent?: InputMaybe<OrderBy>;
  InformationBannerStyle?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  LinksContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  LinksContentAreaColorTheme?: InputMaybe<OrderBy>;
  Logo?: InputMaybe<ContentModelReferenceOrderByInput>;
  LogoYellow?: InputMaybe<ContentModelReferenceOrderByInput>;
  LowerFooterLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  MapsApiKey?: InputMaybe<OrderBy>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MetaDescription?: InputMaybe<OrderBy>;
  MetaKeywords?: InputMaybe<OrderBy>;
  MetaTitle?: InputMaybe<OrderBy>;
  MyPagesRoot?: InputMaybe<ContentModelReferenceOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  NotFoundPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  NoticeBlock?: InputMaybe<ContentModelReferenceOrderByInput>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PermissionDeniedPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  PopularSearchTerms?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  SearchEngineOptimization?: InputMaybe<OrderBy>;
  SearchPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  SearchResultPage?: InputMaybe<ContentModelReferenceOrderByInput>;
  ServicesContentArea?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  ServicesContentAreaColorTheme?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  SocialMediaLinks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  StandardTermsAndConditions?: InputMaybe<MixedHtmlModelOrderByInput>;
  StandardTermsAndConditionsButtons?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisibleInMenu?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type StartPageModelOutput = {
  __typename?: 'StartPageModelOutput';
  autocomplete?: Maybe<StartPageModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<StartPageModelFacet>;
  item?: Maybe<StartPageModel>;
  items?: Maybe<Array<Maybe<StartPageModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type StartPageModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartPageModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BodyScripts?: InputMaybe<StringFilterInput>;
  BottomContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  CookieBannerContent?: InputMaybe<MixedHtmlModelWhereInput>;
  Created?: InputMaybe<DateFilterInput>;
  DisableIndexing?: InputMaybe<BoolFilterInput>;
  EService?: InputMaybe<BoolFilterInput>;
  ErrorPage?: InputMaybe<ContentModelReferenceWhereInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  ExternalURL?: InputMaybe<StringFilterInput>;
  FeaturedImage?: InputMaybe<ContentModelReferenceWhereInput>;
  FooterScripts?: InputMaybe<StringFilterInput>;
  GlobalBodyScripts?: InputMaybe<StringFilterInput>;
  GlobalFooterScripts?: InputMaybe<StringFilterInput>;
  GlobalHeaderScripts?: InputMaybe<StringFilterInput>;
  HeaderScripts?: InputMaybe<StringFilterInput>;
  Headline?: InputMaybe<SearchableStringFilterInput>;
  Hero?: InputMaybe<ContentModelReferenceWhereInput>;
  InformationBannerContent?: InputMaybe<StringFilterInput>;
  InformationBannerStyle?: InputMaybe<IntFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  LinksContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  LinksContentAreaColorTheme?: InputMaybe<IntFilterInput>;
  Logo?: InputMaybe<ContentModelReferenceWhereInput>;
  LogoYellow?: InputMaybe<ContentModelReferenceWhereInput>;
  LowerFooterLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  MapsApiKey?: InputMaybe<StringFilterInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MetaDescription?: InputMaybe<SearchableStringFilterInput>;
  MetaKeywords?: InputMaybe<SearchableStringFilterInput>;
  MetaTitle?: InputMaybe<SearchableStringFilterInput>;
  MyPagesRoot?: InputMaybe<ContentModelReferenceWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  NotFoundPage?: InputMaybe<ContentModelReferenceWhereInput>;
  NoticeBlock?: InputMaybe<ContentModelReferenceWhereInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PermissionDeniedPage?: InputMaybe<ContentModelReferenceWhereInput>;
  PopularSearchTerms?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  SearchEngineOptimization?: InputMaybe<StringFilterInput>;
  SearchPage?: InputMaybe<ContentModelReferenceWhereInput>;
  SearchResultPage?: InputMaybe<ContentModelReferenceWhereInput>;
  ServicesContentArea?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  ServicesContentAreaColorTheme?: InputMaybe<IntFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  SocialMediaLinks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  StandardTermsAndConditions?: InputMaybe<MixedHtmlModelWhereInput>;
  StandardTermsAndConditionsButtons?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<StringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisibleInMenu?: InputMaybe<BoolFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<StartPageModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<StartPageModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<StartPageModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type StoreFlyersBlockModel = IContent & IData & {
  __typename?: 'StoreFlyersBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Text?: Maybe<MixedHtmlModelSearch>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type StoreFlyersBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreFlyersBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreFlyersBlockModelTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreFlyersBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type StoreFlyersBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type StoreFlyersBlockModelAutocomplete = {
  __typename?: 'StoreFlyersBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type StoreFlyersBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreFlyersBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreFlyersBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreFlyersBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreFlyersBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreFlyersBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreFlyersBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreFlyersBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type StoreFlyersBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type StoreFlyersBlockModelFacet = {
  __typename?: 'StoreFlyersBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Text?: Maybe<MixedHtmlModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type StoreFlyersBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreFlyersBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StoreFlyersBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreFlyersBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StoreFlyersBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreFlyersBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreFlyersBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreFlyersBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreFlyersBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreFlyersBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StoreFlyersBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreFlyersBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreFlyersBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StoreFlyersBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreFlyersBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type StoreFlyersBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type StoreFlyersBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type StoreFlyersBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Text?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type StoreFlyersBlockModelOutput = {
  __typename?: 'StoreFlyersBlockModelOutput';
  autocomplete?: Maybe<StoreFlyersBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<StoreFlyersBlockModelFacet>;
  item?: Maybe<StoreFlyersBlockModel>;
  items?: Maybe<Array<Maybe<StoreFlyersBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type StoreFlyersBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StoreFlyersBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Text?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<StoreFlyersBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<StoreFlyersBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<StoreFlyersBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type StringFacet = {
  __typename?: 'StringFacet';
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StringFilterInput = {
  /** `boost` influences the weight of a field by boosting a match with a number (default: 1) — counts more towards the eventual relevance score which can be projected with `_score` — at query time. Note that `boost` cannot be a negative number. */
  boost?: InputMaybe<Scalars['Int']['input']>;
  /** `ends_with` retrieves matches that end with a certain value (suffix). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** `eq` matches on an exact value, but the value is case-insensitive. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** `exist` matches results that have this field. */
  exist?: InputMaybe<Scalars['Boolean']['input']>;
  /** enables supporting fuzzy matching on the query terms (keywords), which returns items that contain terms in the content similar to the keywords, as measured by a _Levenshtein edit distance_. An edit distance is the number of one-character changes needed to turn one term into another. The edit distance is based on the length of the term.  */
  fuzzy?: InputMaybe<Scalars['Boolean']['input']>;
  /** `in` matches with 1 or more exact values in a list. Example: `in: ["word1", "word2", "this is a phrase"]` */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `like` matches on substrings with wildcard support: `%` to match on 0 or more characters, `_` to match on any character.  */
  like?: InputMaybe<Scalars['String']['input']>;
  /** `not_eq` retrieves results not matching with an exact (but case-insensitive) value. */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** `not_in` returns results that do not match with 1 or more exact values in a list. Example: `not_in: ["word1", "word2", "this is a phrase"]` */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** `starts_with` retrieves matches that start with a certain value (prefix). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** expands query value with synonyms. Example: if `H2O` is a synonym of `water`, then querying for `water` will also return results with `H2O`. */
  synonyms?: InputMaybe<Array<InputMaybe<SynonymSlot>>>;
};

export type SubmitButtonElementBlock = IContent & IData & {
  __typename?: 'SubmitButtonElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FinalizeForm?: Maybe<Scalars['Bool']['output']>;
  Image?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RedirectToPage?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SubmitButtonElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SubmitButtonElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SubmitButtonElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SubmitButtonElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SubmitButtonElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SubmitButtonElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SubmitButtonElementBlockAutocomplete = {
  __typename?: 'SubmitButtonElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RedirectToPage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SubmitButtonElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteImageArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteRedirectToPageArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SubmitButtonElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SubmitButtonElementBlockFacet = {
  __typename?: 'SubmitButtonElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FinalizeForm?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RedirectToPage?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SubmitButtonElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SubmitButtonElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type SubmitButtonElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SubmitButtonElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetFinalizeFormArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetImageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetRedirectToPageArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SubmitButtonElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SubmitButtonElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SubmitButtonElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SubmitButtonElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SubmitButtonElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FinalizeForm?: InputMaybe<OrderBy>;
  Image?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RedirectToPage?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SubmitButtonElementBlockOutput = {
  __typename?: 'SubmitButtonElementBlockOutput';
  autocomplete?: Maybe<SubmitButtonElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SubmitButtonElementBlockFacet>;
  item?: Maybe<SubmitButtonElementBlock>;
  items?: Maybe<Array<Maybe<SubmitButtonElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SubmitButtonElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitButtonElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FinalizeForm?: InputMaybe<BoolFilterInput>;
  Image?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RedirectToPage?: InputMaybe<StringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SubmitButtonElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SubmitButtonElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SubmitButtonElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SwishCertificateBlockModel = IContent & IData & {
  __typename?: 'SwishCertificateBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Text?: Maybe<MixedHtmlModelSearch>;
  UploadHelpText?: Maybe<MixedHtmlModelSearch>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SwishCertificateBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishCertificateBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishCertificateBlockModelTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishCertificateBlockModelUploadHelpTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishCertificateBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishCertificateBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SwishCertificateBlockModelAutocomplete = {
  __typename?: 'SwishCertificateBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SwishCertificateBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishCertificateBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishCertificateBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishCertificateBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishCertificateBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishCertificateBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishCertificateBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishCertificateBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishCertificateBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SwishCertificateBlockModelFacet = {
  __typename?: 'SwishCertificateBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Text?: Maybe<MixedHtmlModelSearchFacet>;
  UploadHelpText?: Maybe<MixedHtmlModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SwishCertificateBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishCertificateBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishCertificateBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishCertificateBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishCertificateBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishCertificateBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishCertificateBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishCertificateBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishCertificateBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishCertificateBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishCertificateBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishCertificateBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishCertificateBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishCertificateBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishCertificateBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishCertificateBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishCertificateBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SwishCertificateBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Text?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  UploadHelpText?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SwishCertificateBlockModelOutput = {
  __typename?: 'SwishCertificateBlockModelOutput';
  autocomplete?: Maybe<SwishCertificateBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SwishCertificateBlockModelFacet>;
  item?: Maybe<SwishCertificateBlockModel>;
  items?: Maybe<Array<Maybe<SwishCertificateBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SwishCertificateBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SwishCertificateBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Text?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  UploadHelpText?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SwishCertificateBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SwishCertificateBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SwishCertificateBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SwishFormBlockModel = IContent & IData & {
  __typename?: 'SwishFormBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FormReference?: Maybe<ContentModelReference>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SwishFormBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishFormBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishFormBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishFormBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SwishFormBlockModelAutocomplete = {
  __typename?: 'SwishFormBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  FormReference?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SwishFormBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishFormBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishFormBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishFormBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishFormBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishFormBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishFormBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishFormBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishFormBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SwishFormBlockModelFacet = {
  __typename?: 'SwishFormBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FormReference?: Maybe<ContentModelReferenceFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SwishFormBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishFormBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishFormBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishFormBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishFormBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishFormBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishFormBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishFormBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishFormBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishFormBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishFormBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishFormBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishFormBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishFormBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishFormBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishFormBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishFormBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SwishFormBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FormReference?: InputMaybe<ContentModelReferenceOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SwishFormBlockModelOutput = {
  __typename?: 'SwishFormBlockModelOutput';
  autocomplete?: Maybe<SwishFormBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SwishFormBlockModelFacet>;
  item?: Maybe<SwishFormBlockModel>;
  items?: Maybe<Array<Maybe<SwishFormBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SwishFormBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SwishFormBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FormReference?: InputMaybe<ContentModelReferenceWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SwishFormBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SwishFormBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SwishFormBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SwishRegistrationBlockModel = IContent & IData & {
  __typename?: 'SwishRegistrationBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  Link?: Maybe<ContentModelReference>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SwishRegistrationBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishRegistrationBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishRegistrationBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SwishRegistrationBlockModelAutocomplete = {
  __typename?: 'SwishRegistrationBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Heading?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Link?: Maybe<ContentModelReferenceAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SwishRegistrationBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishRegistrationBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishRegistrationBlockModelAutocompleteHeadingArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishRegistrationBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishRegistrationBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishRegistrationBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishRegistrationBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishRegistrationBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishRegistrationBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishRegistrationBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SwishRegistrationBlockModelFacet = {
  __typename?: 'SwishRegistrationBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Link?: Maybe<ContentModelReferenceFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SwishRegistrationBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishRegistrationBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishRegistrationBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishRegistrationBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishRegistrationBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishRegistrationBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishRegistrationBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishRegistrationBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishRegistrationBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishRegistrationBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishRegistrationBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishRegistrationBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishRegistrationBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishRegistrationBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishRegistrationBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishRegistrationBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishRegistrationBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SwishRegistrationBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Link?: InputMaybe<ContentModelReferenceOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SwishRegistrationBlockModelOutput = {
  __typename?: 'SwishRegistrationBlockModelOutput';
  autocomplete?: Maybe<SwishRegistrationBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SwishRegistrationBlockModelFacet>;
  item?: Maybe<SwishRegistrationBlockModel>;
  items?: Maybe<Array<Maybe<SwishRegistrationBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SwishRegistrationBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SwishRegistrationBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Link?: InputMaybe<ContentModelReferenceWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SwishRegistrationBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SwishRegistrationBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SwishRegistrationBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type SwishStoreRegistrationBlockModel = IContent & IData & {
  __typename?: 'SwishStoreRegistrationBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  InstructionText?: Maybe<MixedHtmlModelSearch>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type SwishStoreRegistrationBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishStoreRegistrationBlockModelInstructionTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishStoreRegistrationBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishStoreRegistrationBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type SwishStoreRegistrationBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type SwishStoreRegistrationBlockModelAutocomplete = {
  __typename?: 'SwishStoreRegistrationBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type SwishStoreRegistrationBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishStoreRegistrationBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishStoreRegistrationBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishStoreRegistrationBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishStoreRegistrationBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishStoreRegistrationBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishStoreRegistrationBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishStoreRegistrationBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type SwishStoreRegistrationBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type SwishStoreRegistrationBlockModelFacet = {
  __typename?: 'SwishStoreRegistrationBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  InstructionText?: Maybe<MixedHtmlModelSearchFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type SwishStoreRegistrationBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishStoreRegistrationBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishStoreRegistrationBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishStoreRegistrationBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishStoreRegistrationBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishStoreRegistrationBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishStoreRegistrationBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishStoreRegistrationBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishStoreRegistrationBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishStoreRegistrationBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishStoreRegistrationBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishStoreRegistrationBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishStoreRegistrationBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishStoreRegistrationBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishStoreRegistrationBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type SwishStoreRegistrationBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type SwishStoreRegistrationBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type SwishStoreRegistrationBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  InstructionText?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SwishStoreRegistrationBlockModelOutput = {
  __typename?: 'SwishStoreRegistrationBlockModelOutput';
  autocomplete?: Maybe<SwishStoreRegistrationBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<SwishStoreRegistrationBlockModelFacet>;
  item?: Maybe<SwishStoreRegistrationBlockModel>;
  items?: Maybe<Array<Maybe<SwishStoreRegistrationBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type SwishStoreRegistrationBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SwishStoreRegistrationBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  InstructionText?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<SwishStoreRegistrationBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<SwishStoreRegistrationBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<SwishStoreRegistrationBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export enum SynonymSlot {
  /** synonym slot 1 */
  One = 'ONE',
  /** synonym slot 2 */
  Two = 'TWO'
}

export type TabBlockModel = IContent & IData & {
  __typename?: 'TabBlockModel';
  AddDivider?: Maybe<Scalars['Bool']['output']>;
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Tabs?: Maybe<Array<Maybe<TabBlockModelTabItem>>>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type TabBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TabBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TabBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TabBlockModelAutocomplete = {
  __typename?: 'TabBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Tabs?: Maybe<TabBlockModelTabItemAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TabBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabBlockModelFacet = {
  __typename?: 'TabBlockModelFacet';
  AddDivider?: Maybe<Array<Maybe<StringFacet>>>;
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Tabs?: Maybe<TabBlockModelTabItemFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TabBlockModelFacetAddDividerArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabBlockModelOrderByInput = {
  AddDivider?: InputMaybe<OrderBy>;
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Tabs?: InputMaybe<TabBlockModelTabItemOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type TabBlockModelOutput = {
  __typename?: 'TabBlockModelOutput';
  autocomplete?: Maybe<TabBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TabBlockModelFacet>;
  item?: Maybe<TabBlockModel>;
  items?: Maybe<Array<Maybe<TabBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TabBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabBlockModelTabItem = {
  __typename?: 'TabBlockModelTabItem';
  Blocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  IncludedFeature?: Maybe<Scalars['String']['output']>;
  TabHeading?: Maybe<Scalars['String']['output']>;
};


export type TabBlockModelTabItemBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TabBlockModelTabItemTabHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TabBlockModelTabItemAutocomplete = {
  __typename?: 'TabBlockModelTabItemAutocomplete';
  IncludedFeature?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TabBlockModelTabItemAutocompleteIncludedFeatureArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabBlockModelTabItemFacet = {
  __typename?: 'TabBlockModelTabItemFacet';
  Blocks?: Maybe<ContentAreaItemModelSearchFacet>;
  IncludedFeature?: Maybe<Array<Maybe<StringFacet>>>;
  TabHeading?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TabBlockModelTabItemFacetIncludedFeatureArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabBlockModelTabItemFacetTabHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabBlockModelTabItemOrderByInput = {
  Blocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  IncludedFeature?: InputMaybe<OrderBy>;
  TabHeading?: InputMaybe<OrderBy>;
};

export type TabBlockModelTabItemWhereInput = {
  Blocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  IncludedFeature?: InputMaybe<StringFilterInput>;
  TabHeading?: InputMaybe<SearchableStringFilterInput>;
};

export type TabBlockModelWhereInput = {
  AddDivider?: InputMaybe<BoolFilterInput>;
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Tabs?: InputMaybe<TabBlockModelTabItemWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TabBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TabBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TabBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type TabItem = IContent & IData & {
  __typename?: 'TabItem';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Blocks?: Maybe<Array<Maybe<ContentAreaItemModelSearch>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IncludedFeature?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TabHeading?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type TabItemBlocksArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TabItemNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TabItemTabHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TabItem_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TabItem_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TabItemAutocomplete = {
  __typename?: 'TabItemAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  IncludedFeature?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TabItemAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemAutocompleteIncludedFeatureArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TabItemAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TabItemFacet = {
  __typename?: 'TabItemFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Blocks?: Maybe<ContentAreaItemModelSearchFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IncludedFeature?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TabHeading?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TabItemFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabItemFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabItemFacetIncludedFeatureArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabItemFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabItemFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TabItemFacetTabHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TabItemFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TabItemOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Blocks?: InputMaybe<ContentAreaItemModelSearchOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IncludedFeature?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TabHeading?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type TabItemOutput = {
  __typename?: 'TabItemOutput';
  autocomplete?: Maybe<TabItemAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TabItemFacet>;
  item?: Maybe<TabItem>;
  items?: Maybe<Array<Maybe<TabItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TabItemOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabItemWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Blocks?: InputMaybe<ContentAreaItemModelSearchWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IncludedFeature?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TabHeading?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TabItemWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TabItemWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TabItemWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type TeaserLinkBlockModel = IContent & IData & {
  __typename?: 'TeaserLinkBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackgroundImage?: Maybe<ContentModelReference>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ColorTheme?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  Image?: Maybe<ContentModelReference>;
  ImageAlignment?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  Link?: Maybe<ContentModelReference>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<MixedHtmlModelSearch>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type TeaserLinkBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TeaserLinkBlockModelImageAlignmentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TeaserLinkBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TeaserLinkBlockModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TeaserLinkBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TeaserLinkBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TeaserLinkBlockModelAutocomplete = {
  __typename?: 'TeaserLinkBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  BackgroundImage?: Maybe<ContentModelReferenceAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Image?: Maybe<ContentModelReferenceAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  Link?: Maybe<ContentModelReferenceAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TeaserLinkBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TeaserLinkBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TeaserLinkBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TeaserLinkBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TeaserLinkBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TeaserLinkBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TeaserLinkBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TeaserLinkBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TeaserLinkBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TeaserLinkBlockModelFacet = {
  __typename?: 'TeaserLinkBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  BackgroundImage?: Maybe<ContentModelReferenceFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ColorTheme?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  Image?: Maybe<ContentModelReferenceFacet>;
  ImageAlignment?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  Link?: Maybe<ContentModelReferenceFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<MixedHtmlModelSearchFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TeaserLinkBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TeaserLinkBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TeaserLinkBlockModelFacetColorThemeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TeaserLinkBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TeaserLinkBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TeaserLinkBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TeaserLinkBlockModelFacetImageAlignmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TeaserLinkBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TeaserLinkBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TeaserLinkBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TeaserLinkBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TeaserLinkBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TeaserLinkBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TeaserLinkBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TeaserLinkBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TeaserLinkBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TeaserLinkBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TeaserLinkBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TeaserLinkBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TeaserLinkBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  BackgroundImage?: InputMaybe<ContentModelReferenceOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ColorTheme?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  Image?: InputMaybe<ContentModelReferenceOrderByInput>;
  ImageAlignment?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  Link?: InputMaybe<ContentModelReferenceOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type TeaserLinkBlockModelOutput = {
  __typename?: 'TeaserLinkBlockModelOutput';
  autocomplete?: Maybe<TeaserLinkBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TeaserLinkBlockModelFacet>;
  item?: Maybe<TeaserLinkBlockModel>;
  items?: Maybe<Array<Maybe<TeaserLinkBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TeaserLinkBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeaserLinkBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  BackgroundImage?: InputMaybe<ContentModelReferenceWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ColorTheme?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  Image?: InputMaybe<ContentModelReferenceWhereInput>;
  ImageAlignment?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  Link?: InputMaybe<ContentModelReferenceWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TeaserLinkBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TeaserLinkBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TeaserLinkBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type TextBlockModel = IContent & IData & {
  __typename?: 'TextBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Body?: Maybe<MixedHtmlModelSearch>;
  Button?: Maybe<TextBlockModelButtonLinkBlockModel>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  Heading?: Maybe<Scalars['String']['output']>;
  HeadingLevel?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TopAlignContent?: Maybe<Scalars['Bool']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type TextBlockModelBodyArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextBlockModelHeadingArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TextBlockModelAutocomplete = {
  __typename?: 'TextBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Button?: Maybe<TextBlockModelButtonLinkBlockModelAutocomplete>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  HeadingLevel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TextBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextBlockModelAutocompleteHeadingLevelArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextBlockModelButtonLinkBlockModel = {
  __typename?: 'TextBlockModelButtonLinkBlockModel';
  ButtonClass?: Maybe<Scalars['Int']['output']>;
  DocumentLink?: Maybe<ContentModelReference>;
  ExternalLink?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<ContentModelReference>;
  LinkText?: Maybe<Scalars['String']['output']>;
  PopupContent?: Maybe<MixedHtmlModelSearch>;
  Title?: Maybe<Scalars['String']['output']>;
  VideoUrl?: Maybe<Scalars['String']['output']>;
};


export type TextBlockModelButtonLinkBlockModelExternalLinkArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextBlockModelButtonLinkBlockModelLinkTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextBlockModelButtonLinkBlockModelPopupContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextBlockModelButtonLinkBlockModelTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextBlockModelButtonLinkBlockModelVideoUrlArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};

export type TextBlockModelButtonLinkBlockModelAutocomplete = {
  __typename?: 'TextBlockModelButtonLinkBlockModelAutocomplete';
  DocumentLink?: Maybe<ContentModelReferenceAutocomplete>;
  Link?: Maybe<ContentModelReferenceAutocomplete>;
};

export type TextBlockModelButtonLinkBlockModelFacet = {
  __typename?: 'TextBlockModelButtonLinkBlockModelFacet';
  ButtonClass?: Maybe<Array<Maybe<NumberFacet>>>;
  DocumentLink?: Maybe<ContentModelReferenceFacet>;
  ExternalLink?: Maybe<Array<Maybe<StringFacet>>>;
  Link?: Maybe<ContentModelReferenceFacet>;
  LinkText?: Maybe<Array<Maybe<StringFacet>>>;
  PopupContent?: Maybe<MixedHtmlModelSearchFacet>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  VideoUrl?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TextBlockModelButtonLinkBlockModelFacetButtonClassArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TextBlockModelButtonLinkBlockModelFacetExternalLinkArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelButtonLinkBlockModelFacetLinkTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelButtonLinkBlockModelFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelButtonLinkBlockModelFacetVideoUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextBlockModelButtonLinkBlockModelOrderByInput = {
  ButtonClass?: InputMaybe<OrderBy>;
  DocumentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ExternalLink?: InputMaybe<OrderBy>;
  Link?: InputMaybe<ContentModelReferenceOrderByInput>;
  LinkText?: InputMaybe<OrderBy>;
  PopupContent?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Title?: InputMaybe<OrderBy>;
  VideoUrl?: InputMaybe<OrderBy>;
};

export type TextBlockModelButtonLinkBlockModelWhereInput = {
  ButtonClass?: InputMaybe<IntFilterInput>;
  DocumentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ExternalLink?: InputMaybe<SearchableStringFilterInput>;
  Link?: InputMaybe<ContentModelReferenceWhereInput>;
  LinkText?: InputMaybe<SearchableStringFilterInput>;
  PopupContent?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  VideoUrl?: InputMaybe<SearchableStringFilterInput>;
};

export type TextBlockModelFacet = {
  __typename?: 'TextBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Body?: Maybe<MixedHtmlModelSearchFacet>;
  Button?: Maybe<TextBlockModelButtonLinkBlockModelFacet>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  Heading?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingLevel?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TopAlignContent?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TextBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextBlockModelFacetHeadingArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelFacetHeadingLevelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextBlockModelFacetTopAlignContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Body?: InputMaybe<MixedHtmlModelSearchOrderByInput>;
  Button?: InputMaybe<TextBlockModelButtonLinkBlockModelOrderByInput>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  Heading?: InputMaybe<OrderBy>;
  HeadingLevel?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TopAlignContent?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type TextBlockModelOutput = {
  __typename?: 'TextBlockModelOutput';
  autocomplete?: Maybe<TextBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TextBlockModelFacet>;
  item?: Maybe<TextBlockModel>;
  items?: Maybe<Array<Maybe<TextBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TextBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Body?: InputMaybe<MixedHtmlModelSearchWhereInput>;
  Button?: InputMaybe<TextBlockModelButtonLinkBlockModelWhereInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  Heading?: InputMaybe<SearchableStringFilterInput>;
  HeadingLevel?: InputMaybe<StringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TopAlignContent?: InputMaybe<BoolFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TextBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TextBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TextBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type TextareaElementBlock = IContent & IData & {
  __typename?: 'TextareaElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AutoComplete?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type TextareaElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextareaElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TextareaElementBlockAutocomplete = {
  __typename?: 'TextareaElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TextareaElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextareaElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextareaElementBlockFacet = {
  __typename?: 'TextareaElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TextareaElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TextareaElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextareaElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TextareaElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextareaElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextareaElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextareaElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextareaElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextareaElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextareaElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type TextareaElementBlockOutput = {
  __typename?: 'TextareaElementBlockOutput';
  autocomplete?: Maybe<TextareaElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TextareaElementBlockFacet>;
  item?: Maybe<TextareaElementBlock>;
  items?: Maybe<Array<Maybe<TextareaElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TextareaElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextareaElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TextareaElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TextareaElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TextareaElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type TextboxElementBlock = IContent & IData & {
  __typename?: 'TextboxElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  AutoComplete?: Maybe<Scalars['Int']['output']>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  PredefinedValue?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type TextboxElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type TextboxElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type TextboxElementBlockAutocomplete = {
  __typename?: 'TextboxElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type TextboxElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type TextboxElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type TextboxElementBlockFacet = {
  __typename?: 'TextboxElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  AutoComplete?: Maybe<Array<Maybe<NumberFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type TextboxElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetAutoCompleteArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TextboxElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextboxElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type TextboxElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextboxElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextboxElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextboxElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type TextboxElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type TextboxElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type TextboxElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  AutoComplete?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type TextboxElementBlockOutput = {
  __typename?: 'TextboxElementBlockOutput';
  autocomplete?: Maybe<TextboxElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<TextboxElementBlockFacet>;
  item?: Maybe<TextboxElementBlock>;
  items?: Maybe<Array<Maybe<TextboxElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type TextboxElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextboxElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  AutoComplete?: InputMaybe<IntFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<TextboxElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<TextboxElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<TextboxElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type TrackingInput = {
  /** Search phrase to track */
  phrase: Scalars['String']['input'];
  /** Source of the search query (optional) */
  source?: InputMaybe<Scalars['String']['input']>;
};

export type UrlElementBlock = IContent & IData & {
  __typename?: 'UrlElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ConditionCombination?: Maybe<Scalars['Int']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PlaceHolder?: Maybe<Scalars['String']['output']>;
  PredefinedValue?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  SatisfiedAction?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  Validators?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type UrlElementBlockDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlockLabelArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlockPlaceHolderArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlockPredefinedValueArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlockSatisfiedActionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlockValidatorsArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type UrlElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type UrlElementBlockAutocomplete = {
  __typename?: 'UrlElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type UrlElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type UrlElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type UrlElementBlockFacet = {
  __typename?: 'UrlElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ConditionCombination?: Maybe<Array<Maybe<NumberFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Label?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PlaceHolder?: Maybe<Array<Maybe<StringFacet>>>;
  PredefinedValue?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  SatisfiedAction?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  Validators?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type UrlElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type UrlElementBlockFacetConditionCombinationArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type UrlElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type UrlElementBlockFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetLabelArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetPlaceHolderArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetPredefinedValueArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetSatisfiedActionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type UrlElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type UrlElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type UrlElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacetValidatorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type UrlElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type UrlElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ConditionCombination?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Label?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PlaceHolder?: InputMaybe<OrderBy>;
  PredefinedValue?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  SatisfiedAction?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  Validators?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type UrlElementBlockOutput = {
  __typename?: 'UrlElementBlockOutput';
  autocomplete?: Maybe<UrlElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<UrlElementBlockFacet>;
  item?: Maybe<UrlElementBlock>;
  items?: Maybe<Array<Maybe<UrlElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type UrlElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UrlElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ConditionCombination?: InputMaybe<IntFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Label?: InputMaybe<SearchableStringFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PlaceHolder?: InputMaybe<SearchableStringFilterInput>;
  PredefinedValue?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  SatisfiedAction?: InputMaybe<SearchableStringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  Validators?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<UrlElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<UrlElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<UrlElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export enum VariationIncludeMode {
  All = 'ALL',
  None = 'NONE',
  Some = 'SOME'
}

export type VariationInput = {
  include?: InputMaybe<VariationIncludeMode>;
  includeOriginal?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VisitorDataHiddenElementBlock = IContent & IData & {
  __typename?: 'VisitorDataHiddenElementBlock';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  VisitorDataSources?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type VisitorDataHiddenElementBlockNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisitorDataHiddenElementBlockVisitorDataSourcesArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisitorDataHiddenElementBlock_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type VisitorDataHiddenElementBlock_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type VisitorDataHiddenElementBlockAutocomplete = {
  __typename?: 'VisitorDataHiddenElementBlockAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type VisitorDataHiddenElementBlockAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type VisitorDataHiddenElementBlockAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type VisitorDataHiddenElementBlockFacet = {
  __typename?: 'VisitorDataHiddenElementBlockFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  VisitorDataSources?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type VisitorDataHiddenElementBlockFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisitorDataHiddenElementBlockFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisitorDataHiddenElementBlockFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisitorDataHiddenElementBlockFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisitorDataHiddenElementBlockFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type VisitorDataHiddenElementBlockFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacetVisitorDataSourcesArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type VisitorDataHiddenElementBlockFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type VisitorDataHiddenElementBlockOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  VisitorDataSources?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type VisitorDataHiddenElementBlockOutput = {
  __typename?: 'VisitorDataHiddenElementBlockOutput';
  autocomplete?: Maybe<VisitorDataHiddenElementBlockAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<VisitorDataHiddenElementBlockFacet>;
  item?: Maybe<VisitorDataHiddenElementBlock>;
  items?: Maybe<Array<Maybe<VisitorDataHiddenElementBlock>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type VisitorDataHiddenElementBlockOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VisitorDataHiddenElementBlockWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  VisitorDataSources?: InputMaybe<SearchableStringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<VisitorDataHiddenElementBlockWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<VisitorDataHiddenElementBlockWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<VisitorDataHiddenElementBlockWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type WebShopLinkBlockModel = IContent & IData & {
  __typename?: 'WebShopLinkBlockModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  InvertIcon?: Maybe<Scalars['Bool']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MenuIcon?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  TeaserText?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type WebShopLinkBlockModelMenuIconArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type WebShopLinkBlockModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type WebShopLinkBlockModelTeaserTextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type WebShopLinkBlockModelTitleArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type WebShopLinkBlockModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type WebShopLinkBlockModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type WebShopLinkBlockModelAutocomplete = {
  __typename?: 'WebShopLinkBlockModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type WebShopLinkBlockModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WebShopLinkBlockModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WebShopLinkBlockModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WebShopLinkBlockModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WebShopLinkBlockModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WebShopLinkBlockModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WebShopLinkBlockModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WebShopLinkBlockModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WebShopLinkBlockModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WebShopLinkBlockModelFacet = {
  __typename?: 'WebShopLinkBlockModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  InvertIcon?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MenuIcon?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  TeaserText?: Maybe<Array<Maybe<StringFacet>>>;
  Title?: Maybe<Array<Maybe<StringFacet>>>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type WebShopLinkBlockModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WebShopLinkBlockModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WebShopLinkBlockModelFacetInvertIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacetMenuIconArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WebShopLinkBlockModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WebShopLinkBlockModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WebShopLinkBlockModelFacetTeaserTextArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacetTitleArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WebShopLinkBlockModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WebShopLinkBlockModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  InvertIcon?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MenuIcon?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  TeaserText?: InputMaybe<OrderBy>;
  Title?: InputMaybe<OrderBy>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type WebShopLinkBlockModelOutput = {
  __typename?: 'WebShopLinkBlockModelOutput';
  autocomplete?: Maybe<WebShopLinkBlockModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<WebShopLinkBlockModelFacet>;
  item?: Maybe<WebShopLinkBlockModel>;
  items?: Maybe<Array<Maybe<WebShopLinkBlockModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type WebShopLinkBlockModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WebShopLinkBlockModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  InvertIcon?: InputMaybe<BoolFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MenuIcon?: InputMaybe<SearchableStringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  TeaserText?: InputMaybe<SearchableStringFilterInput>;
  Title?: InputMaybe<SearchableStringFilterInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<WebShopLinkBlockModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<WebShopLinkBlockModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<WebShopLinkBlockModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export type WordMediaModel = IContent & IData & {
  __typename?: 'WordMediaModel';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<Array<Maybe<CategoryModel>>>;
  Changed?: Maybe<Scalars['Date']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentLink?: Maybe<ContentModelReference>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Created?: Maybe<Scalars['Date']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  ExistingLanguages?: Maybe<Array<Maybe<ContentLanguageModel>>>;
  FileSize?: Maybe<Scalars['Int']['output']>;
  HeadingEn?: Maybe<Scalars['String']['output']>;
  HeadingSv?: Maybe<Scalars['String']['output']>;
  IsCommonDraft?: Maybe<Scalars['Bool']['output']>;
  Language?: Maybe<ContentLanguageModel>;
  MasterLanguage?: Maybe<ContentLanguageModel>;
  MimeType?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ParentLink?: Maybe<ContentModelReference>;
  PreambleEn?: Maybe<Scalars['String']['output']>;
  PreambleSv?: Maybe<Scalars['String']['output']>;
  RelativePath?: Maybe<Scalars['String']['output']>;
  RouteSegment?: Maybe<Scalars['String']['output']>;
  Saved?: Maybe<Scalars['Date']['output']>;
  Shortcut?: Maybe<Scalars['String']['output']>;
  SiteId?: Maybe<Scalars['String']['output']>;
  StartPublish?: Maybe<Scalars['Date']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  StopPublish?: Maybe<Scalars['Date']['output']>;
  Thumbnail?: Maybe<BlobModel>;
  Url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `_link` field instead */
  _children?: Maybe<QueryRef>;
  _concreteType?: Maybe<Scalars['String']['output']>;
  _deleted?: Maybe<Scalars['Bool']['output']>;
  _fulltext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _id?: Maybe<Scalars['String']['output']>;
  _json?: Maybe<Scalars['JSON']['output']>;
  _link?: Maybe<QueryRef>;
  _modified?: Maybe<Scalars['Date']['output']>;
  _score?: Maybe<Scalars['Float']['output']>;
  _source?: Maybe<Scalars['String']['output']>;
  _track?: Maybe<Scalars['String']['output']>;
};


export type WordMediaModelContentArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type WordMediaModelDescriptionArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type WordMediaModelHeadingEnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type WordMediaModelHeadingSvArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type WordMediaModelNameArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type WordMediaModelPreambleEnArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type WordMediaModelPreambleSvArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type WordMediaModel_FulltextArgs = {
  highlight?: InputMaybe<HighlightOptions>;
};


export type WordMediaModel_LinkArgs = {
  type?: InputMaybe<LinkTypes>;
};

export type WordMediaModelAutocomplete = {
  __typename?: 'WordMediaModelAutocomplete';
  Ancestors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Category?: Maybe<CategoryModelAutocomplete>;
  ContentLink?: Maybe<ContentModelReferenceAutocomplete>;
  ContentType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelAutocomplete>;
  Language?: Maybe<ContentLanguageModelAutocomplete>;
  MasterLanguage?: Maybe<ContentLanguageModelAutocomplete>;
  MimeType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ParentLink?: Maybe<ContentModelReferenceAutocomplete>;
  RelativePath?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  RouteSegment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Shortcut?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SiteId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Status?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Thumbnail?: Maybe<BlobModelAutocomplete>;
  Url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  _concreteType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type WordMediaModelAutocompleteAncestorsArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WordMediaModelAutocompleteContentTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WordMediaModelAutocompleteMimeTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WordMediaModelAutocompleteRelativePathArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WordMediaModelAutocompleteRouteSegmentArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WordMediaModelAutocompleteShortcutArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WordMediaModelAutocompleteSiteIdArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WordMediaModelAutocompleteStatusArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WordMediaModelAutocompleteUrlArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type WordMediaModelAutocomplete_ConcreteTypeArgs = {
  limit?: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type WordMediaModelFacet = {
  __typename?: 'WordMediaModelFacet';
  Ancestors?: Maybe<Array<Maybe<StringFacet>>>;
  Category?: Maybe<CategoryModelFacet>;
  Changed?: Maybe<Array<Maybe<DateFacet>>>;
  Content?: Maybe<Array<Maybe<StringFacet>>>;
  ContentLink?: Maybe<ContentModelReferenceFacet>;
  ContentType?: Maybe<Array<Maybe<StringFacet>>>;
  Created?: Maybe<Array<Maybe<DateFacet>>>;
  Description?: Maybe<Array<Maybe<StringFacet>>>;
  ExistingLanguages?: Maybe<ContentLanguageModelFacet>;
  FileSize?: Maybe<Array<Maybe<NumberFacet>>>;
  HeadingEn?: Maybe<Array<Maybe<StringFacet>>>;
  HeadingSv?: Maybe<Array<Maybe<StringFacet>>>;
  IsCommonDraft?: Maybe<Array<Maybe<StringFacet>>>;
  Language?: Maybe<ContentLanguageModelFacet>;
  MasterLanguage?: Maybe<ContentLanguageModelFacet>;
  MimeType?: Maybe<Array<Maybe<StringFacet>>>;
  Name?: Maybe<Array<Maybe<StringFacet>>>;
  ParentLink?: Maybe<ContentModelReferenceFacet>;
  PreambleEn?: Maybe<Array<Maybe<StringFacet>>>;
  PreambleSv?: Maybe<Array<Maybe<StringFacet>>>;
  RelativePath?: Maybe<Array<Maybe<StringFacet>>>;
  RouteSegment?: Maybe<Array<Maybe<StringFacet>>>;
  Saved?: Maybe<Array<Maybe<DateFacet>>>;
  Shortcut?: Maybe<Array<Maybe<StringFacet>>>;
  SiteId?: Maybe<Array<Maybe<StringFacet>>>;
  StartPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Status?: Maybe<Array<Maybe<StringFacet>>>;
  StopPublish?: Maybe<Array<Maybe<DateFacet>>>;
  Thumbnail?: Maybe<BlobModelFacet>;
  Url?: Maybe<Array<Maybe<StringFacet>>>;
  _concreteType?: Maybe<Array<Maybe<StringFacet>>>;
};


export type WordMediaModelFacetAncestorsArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetChangedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WordMediaModelFacetContentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetContentTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetCreatedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WordMediaModelFacetDescriptionArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetFileSizeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
  ranges?: InputMaybe<Array<InputMaybe<RangeFacetsInput>>>;
};


export type WordMediaModelFacetHeadingEnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetHeadingSvArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetIsCommonDraftArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetMimeTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetNameArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetPreambleEnArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetPreambleSvArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetRelativePathArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetRouteSegmentArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetSavedArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WordMediaModelFacetShortcutArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetSiteIdArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetStartPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WordMediaModelFacetStatusArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacetStopPublishArgs = {
  unit?: InputMaybe<DateFacetUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};


export type WordMediaModelFacetUrlArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};


export type WordMediaModelFacet_ConcreteTypeArgs = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderBy>;
  orderType?: InputMaybe<OrderByFacetType>;
};

export type WordMediaModelOrderByInput = {
  Ancestors?: InputMaybe<OrderBy>;
  Category?: InputMaybe<CategoryModelOrderByInput>;
  Changed?: InputMaybe<OrderBy>;
  Content?: InputMaybe<OrderBy>;
  ContentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  ContentType?: InputMaybe<OrderBy>;
  Created?: InputMaybe<OrderBy>;
  Description?: InputMaybe<OrderBy>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelOrderByInput>;
  FileSize?: InputMaybe<OrderBy>;
  HeadingEn?: InputMaybe<OrderBy>;
  HeadingSv?: InputMaybe<OrderBy>;
  IsCommonDraft?: InputMaybe<OrderBy>;
  Language?: InputMaybe<ContentLanguageModelOrderByInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelOrderByInput>;
  MimeType?: InputMaybe<OrderBy>;
  Name?: InputMaybe<OrderBy>;
  ParentLink?: InputMaybe<ContentModelReferenceOrderByInput>;
  PreambleEn?: InputMaybe<OrderBy>;
  PreambleSv?: InputMaybe<OrderBy>;
  RelativePath?: InputMaybe<OrderBy>;
  RouteSegment?: InputMaybe<OrderBy>;
  Saved?: InputMaybe<OrderBy>;
  Shortcut?: InputMaybe<OrderBy>;
  SiteId?: InputMaybe<OrderBy>;
  StartPublish?: InputMaybe<OrderBy>;
  Status?: InputMaybe<OrderBy>;
  StopPublish?: InputMaybe<OrderBy>;
  Thumbnail?: InputMaybe<BlobModelOrderByInput>;
  Url?: InputMaybe<OrderBy>;
  _concreteType?: InputMaybe<OrderBy>;
  _minimumScore?: InputMaybe<Scalars['Float']['input']>;
  _modified?: InputMaybe<OrderBy>;
  _ranking?: InputMaybe<Ranking>;
  /** The value needs to be a positive value, but cannot exceed the maximum value of an integer. In case it is exceeded, the maximum of an integer is used. In case of a negative value, semantic search will be disabled. */
  _semanticWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type WordMediaModelOutput = {
  __typename?: 'WordMediaModelOutput';
  autocomplete?: Maybe<WordMediaModelAutocomplete>;
  cursor?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<WordMediaModelFacet>;
  item?: Maybe<WordMediaModel>;
  items?: Maybe<Array<Maybe<WordMediaModel>>>;
  total?: Maybe<Scalars['Int']['output']>;
};


export type WordMediaModelOutputTotalArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WordMediaModelWhereInput = {
  Ancestors?: InputMaybe<StringFilterInput>;
  Category?: InputMaybe<CategoryModelWhereInput>;
  Changed?: InputMaybe<DateFilterInput>;
  Content?: InputMaybe<SearchableStringFilterInput>;
  ContentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  ContentType?: InputMaybe<StringFilterInput>;
  Created?: InputMaybe<DateFilterInput>;
  Description?: InputMaybe<SearchableStringFilterInput>;
  ExistingLanguages?: InputMaybe<ContentLanguageModelWhereInput>;
  FileSize?: InputMaybe<IntFilterInput>;
  HeadingEn?: InputMaybe<SearchableStringFilterInput>;
  HeadingSv?: InputMaybe<SearchableStringFilterInput>;
  IsCommonDraft?: InputMaybe<BoolFilterInput>;
  Language?: InputMaybe<ContentLanguageModelWhereInput>;
  MasterLanguage?: InputMaybe<ContentLanguageModelWhereInput>;
  MimeType?: InputMaybe<StringFilterInput>;
  Name?: InputMaybe<SearchableStringFilterInput>;
  ParentLink?: InputMaybe<ContentModelReferenceWhereInput>;
  PreambleEn?: InputMaybe<SearchableStringFilterInput>;
  PreambleSv?: InputMaybe<SearchableStringFilterInput>;
  RelativePath?: InputMaybe<StringFilterInput>;
  RouteSegment?: InputMaybe<StringFilterInput>;
  Saved?: InputMaybe<DateFilterInput>;
  Shortcut?: InputMaybe<StringFilterInput>;
  SiteId?: InputMaybe<StringFilterInput>;
  StartPublish?: InputMaybe<DateFilterInput>;
  Status?: InputMaybe<StringFilterInput>;
  StopPublish?: InputMaybe<DateFilterInput>;
  Thumbnail?: InputMaybe<BlobModelWhereInput>;
  Url?: InputMaybe<StringFilterInput>;
  _and?: InputMaybe<Array<InputMaybe<WordMediaModelWhereInput>>>;
  _concreteType?: InputMaybe<StringFilterInput>;
  _fulltext?: InputMaybe<SearchableStringFilterInput>;
  _modified?: InputMaybe<DateFilterInput>;
  _not?: InputMaybe<Array<InputMaybe<WordMediaModelWhereInput>>>;
  _or?: InputMaybe<Array<InputMaybe<WordMediaModelWhereInput>>>;
  _source?: InputMaybe<SourceFilterInput>;
};

export enum System_Locales {
  All = 'ALL',
  Neutral = 'NEUTRAL'
}

export type UsePinnedInput = {
  collectionId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phrase?: InputMaybe<Scalars['String']['input']>;
};

export type AssociationBattleBlockFragment = { __typename?: 'AssociationBattleBlockModel', Heading?: string | null, WideLayout?: any | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null };

export type AssociationBattleBlockQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type AssociationBattleBlockQuery = { __typename?: 'Query', Content?: { __typename?: 'ContentOutput', items?: Array<{ __typename?: 'ActivationPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AgreementPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AssociationBattleBlockModel', Heading?: string | null, WideLayout?: any | null, _id?: string | null, Name?: string | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AtoZPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ButtonLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CampaignBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CaptchaElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ChoiceElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CompensationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'Content', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CsvMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetVariant', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'EanCheckBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'EmbedVideoBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ErrorPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExcelMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExtendedLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqCategoryPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqItemPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqListPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FeatureBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FileUploadElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FormContainerBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FormStepBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'HeroBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'IFramePageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageAndTextBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageChoiceElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MainImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MainMenuPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesAdminPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesContainerPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesStartPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NewsContainerPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NewsPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NominationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NumberElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ParagraphTextElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PexMapBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PopupBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PptMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RangeElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RelatedLinksBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ResetButtonElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ResponsiveImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ScriptBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ScriptImportBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SearchResultPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SectionBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SelectionElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SeoBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteDocumentMediaData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteImageData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteMediaData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteVideoData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StandardBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StandardPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StartPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StoreFlyersBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SubmitButtonElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishCertificateBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishFormBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishRegistrationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TabBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TabItem', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TeaserLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextareaElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextboxElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'UrlElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'WebShopLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'WordMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | null> | null } | null };

export type GetCompanyRegistrationsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetCompanyRegistrationsQuery = { __typename?: 'Query', StartPageModel?: { __typename?: 'StartPageModelOutput', items?: Array<{ __typename?: 'StartPageModel', StandardTermsAndConditions?: { __typename?: 'MixedHtmlModel', Html?: string | null } | null } | null> | null } | null, CompanyRegistrationsBlockModel?: { __typename?: 'CompanyRegistrationsBlockModelOutput', items?: Array<{ __typename?: 'CompanyRegistrationsBlockModel', Form?: string | null, ButtonText?: string | null, AlternativeTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditionsButton?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | null> | null } | null };

type ConnectLinksContentArea_ActivationPageModel_Fragment = { __typename?: 'ActivationPageModel' };

type ConnectLinksContentArea_AgreementPageModel_Fragment = { __typename?: 'AgreementPageModel' };

type ConnectLinksContentArea_AssociationBattleBlockModel_Fragment = { __typename?: 'AssociationBattleBlockModel' };

type ConnectLinksContentArea_AtoZPageModel_Fragment = { __typename?: 'AtoZPageModel' };

type ConnectLinksContentArea_ButtonLinkBlockModel_Fragment = { __typename?: 'ButtonLinkBlockModel' };

type ConnectLinksContentArea_CampaignBlock_Fragment = { __typename?: 'CampaignBlock' };

type ConnectLinksContentArea_CaptchaElementBlock_Fragment = { __typename?: 'CaptchaElementBlock' };

type ConnectLinksContentArea_ChoiceElementBlock_Fragment = { __typename?: 'ChoiceElementBlock' };

type ConnectLinksContentArea_CompanyRegistrationsBlockModel_Fragment = { __typename?: 'CompanyRegistrationsBlockModel' };

type ConnectLinksContentArea_CompensationBlockModel_Fragment = { __typename?: 'CompensationBlockModel' };

type ConnectLinksContentArea_ConnectedProducersListBlockModel_Fragment = { __typename?: 'ConnectedProducersListBlockModel' };

type ConnectLinksContentArea_Content_Fragment = { __typename?: 'Content' };

type ConnectLinksContentArea_CsvMediaModel_Fragment = { __typename?: 'CsvMediaModel' };

type ConnectLinksContentArea_DepositLabelOrderBlockModel_Fragment = { __typename?: 'DepositLabelOrderBlockModel' };

type ConnectLinksContentArea_DepositLabelOrderHistoryBlockModel_Fragment = { __typename?: 'DepositLabelOrderHistoryBlockModel' };

type ConnectLinksContentArea_DownloadAssetLocalBlockModel_Fragment = { __typename?: 'DownloadAssetLocalBlockModel' };

type ConnectLinksContentArea_DownloadAssetVariant_Fragment = { __typename?: 'DownloadAssetVariant' };

type ConnectLinksContentArea_DownloadAssetsBlockModel_Fragment = { __typename?: 'DownloadAssetsBlockModel' };

type ConnectLinksContentArea_EanCheckBlockModel_Fragment = { __typename?: 'EanCheckBlockModel' };

type ConnectLinksContentArea_EmbedVideoBlockModel_Fragment = { __typename?: 'EmbedVideoBlockModel' };

type ConnectLinksContentArea_ErrorPageModel_Fragment = { __typename?: 'ErrorPageModel' };

type ConnectLinksContentArea_ExcelMediaModel_Fragment = { __typename?: 'ExcelMediaModel' };

type ConnectLinksContentArea_ExtendedLinkBlockModel_Fragment = { __typename?: 'ExtendedLinkBlockModel', Heading?: string | null, InvertIcon?: any | null, Title?: string | null, MenuIcon?: string | null, LinkUrl?: string | null, TeaserText?: string | null, FormReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel', Form?: string | null, ButtonText?: string | null, AlternativeTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditionsButton?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null };

type ConnectLinksContentArea_ExtraPickupFormBlockModel_Fragment = { __typename?: 'ExtraPickupFormBlockModel' };

type ConnectLinksContentArea_FaqCategoryPageModel_Fragment = { __typename?: 'FaqCategoryPageModel' };

type ConnectLinksContentArea_FaqItemPageModel_Fragment = { __typename?: 'FaqItemPageModel' };

type ConnectLinksContentArea_FaqListPageModel_Fragment = { __typename?: 'FaqListPageModel' };

type ConnectLinksContentArea_FeatureBlockModel_Fragment = { __typename?: 'FeatureBlockModel' };

type ConnectLinksContentArea_FileUploadElementBlock_Fragment = { __typename?: 'FileUploadElementBlock' };

type ConnectLinksContentArea_FormContainerBlock_Fragment = { __typename?: 'FormContainerBlock' };

type ConnectLinksContentArea_FormStepBlock_Fragment = { __typename?: 'FormStepBlock' };

type ConnectLinksContentArea_HeroBlockModel_Fragment = { __typename?: 'HeroBlockModel' };

type ConnectLinksContentArea_IFramePageModel_Fragment = { __typename?: 'IFramePageModel' };

type ConnectLinksContentArea_ImageAndTextBlockModel_Fragment = { __typename?: 'ImageAndTextBlockModel' };

type ConnectLinksContentArea_ImageBlockModel_Fragment = { __typename?: 'ImageBlockModel' };

type ConnectLinksContentArea_ImageChoiceElementBlock_Fragment = { __typename?: 'ImageChoiceElementBlock' };

type ConnectLinksContentArea_MainImageBlockModel_Fragment = { __typename?: 'MainImageBlockModel' };

type ConnectLinksContentArea_MainMenuPageModel_Fragment = { __typename?: 'MainMenuPageModel' };

type ConnectLinksContentArea_MyPagesAdminPageModel_Fragment = { __typename?: 'MyPagesAdminPageModel' };

type ConnectLinksContentArea_MyPagesBlockModel_Fragment = { __typename?: 'MyPagesBlockModel' };

type ConnectLinksContentArea_MyPagesContainerPageModel_Fragment = { __typename?: 'MyPagesContainerPageModel' };

type ConnectLinksContentArea_MyPagesPageModel_Fragment = { __typename?: 'MyPagesPageModel' };

type ConnectLinksContentArea_MyPagesStartPageModel_Fragment = { __typename?: 'MyPagesStartPageModel' };

type ConnectLinksContentArea_NewsContainerPageModel_Fragment = { __typename?: 'NewsContainerPageModel' };

type ConnectLinksContentArea_NewsPageModel_Fragment = { __typename?: 'NewsPageModel' };

type ConnectLinksContentArea_NominationBlockModel_Fragment = { __typename?: 'NominationBlockModel' };

type ConnectLinksContentArea_NumberElementBlock_Fragment = { __typename?: 'NumberElementBlock' };

type ConnectLinksContentArea_OrderAssetLocalBlockModel_Fragment = { __typename?: 'OrderAssetLocalBlockModel' };

type ConnectLinksContentArea_ParagraphTextElementBlock_Fragment = { __typename?: 'ParagraphTextElementBlock' };

type ConnectLinksContentArea_PexMapBlockModel_Fragment = { __typename?: 'PexMapBlockModel' };

type ConnectLinksContentArea_PopupBlockModel_Fragment = { __typename?: 'PopupBlockModel' };

type ConnectLinksContentArea_PptMediaModel_Fragment = { __typename?: 'PptMediaModel' };

type ConnectLinksContentArea_PredefinedHiddenElementBlock_Fragment = { __typename?: 'PredefinedHiddenElementBlock' };

type ConnectLinksContentArea_PrizePoolBlockModel_Fragment = { __typename?: 'PrizePoolBlockModel' };

type ConnectLinksContentArea_PrizePoolDistributionLocalBlockModel_Fragment = { __typename?: 'PrizePoolDistributionLocalBlockModel' };

type ConnectLinksContentArea_PrizePoolNumbersLocalBlockModel_Fragment = { __typename?: 'PrizePoolNumbersLocalBlockModel' };

type ConnectLinksContentArea_RangeElementBlock_Fragment = { __typename?: 'RangeElementBlock' };

type ConnectLinksContentArea_RecyclingStoreTopListBlockModel_Fragment = { __typename?: 'RecyclingStoreTopListBlockModel' };

type ConnectLinksContentArea_RelatedLinksBlockModel_Fragment = { __typename?: 'RelatedLinksBlockModel' };

type ConnectLinksContentArea_ResetButtonElementBlock_Fragment = { __typename?: 'ResetButtonElementBlock' };

type ConnectLinksContentArea_ResponsiveImageBlockModel_Fragment = { __typename?: 'ResponsiveImageBlockModel' };

type ConnectLinksContentArea_ScriptBlock_Fragment = { __typename?: 'ScriptBlock' };

type ConnectLinksContentArea_ScriptImportBlockModel_Fragment = { __typename?: 'ScriptImportBlockModel' };

type ConnectLinksContentArea_SearchResultPageModel_Fragment = { __typename?: 'SearchResultPageModel' };

type ConnectLinksContentArea_SectionBlockModel_Fragment = { __typename?: 'SectionBlockModel' };

type ConnectLinksContentArea_SelectionElementBlock_Fragment = { __typename?: 'SelectionElementBlock' };

type ConnectLinksContentArea_SeoBlockModel_Fragment = { __typename?: 'SeoBlockModel' };

type ConnectLinksContentArea_SiteContextSettingsBlockModel_Fragment = { __typename?: 'SiteContextSettingsBlockModel' };

type ConnectLinksContentArea_SiteDocumentMediaData_Fragment = { __typename?: 'SiteDocumentMediaData' };

type ConnectLinksContentArea_SiteImageData_Fragment = { __typename?: 'SiteImageData' };

type ConnectLinksContentArea_SiteMediaData_Fragment = { __typename?: 'SiteMediaData' };

type ConnectLinksContentArea_SiteVideoData_Fragment = { __typename?: 'SiteVideoData' };

type ConnectLinksContentArea_StandardBlockModel_Fragment = { __typename?: 'StandardBlockModel' };

type ConnectLinksContentArea_StandardPageModel_Fragment = { __typename?: 'StandardPageModel' };

type ConnectLinksContentArea_StartPageModel_Fragment = { __typename?: 'StartPageModel' };

type ConnectLinksContentArea_StoreFlyersBlockModel_Fragment = { __typename?: 'StoreFlyersBlockModel' };

type ConnectLinksContentArea_SubmitButtonElementBlock_Fragment = { __typename?: 'SubmitButtonElementBlock' };

type ConnectLinksContentArea_SwishCertificateBlockModel_Fragment = { __typename?: 'SwishCertificateBlockModel' };

type ConnectLinksContentArea_SwishFormBlockModel_Fragment = { __typename?: 'SwishFormBlockModel' };

type ConnectLinksContentArea_SwishRegistrationBlockModel_Fragment = { __typename?: 'SwishRegistrationBlockModel' };

type ConnectLinksContentArea_SwishStoreRegistrationBlockModel_Fragment = { __typename?: 'SwishStoreRegistrationBlockModel' };

type ConnectLinksContentArea_TabBlockModel_Fragment = { __typename?: 'TabBlockModel' };

type ConnectLinksContentArea_TabItem_Fragment = { __typename?: 'TabItem' };

type ConnectLinksContentArea_TeaserLinkBlockModel_Fragment = { __typename?: 'TeaserLinkBlockModel' };

type ConnectLinksContentArea_TextBlockModel_Fragment = { __typename?: 'TextBlockModel' };

type ConnectLinksContentArea_TextareaElementBlock_Fragment = { __typename?: 'TextareaElementBlock' };

type ConnectLinksContentArea_TextboxElementBlock_Fragment = { __typename?: 'TextboxElementBlock' };

type ConnectLinksContentArea_UrlElementBlock_Fragment = { __typename?: 'UrlElementBlock' };

type ConnectLinksContentArea_VisitorDataHiddenElementBlock_Fragment = { __typename?: 'VisitorDataHiddenElementBlock' };

type ConnectLinksContentArea_WebShopLinkBlockModel_Fragment = { __typename?: 'WebShopLinkBlockModel' };

type ConnectLinksContentArea_WordMediaModel_Fragment = { __typename?: 'WordMediaModel' };

export type ConnectLinksContentAreaFragment = ConnectLinksContentArea_ActivationPageModel_Fragment | ConnectLinksContentArea_AgreementPageModel_Fragment | ConnectLinksContentArea_AssociationBattleBlockModel_Fragment | ConnectLinksContentArea_AtoZPageModel_Fragment | ConnectLinksContentArea_ButtonLinkBlockModel_Fragment | ConnectLinksContentArea_CampaignBlock_Fragment | ConnectLinksContentArea_CaptchaElementBlock_Fragment | ConnectLinksContentArea_ChoiceElementBlock_Fragment | ConnectLinksContentArea_CompanyRegistrationsBlockModel_Fragment | ConnectLinksContentArea_CompensationBlockModel_Fragment | ConnectLinksContentArea_ConnectedProducersListBlockModel_Fragment | ConnectLinksContentArea_Content_Fragment | ConnectLinksContentArea_CsvMediaModel_Fragment | ConnectLinksContentArea_DepositLabelOrderBlockModel_Fragment | ConnectLinksContentArea_DepositLabelOrderHistoryBlockModel_Fragment | ConnectLinksContentArea_DownloadAssetLocalBlockModel_Fragment | ConnectLinksContentArea_DownloadAssetVariant_Fragment | ConnectLinksContentArea_DownloadAssetsBlockModel_Fragment | ConnectLinksContentArea_EanCheckBlockModel_Fragment | ConnectLinksContentArea_EmbedVideoBlockModel_Fragment | ConnectLinksContentArea_ErrorPageModel_Fragment | ConnectLinksContentArea_ExcelMediaModel_Fragment | ConnectLinksContentArea_ExtendedLinkBlockModel_Fragment | ConnectLinksContentArea_ExtraPickupFormBlockModel_Fragment | ConnectLinksContentArea_FaqCategoryPageModel_Fragment | ConnectLinksContentArea_FaqItemPageModel_Fragment | ConnectLinksContentArea_FaqListPageModel_Fragment | ConnectLinksContentArea_FeatureBlockModel_Fragment | ConnectLinksContentArea_FileUploadElementBlock_Fragment | ConnectLinksContentArea_FormContainerBlock_Fragment | ConnectLinksContentArea_FormStepBlock_Fragment | ConnectLinksContentArea_HeroBlockModel_Fragment | ConnectLinksContentArea_IFramePageModel_Fragment | ConnectLinksContentArea_ImageAndTextBlockModel_Fragment | ConnectLinksContentArea_ImageBlockModel_Fragment | ConnectLinksContentArea_ImageChoiceElementBlock_Fragment | ConnectLinksContentArea_MainImageBlockModel_Fragment | ConnectLinksContentArea_MainMenuPageModel_Fragment | ConnectLinksContentArea_MyPagesAdminPageModel_Fragment | ConnectLinksContentArea_MyPagesBlockModel_Fragment | ConnectLinksContentArea_MyPagesContainerPageModel_Fragment | ConnectLinksContentArea_MyPagesPageModel_Fragment | ConnectLinksContentArea_MyPagesStartPageModel_Fragment | ConnectLinksContentArea_NewsContainerPageModel_Fragment | ConnectLinksContentArea_NewsPageModel_Fragment | ConnectLinksContentArea_NominationBlockModel_Fragment | ConnectLinksContentArea_NumberElementBlock_Fragment | ConnectLinksContentArea_OrderAssetLocalBlockModel_Fragment | ConnectLinksContentArea_ParagraphTextElementBlock_Fragment | ConnectLinksContentArea_PexMapBlockModel_Fragment | ConnectLinksContentArea_PopupBlockModel_Fragment | ConnectLinksContentArea_PptMediaModel_Fragment | ConnectLinksContentArea_PredefinedHiddenElementBlock_Fragment | ConnectLinksContentArea_PrizePoolBlockModel_Fragment | ConnectLinksContentArea_PrizePoolDistributionLocalBlockModel_Fragment | ConnectLinksContentArea_PrizePoolNumbersLocalBlockModel_Fragment | ConnectLinksContentArea_RangeElementBlock_Fragment | ConnectLinksContentArea_RecyclingStoreTopListBlockModel_Fragment | ConnectLinksContentArea_RelatedLinksBlockModel_Fragment | ConnectLinksContentArea_ResetButtonElementBlock_Fragment | ConnectLinksContentArea_ResponsiveImageBlockModel_Fragment | ConnectLinksContentArea_ScriptBlock_Fragment | ConnectLinksContentArea_ScriptImportBlockModel_Fragment | ConnectLinksContentArea_SearchResultPageModel_Fragment | ConnectLinksContentArea_SectionBlockModel_Fragment | ConnectLinksContentArea_SelectionElementBlock_Fragment | ConnectLinksContentArea_SeoBlockModel_Fragment | ConnectLinksContentArea_SiteContextSettingsBlockModel_Fragment | ConnectLinksContentArea_SiteDocumentMediaData_Fragment | ConnectLinksContentArea_SiteImageData_Fragment | ConnectLinksContentArea_SiteMediaData_Fragment | ConnectLinksContentArea_SiteVideoData_Fragment | ConnectLinksContentArea_StandardBlockModel_Fragment | ConnectLinksContentArea_StandardPageModel_Fragment | ConnectLinksContentArea_StartPageModel_Fragment | ConnectLinksContentArea_StoreFlyersBlockModel_Fragment | ConnectLinksContentArea_SubmitButtonElementBlock_Fragment | ConnectLinksContentArea_SwishCertificateBlockModel_Fragment | ConnectLinksContentArea_SwishFormBlockModel_Fragment | ConnectLinksContentArea_SwishRegistrationBlockModel_Fragment | ConnectLinksContentArea_SwishStoreRegistrationBlockModel_Fragment | ConnectLinksContentArea_TabBlockModel_Fragment | ConnectLinksContentArea_TabItem_Fragment | ConnectLinksContentArea_TeaserLinkBlockModel_Fragment | ConnectLinksContentArea_TextBlockModel_Fragment | ConnectLinksContentArea_TextareaElementBlock_Fragment | ConnectLinksContentArea_TextboxElementBlock_Fragment | ConnectLinksContentArea_UrlElementBlock_Fragment | ConnectLinksContentArea_VisitorDataHiddenElementBlock_Fragment | ConnectLinksContentArea_WebShopLinkBlockModel_Fragment | ConnectLinksContentArea_WordMediaModel_Fragment;

export type GetMyPagesContainerPropsQueryVariables = Exact<{
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetMyPagesContainerPropsQuery = { __typename?: 'Query', MyPagesContainerPageModel?: { __typename?: 'MyPagesContainerPageModelOutput', items?: Array<{ __typename?: 'MyPagesContainerPageModel', ConnectHeader?: string | null, AddCustomerDialogHeader?: string | null, AddCustomerDialogText?: string | null, PopUpContentArea?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel', Name?: string | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null, ConnectFooter?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, ConnectContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, ConnectLinksContentArea?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel', Heading?: string | null, InvertIcon?: any | null, Title?: string | null, MenuIcon?: string | null, LinkUrl?: string | null, TeaserText?: string | null, FormReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel', Form?: string | null, ButtonText?: string | null, AlternativeTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditionsButton?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null, AddConfirmDialog?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, _children?: { __typename?: 'QueryRef', MyPagesStartPageModel?: { __typename?: 'MyPagesStartPageModelOutput', items?: Array<{ __typename?: 'MyPagesStartPageModel', OngoingRegistrationHeader1?: string | null, OngoingRegistrationHeader2?: string | null, OngoingRegistrationHeader3?: string | null, OngoingRegistrationHeader4?: string | null, OngoingRegistrationHeader5?: string | null, CustomerType?: string | null, OngoingRegistrationStep1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, OngoingRegistrationStep2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, OngoingRegistrationStep3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, OngoingRegistrationStep4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, OngoingRegistrationStep5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | null> | null } | null } | null } | null> | null } | null };

export type GetFilteredMyPagesBlocksQueryVariables = Exact<{
  userCategory: Scalars['String']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
  features: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetFilteredMyPagesBlocksQuery = { __typename?: 'Query', MyPagesStartPageModel?: { __typename?: 'MyPagesStartPageModelOutput', items?: Array<{ __typename?: 'MyPagesStartPageModel', _children?: { __typename?: 'QueryRef', MyPagesPageModel?: { __typename?: 'MyPagesPageModelOutput', items?: Array<{ __typename?: 'MyPagesPageModel', Name?: string | null, RelativePath?: string | null, RequiredUserRole?: string | null, IncludedFeature?: string | null, MainContentArea?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel', Component?: string | null, IncludedFeature?: string | null } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | null> | null } | null } | null } | null> | null } | null };

export type GetStoreFlyersBlockQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetStoreFlyersBlockQuery = { __typename?: 'Query', Content?: { __typename?: 'ContentOutput', items?: Array<{ __typename?: 'ActivationPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AgreementPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AssociationBattleBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AtoZPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ButtonLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CampaignBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CaptchaElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ChoiceElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CompensationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'Content', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CsvMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetVariant', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'EanCheckBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'EmbedVideoBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ErrorPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExcelMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExtendedLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqCategoryPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqItemPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqListPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FeatureBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FileUploadElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FormContainerBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FormStepBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'HeroBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'IFramePageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageAndTextBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageChoiceElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MainImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MainMenuPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesAdminPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesContainerPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesStartPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NewsContainerPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NewsPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NominationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NumberElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ParagraphTextElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PexMapBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PopupBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PptMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RangeElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RelatedLinksBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ResetButtonElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ResponsiveImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ScriptBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ScriptImportBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SearchResultPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SectionBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SelectionElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SeoBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteDocumentMediaData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteImageData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteMediaData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteVideoData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StandardBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StandardPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StartPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StoreFlyersBlockModel', Heading?: string | null, _id?: string | null, Name?: string | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SubmitButtonElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishCertificateBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishFormBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishRegistrationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TabBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TabItem', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TeaserLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextareaElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextboxElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'UrlElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'WebShopLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'WordMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | null> | null } | null };

export type GetActivationPageUrlQueryVariables = Exact<{
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetActivationPageUrlQuery = { __typename?: 'Query', ActivationPageModel?: { __typename?: 'ActivationPageModelOutput', items?: Array<{ __typename?: 'ActivationPageModel', Url?: string | null } | null> | null } | null };

export type MyPagesBlockFragment = { __typename?: 'MyPagesBlockModel', Heading?: string | null, TeaserText?: string | null, Component?: string | null, IncludedFeature?: string | null, UseGeneralTab?: any | null, GeneralTabHeading?: string | null, GeneralTabText?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null };

type MyPagesContentArea_ActivationPageModel_Fragment = { __typename: 'ActivationPageModel' };

type MyPagesContentArea_AgreementPageModel_Fragment = { __typename: 'AgreementPageModel' };

type MyPagesContentArea_AssociationBattleBlockModel_Fragment = { __typename: 'AssociationBattleBlockModel', Heading?: string | null, WideLayout?: any | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null };

type MyPagesContentArea_AtoZPageModel_Fragment = { __typename: 'AtoZPageModel' };

type MyPagesContentArea_ButtonLinkBlockModel_Fragment = { __typename: 'ButtonLinkBlockModel' };

type MyPagesContentArea_CampaignBlock_Fragment = { __typename: 'CampaignBlock' };

type MyPagesContentArea_CaptchaElementBlock_Fragment = { __typename: 'CaptchaElementBlock' };

type MyPagesContentArea_ChoiceElementBlock_Fragment = { __typename: 'ChoiceElementBlock' };

type MyPagesContentArea_CompanyRegistrationsBlockModel_Fragment = { __typename: 'CompanyRegistrationsBlockModel' };

type MyPagesContentArea_CompensationBlockModel_Fragment = { __typename: 'CompensationBlockModel' };

type MyPagesContentArea_ConnectedProducersListBlockModel_Fragment = { __typename: 'ConnectedProducersListBlockModel' };

type MyPagesContentArea_Content_Fragment = { __typename: 'Content' };

type MyPagesContentArea_CsvMediaModel_Fragment = { __typename: 'CsvMediaModel' };

type MyPagesContentArea_DepositLabelOrderBlockModel_Fragment = { __typename: 'DepositLabelOrderBlockModel', Heading?: string | null, PriceInformation?: string | null, ShippingInformation?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Button?: { __typename?: 'DepositLabelOrderBlockModelButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null } | null };

type MyPagesContentArea_DepositLabelOrderHistoryBlockModel_Fragment = { __typename: 'DepositLabelOrderHistoryBlockModel', Heading?: string | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null };

type MyPagesContentArea_DownloadAssetLocalBlockModel_Fragment = { __typename: 'DownloadAssetLocalBlockModel' };

type MyPagesContentArea_DownloadAssetVariant_Fragment = { __typename: 'DownloadAssetVariant' };

type MyPagesContentArea_DownloadAssetsBlockModel_Fragment = { __typename: 'DownloadAssetsBlockModel' };

type MyPagesContentArea_EanCheckBlockModel_Fragment = { __typename: 'EanCheckBlockModel' };

type MyPagesContentArea_EmbedVideoBlockModel_Fragment = { __typename: 'EmbedVideoBlockModel', Heading?: string | null, EmbedUrl?: string | null, VideoDescription?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null };

type MyPagesContentArea_ErrorPageModel_Fragment = { __typename: 'ErrorPageModel' };

type MyPagesContentArea_ExcelMediaModel_Fragment = { __typename: 'ExcelMediaModel' };

type MyPagesContentArea_ExtendedLinkBlockModel_Fragment = { __typename: 'ExtendedLinkBlockModel', Heading?: string | null, InvertIcon?: any | null, Title?: string | null, MenuIcon?: string | null, LinkUrl?: string | null, TeaserText?: string | null, FormReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel', Form?: string | null, ButtonText?: string | null, AlternativeTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditionsButton?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null };

type MyPagesContentArea_ExtraPickupFormBlockModel_Fragment = { __typename: 'ExtraPickupFormBlockModel' };

type MyPagesContentArea_FaqCategoryPageModel_Fragment = { __typename: 'FaqCategoryPageModel' };

type MyPagesContentArea_FaqItemPageModel_Fragment = { __typename: 'FaqItemPageModel' };

type MyPagesContentArea_FaqListPageModel_Fragment = { __typename: 'FaqListPageModel' };

type MyPagesContentArea_FeatureBlockModel_Fragment = { __typename: 'FeatureBlockModel', Heading?: string | null, TeaserText?: string | null, ContentTextPosition?: number | null, ColorTheme?: number | null, BackGround?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null };

type MyPagesContentArea_FileUploadElementBlock_Fragment = { __typename: 'FileUploadElementBlock' };

type MyPagesContentArea_FormContainerBlock_Fragment = { __typename: 'FormContainerBlock' };

type MyPagesContentArea_FormStepBlock_Fragment = { __typename: 'FormStepBlock' };

type MyPagesContentArea_HeroBlockModel_Fragment = { __typename: 'HeroBlockModel', IncludedFeature?: string | null, Heading?: string | null, PreHeading?: string | null, PreHeadingFont?: string | null, ColorTheme?: number | null, TeaserText?: string | null, TeaserTextFont?: string | null, ContentImagePosition?: number | null, ContentTextAlignment?: number | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Background?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, ImageMobile?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null };

type MyPagesContentArea_IFramePageModel_Fragment = { __typename: 'IFramePageModel' };

type MyPagesContentArea_ImageAndTextBlockModel_Fragment = { __typename: 'ImageAndTextBlockModel' };

type MyPagesContentArea_ImageBlockModel_Fragment = { __typename: 'ImageBlockModel' };

type MyPagesContentArea_ImageChoiceElementBlock_Fragment = { __typename: 'ImageChoiceElementBlock' };

type MyPagesContentArea_MainImageBlockModel_Fragment = { __typename: 'MainImageBlockModel' };

type MyPagesContentArea_MainMenuPageModel_Fragment = { __typename: 'MainMenuPageModel' };

type MyPagesContentArea_MyPagesAdminPageModel_Fragment = { __typename: 'MyPagesAdminPageModel' };

type MyPagesContentArea_MyPagesBlockModel_Fragment = { __typename: 'MyPagesBlockModel', Heading?: string | null, TeaserText?: string | null, Component?: string | null, IncludedFeature?: string | null, UseGeneralTab?: any | null, GeneralTabHeading?: string | null, GeneralTabText?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null };

type MyPagesContentArea_MyPagesContainerPageModel_Fragment = { __typename: 'MyPagesContainerPageModel' };

type MyPagesContentArea_MyPagesPageModel_Fragment = { __typename: 'MyPagesPageModel' };

type MyPagesContentArea_MyPagesStartPageModel_Fragment = { __typename: 'MyPagesStartPageModel' };

type MyPagesContentArea_NewsContainerPageModel_Fragment = { __typename: 'NewsContainerPageModel' };

type MyPagesContentArea_NewsPageModel_Fragment = { __typename: 'NewsPageModel' };

type MyPagesContentArea_NominationBlockModel_Fragment = { __typename: 'NominationBlockModel' };

type MyPagesContentArea_NumberElementBlock_Fragment = { __typename: 'NumberElementBlock' };

type MyPagesContentArea_OrderAssetLocalBlockModel_Fragment = { __typename: 'OrderAssetLocalBlockModel' };

type MyPagesContentArea_ParagraphTextElementBlock_Fragment = { __typename: 'ParagraphTextElementBlock' };

type MyPagesContentArea_PexMapBlockModel_Fragment = { __typename: 'PexMapBlockModel' };

type MyPagesContentArea_PopupBlockModel_Fragment = { __typename: 'PopupBlockModel', Name?: string | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null };

type MyPagesContentArea_PptMediaModel_Fragment = { __typename: 'PptMediaModel' };

type MyPagesContentArea_PredefinedHiddenElementBlock_Fragment = { __typename: 'PredefinedHiddenElementBlock' };

type MyPagesContentArea_PrizePoolBlockModel_Fragment = { __typename: 'PrizePoolBlockModel' };

type MyPagesContentArea_PrizePoolDistributionLocalBlockModel_Fragment = { __typename: 'PrizePoolDistributionLocalBlockModel' };

type MyPagesContentArea_PrizePoolNumbersLocalBlockModel_Fragment = { __typename: 'PrizePoolNumbersLocalBlockModel' };

type MyPagesContentArea_RangeElementBlock_Fragment = { __typename: 'RangeElementBlock' };

type MyPagesContentArea_RecyclingStoreTopListBlockModel_Fragment = { __typename: 'RecyclingStoreTopListBlockModel' };

type MyPagesContentArea_RelatedLinksBlockModel_Fragment = { __typename: 'RelatedLinksBlockModel' };

type MyPagesContentArea_ResetButtonElementBlock_Fragment = { __typename: 'ResetButtonElementBlock' };

type MyPagesContentArea_ResponsiveImageBlockModel_Fragment = { __typename: 'ResponsiveImageBlockModel' };

type MyPagesContentArea_ScriptBlock_Fragment = { __typename: 'ScriptBlock' };

type MyPagesContentArea_ScriptImportBlockModel_Fragment = { __typename: 'ScriptImportBlockModel' };

type MyPagesContentArea_SearchResultPageModel_Fragment = { __typename: 'SearchResultPageModel' };

type MyPagesContentArea_SectionBlockModel_Fragment = { __typename: 'SectionBlockModel' };

type MyPagesContentArea_SelectionElementBlock_Fragment = { __typename: 'SelectionElementBlock' };

type MyPagesContentArea_SeoBlockModel_Fragment = { __typename: 'SeoBlockModel' };

type MyPagesContentArea_SiteContextSettingsBlockModel_Fragment = { __typename: 'SiteContextSettingsBlockModel' };

type MyPagesContentArea_SiteDocumentMediaData_Fragment = { __typename: 'SiteDocumentMediaData' };

type MyPagesContentArea_SiteImageData_Fragment = { __typename: 'SiteImageData' };

type MyPagesContentArea_SiteMediaData_Fragment = { __typename: 'SiteMediaData' };

type MyPagesContentArea_SiteVideoData_Fragment = { __typename: 'SiteVideoData' };

type MyPagesContentArea_StandardBlockModel_Fragment = { __typename: 'StandardBlockModel', WideLayout?: any | null, Heading?: string | null, ImageAlignment?: string | null, ColorTheme?: number | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, BackgroundImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null };

type MyPagesContentArea_StandardPageModel_Fragment = { __typename: 'StandardPageModel' };

type MyPagesContentArea_StartPageModel_Fragment = { __typename: 'StartPageModel' };

type MyPagesContentArea_StoreFlyersBlockModel_Fragment = { __typename: 'StoreFlyersBlockModel' };

type MyPagesContentArea_SubmitButtonElementBlock_Fragment = { __typename: 'SubmitButtonElementBlock' };

type MyPagesContentArea_SwishCertificateBlockModel_Fragment = { __typename: 'SwishCertificateBlockModel', Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, UploadHelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null };

type MyPagesContentArea_SwishFormBlockModel_Fragment = { __typename: 'SwishFormBlockModel' };

type MyPagesContentArea_SwishRegistrationBlockModel_Fragment = { __typename: 'SwishRegistrationBlockModel' };

type MyPagesContentArea_SwishStoreRegistrationBlockModel_Fragment = { __typename: 'SwishStoreRegistrationBlockModel', InstructionText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null };

type MyPagesContentArea_TabBlockModel_Fragment = { __typename: 'TabBlockModel' };

type MyPagesContentArea_TabItem_Fragment = { __typename: 'TabItem' };

type MyPagesContentArea_TeaserLinkBlockModel_Fragment = { __typename: 'TeaserLinkBlockModel' };

type MyPagesContentArea_TextBlockModel_Fragment = { __typename: 'TextBlockModel' };

type MyPagesContentArea_TextareaElementBlock_Fragment = { __typename: 'TextareaElementBlock' };

type MyPagesContentArea_TextboxElementBlock_Fragment = { __typename: 'TextboxElementBlock' };

type MyPagesContentArea_UrlElementBlock_Fragment = { __typename: 'UrlElementBlock' };

type MyPagesContentArea_VisitorDataHiddenElementBlock_Fragment = { __typename: 'VisitorDataHiddenElementBlock' };

type MyPagesContentArea_WebShopLinkBlockModel_Fragment = { __typename: 'WebShopLinkBlockModel' };

type MyPagesContentArea_WordMediaModel_Fragment = { __typename: 'WordMediaModel' };

export type MyPagesContentAreaFragment = MyPagesContentArea_ActivationPageModel_Fragment | MyPagesContentArea_AgreementPageModel_Fragment | MyPagesContentArea_AssociationBattleBlockModel_Fragment | MyPagesContentArea_AtoZPageModel_Fragment | MyPagesContentArea_ButtonLinkBlockModel_Fragment | MyPagesContentArea_CampaignBlock_Fragment | MyPagesContentArea_CaptchaElementBlock_Fragment | MyPagesContentArea_ChoiceElementBlock_Fragment | MyPagesContentArea_CompanyRegistrationsBlockModel_Fragment | MyPagesContentArea_CompensationBlockModel_Fragment | MyPagesContentArea_ConnectedProducersListBlockModel_Fragment | MyPagesContentArea_Content_Fragment | MyPagesContentArea_CsvMediaModel_Fragment | MyPagesContentArea_DepositLabelOrderBlockModel_Fragment | MyPagesContentArea_DepositLabelOrderHistoryBlockModel_Fragment | MyPagesContentArea_DownloadAssetLocalBlockModel_Fragment | MyPagesContentArea_DownloadAssetVariant_Fragment | MyPagesContentArea_DownloadAssetsBlockModel_Fragment | MyPagesContentArea_EanCheckBlockModel_Fragment | MyPagesContentArea_EmbedVideoBlockModel_Fragment | MyPagesContentArea_ErrorPageModel_Fragment | MyPagesContentArea_ExcelMediaModel_Fragment | MyPagesContentArea_ExtendedLinkBlockModel_Fragment | MyPagesContentArea_ExtraPickupFormBlockModel_Fragment | MyPagesContentArea_FaqCategoryPageModel_Fragment | MyPagesContentArea_FaqItemPageModel_Fragment | MyPagesContentArea_FaqListPageModel_Fragment | MyPagesContentArea_FeatureBlockModel_Fragment | MyPagesContentArea_FileUploadElementBlock_Fragment | MyPagesContentArea_FormContainerBlock_Fragment | MyPagesContentArea_FormStepBlock_Fragment | MyPagesContentArea_HeroBlockModel_Fragment | MyPagesContentArea_IFramePageModel_Fragment | MyPagesContentArea_ImageAndTextBlockModel_Fragment | MyPagesContentArea_ImageBlockModel_Fragment | MyPagesContentArea_ImageChoiceElementBlock_Fragment | MyPagesContentArea_MainImageBlockModel_Fragment | MyPagesContentArea_MainMenuPageModel_Fragment | MyPagesContentArea_MyPagesAdminPageModel_Fragment | MyPagesContentArea_MyPagesBlockModel_Fragment | MyPagesContentArea_MyPagesContainerPageModel_Fragment | MyPagesContentArea_MyPagesPageModel_Fragment | MyPagesContentArea_MyPagesStartPageModel_Fragment | MyPagesContentArea_NewsContainerPageModel_Fragment | MyPagesContentArea_NewsPageModel_Fragment | MyPagesContentArea_NominationBlockModel_Fragment | MyPagesContentArea_NumberElementBlock_Fragment | MyPagesContentArea_OrderAssetLocalBlockModel_Fragment | MyPagesContentArea_ParagraphTextElementBlock_Fragment | MyPagesContentArea_PexMapBlockModel_Fragment | MyPagesContentArea_PopupBlockModel_Fragment | MyPagesContentArea_PptMediaModel_Fragment | MyPagesContentArea_PredefinedHiddenElementBlock_Fragment | MyPagesContentArea_PrizePoolBlockModel_Fragment | MyPagesContentArea_PrizePoolDistributionLocalBlockModel_Fragment | MyPagesContentArea_PrizePoolNumbersLocalBlockModel_Fragment | MyPagesContentArea_RangeElementBlock_Fragment | MyPagesContentArea_RecyclingStoreTopListBlockModel_Fragment | MyPagesContentArea_RelatedLinksBlockModel_Fragment | MyPagesContentArea_ResetButtonElementBlock_Fragment | MyPagesContentArea_ResponsiveImageBlockModel_Fragment | MyPagesContentArea_ScriptBlock_Fragment | MyPagesContentArea_ScriptImportBlockModel_Fragment | MyPagesContentArea_SearchResultPageModel_Fragment | MyPagesContentArea_SectionBlockModel_Fragment | MyPagesContentArea_SelectionElementBlock_Fragment | MyPagesContentArea_SeoBlockModel_Fragment | MyPagesContentArea_SiteContextSettingsBlockModel_Fragment | MyPagesContentArea_SiteDocumentMediaData_Fragment | MyPagesContentArea_SiteImageData_Fragment | MyPagesContentArea_SiteMediaData_Fragment | MyPagesContentArea_SiteVideoData_Fragment | MyPagesContentArea_StandardBlockModel_Fragment | MyPagesContentArea_StandardPageModel_Fragment | MyPagesContentArea_StartPageModel_Fragment | MyPagesContentArea_StoreFlyersBlockModel_Fragment | MyPagesContentArea_SubmitButtonElementBlock_Fragment | MyPagesContentArea_SwishCertificateBlockModel_Fragment | MyPagesContentArea_SwishFormBlockModel_Fragment | MyPagesContentArea_SwishRegistrationBlockModel_Fragment | MyPagesContentArea_SwishStoreRegistrationBlockModel_Fragment | MyPagesContentArea_TabBlockModel_Fragment | MyPagesContentArea_TabItem_Fragment | MyPagesContentArea_TeaserLinkBlockModel_Fragment | MyPagesContentArea_TextBlockModel_Fragment | MyPagesContentArea_TextareaElementBlock_Fragment | MyPagesContentArea_TextboxElementBlock_Fragment | MyPagesContentArea_UrlElementBlock_Fragment | MyPagesContentArea_VisitorDataHiddenElementBlock_Fragment | MyPagesContentArea_WebShopLinkBlockModel_Fragment | MyPagesContentArea_WordMediaModel_Fragment;

export type MyPagesPageQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
  features: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MyPagesPageQuery = { __typename?: 'Query', MyPagesPageModel?: { __typename?: 'MyPagesPageModelOutput', items?: Array<{ __typename?: 'MyPagesPageModel', Headline?: string | null, IncludedFeature?: string | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null, Structure?: string | null } | null, MainContentArea?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'ActivationPageModel' } | { __typename: 'AgreementPageModel' } | { __typename: 'AssociationBattleBlockModel', Heading?: string | null, WideLayout?: any | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'AtoZPageModel' } | { __typename: 'ButtonLinkBlockModel' } | { __typename: 'CampaignBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'CompanyRegistrationsBlockModel' } | { __typename: 'CompensationBlockModel' } | { __typename: 'ConnectedProducersListBlockModel' } | { __typename: 'Content' } | { __typename: 'CsvMediaModel' } | { __typename: 'DepositLabelOrderBlockModel', Heading?: string | null, PriceInformation?: string | null, ShippingInformation?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Button?: { __typename?: 'DepositLabelOrderBlockModelButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null } | null } | { __typename: 'DepositLabelOrderHistoryBlockModel', Heading?: string | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'DownloadAssetLocalBlockModel' } | { __typename: 'DownloadAssetVariant' } | { __typename: 'DownloadAssetsBlockModel' } | { __typename: 'EanCheckBlockModel' } | { __typename: 'EmbedVideoBlockModel', Heading?: string | null, EmbedUrl?: string | null, VideoDescription?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'ErrorPageModel' } | { __typename: 'ExcelMediaModel' } | { __typename: 'ExtendedLinkBlockModel', Heading?: string | null, InvertIcon?: any | null, Title?: string | null, MenuIcon?: string | null, LinkUrl?: string | null, TeaserText?: string | null, FormReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel', Form?: string | null, ButtonText?: string | null, AlternativeTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditionsButton?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'ExtraPickupFormBlockModel' } | { __typename: 'FaqCategoryPageModel' } | { __typename: 'FaqItemPageModel' } | { __typename: 'FaqListPageModel' } | { __typename: 'FeatureBlockModel', Heading?: string | null, TeaserText?: string | null, ContentTextPosition?: number | null, ColorTheme?: number | null, BackGround?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'HeroBlockModel', IncludedFeature?: string | null, Heading?: string | null, PreHeading?: string | null, PreHeadingFont?: string | null, ColorTheme?: number | null, TeaserText?: string | null, TeaserTextFont?: string | null, ContentImagePosition?: number | null, ContentTextAlignment?: number | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Background?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, ImageMobile?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'IFramePageModel' } | { __typename: 'ImageAndTextBlockModel' } | { __typename: 'ImageBlockModel' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'MainImageBlockModel' } | { __typename: 'MainMenuPageModel' } | { __typename: 'MyPagesAdminPageModel' } | { __typename: 'MyPagesBlockModel', Heading?: string | null, TeaserText?: string | null, Component?: string | null, IncludedFeature?: string | null, UseGeneralTab?: any | null, GeneralTabHeading?: string | null, GeneralTabText?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'MyPagesContainerPageModel' } | { __typename: 'MyPagesPageModel' } | { __typename: 'MyPagesStartPageModel' } | { __typename: 'NewsContainerPageModel' } | { __typename: 'NewsPageModel' } | { __typename: 'NominationBlockModel' } | { __typename: 'NumberElementBlock' } | { __typename: 'OrderAssetLocalBlockModel' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PexMapBlockModel' } | { __typename: 'PopupBlockModel', Name?: string | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename: 'PptMediaModel' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrizePoolBlockModel' } | { __typename: 'PrizePoolDistributionLocalBlockModel' } | { __typename: 'PrizePoolNumbersLocalBlockModel' } | { __typename: 'RangeElementBlock' } | { __typename: 'RecyclingStoreTopListBlockModel' } | { __typename: 'RelatedLinksBlockModel' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ResponsiveImageBlockModel' } | { __typename: 'ScriptBlock' } | { __typename: 'ScriptImportBlockModel' } | { __typename: 'SearchResultPageModel' } | { __typename: 'SectionBlockModel' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SeoBlockModel' } | { __typename: 'SiteContextSettingsBlockModel' } | { __typename: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData' } | { __typename: 'SiteMediaData' } | { __typename: 'SiteVideoData' } | { __typename: 'StandardBlockModel', WideLayout?: any | null, Heading?: string | null, ImageAlignment?: string | null, ColorTheme?: number | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, BackgroundImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'StandardPageModel' } | { __typename: 'StartPageModel' } | { __typename: 'StoreFlyersBlockModel' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SwishCertificateBlockModel', Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, UploadHelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'SwishFormBlockModel' } | { __typename: 'SwishRegistrationBlockModel' } | { __typename: 'SwishStoreRegistrationBlockModel', InstructionText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'TabBlockModel', AddDivider?: any | null, Tabs?: Array<{ __typename?: 'TabBlockModelTabItem', TabHeading?: string | null, Blocks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'ActivationPageModel' } | { __typename: 'AgreementPageModel' } | { __typename: 'AssociationBattleBlockModel', Heading?: string | null, WideLayout?: any | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'AtoZPageModel' } | { __typename: 'ButtonLinkBlockModel' } | { __typename: 'CampaignBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'CompanyRegistrationsBlockModel' } | { __typename: 'CompensationBlockModel' } | { __typename: 'ConnectedProducersListBlockModel' } | { __typename: 'Content' } | { __typename: 'CsvMediaModel' } | { __typename: 'DepositLabelOrderBlockModel', Heading?: string | null, PriceInformation?: string | null, ShippingInformation?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Button?: { __typename?: 'DepositLabelOrderBlockModelButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null } | null } | { __typename: 'DepositLabelOrderHistoryBlockModel', Heading?: string | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'DownloadAssetLocalBlockModel' } | { __typename: 'DownloadAssetVariant' } | { __typename: 'DownloadAssetsBlockModel' } | { __typename: 'EanCheckBlockModel' } | { __typename: 'EmbedVideoBlockModel', Heading?: string | null, EmbedUrl?: string | null, VideoDescription?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'ErrorPageModel' } | { __typename: 'ExcelMediaModel' } | { __typename: 'ExtendedLinkBlockModel', Heading?: string | null, InvertIcon?: any | null, Title?: string | null, MenuIcon?: string | null, LinkUrl?: string | null, TeaserText?: string | null, FormReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel', Form?: string | null, ButtonText?: string | null, AlternativeTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditionsButton?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'ExtraPickupFormBlockModel' } | { __typename: 'FaqCategoryPageModel' } | { __typename: 'FaqItemPageModel' } | { __typename: 'FaqListPageModel' } | { __typename: 'FeatureBlockModel', Heading?: string | null, TeaserText?: string | null, ContentTextPosition?: number | null, ColorTheme?: number | null, BackGround?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'HeroBlockModel', IncludedFeature?: string | null, Heading?: string | null, PreHeading?: string | null, PreHeadingFont?: string | null, ColorTheme?: number | null, TeaserText?: string | null, TeaserTextFont?: string | null, ContentImagePosition?: number | null, ContentTextAlignment?: number | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Background?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, ImageMobile?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'IFramePageModel' } | { __typename: 'ImageAndTextBlockModel' } | { __typename: 'ImageBlockModel' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'MainImageBlockModel' } | { __typename: 'MainMenuPageModel' } | { __typename: 'MyPagesAdminPageModel' } | { __typename: 'MyPagesBlockModel', Heading?: string | null, TeaserText?: string | null, Component?: string | null, IncludedFeature?: string | null, UseGeneralTab?: any | null, GeneralTabHeading?: string | null, GeneralTabText?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'MyPagesContainerPageModel' } | { __typename: 'MyPagesPageModel' } | { __typename: 'MyPagesStartPageModel' } | { __typename: 'NewsContainerPageModel' } | { __typename: 'NewsPageModel' } | { __typename: 'NominationBlockModel' } | { __typename: 'NumberElementBlock' } | { __typename: 'OrderAssetLocalBlockModel' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PexMapBlockModel' } | { __typename: 'PopupBlockModel', Name?: string | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename: 'PptMediaModel' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrizePoolBlockModel' } | { __typename: 'PrizePoolDistributionLocalBlockModel' } | { __typename: 'PrizePoolNumbersLocalBlockModel' } | { __typename: 'RangeElementBlock' } | { __typename: 'RecyclingStoreTopListBlockModel' } | { __typename: 'RelatedLinksBlockModel' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ResponsiveImageBlockModel' } | { __typename: 'ScriptBlock' } | { __typename: 'ScriptImportBlockModel' } | { __typename: 'SearchResultPageModel' } | { __typename: 'SectionBlockModel' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SeoBlockModel' } | { __typename: 'SiteContextSettingsBlockModel' } | { __typename: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData' } | { __typename: 'SiteMediaData' } | { __typename: 'SiteVideoData' } | { __typename: 'StandardBlockModel', WideLayout?: any | null, Heading?: string | null, ImageAlignment?: string | null, ColorTheme?: number | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, BackgroundImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'StandardPageModel' } | { __typename: 'StartPageModel' } | { __typename: 'StoreFlyersBlockModel' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SwishCertificateBlockModel', Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, UploadHelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'SwishFormBlockModel' } | { __typename: 'SwishRegistrationBlockModel' } | { __typename: 'SwishStoreRegistrationBlockModel', InstructionText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'TabBlockModel' } | { __typename: 'TabItem' } | { __typename: 'TeaserLinkBlockModel' } | { __typename: 'TextBlockModel' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WebShopLinkBlockModel' } | { __typename: 'WordMediaModel' } | null } | null } | null> | null } | null> | null } | { __typename: 'TabItem' } | { __typename: 'TeaserLinkBlockModel' } | { __typename: 'TextBlockModel' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WebShopLinkBlockModel' } | { __typename: 'WordMediaModel' } | null } | null } | null> | null } | null> | null } | null };

export type GetMyPagesStartPageQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetMyPagesStartPageQuery = { __typename?: 'Query', MyPagesStartPageModel?: { __typename?: 'MyPagesStartPageModelOutput', items?: Array<{ __typename?: 'MyPagesStartPageModel', Headline?: string | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, MainContentArea?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'ActivationPageModel' } | { __typename: 'AgreementPageModel' } | { __typename: 'AssociationBattleBlockModel', Heading?: string | null, WideLayout?: any | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'AtoZPageModel' } | { __typename: 'ButtonLinkBlockModel' } | { __typename: 'CampaignBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'CompanyRegistrationsBlockModel' } | { __typename: 'CompensationBlockModel' } | { __typename: 'ConnectedProducersListBlockModel' } | { __typename: 'Content' } | { __typename: 'CsvMediaModel' } | { __typename: 'DepositLabelOrderBlockModel', Heading?: string | null, PriceInformation?: string | null, ShippingInformation?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Button?: { __typename?: 'DepositLabelOrderBlockModelButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null } | null } | { __typename: 'DepositLabelOrderHistoryBlockModel', Heading?: string | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'DownloadAssetLocalBlockModel' } | { __typename: 'DownloadAssetVariant' } | { __typename: 'DownloadAssetsBlockModel' } | { __typename: 'EanCheckBlockModel' } | { __typename: 'EmbedVideoBlockModel', Heading?: string | null, EmbedUrl?: string | null, VideoDescription?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'ErrorPageModel' } | { __typename: 'ExcelMediaModel' } | { __typename: 'ExtendedLinkBlockModel', Heading?: string | null, InvertIcon?: any | null, Title?: string | null, MenuIcon?: string | null, LinkUrl?: string | null, TeaserText?: string | null, FormReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel', Form?: string | null, ButtonText?: string | null, AlternativeTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditionsButton?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'ExtraPickupFormBlockModel' } | { __typename: 'FaqCategoryPageModel' } | { __typename: 'FaqItemPageModel' } | { __typename: 'FaqListPageModel' } | { __typename: 'FeatureBlockModel', Heading?: string | null, TeaserText?: string | null, ContentTextPosition?: number | null, ColorTheme?: number | null, BackGround?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'HeroBlockModel', IncludedFeature?: string | null, Heading?: string | null, PreHeading?: string | null, PreHeadingFont?: string | null, ColorTheme?: number | null, TeaserText?: string | null, TeaserTextFont?: string | null, ContentImagePosition?: number | null, ContentTextAlignment?: number | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Background?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, ImageMobile?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'IFramePageModel' } | { __typename: 'ImageAndTextBlockModel' } | { __typename: 'ImageBlockModel' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'MainImageBlockModel' } | { __typename: 'MainMenuPageModel' } | { __typename: 'MyPagesAdminPageModel' } | { __typename: 'MyPagesBlockModel', Heading?: string | null, TeaserText?: string | null, Component?: string | null, IncludedFeature?: string | null, UseGeneralTab?: any | null, GeneralTabHeading?: string | null, GeneralTabText?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'MyPagesContainerPageModel' } | { __typename: 'MyPagesPageModel' } | { __typename: 'MyPagesStartPageModel' } | { __typename: 'NewsContainerPageModel' } | { __typename: 'NewsPageModel' } | { __typename: 'NominationBlockModel' } | { __typename: 'NumberElementBlock' } | { __typename: 'OrderAssetLocalBlockModel' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PexMapBlockModel' } | { __typename: 'PopupBlockModel', Name?: string | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename: 'PptMediaModel' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrizePoolBlockModel' } | { __typename: 'PrizePoolDistributionLocalBlockModel' } | { __typename: 'PrizePoolNumbersLocalBlockModel' } | { __typename: 'RangeElementBlock' } | { __typename: 'RecyclingStoreTopListBlockModel' } | { __typename: 'RelatedLinksBlockModel' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ResponsiveImageBlockModel' } | { __typename: 'ScriptBlock' } | { __typename: 'ScriptImportBlockModel' } | { __typename: 'SearchResultPageModel' } | { __typename: 'SectionBlockModel' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SeoBlockModel' } | { __typename: 'SiteContextSettingsBlockModel' } | { __typename: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData' } | { __typename: 'SiteMediaData' } | { __typename: 'SiteVideoData' } | { __typename: 'StandardBlockModel', WideLayout?: any | null, Heading?: string | null, ImageAlignment?: string | null, ColorTheme?: number | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, BackgroundImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'StandardPageModel' } | { __typename: 'StartPageModel' } | { __typename: 'StoreFlyersBlockModel' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SwishCertificateBlockModel', Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, UploadHelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'SwishFormBlockModel' } | { __typename: 'SwishRegistrationBlockModel' } | { __typename: 'SwishStoreRegistrationBlockModel', InstructionText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'TabBlockModel' } | { __typename: 'TabItem' } | { __typename: 'TeaserLinkBlockModel' } | { __typename: 'TextBlockModel' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WebShopLinkBlockModel' } | { __typename: 'WordMediaModel' } | null } | null } | null> | null, SecondaryContentArea?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'ActivationPageModel' } | { __typename: 'AgreementPageModel' } | { __typename: 'AssociationBattleBlockModel', Heading?: string | null, WideLayout?: any | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'AtoZPageModel' } | { __typename: 'ButtonLinkBlockModel' } | { __typename: 'CampaignBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'CompanyRegistrationsBlockModel' } | { __typename: 'CompensationBlockModel' } | { __typename: 'ConnectedProducersListBlockModel' } | { __typename: 'Content' } | { __typename: 'CsvMediaModel' } | { __typename: 'DepositLabelOrderBlockModel', Heading?: string | null, PriceInformation?: string | null, ShippingInformation?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Button?: { __typename?: 'DepositLabelOrderBlockModelButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null } | null } | { __typename: 'DepositLabelOrderHistoryBlockModel' } | { __typename: 'DownloadAssetLocalBlockModel' } | { __typename: 'DownloadAssetVariant' } | { __typename: 'DownloadAssetsBlockModel' } | { __typename: 'EanCheckBlockModel' } | { __typename: 'EmbedVideoBlockModel', Heading?: string | null, EmbedUrl?: string | null, VideoDescription?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'ErrorPageModel' } | { __typename: 'ExcelMediaModel' } | { __typename: 'ExtendedLinkBlockModel', Heading?: string | null, InvertIcon?: any | null, Title?: string | null, MenuIcon?: string | null, LinkUrl?: string | null, TeaserText?: string | null, FormReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel', Form?: string | null, ButtonText?: string | null, AlternativeTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditionsButton?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'ExtraPickupFormBlockModel' } | { __typename: 'FaqCategoryPageModel' } | { __typename: 'FaqItemPageModel' } | { __typename: 'FaqListPageModel' } | { __typename: 'FeatureBlockModel', Heading?: string | null, TeaserText?: string | null, ContentTextPosition?: number | null, ColorTheme?: number | null, BackGround?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'HeroBlockModel', IncludedFeature?: string | null, Heading?: string | null, PreHeading?: string | null, PreHeadingFont?: string | null, ColorTheme?: number | null, TeaserText?: string | null, TeaserTextFont?: string | null, ContentImagePosition?: number | null, ContentTextAlignment?: number | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Background?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, ImageMobile?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'IFramePageModel' } | { __typename: 'ImageAndTextBlockModel' } | { __typename: 'ImageBlockModel' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'MainImageBlockModel' } | { __typename: 'MainMenuPageModel' } | { __typename: 'MyPagesAdminPageModel' } | { __typename: 'MyPagesBlockModel', Heading?: string | null, TeaserText?: string | null, Component?: string | null, IncludedFeature?: string | null, UseGeneralTab?: any | null, GeneralTabHeading?: string | null, GeneralTabText?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'MyPagesContainerPageModel' } | { __typename: 'MyPagesPageModel' } | { __typename: 'MyPagesStartPageModel' } | { __typename: 'NewsContainerPageModel' } | { __typename: 'NewsPageModel' } | { __typename: 'NominationBlockModel' } | { __typename: 'NumberElementBlock' } | { __typename: 'OrderAssetLocalBlockModel' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PexMapBlockModel' } | { __typename: 'PopupBlockModel', Name?: string | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename: 'PptMediaModel' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrizePoolBlockModel' } | { __typename: 'PrizePoolDistributionLocalBlockModel' } | { __typename: 'PrizePoolNumbersLocalBlockModel' } | { __typename: 'RangeElementBlock' } | { __typename: 'RecyclingStoreTopListBlockModel' } | { __typename: 'RelatedLinksBlockModel' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ResponsiveImageBlockModel' } | { __typename: 'ScriptBlock' } | { __typename: 'ScriptImportBlockModel' } | { __typename: 'SearchResultPageModel' } | { __typename: 'SectionBlockModel' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SeoBlockModel' } | { __typename: 'SiteContextSettingsBlockModel' } | { __typename: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData' } | { __typename: 'SiteMediaData' } | { __typename: 'SiteVideoData' } | { __typename: 'StandardBlockModel', WideLayout?: any | null, Heading?: string | null, ImageAlignment?: string | null, ColorTheme?: number | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, BackgroundImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'StandardPageModel' } | { __typename: 'StartPageModel' } | { __typename: 'StoreFlyersBlockModel' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SwishCertificateBlockModel' } | { __typename: 'SwishFormBlockModel' } | { __typename: 'SwishRegistrationBlockModel' } | { __typename: 'SwishStoreRegistrationBlockModel' } | { __typename: 'TabBlockModel' } | { __typename: 'TabItem' } | { __typename: 'TeaserLinkBlockModel' } | { __typename: 'TextBlockModel' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WebShopLinkBlockModel' } | { __typename: 'WordMediaModel' } | null } | null } | null> | null, LinksContentArea?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'ActivationPageModel' } | { __typename: 'AgreementPageModel' } | { __typename: 'AssociationBattleBlockModel' } | { __typename: 'AtoZPageModel', Name?: string | null, TeaserText?: string | null, RelativePath?: string | null } | { __typename: 'ButtonLinkBlockModel' } | { __typename: 'CampaignBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'CompanyRegistrationsBlockModel' } | { __typename: 'CompensationBlockModel' } | { __typename: 'ConnectedProducersListBlockModel' } | { __typename: 'Content' } | { __typename: 'CsvMediaModel' } | { __typename: 'DepositLabelOrderBlockModel' } | { __typename: 'DepositLabelOrderHistoryBlockModel' } | { __typename: 'DownloadAssetLocalBlockModel' } | { __typename: 'DownloadAssetVariant' } | { __typename: 'DownloadAssetsBlockModel' } | { __typename: 'EanCheckBlockModel' } | { __typename: 'EmbedVideoBlockModel' } | { __typename: 'ErrorPageModel' } | { __typename: 'ExcelMediaModel' } | { __typename: 'ExtendedLinkBlockModel', Title?: string | null, TeaserText?: string | null, LinkUrl?: string | null, MenuIcon?: string | null } | { __typename: 'ExtraPickupFormBlockModel' } | { __typename: 'FaqCategoryPageModel' } | { __typename: 'FaqItemPageModel' } | { __typename: 'FaqListPageModel', Title?: string | null, TeaserText?: string | null, RelativePath?: string | null, MenuIcon?: string | null } | { __typename: 'FeatureBlockModel' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'HeroBlockModel' } | { __typename: 'IFramePageModel' } | { __typename: 'ImageAndTextBlockModel' } | { __typename: 'ImageBlockModel' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'MainImageBlockModel' } | { __typename: 'MainMenuPageModel', TeaserText?: string | null, Name?: string | null, RelativePath?: string | null, MenuIcon?: string | null } | { __typename: 'MyPagesAdminPageModel' } | { __typename: 'MyPagesBlockModel' } | { __typename: 'MyPagesContainerPageModel', Name?: string | null, TeaserText?: string | null, RelativePath?: string | null, MenuIcon?: string | null } | { __typename: 'MyPagesPageModel', TeaserText?: string | null, Title?: string | null, Name?: string | null, RelativePath?: string | null, MenuIcon?: string | null, MenuTagLine?: string | null, RequiredUserRole?: string | null, IncludedFeature?: string | null } | { __typename: 'MyPagesStartPageModel', TeaserText?: string | null, MenuTagLine?: string | null, RelativePath?: string | null, MenuIcon?: string | null } | { __typename: 'NewsContainerPageModel', Name?: string | null, RelativePath?: string | null } | { __typename: 'NewsPageModel', MenuTagLine?: string | null, TeaserText?: string | null, RelativePath?: string | null, MenuIcon?: string | null, Date?: any | null } | { __typename: 'NominationBlockModel' } | { __typename: 'NumberElementBlock' } | { __typename: 'OrderAssetLocalBlockModel' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PexMapBlockModel' } | { __typename: 'PopupBlockModel' } | { __typename: 'PptMediaModel' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrizePoolBlockModel' } | { __typename: 'PrizePoolDistributionLocalBlockModel' } | { __typename: 'PrizePoolNumbersLocalBlockModel' } | { __typename: 'RangeElementBlock' } | { __typename: 'RecyclingStoreTopListBlockModel' } | { __typename: 'RelatedLinksBlockModel' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ResponsiveImageBlockModel' } | { __typename: 'ScriptBlock' } | { __typename: 'ScriptImportBlockModel' } | { __typename: 'SearchResultPageModel' } | { __typename: 'SectionBlockModel' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SeoBlockModel' } | { __typename: 'SiteContextSettingsBlockModel' } | { __typename: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData' } | { __typename: 'SiteMediaData' } | { __typename: 'SiteVideoData' } | { __typename: 'StandardBlockModel' } | { __typename: 'StandardPageModel', Name?: string | null, TeaserText?: string | null, RelativePath?: string | null, MenuIcon?: string | null } | { __typename: 'StartPageModel' } | { __typename: 'StoreFlyersBlockModel' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SwishCertificateBlockModel' } | { __typename: 'SwishFormBlockModel' } | { __typename: 'SwishRegistrationBlockModel' } | { __typename: 'SwishStoreRegistrationBlockModel' } | { __typename: 'TabBlockModel' } | { __typename: 'TabItem' } | { __typename: 'TeaserLinkBlockModel' } | { __typename: 'TextBlockModel' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WebShopLinkBlockModel', Title?: string | null, TeaserText?: string | null, MenuIcon?: string | null } | { __typename: 'WordMediaModel' } | null } | null } | null> | null, NewsContainer?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null> | null } | null };

export type GetNewsContainerAndChildrenQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetNewsContainerAndChildrenQuery = { __typename?: 'Query', NewsContainerPageModel?: { __typename?: 'NewsContainerPageModelOutput', items?: Array<{ __typename?: 'NewsContainerPageModel', Name?: string | null, NewsPagesLinksColorTheme?: number | null, Button?: { __typename?: 'NewsContainerPageModelButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', Url?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | null, _children?: { __typename?: 'QueryRef', NewsPageModel?: { __typename?: 'NewsPageModelOutput', items?: Array<{ __typename?: 'NewsPageModel', Date?: any | null, Name?: string | null, MenuIcon?: string | null, RelativePath?: string | null, TeaserText?: string | null } | null> | null } | null } | null } | null> | null } | null };

export type PexMapBlockQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type PexMapBlockQuery = { __typename?: 'Query', Content?: { __typename?: 'ContentOutput', items?: Array<{ __typename?: 'ActivationPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'AgreementPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'AssociationBattleBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'AtoZPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ButtonLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'CampaignBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'CaptchaElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ChoiceElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'CompensationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'Content', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'CsvMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetVariant', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'EanCheckBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'EmbedVideoBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ErrorPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ExcelMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ExtendedLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'FaqCategoryPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'FaqItemPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'FaqListPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'FeatureBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'FileUploadElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'FormContainerBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'FormStepBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'HeroBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'IFramePageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ImageAndTextBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ImageChoiceElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'MainImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'MainMenuPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'MyPagesAdminPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'MyPagesBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'MyPagesContainerPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'MyPagesPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'MyPagesStartPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'NewsContainerPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'NewsPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'NominationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'NumberElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ParagraphTextElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'PexMapBlockModel', AvailableRecyclingAlternatives?: string | null, PreSelectedRecyclingAlternatives?: string | null, ShowSearch?: any | null, RecycleAlternativesLabel?: string | null, _id?: string | null, Name?: string | null, RecycleAlternativesDialogContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'PopupBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'PptMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'PrizePoolBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'RangeElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'RelatedLinksBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ResetButtonElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ResponsiveImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ScriptBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'ScriptImportBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SearchResultPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SectionBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SelectionElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SeoBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SiteDocumentMediaData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SiteImageData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SiteMediaData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SiteVideoData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'StandardBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'StandardPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'StartPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'StoreFlyersBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SubmitButtonElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SwishCertificateBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SwishFormBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SwishRegistrationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'TabBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'TabItem', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'TeaserLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'TextBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'TextareaElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'TextboxElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'UrlElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'WebShopLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | { __typename?: 'WordMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null } | null> | null } | null };

export type GetRecyclingStoreTopListBlockQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetRecyclingStoreTopListBlockQuery = { __typename?: 'Query', RecyclingStoreTopListBlockModel?: { __typename?: 'RecyclingStoreTopListBlockModelOutput', items?: Array<{ __typename?: 'RecyclingStoreTopListBlockModel', _id?: string | null, Name?: string | null, Heading?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, Url?: string | null } | null, TopListDescription?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | null> | null } | null };

export type CompensationBlockQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type CompensationBlockQuery = { __typename?: 'Query', CompensationBlockModel?: { __typename?: 'CompensationBlockModelOutput', items?: Array<{ __typename?: 'CompensationBlockModel', Heading?: string | null, Payments?: string | null, ConfirmationText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | null> | null } | null };

export type DepositLabelOrderHistoryBlockFragment = { __typename?: 'DepositLabelOrderHistoryBlockModel', Heading?: string | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null };

export type DepositLabelOrderBlockFragment = { __typename?: 'DepositLabelOrderBlockModel', Heading?: string | null, PriceInformation?: string | null, ShippingInformation?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Button?: { __typename?: 'DepositLabelOrderBlockModelButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null } | null };

export type ExtraPickupFormBlockQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type ExtraPickupFormBlockQuery = { __typename?: 'Query', ExtraPickupFormBlockModel?: { __typename?: 'ExtraPickupFormBlockModelOutput', items?: Array<{ __typename?: 'ExtraPickupFormBlockModel', Heading?: string | null, ConfirmationText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | null> | null } | null };

export type SwishCertificateBlockFragment = { __typename: 'SwishCertificateBlockModel', Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, UploadHelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null };

export type SwishFormBlockQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type SwishFormBlockQuery = { __typename?: 'Query', Content?: { __typename?: 'ContentOutput', items?: Array<{ __typename?: 'ActivationPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AgreementPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AssociationBattleBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AtoZPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ButtonLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CampaignBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CaptchaElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ChoiceElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CompensationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'Content', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CsvMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetVariant', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'EanCheckBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'EmbedVideoBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ErrorPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExcelMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExtendedLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqCategoryPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqItemPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqListPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FeatureBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FileUploadElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FormContainerBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FormStepBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'HeroBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'IFramePageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageAndTextBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageChoiceElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MainImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MainMenuPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesAdminPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesContainerPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesStartPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NewsContainerPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NewsPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NominationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NumberElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ParagraphTextElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PexMapBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PopupBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PptMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RangeElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RelatedLinksBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ResetButtonElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ResponsiveImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ScriptBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ScriptImportBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SearchResultPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SectionBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SelectionElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SeoBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteDocumentMediaData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteImageData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteMediaData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteVideoData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StandardBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StandardPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StartPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StoreFlyersBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SubmitButtonElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishCertificateBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishFormBlockModel', Heading?: string | null, _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishRegistrationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TabBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TabItem', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TeaserLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextareaElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextboxElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'UrlElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'WebShopLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'WordMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | null> | null } | null };

export type SwishStoreRegistrationBlockFragment = { __typename: 'SwishStoreRegistrationBlockModel', InstructionText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null };

export type TabBlockFragment = { __typename: 'TabBlockModel', AddDivider?: any | null, Tabs?: Array<{ __typename?: 'TabBlockModelTabItem', TabHeading?: string | null, Blocks?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Expanded?: { __typename: 'ActivationPageModel' } | { __typename: 'AgreementPageModel' } | { __typename: 'AssociationBattleBlockModel', Heading?: string | null, WideLayout?: any | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'AtoZPageModel' } | { __typename: 'ButtonLinkBlockModel' } | { __typename: 'CampaignBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'CompanyRegistrationsBlockModel' } | { __typename: 'CompensationBlockModel' } | { __typename: 'ConnectedProducersListBlockModel' } | { __typename: 'Content' } | { __typename: 'CsvMediaModel' } | { __typename: 'DepositLabelOrderBlockModel', Heading?: string | null, PriceInformation?: string | null, ShippingInformation?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Button?: { __typename?: 'DepositLabelOrderBlockModelButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null } | null } | { __typename: 'DepositLabelOrderHistoryBlockModel', Heading?: string | null, MainBody?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'DownloadAssetLocalBlockModel' } | { __typename: 'DownloadAssetVariant' } | { __typename: 'DownloadAssetsBlockModel' } | { __typename: 'EanCheckBlockModel' } | { __typename: 'EmbedVideoBlockModel', Heading?: string | null, EmbedUrl?: string | null, VideoDescription?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'ErrorPageModel' } | { __typename: 'ExcelMediaModel' } | { __typename: 'ExtendedLinkBlockModel', Heading?: string | null, InvertIcon?: any | null, Title?: string | null, MenuIcon?: string | null, LinkUrl?: string | null, TeaserText?: string | null, FormReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel', Form?: string | null, ButtonText?: string | null, AlternativeTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditionsButton?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'ExtraPickupFormBlockModel' } | { __typename: 'FaqCategoryPageModel' } | { __typename: 'FaqItemPageModel' } | { __typename: 'FaqListPageModel' } | { __typename: 'FeatureBlockModel', Heading?: string | null, TeaserText?: string | null, ContentTextPosition?: number | null, ColorTheme?: number | null, BackGround?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'HeroBlockModel', IncludedFeature?: string | null, Heading?: string | null, PreHeading?: string | null, PreHeadingFont?: string | null, ColorTheme?: number | null, TeaserText?: string | null, TeaserTextFont?: string | null, ContentImagePosition?: number | null, ContentTextAlignment?: number | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Background?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, ImageMobile?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'IFramePageModel' } | { __typename: 'ImageAndTextBlockModel' } | { __typename: 'ImageBlockModel' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'MainImageBlockModel' } | { __typename: 'MainMenuPageModel' } | { __typename: 'MyPagesAdminPageModel' } | { __typename: 'MyPagesBlockModel', Heading?: string | null, TeaserText?: string | null, Component?: string | null, IncludedFeature?: string | null, UseGeneralTab?: any | null, GeneralTabHeading?: string | null, GeneralTabText?: string | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'MyPagesContainerPageModel' } | { __typename: 'MyPagesPageModel' } | { __typename: 'MyPagesStartPageModel' } | { __typename: 'NewsContainerPageModel' } | { __typename: 'NewsPageModel' } | { __typename: 'NominationBlockModel' } | { __typename: 'NumberElementBlock' } | { __typename: 'OrderAssetLocalBlockModel' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PexMapBlockModel' } | { __typename: 'PopupBlockModel', Name?: string | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename: 'PptMediaModel' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrizePoolBlockModel' } | { __typename: 'PrizePoolDistributionLocalBlockModel' } | { __typename: 'PrizePoolNumbersLocalBlockModel' } | { __typename: 'RangeElementBlock' } | { __typename: 'RecyclingStoreTopListBlockModel' } | { __typename: 'RelatedLinksBlockModel' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ResponsiveImageBlockModel' } | { __typename: 'ScriptBlock' } | { __typename: 'ScriptImportBlockModel' } | { __typename: 'SearchResultPageModel' } | { __typename: 'SectionBlockModel' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SeoBlockModel' } | { __typename: 'SiteContextSettingsBlockModel' } | { __typename: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData' } | { __typename: 'SiteMediaData' } | { __typename: 'SiteVideoData' } | { __typename: 'StandardBlockModel', WideLayout?: any | null, Heading?: string | null, ImageAlignment?: string | null, ColorTheme?: number | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, BackgroundImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'StandardPageModel' } | { __typename: 'StartPageModel' } | { __typename: 'StoreFlyersBlockModel' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SwishCertificateBlockModel', Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, UploadHelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'SwishFormBlockModel' } | { __typename: 'SwishRegistrationBlockModel' } | { __typename: 'SwishStoreRegistrationBlockModel', InstructionText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename: 'TabBlockModel' } | { __typename: 'TabItem' } | { __typename: 'TeaserLinkBlockModel' } | { __typename: 'TextBlockModel' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WebShopLinkBlockModel' } | { __typename: 'WordMediaModel' } | null } | null } | null> | null } | null> | null };

export type GetAtoZItemsQueryVariables = Exact<{
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
  skip: Scalars['Int']['input'];
}>;


export type GetAtoZItemsQuery = { __typename?: 'Query', Content?: { __typename?: 'ContentOutput', total?: number | null, items?: Array<{ __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel', Name?: string | null, RelativePath?: string | null } | { __typename?: 'FaqListPageModel', Name?: string | null, RelativePath?: string | null } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel', Name?: string | null, RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel', Name?: string | null, RelativePath?: string | null } | { __typename?: 'StartPageModel', Name?: string | null, RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null> | null } | null };

export type GetConnectedProducersBlockQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetConnectedProducersBlockQuery = { __typename?: 'Query', ConnectedProducersListBlockModel?: { __typename?: 'ConnectedProducersListBlockModelOutput', items?: Array<{ __typename?: 'ConnectedProducersListBlockModel', Heading?: string | null } | null> | null } | null };

export type EanCheckBlockQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type EanCheckBlockQuery = { __typename?: 'Query', Content?: { __typename?: 'ContentOutput', items?: Array<{ __typename?: 'ActivationPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AgreementPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AssociationBattleBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AtoZPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ButtonLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CampaignBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CaptchaElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ChoiceElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CompensationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'Content', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CsvMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetVariant', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'EanCheckBlockModel', Heading?: string | null, _id?: string | null, Name?: string | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'EmbedVideoBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ErrorPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExcelMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExtendedLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqCategoryPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqItemPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqListPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FeatureBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FileUploadElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FormContainerBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FormStepBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'HeroBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'IFramePageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageAndTextBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageChoiceElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MainImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MainMenuPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesAdminPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesContainerPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesStartPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NewsContainerPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NewsPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NominationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NumberElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ParagraphTextElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PexMapBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PopupBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PptMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RangeElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RelatedLinksBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ResetButtonElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ResponsiveImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ScriptBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ScriptImportBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SearchResultPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SectionBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SelectionElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SeoBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteDocumentMediaData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteImageData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteMediaData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteVideoData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StandardBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StandardPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StartPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StoreFlyersBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SubmitButtonElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishCertificateBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishFormBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishRegistrationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TabBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TabItem', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TeaserLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextareaElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextboxElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'UrlElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'WebShopLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'WordMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | null> | null } | null };

export type GetExternalVideoQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetExternalVideoQuery = { __typename?: 'Query', Content?: { __typename?: 'ContentOutput', items?: Array<{ __typename: 'ActivationPageModel' } | { __typename: 'AgreementPageModel' } | { __typename: 'AssociationBattleBlockModel' } | { __typename: 'AtoZPageModel' } | { __typename: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename: 'CampaignBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'CompanyRegistrationsBlockModel' } | { __typename: 'CompensationBlockModel' } | { __typename: 'ConnectedProducersListBlockModel' } | { __typename: 'Content' } | { __typename: 'CsvMediaModel' } | { __typename: 'DepositLabelOrderBlockModel' } | { __typename: 'DepositLabelOrderHistoryBlockModel' } | { __typename: 'DownloadAssetLocalBlockModel' } | { __typename: 'DownloadAssetVariant' } | { __typename: 'DownloadAssetsBlockModel' } | { __typename: 'EanCheckBlockModel' } | { __typename: 'EmbedVideoBlockModel', Heading?: string | null, EmbedUrl?: string | null, VideoDescription?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'ErrorPageModel' } | { __typename: 'ExcelMediaModel' } | { __typename: 'ExtendedLinkBlockModel' } | { __typename: 'ExtraPickupFormBlockModel' } | { __typename: 'FaqCategoryPageModel' } | { __typename: 'FaqItemPageModel' } | { __typename: 'FaqListPageModel' } | { __typename: 'FeatureBlockModel' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'HeroBlockModel' } | { __typename: 'IFramePageModel' } | { __typename: 'ImageAndTextBlockModel' } | { __typename: 'ImageBlockModel' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'MainImageBlockModel' } | { __typename: 'MainMenuPageModel' } | { __typename: 'MyPagesAdminPageModel' } | { __typename: 'MyPagesBlockModel' } | { __typename: 'MyPagesContainerPageModel' } | { __typename: 'MyPagesPageModel' } | { __typename: 'MyPagesStartPageModel' } | { __typename: 'NewsContainerPageModel' } | { __typename: 'NewsPageModel' } | { __typename: 'NominationBlockModel' } | { __typename: 'NumberElementBlock' } | { __typename: 'OrderAssetLocalBlockModel' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PexMapBlockModel' } | { __typename: 'PopupBlockModel' } | { __typename: 'PptMediaModel' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrizePoolBlockModel' } | { __typename: 'PrizePoolDistributionLocalBlockModel' } | { __typename: 'PrizePoolNumbersLocalBlockModel' } | { __typename: 'RangeElementBlock' } | { __typename: 'RecyclingStoreTopListBlockModel' } | { __typename: 'RelatedLinksBlockModel' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ResponsiveImageBlockModel' } | { __typename: 'ScriptBlock' } | { __typename: 'ScriptImportBlockModel' } | { __typename: 'SearchResultPageModel' } | { __typename: 'SectionBlockModel' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SeoBlockModel' } | { __typename: 'SiteContextSettingsBlockModel' } | { __typename: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData' } | { __typename: 'SiteMediaData' } | { __typename: 'SiteVideoData' } | { __typename: 'StandardBlockModel' } | { __typename: 'StandardPageModel' } | { __typename: 'StartPageModel' } | { __typename: 'StoreFlyersBlockModel' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SwishCertificateBlockModel' } | { __typename: 'SwishFormBlockModel' } | { __typename: 'SwishRegistrationBlockModel' } | { __typename: 'SwishStoreRegistrationBlockModel' } | { __typename: 'TabBlockModel' } | { __typename: 'TabItem' } | { __typename: 'TeaserLinkBlockModel' } | { __typename: 'TextBlockModel' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WebShopLinkBlockModel' } | { __typename: 'WordMediaModel' } | null> | null } | null };

export type GetFaqCategoriesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetFaqCategoriesQuery = { __typename?: 'Query', FaqListPageModel?: { __typename?: 'FaqListPageModelOutput', items?: Array<{ __typename?: 'FaqListPageModel', _children?: { __typename?: 'QueryRef', FaqCategoryPageModel?: { __typename?: 'FaqCategoryPageModelOutput', items?: Array<{ __typename?: 'FaqCategoryPageModel', Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null, _children?: { __typename?: 'QueryRef', FaqItemPageModel?: { __typename?: 'FaqItemPageModelOutput', items?: Array<{ __typename?: 'FaqItemPageModel', Name?: string | null, RelativePath?: string | null, TeaserText?: string | null, Question?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null, Answer?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | null> | null } | null } | null } | null> | null } | null } | null } | null> | null } | null };

export type HeroBlockFragment = { __typename: 'HeroBlockModel', IncludedFeature?: string | null, Heading?: string | null, PreHeading?: string | null, PreHeadingFont?: string | null, ColorTheme?: number | null, TeaserText?: string | null, TeaserTextFont?: string | null, ContentImagePosition?: number | null, ContentTextAlignment?: number | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Background?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, ImageMobile?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null };

export type GetHeroQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetHeroQuery = { __typename?: 'Query', Content?: { __typename?: 'ContentOutput', items?: Array<{ __typename: 'ActivationPageModel' } | { __typename: 'AgreementPageModel' } | { __typename: 'AssociationBattleBlockModel' } | { __typename: 'AtoZPageModel' } | { __typename: 'ButtonLinkBlockModel' } | { __typename: 'CampaignBlock' } | { __typename: 'CaptchaElementBlock' } | { __typename: 'ChoiceElementBlock' } | { __typename: 'CompanyRegistrationsBlockModel' } | { __typename: 'CompensationBlockModel' } | { __typename: 'ConnectedProducersListBlockModel' } | { __typename: 'Content' } | { __typename: 'CsvMediaModel' } | { __typename: 'DepositLabelOrderBlockModel' } | { __typename: 'DepositLabelOrderHistoryBlockModel' } | { __typename: 'DownloadAssetLocalBlockModel' } | { __typename: 'DownloadAssetVariant' } | { __typename: 'DownloadAssetsBlockModel' } | { __typename: 'EanCheckBlockModel' } | { __typename: 'EmbedVideoBlockModel' } | { __typename: 'ErrorPageModel' } | { __typename: 'ExcelMediaModel' } | { __typename: 'ExtendedLinkBlockModel' } | { __typename: 'ExtraPickupFormBlockModel' } | { __typename: 'FaqCategoryPageModel' } | { __typename: 'FaqItemPageModel' } | { __typename: 'FaqListPageModel' } | { __typename: 'FeatureBlockModel' } | { __typename: 'FileUploadElementBlock' } | { __typename: 'FormContainerBlock' } | { __typename: 'FormStepBlock' } | { __typename: 'HeroBlockModel', IncludedFeature?: string | null, Heading?: string | null, PreHeading?: string | null, PreHeadingFont?: string | null, ColorTheme?: number | null, TeaserText?: string | null, TeaserTextFont?: string | null, ContentImagePosition?: number | null, ContentTextAlignment?: number | null, Language?: { __typename?: 'ContentLanguageModel', Name?: string | null } | null, Background?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, ImageMobile?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | { __typename: 'IFramePageModel' } | { __typename: 'ImageAndTextBlockModel' } | { __typename: 'ImageBlockModel' } | { __typename: 'ImageChoiceElementBlock' } | { __typename: 'MainImageBlockModel' } | { __typename: 'MainMenuPageModel' } | { __typename: 'MyPagesAdminPageModel' } | { __typename: 'MyPagesBlockModel' } | { __typename: 'MyPagesContainerPageModel' } | { __typename: 'MyPagesPageModel' } | { __typename: 'MyPagesStartPageModel' } | { __typename: 'NewsContainerPageModel' } | { __typename: 'NewsPageModel' } | { __typename: 'NominationBlockModel' } | { __typename: 'NumberElementBlock' } | { __typename: 'OrderAssetLocalBlockModel' } | { __typename: 'ParagraphTextElementBlock' } | { __typename: 'PexMapBlockModel' } | { __typename: 'PopupBlockModel' } | { __typename: 'PptMediaModel' } | { __typename: 'PredefinedHiddenElementBlock' } | { __typename: 'PrizePoolBlockModel' } | { __typename: 'PrizePoolDistributionLocalBlockModel' } | { __typename: 'PrizePoolNumbersLocalBlockModel' } | { __typename: 'RangeElementBlock' } | { __typename: 'RecyclingStoreTopListBlockModel' } | { __typename: 'RelatedLinksBlockModel' } | { __typename: 'ResetButtonElementBlock' } | { __typename: 'ResponsiveImageBlockModel' } | { __typename: 'ScriptBlock' } | { __typename: 'ScriptImportBlockModel' } | { __typename: 'SearchResultPageModel' } | { __typename: 'SectionBlockModel' } | { __typename: 'SelectionElementBlock' } | { __typename: 'SeoBlockModel' } | { __typename: 'SiteContextSettingsBlockModel' } | { __typename: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename: 'StandardBlockModel' } | { __typename: 'StandardPageModel' } | { __typename: 'StartPageModel' } | { __typename: 'StoreFlyersBlockModel' } | { __typename: 'SubmitButtonElementBlock' } | { __typename: 'SwishCertificateBlockModel' } | { __typename: 'SwishFormBlockModel' } | { __typename: 'SwishRegistrationBlockModel' } | { __typename: 'SwishStoreRegistrationBlockModel' } | { __typename: 'TabBlockModel' } | { __typename: 'TabItem' } | { __typename: 'TeaserLinkBlockModel' } | { __typename: 'TextBlockModel' } | { __typename: 'TextareaElementBlock' } | { __typename: 'TextboxElementBlock' } | { __typename: 'UrlElementBlock' } | { __typename: 'VisitorDataHiddenElementBlock' } | { __typename: 'WebShopLinkBlockModel' } | { __typename: 'WordMediaModel' } | null> | null } | null };

export type ButtonLinkBlockFragment = { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null };

export type CompanyRegistrationsBlockFragment = { __typename?: 'CompanyRegistrationsBlockModel', Form?: string | null, ButtonText?: string | null, AlternativeTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditionsButton?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null };

export type ContentReferenceFragment = { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null };

export type EmbedVideoBlockFragment = { __typename?: 'EmbedVideoBlockModel', Heading?: string | null, EmbedUrl?: string | null, VideoDescription?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null };

export type ExtendedLinkBlockFragment = { __typename?: 'ExtendedLinkBlockModel', Heading?: string | null, InvertIcon?: any | null, Title?: string | null, MenuIcon?: string | null, LinkUrl?: string | null, TeaserText?: string | null, FormReference?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel', Form?: string | null, ButtonText?: string | null, AlternativeTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditions?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, CustomTermsAndConditionsButton?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null, Extra1?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra2?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra3?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra4?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Extra5?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, HelpText?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null };

export type FeatureBlockFragment = { __typename?: 'FeatureBlockModel', Heading?: string | null, TeaserText?: string | null, ContentTextPosition?: number | null, ColorTheme?: number | null, BackGround?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null };

type ILinkable_ActivationPageModel_Fragment = { __typename?: 'ActivationPageModel' };

type ILinkable_AgreementPageModel_Fragment = { __typename?: 'AgreementPageModel' };

type ILinkable_AssociationBattleBlockModel_Fragment = { __typename?: 'AssociationBattleBlockModel' };

type ILinkable_AtoZPageModel_Fragment = { __typename?: 'AtoZPageModel', Name?: string | null, TeaserText?: string | null, RelativePath?: string | null };

type ILinkable_ButtonLinkBlockModel_Fragment = { __typename?: 'ButtonLinkBlockModel' };

type ILinkable_CampaignBlock_Fragment = { __typename?: 'CampaignBlock' };

type ILinkable_CaptchaElementBlock_Fragment = { __typename?: 'CaptchaElementBlock' };

type ILinkable_ChoiceElementBlock_Fragment = { __typename?: 'ChoiceElementBlock' };

type ILinkable_CompanyRegistrationsBlockModel_Fragment = { __typename?: 'CompanyRegistrationsBlockModel' };

type ILinkable_CompensationBlockModel_Fragment = { __typename?: 'CompensationBlockModel' };

type ILinkable_ConnectedProducersListBlockModel_Fragment = { __typename?: 'ConnectedProducersListBlockModel' };

type ILinkable_Content_Fragment = { __typename?: 'Content' };

type ILinkable_CsvMediaModel_Fragment = { __typename?: 'CsvMediaModel' };

type ILinkable_DepositLabelOrderBlockModel_Fragment = { __typename?: 'DepositLabelOrderBlockModel' };

type ILinkable_DepositLabelOrderHistoryBlockModel_Fragment = { __typename?: 'DepositLabelOrderHistoryBlockModel' };

type ILinkable_DownloadAssetLocalBlockModel_Fragment = { __typename?: 'DownloadAssetLocalBlockModel' };

type ILinkable_DownloadAssetVariant_Fragment = { __typename?: 'DownloadAssetVariant' };

type ILinkable_DownloadAssetsBlockModel_Fragment = { __typename?: 'DownloadAssetsBlockModel' };

type ILinkable_EanCheckBlockModel_Fragment = { __typename?: 'EanCheckBlockModel' };

type ILinkable_EmbedVideoBlockModel_Fragment = { __typename?: 'EmbedVideoBlockModel' };

type ILinkable_ErrorPageModel_Fragment = { __typename?: 'ErrorPageModel' };

type ILinkable_ExcelMediaModel_Fragment = { __typename?: 'ExcelMediaModel' };

type ILinkable_ExtendedLinkBlockModel_Fragment = { __typename?: 'ExtendedLinkBlockModel', Title?: string | null, TeaserText?: string | null, LinkUrl?: string | null, MenuIcon?: string | null };

type ILinkable_ExtraPickupFormBlockModel_Fragment = { __typename?: 'ExtraPickupFormBlockModel' };

type ILinkable_FaqCategoryPageModel_Fragment = { __typename?: 'FaqCategoryPageModel' };

type ILinkable_FaqItemPageModel_Fragment = { __typename?: 'FaqItemPageModel' };

type ILinkable_FaqListPageModel_Fragment = { __typename?: 'FaqListPageModel', Title?: string | null, TeaserText?: string | null, RelativePath?: string | null, MenuIcon?: string | null };

type ILinkable_FeatureBlockModel_Fragment = { __typename?: 'FeatureBlockModel' };

type ILinkable_FileUploadElementBlock_Fragment = { __typename?: 'FileUploadElementBlock' };

type ILinkable_FormContainerBlock_Fragment = { __typename?: 'FormContainerBlock' };

type ILinkable_FormStepBlock_Fragment = { __typename?: 'FormStepBlock' };

type ILinkable_HeroBlockModel_Fragment = { __typename?: 'HeroBlockModel' };

type ILinkable_IFramePageModel_Fragment = { __typename?: 'IFramePageModel' };

type ILinkable_ImageAndTextBlockModel_Fragment = { __typename?: 'ImageAndTextBlockModel' };

type ILinkable_ImageBlockModel_Fragment = { __typename?: 'ImageBlockModel' };

type ILinkable_ImageChoiceElementBlock_Fragment = { __typename?: 'ImageChoiceElementBlock' };

type ILinkable_MainImageBlockModel_Fragment = { __typename?: 'MainImageBlockModel' };

type ILinkable_MainMenuPageModel_Fragment = { __typename?: 'MainMenuPageModel', TeaserText?: string | null, Name?: string | null, RelativePath?: string | null, MenuIcon?: string | null };

type ILinkable_MyPagesAdminPageModel_Fragment = { __typename?: 'MyPagesAdminPageModel' };

type ILinkable_MyPagesBlockModel_Fragment = { __typename?: 'MyPagesBlockModel' };

type ILinkable_MyPagesContainerPageModel_Fragment = { __typename?: 'MyPagesContainerPageModel', Name?: string | null, TeaserText?: string | null, RelativePath?: string | null, MenuIcon?: string | null };

type ILinkable_MyPagesPageModel_Fragment = { __typename?: 'MyPagesPageModel', TeaserText?: string | null, Title?: string | null, Name?: string | null, RelativePath?: string | null, MenuIcon?: string | null, MenuTagLine?: string | null, RequiredUserRole?: string | null, IncludedFeature?: string | null };

type ILinkable_MyPagesStartPageModel_Fragment = { __typename?: 'MyPagesStartPageModel', TeaserText?: string | null, MenuTagLine?: string | null, RelativePath?: string | null, MenuIcon?: string | null };

type ILinkable_NewsContainerPageModel_Fragment = { __typename?: 'NewsContainerPageModel', Name?: string | null, RelativePath?: string | null };

type ILinkable_NewsPageModel_Fragment = { __typename?: 'NewsPageModel', MenuTagLine?: string | null, TeaserText?: string | null, RelativePath?: string | null, MenuIcon?: string | null, Date?: any | null };

type ILinkable_NominationBlockModel_Fragment = { __typename?: 'NominationBlockModel' };

type ILinkable_NumberElementBlock_Fragment = { __typename?: 'NumberElementBlock' };

type ILinkable_OrderAssetLocalBlockModel_Fragment = { __typename?: 'OrderAssetLocalBlockModel' };

type ILinkable_ParagraphTextElementBlock_Fragment = { __typename?: 'ParagraphTextElementBlock' };

type ILinkable_PexMapBlockModel_Fragment = { __typename?: 'PexMapBlockModel' };

type ILinkable_PopupBlockModel_Fragment = { __typename?: 'PopupBlockModel' };

type ILinkable_PptMediaModel_Fragment = { __typename?: 'PptMediaModel' };

type ILinkable_PredefinedHiddenElementBlock_Fragment = { __typename?: 'PredefinedHiddenElementBlock' };

type ILinkable_PrizePoolBlockModel_Fragment = { __typename?: 'PrizePoolBlockModel' };

type ILinkable_PrizePoolDistributionLocalBlockModel_Fragment = { __typename?: 'PrizePoolDistributionLocalBlockModel' };

type ILinkable_PrizePoolNumbersLocalBlockModel_Fragment = { __typename?: 'PrizePoolNumbersLocalBlockModel' };

type ILinkable_RangeElementBlock_Fragment = { __typename?: 'RangeElementBlock' };

type ILinkable_RecyclingStoreTopListBlockModel_Fragment = { __typename?: 'RecyclingStoreTopListBlockModel' };

type ILinkable_RelatedLinksBlockModel_Fragment = { __typename?: 'RelatedLinksBlockModel' };

type ILinkable_ResetButtonElementBlock_Fragment = { __typename?: 'ResetButtonElementBlock' };

type ILinkable_ResponsiveImageBlockModel_Fragment = { __typename?: 'ResponsiveImageBlockModel' };

type ILinkable_ScriptBlock_Fragment = { __typename?: 'ScriptBlock' };

type ILinkable_ScriptImportBlockModel_Fragment = { __typename?: 'ScriptImportBlockModel' };

type ILinkable_SearchResultPageModel_Fragment = { __typename?: 'SearchResultPageModel' };

type ILinkable_SectionBlockModel_Fragment = { __typename?: 'SectionBlockModel' };

type ILinkable_SelectionElementBlock_Fragment = { __typename?: 'SelectionElementBlock' };

type ILinkable_SeoBlockModel_Fragment = { __typename?: 'SeoBlockModel' };

type ILinkable_SiteContextSettingsBlockModel_Fragment = { __typename?: 'SiteContextSettingsBlockModel' };

type ILinkable_SiteDocumentMediaData_Fragment = { __typename?: 'SiteDocumentMediaData' };

type ILinkable_SiteImageData_Fragment = { __typename?: 'SiteImageData' };

type ILinkable_SiteMediaData_Fragment = { __typename?: 'SiteMediaData' };

type ILinkable_SiteVideoData_Fragment = { __typename?: 'SiteVideoData' };

type ILinkable_StandardBlockModel_Fragment = { __typename?: 'StandardBlockModel' };

type ILinkable_StandardPageModel_Fragment = { __typename?: 'StandardPageModel', Name?: string | null, TeaserText?: string | null, RelativePath?: string | null, MenuIcon?: string | null };

type ILinkable_StartPageModel_Fragment = { __typename?: 'StartPageModel' };

type ILinkable_StoreFlyersBlockModel_Fragment = { __typename?: 'StoreFlyersBlockModel' };

type ILinkable_SubmitButtonElementBlock_Fragment = { __typename?: 'SubmitButtonElementBlock' };

type ILinkable_SwishCertificateBlockModel_Fragment = { __typename?: 'SwishCertificateBlockModel' };

type ILinkable_SwishFormBlockModel_Fragment = { __typename?: 'SwishFormBlockModel' };

type ILinkable_SwishRegistrationBlockModel_Fragment = { __typename?: 'SwishRegistrationBlockModel' };

type ILinkable_SwishStoreRegistrationBlockModel_Fragment = { __typename?: 'SwishStoreRegistrationBlockModel' };

type ILinkable_TabBlockModel_Fragment = { __typename?: 'TabBlockModel' };

type ILinkable_TabItem_Fragment = { __typename?: 'TabItem' };

type ILinkable_TeaserLinkBlockModel_Fragment = { __typename?: 'TeaserLinkBlockModel' };

type ILinkable_TextBlockModel_Fragment = { __typename?: 'TextBlockModel' };

type ILinkable_TextareaElementBlock_Fragment = { __typename?: 'TextareaElementBlock' };

type ILinkable_TextboxElementBlock_Fragment = { __typename?: 'TextboxElementBlock' };

type ILinkable_UrlElementBlock_Fragment = { __typename?: 'UrlElementBlock' };

type ILinkable_VisitorDataHiddenElementBlock_Fragment = { __typename?: 'VisitorDataHiddenElementBlock' };

type ILinkable_WebShopLinkBlockModel_Fragment = { __typename?: 'WebShopLinkBlockModel', Title?: string | null, TeaserText?: string | null, MenuIcon?: string | null };

type ILinkable_WordMediaModel_Fragment = { __typename?: 'WordMediaModel' };

export type ILinkableFragment = ILinkable_ActivationPageModel_Fragment | ILinkable_AgreementPageModel_Fragment | ILinkable_AssociationBattleBlockModel_Fragment | ILinkable_AtoZPageModel_Fragment | ILinkable_ButtonLinkBlockModel_Fragment | ILinkable_CampaignBlock_Fragment | ILinkable_CaptchaElementBlock_Fragment | ILinkable_ChoiceElementBlock_Fragment | ILinkable_CompanyRegistrationsBlockModel_Fragment | ILinkable_CompensationBlockModel_Fragment | ILinkable_ConnectedProducersListBlockModel_Fragment | ILinkable_Content_Fragment | ILinkable_CsvMediaModel_Fragment | ILinkable_DepositLabelOrderBlockModel_Fragment | ILinkable_DepositLabelOrderHistoryBlockModel_Fragment | ILinkable_DownloadAssetLocalBlockModel_Fragment | ILinkable_DownloadAssetVariant_Fragment | ILinkable_DownloadAssetsBlockModel_Fragment | ILinkable_EanCheckBlockModel_Fragment | ILinkable_EmbedVideoBlockModel_Fragment | ILinkable_ErrorPageModel_Fragment | ILinkable_ExcelMediaModel_Fragment | ILinkable_ExtendedLinkBlockModel_Fragment | ILinkable_ExtraPickupFormBlockModel_Fragment | ILinkable_FaqCategoryPageModel_Fragment | ILinkable_FaqItemPageModel_Fragment | ILinkable_FaqListPageModel_Fragment | ILinkable_FeatureBlockModel_Fragment | ILinkable_FileUploadElementBlock_Fragment | ILinkable_FormContainerBlock_Fragment | ILinkable_FormStepBlock_Fragment | ILinkable_HeroBlockModel_Fragment | ILinkable_IFramePageModel_Fragment | ILinkable_ImageAndTextBlockModel_Fragment | ILinkable_ImageBlockModel_Fragment | ILinkable_ImageChoiceElementBlock_Fragment | ILinkable_MainImageBlockModel_Fragment | ILinkable_MainMenuPageModel_Fragment | ILinkable_MyPagesAdminPageModel_Fragment | ILinkable_MyPagesBlockModel_Fragment | ILinkable_MyPagesContainerPageModel_Fragment | ILinkable_MyPagesPageModel_Fragment | ILinkable_MyPagesStartPageModel_Fragment | ILinkable_NewsContainerPageModel_Fragment | ILinkable_NewsPageModel_Fragment | ILinkable_NominationBlockModel_Fragment | ILinkable_NumberElementBlock_Fragment | ILinkable_OrderAssetLocalBlockModel_Fragment | ILinkable_ParagraphTextElementBlock_Fragment | ILinkable_PexMapBlockModel_Fragment | ILinkable_PopupBlockModel_Fragment | ILinkable_PptMediaModel_Fragment | ILinkable_PredefinedHiddenElementBlock_Fragment | ILinkable_PrizePoolBlockModel_Fragment | ILinkable_PrizePoolDistributionLocalBlockModel_Fragment | ILinkable_PrizePoolNumbersLocalBlockModel_Fragment | ILinkable_RangeElementBlock_Fragment | ILinkable_RecyclingStoreTopListBlockModel_Fragment | ILinkable_RelatedLinksBlockModel_Fragment | ILinkable_ResetButtonElementBlock_Fragment | ILinkable_ResponsiveImageBlockModel_Fragment | ILinkable_ScriptBlock_Fragment | ILinkable_ScriptImportBlockModel_Fragment | ILinkable_SearchResultPageModel_Fragment | ILinkable_SectionBlockModel_Fragment | ILinkable_SelectionElementBlock_Fragment | ILinkable_SeoBlockModel_Fragment | ILinkable_SiteContextSettingsBlockModel_Fragment | ILinkable_SiteDocumentMediaData_Fragment | ILinkable_SiteImageData_Fragment | ILinkable_SiteMediaData_Fragment | ILinkable_SiteVideoData_Fragment | ILinkable_StandardBlockModel_Fragment | ILinkable_StandardPageModel_Fragment | ILinkable_StartPageModel_Fragment | ILinkable_StoreFlyersBlockModel_Fragment | ILinkable_SubmitButtonElementBlock_Fragment | ILinkable_SwishCertificateBlockModel_Fragment | ILinkable_SwishFormBlockModel_Fragment | ILinkable_SwishRegistrationBlockModel_Fragment | ILinkable_SwishStoreRegistrationBlockModel_Fragment | ILinkable_TabBlockModel_Fragment | ILinkable_TabItem_Fragment | ILinkable_TeaserLinkBlockModel_Fragment | ILinkable_TextBlockModel_Fragment | ILinkable_TextareaElementBlock_Fragment | ILinkable_TextboxElementBlock_Fragment | ILinkable_UrlElementBlock_Fragment | ILinkable_VisitorDataHiddenElementBlock_Fragment | ILinkable_WebShopLinkBlockModel_Fragment | ILinkable_WordMediaModel_Fragment;

export type ImageDetailsFragment = { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null };

export type PopupBlockFragment = { __typename?: 'PopupBlockModel', Name?: string | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null };

export type StandardBlockFragment = { __typename?: 'StandardBlockModel', WideLayout?: any | null, Heading?: string | null, ImageAlignment?: string | null, ColorTheme?: number | null, Text?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, BackgroundImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, Buttons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null };

export type VideoDetailsFragment = { __typename: 'SiteVideoData', Name?: string | null, RelativePath?: string | null, MimeType?: string | null, PreviewImage?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null };

export type GetMyPagesContainerPageUrlQueryVariables = Exact<{
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetMyPagesContainerPageUrlQuery = { __typename?: 'Query', MyPagesContainerPageModel?: { __typename?: 'MyPagesContainerPageModelOutput', items?: Array<{ __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | null> | null } | null };

export type GetStartPageModelQueryVariables = Exact<{
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetStartPageModelQuery = { __typename?: 'Query', StartPageModel?: { __typename?: 'StartPageModelOutput', items?: Array<{ __typename?: 'StartPageModel', Name?: string | null, PopularSearchTerms?: string | null, MapsApiKey?: string | null, SearchResultPage?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'AgreementPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'AssociationBattleBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'AtoZPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ButtonLinkBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'CampaignBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'CaptchaElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ChoiceElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'CompensationBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'Content', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'CsvMediaModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'DownloadAssetVariant', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'DownloadAssetsBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'EanCheckBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'EmbedVideoBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ErrorPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ExcelMediaModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ExtendedLinkBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'FaqCategoryPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'FaqItemPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'FaqListPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'FeatureBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'FileUploadElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'FormContainerBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'FormStepBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'HeroBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'IFramePageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ImageAndTextBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ImageBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ImageChoiceElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'MainImageBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'MainMenuPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'MyPagesAdminPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'MyPagesBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'MyPagesContainerPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'MyPagesPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'MyPagesStartPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'NewsContainerPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'NewsPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'NominationBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'NumberElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ParagraphTextElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'PexMapBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'PopupBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'PptMediaModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'PrizePoolBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'RangeElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'RelatedLinksBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ResetButtonElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ResponsiveImageBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ScriptBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'ScriptImportBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SearchResultPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SectionBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SelectionElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SeoBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SiteDocumentMediaData', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SiteImageData', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SiteMediaData', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SiteVideoData', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'StandardBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'StandardPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'StartPageModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'StoreFlyersBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SubmitButtonElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SwishCertificateBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SwishFormBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SwishRegistrationBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'TabBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'TabItem', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'TeaserLinkBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'TextBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'TextareaElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'TextboxElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'UrlElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'WebShopLinkBlockModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | { __typename?: 'WordMediaModel', ContentLink?: { __typename?: 'ContentModelReference', Url?: string | null } | null } | null } | null, StandardTermsAndConditions?: { __typename?: 'MixedHtmlModel', Html?: string | null } | null, StandardTermsAndConditionsButtons?: Array<{ __typename?: 'ContentAreaItemModelSearch', ContentLink?: { __typename?: 'ContentModelReferenceSearch', Id?: number | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel', ButtonClass?: number | null, LinkText?: string | null, VideoUrl?: string | null, ExternalLink?: string | null, PopupContent?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, DocumentLink?: { __typename?: 'ContentModelReference', Id?: number | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null } | { __typename?: 'Content', RelativePath?: string | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null } | { __typename?: 'SiteImageData', RelativePath?: string | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null } | { __typename?: 'StartPageModel', RelativePath?: string | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null } | { __typename?: 'TabItem', RelativePath?: string | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null } | null } | null, Link?: { __typename?: 'ContentModelReference', Expanded?: { __typename?: 'ActivationPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AgreementPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AssociationBattleBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'AtoZPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ButtonLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CampaignBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CaptchaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CompensationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'Content', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'CsvMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetVariant', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'DownloadAssetsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EanCheckBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'EmbedVideoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ErrorPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExcelMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtendedLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqCategoryPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqItemPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FaqListPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FeatureBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FileUploadElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormContainerBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'FormStepBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'HeroBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'IFramePageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageAndTextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ImageChoiceElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MainMenuPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesAdminPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'MyPagesStartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsContainerPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NewsPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NominationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'NumberElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ParagraphTextElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PexMapBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PopupBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PptMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RangeElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'RelatedLinksBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResetButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ResponsiveImageBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'ScriptImportBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SearchResultPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SectionBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SelectionElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SeoBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteDocumentMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteImageData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteMediaData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SiteVideoData', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StandardPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StartPageModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'StoreFlyersBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SubmitButtonElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishCertificateBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishFormBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TabItem', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TeaserLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextareaElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'TextboxElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'UrlElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WebShopLinkBlockModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | { __typename?: 'WordMediaModel', RelativePath?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null } | null } | null } | null } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename?: 'SiteImageData' } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null } | null> | null } | null> | null } | null };

export type GetNominationBlockQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  locale: Array<InputMaybe<Locales>> | InputMaybe<Locales>;
}>;


export type GetNominationBlockQuery = { __typename?: 'Query', Content?: { __typename?: 'ContentOutput', items?: Array<{ __typename?: 'ActivationPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AgreementPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AssociationBattleBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'AtoZPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ButtonLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CampaignBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CaptchaElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ChoiceElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CompanyRegistrationsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CompensationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ConnectedProducersListBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'Content', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'CsvMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DepositLabelOrderBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DepositLabelOrderHistoryBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetVariant', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'DownloadAssetsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'EanCheckBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'EmbedVideoBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ErrorPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExcelMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExtendedLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ExtraPickupFormBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqCategoryPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqItemPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FaqListPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FeatureBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FileUploadElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FormContainerBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'FormStepBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'HeroBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'IFramePageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageAndTextBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ImageChoiceElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MainImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MainMenuPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesAdminPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesContainerPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'MyPagesStartPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NewsContainerPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NewsPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NominationBlockModel', Heading?: string | null, _id?: string | null, Name?: string | null, NominationPreamble?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, Image?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null, Expanded?: { __typename?: 'ActivationPageModel' } | { __typename?: 'AgreementPageModel' } | { __typename?: 'AssociationBattleBlockModel' } | { __typename?: 'AtoZPageModel' } | { __typename?: 'ButtonLinkBlockModel' } | { __typename?: 'CampaignBlock' } | { __typename?: 'CaptchaElementBlock' } | { __typename?: 'ChoiceElementBlock' } | { __typename?: 'CompanyRegistrationsBlockModel' } | { __typename?: 'CompensationBlockModel' } | { __typename?: 'ConnectedProducersListBlockModel' } | { __typename?: 'Content' } | { __typename?: 'CsvMediaModel' } | { __typename?: 'DepositLabelOrderBlockModel' } | { __typename?: 'DepositLabelOrderHistoryBlockModel' } | { __typename?: 'DownloadAssetLocalBlockModel' } | { __typename?: 'DownloadAssetVariant' } | { __typename?: 'DownloadAssetsBlockModel' } | { __typename?: 'EanCheckBlockModel' } | { __typename?: 'EmbedVideoBlockModel' } | { __typename?: 'ErrorPageModel' } | { __typename?: 'ExcelMediaModel' } | { __typename?: 'ExtendedLinkBlockModel' } | { __typename?: 'ExtraPickupFormBlockModel' } | { __typename?: 'FaqCategoryPageModel' } | { __typename?: 'FaqItemPageModel' } | { __typename?: 'FaqListPageModel' } | { __typename?: 'FeatureBlockModel' } | { __typename?: 'FileUploadElementBlock' } | { __typename?: 'FormContainerBlock' } | { __typename?: 'FormStepBlock' } | { __typename?: 'HeroBlockModel' } | { __typename?: 'IFramePageModel' } | { __typename?: 'ImageAndTextBlockModel' } | { __typename?: 'ImageBlockModel' } | { __typename?: 'ImageChoiceElementBlock' } | { __typename?: 'MainImageBlockModel' } | { __typename?: 'MainMenuPageModel' } | { __typename?: 'MyPagesAdminPageModel' } | { __typename?: 'MyPagesBlockModel' } | { __typename?: 'MyPagesContainerPageModel' } | { __typename?: 'MyPagesPageModel' } | { __typename?: 'MyPagesStartPageModel' } | { __typename?: 'NewsContainerPageModel' } | { __typename?: 'NewsPageModel' } | { __typename?: 'NominationBlockModel' } | { __typename?: 'NumberElementBlock' } | { __typename?: 'OrderAssetLocalBlockModel' } | { __typename?: 'ParagraphTextElementBlock' } | { __typename?: 'PexMapBlockModel' } | { __typename?: 'PopupBlockModel' } | { __typename?: 'PptMediaModel' } | { __typename?: 'PredefinedHiddenElementBlock' } | { __typename?: 'PrizePoolBlockModel' } | { __typename?: 'PrizePoolDistributionLocalBlockModel' } | { __typename?: 'PrizePoolNumbersLocalBlockModel' } | { __typename?: 'RangeElementBlock' } | { __typename?: 'RecyclingStoreTopListBlockModel' } | { __typename?: 'RelatedLinksBlockModel' } | { __typename?: 'ResetButtonElementBlock' } | { __typename?: 'ResponsiveImageBlockModel' } | { __typename?: 'ScriptBlock' } | { __typename?: 'ScriptImportBlockModel' } | { __typename?: 'SearchResultPageModel' } | { __typename?: 'SectionBlockModel' } | { __typename?: 'SelectionElementBlock' } | { __typename?: 'SeoBlockModel' } | { __typename?: 'SiteContextSettingsBlockModel' } | { __typename?: 'SiteDocumentMediaData' } | { __typename: 'SiteImageData', Name?: string | null, AltText?: string | null, RelativePath?: string | null, MimeType?: string | null } | { __typename?: 'SiteMediaData' } | { __typename?: 'SiteVideoData' } | { __typename?: 'StandardBlockModel' } | { __typename?: 'StandardPageModel' } | { __typename?: 'StartPageModel' } | { __typename?: 'StoreFlyersBlockModel' } | { __typename?: 'SubmitButtonElementBlock' } | { __typename?: 'SwishCertificateBlockModel' } | { __typename?: 'SwishFormBlockModel' } | { __typename?: 'SwishRegistrationBlockModel' } | { __typename?: 'SwishStoreRegistrationBlockModel' } | { __typename?: 'TabBlockModel' } | { __typename?: 'TabItem' } | { __typename?: 'TeaserLinkBlockModel' } | { __typename?: 'TextBlockModel' } | { __typename?: 'TextareaElementBlock' } | { __typename?: 'TextboxElementBlock' } | { __typename?: 'UrlElementBlock' } | { __typename?: 'VisitorDataHiddenElementBlock' } | { __typename?: 'WebShopLinkBlockModel' } | { __typename?: 'WordMediaModel' } | null } | null, NominationDescription?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, SecondaryDescription?: { __typename?: 'MixedHtmlModelSearch', Html?: string | null } | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'NumberElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'OrderAssetLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ParagraphTextElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PexMapBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PopupBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PptMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PredefinedHiddenElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolDistributionLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'PrizePoolNumbersLocalBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RangeElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RecyclingStoreTopListBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'RelatedLinksBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ResetButtonElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ResponsiveImageBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ScriptBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'ScriptImportBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SearchResultPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SectionBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SelectionElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SeoBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteContextSettingsBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteDocumentMediaData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteImageData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteMediaData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SiteVideoData', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StandardBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StandardPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StartPageModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'StoreFlyersBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SubmitButtonElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishCertificateBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishFormBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishRegistrationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'SwishStoreRegistrationBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TabBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TabItem', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TeaserLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextareaElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'TextboxElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'UrlElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'VisitorDataHiddenElementBlock', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'WebShopLinkBlockModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | { __typename?: 'WordMediaModel', _id?: string | null, Name?: string | null, ContentLink?: { __typename?: 'ContentModelReference', Id?: number | null, WorkId?: number | null, GuidValue?: string | null, ProviderName?: string | null, Url?: string | null } | null } | null> | null } | null };


export const ButtonLinkBlockFragmentDoc = `
    fragment ButtonLinkBlock on ButtonLinkBlockModel {
  ButtonClass
  LinkText
  VideoUrl
  PopupContent {
    Html
  }
  DocumentLink {
    Id
    Url
    Expanded {
      RelativePath
    }
  }
  ExternalLink
  Link {
    Expanded {
      RelativePath
      ContentLink {
        Id
      }
    }
  }
}
    `;
export const CompanyRegistrationsBlockFragmentDoc = `
    fragment CompanyRegistrationsBlock on CompanyRegistrationsBlockModel {
  AlternativeTermsAndConditions {
    Html
  }
  CustomTermsAndConditions {
    Html
  }
  CustomTermsAndConditionsButton {
    ContentLink {
      Id
      Expanded {
        ...ButtonLinkBlock
      }
    }
  }
  Extra1 {
    Html
  }
  Extra2 {
    Html
  }
  Extra3 {
    Html
  }
  Extra4 {
    Html
  }
  Extra5 {
    Html
  }
  HelpText {
    Html
  }
  Form
  ButtonText
}
    `;
export const ExtendedLinkBlockFragmentDoc = `
    fragment ExtendedLinkBlock on ExtendedLinkBlockModel {
  Heading
  InvertIcon
  Title
  MenuIcon
  LinkUrl
  TeaserText
  FormReference {
    Expanded {
      ...CompanyRegistrationsBlock
    }
  }
}
    `;
export const ConnectLinksContentAreaFragmentDoc = `
    fragment ConnectLinksContentArea on IContent {
  ... on ExtendedLinkBlockModel {
    ...ExtendedLinkBlock
  }
}
    `;
export const MyPagesBlockFragmentDoc = `
    fragment MyPagesBlock on MyPagesBlockModel {
  Heading
  TeaserText
  Component
  IncludedFeature
  HelpText {
    Html
  }
  Extra1 {
    Html
  }
  Extra2 {
    Html
  }
  Extra3 {
    Html
  }
  Extra4 {
    Html
  }
  Extra5 {
    Html
  }
  CustomTermsAndConditions {
    Html
  }
  UseGeneralTab
  GeneralTabHeading
  GeneralTabText
}
    `;
export const PopupBlockFragmentDoc = `
    fragment PopupBlock on PopupBlockModel {
  Name
  Text {
    Html
  }
  ContentLink {
    Id
  }
}
    `;
export const ContentReferenceFragmentDoc = `
    fragment ContentReference on ContentModelReference {
  Id
  WorkId
  GuidValue
  ProviderName
  Url
}
    `;
export const ImageDetailsFragmentDoc = `
    fragment ImageDetails on SiteImageData {
  __typename
  Name
  AltText
  RelativePath
  MimeType
}
    `;
export const VideoDetailsFragmentDoc = `
    fragment VideoDetails on SiteVideoData {
  __typename
  Name
  RelativePath
  MimeType
  PreviewImage {
    ...ContentReference
    Expanded {
      ...ImageDetails
    }
  }
}
    `;
export const HeroBlockFragmentDoc = `
    fragment HeroBlock on HeroBlockModel {
  __typename
  Language {
    Name
  }
  IncludedFeature
  Heading
  PreHeading
  PreHeadingFont
  ColorTheme
  TeaserText
  TeaserTextFont
  Background {
    ...ContentReference
    Expanded {
      ...ImageDetails
      ...VideoDetails
    }
  }
  Image {
    ...ContentReference
    Expanded {
      ...ImageDetails
    }
  }
  ImageMobile {
    ...ContentReference
    Expanded {
      ...ImageDetails
    }
  }
  ContentImagePosition
  ContentTextAlignment
  Buttons {
    ContentLink {
      Id
      Expanded {
        ...ButtonLinkBlock
      }
    }
  }
}
    `;
export const EmbedVideoBlockFragmentDoc = `
    fragment EmbedVideoBlock on EmbedVideoBlockModel {
  Heading
  EmbedUrl
  PreviewImage {
    ...ContentReference
    Expanded {
      ...ImageDetails
    }
  }
  VideoDescription
}
    `;
export const StandardBlockFragmentDoc = `
    fragment StandardBlock on StandardBlockModel {
  WideLayout
  Heading
  Text {
    Html
  }
  Image {
    ...ContentReference
    Expanded {
      ...ImageDetails
    }
  }
  ImageAlignment
  BackgroundImage {
    ...ContentReference
    Expanded {
      ...ImageDetails
    }
  }
  ColorTheme
  Buttons {
    ContentLink {
      Id
      Expanded {
        ...ButtonLinkBlock
      }
    }
  }
}
    `;
export const AssociationBattleBlockFragmentDoc = `
    fragment AssociationBattleBlock on AssociationBattleBlockModel {
  Heading
  WideLayout
  Image {
    ...ContentReference
    Expanded {
      ...ImageDetails
    }
  }
}
    `;
export const FeatureBlockFragmentDoc = `
    fragment FeatureBlock on FeatureBlockModel {
  Heading
  TeaserText
  ContentTextPosition
  ColorTheme
  BackGround {
    ...ContentReference
    Expanded {
      ...ImageDetails
      ...VideoDetails
    }
  }
  Buttons {
    ContentLink {
      Id
      Expanded {
        ...ButtonLinkBlock
      }
    }
  }
}
    `;
export const DepositLabelOrderBlockFragmentDoc = `
    fragment DepositLabelOrderBlock on DepositLabelOrderBlockModel {
  Heading
  HelpText {
    Html
  }
  MainBody {
    Html
  }
  CustomTermsAndConditions {
    Html
  }
  PriceInformation
  ShippingInformation
  Button {
    ButtonClass
    LinkText
  }
}
    `;
export const DepositLabelOrderHistoryBlockFragmentDoc = `
    fragment DepositLabelOrderHistoryBlock on DepositLabelOrderHistoryBlockModel {
  Heading
  MainBody {
    Html
  }
}
    `;
export const SwishCertificateBlockFragmentDoc = `
    fragment SwishCertificateBlock on SwishCertificateBlockModel {
  __typename
  Text {
    Html
  }
  UploadHelpText {
    Html
  }
}
    `;
export const SwishStoreRegistrationBlockFragmentDoc = `
    fragment SwishStoreRegistrationBlock on SwishStoreRegistrationBlockModel {
  __typename
  InstructionText {
    Html
  }
}
    `;
export const MyPagesContentAreaFragmentDoc = `
    fragment MyPagesContentArea on IContent {
  __typename
  ...MyPagesBlock
  ...PopupBlock
  ...HeroBlock
  ...ExtendedLinkBlock
  ...EmbedVideoBlock
  ...StandardBlock
  ...AssociationBattleBlock
  ...FeatureBlock
  ...DepositLabelOrderBlock
  ...DepositLabelOrderHistoryBlock
  ...SwishCertificateBlock
  ...SwishStoreRegistrationBlock
}
    `;
export const TabBlockFragmentDoc = `
    fragment TabBlock on TabBlockModel {
  __typename
  AddDivider
  Tabs {
    TabHeading
    Blocks {
      ContentLink {
        Expanded {
          ...MyPagesContentArea
        }
      }
    }
  }
}
    `;
export const ILinkableFragmentDoc = `
    fragment ILinkable on IContent {
  ... on AtoZPageModel {
    Name
    TeaserText
    RelativePath
  }
  ... on ExtendedLinkBlockModel {
    Title
    TeaserText
    LinkUrl
    MenuIcon
  }
  ... on WebShopLinkBlockModel {
    Title
    TeaserText
    MenuIcon
  }
  ... on FaqListPageModel {
    Title
    TeaserText
    RelativePath
    MenuIcon
  }
  ... on MainMenuPageModel {
    TeaserText
    Name
    RelativePath
    MenuIcon
  }
  ... on MyPagesContainerPageModel {
    Name
    TeaserText
    RelativePath
    MenuIcon
  }
  ... on MyPagesPageModel {
    TeaserText
    Title
    Name
    RelativePath
    MenuIcon
    MenuTagLine
    RequiredUserRole
    IncludedFeature
  }
  ... on MyPagesStartPageModel {
    TeaserText
    MenuTagLine
    RelativePath
    MenuIcon
  }
  ... on NewsContainerPageModel {
    Name
    RelativePath
  }
  ... on NewsPageModel {
    MenuTagLine
    TeaserText
    RelativePath
    MenuIcon
    Date
  }
  ... on StandardPageModel {
    Name
    TeaserText
    RelativePath
    MenuIcon
  }
}
    `;
export const AssociationBattleBlockDocument = `
    query AssociationBattleBlock($id: Int!, $locale: [Locales]!) {
  Content(locale: $locale, limit: 1, where: {ContentLink: {Id: {eq: $id}}}) {
    items {
      _id
      Name
      ContentLink {
        Id
        WorkId
        GuidValue
        ProviderName
        Url
      }
      ... on AssociationBattleBlockModel {
        Heading
        WideLayout
        Image {
          ...ContentReference
          Expanded {
            ...ImageDetails
          }
        }
      }
    }
  }
}
    ${ContentReferenceFragmentDoc}
${ImageDetailsFragmentDoc}`;

export const useAssociationBattleBlockQuery = <
      TData = AssociationBattleBlockQuery,
      TError = unknown
    >(
      variables: AssociationBattleBlockQueryVariables,
      options?: UseQueryOptions<AssociationBattleBlockQuery, TError, TData>
    ) => {
    
    return useQuery<AssociationBattleBlockQuery, TError, TData>(
      ['AssociationBattleBlock', variables],
      fetcher<AssociationBattleBlockQuery, AssociationBattleBlockQueryVariables>(AssociationBattleBlockDocument, variables),
      options
    )};

export const GetCompanyRegistrationsDocument = `
    query GetCompanyRegistrations($id: Int!, $locale: [Locales]!) {
  StartPageModel(locale: $locale) {
    items {
      StandardTermsAndConditions {
        Html
      }
    }
  }
  CompanyRegistrationsBlockModel(
    where: {ContentLink: {Id: {eq: $id}}}
    locale: $locale
  ) {
    items {
      AlternativeTermsAndConditions {
        Html
      }
      CustomTermsAndConditions {
        Html
      }
      CustomTermsAndConditionsButton {
        ContentLink {
          Id
          Expanded {
            ...ButtonLinkBlock
          }
        }
      }
      Extra1 {
        Html
      }
      Extra2 {
        Html
      }
      Extra3 {
        Html
      }
      Extra4 {
        Html
      }
      Extra5 {
        Html
      }
      HelpText {
        Html
      }
      Form
      ButtonText
    }
  }
}
    ${ButtonLinkBlockFragmentDoc}`;

export const useGetCompanyRegistrationsQuery = <
      TData = GetCompanyRegistrationsQuery,
      TError = unknown
    >(
      variables: GetCompanyRegistrationsQueryVariables,
      options?: UseQueryOptions<GetCompanyRegistrationsQuery, TError, TData>
    ) => {
    
    return useQuery<GetCompanyRegistrationsQuery, TError, TData>(
      ['GetCompanyRegistrations', variables],
      fetcher<GetCompanyRegistrationsQuery, GetCompanyRegistrationsQueryVariables>(GetCompanyRegistrationsDocument, variables),
      options
    )};

export const GetMyPagesContainerPropsDocument = `
    query GetMyPagesContainerProps($locale: [Locales]!) {
  MyPagesContainerPageModel(locale: $locale) {
    items {
      PopUpContentArea {
        ContentLink {
          Expanded {
            ...PopupBlock
          }
        }
      }
      ConnectHeader
      ConnectFooter {
        Html
      }
      ConnectContent {
        Html
      }
      ConnectLinksContentArea {
        ContentLink {
          Expanded {
            ...ConnectLinksContentArea
          }
        }
      }
      AddCustomerDialogHeader
      AddCustomerDialogText
      AddConfirmDialog {
        Html
      }
      _children {
        MyPagesStartPageModel(locale: $locale) {
          items {
            OngoingRegistrationHeader1
            OngoingRegistrationHeader2
            OngoingRegistrationHeader3
            OngoingRegistrationHeader4
            OngoingRegistrationHeader5
            OngoingRegistrationStep1 {
              Html
            }
            OngoingRegistrationStep2 {
              Html
            }
            OngoingRegistrationStep3 {
              Html
            }
            OngoingRegistrationStep4 {
              Html
            }
            OngoingRegistrationStep5 {
              Html
            }
            CustomerType
          }
        }
      }
    }
  }
}
    ${PopupBlockFragmentDoc}
${ConnectLinksContentAreaFragmentDoc}
${ExtendedLinkBlockFragmentDoc}
${CompanyRegistrationsBlockFragmentDoc}
${ButtonLinkBlockFragmentDoc}`;

export const useGetMyPagesContainerPropsQuery = <
      TData = GetMyPagesContainerPropsQuery,
      TError = unknown
    >(
      variables: GetMyPagesContainerPropsQueryVariables,
      options?: UseQueryOptions<GetMyPagesContainerPropsQuery, TError, TData>
    ) => {
    
    return useQuery<GetMyPagesContainerPropsQuery, TError, TData>(
      ['GetMyPagesContainerProps', variables],
      fetcher<GetMyPagesContainerPropsQuery, GetMyPagesContainerPropsQueryVariables>(GetMyPagesContainerPropsDocument, variables),
      options
    )};

export const GetFilteredMyPagesBlocksDocument = `
    query GetFilteredMyPagesBlocks($userCategory: String!, $locale: [Locales]!, $features: [String!]!) {
  MyPagesStartPageModel(
    where: {CustomerType: {eq: $userCategory}, VisibleInMenu: {eq: true}}
    locale: $locale
  ) {
    items {
      _children {
        MyPagesPageModel(
          where: {_and: [{VisibleInMenu: {eq: true}}, {_or: [{IncludedFeature: {in: $features}}, {IncludedFeature: {eq: ""}}, {IncludedFeature: {exist: false}}]}]}
        ) {
          items {
            Name
            RelativePath
            RequiredUserRole
            IncludedFeature
            MainContentArea {
              ContentLink {
                Expanded {
                  ... on MyPagesBlockModel {
                    Component
                    IncludedFeature
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetFilteredMyPagesBlocksQuery = <
      TData = GetFilteredMyPagesBlocksQuery,
      TError = unknown
    >(
      variables: GetFilteredMyPagesBlocksQueryVariables,
      options?: UseQueryOptions<GetFilteredMyPagesBlocksQuery, TError, TData>
    ) => {
    
    return useQuery<GetFilteredMyPagesBlocksQuery, TError, TData>(
      ['GetFilteredMyPagesBlocks', variables],
      fetcher<GetFilteredMyPagesBlocksQuery, GetFilteredMyPagesBlocksQueryVariables>(GetFilteredMyPagesBlocksDocument, variables),
      options
    )};

export const GetStoreFlyersBlockDocument = `
    query GetStoreFlyersBlock($id: Int!, $locale: [Locales]!) {
  Content(locale: $locale, limit: 1, where: {ContentLink: {Id: {eq: $id}}}) {
    items {
      _id
      Name
      ContentLink {
        Id
        WorkId
        GuidValue
        ProviderName
        Url
      }
      ... on StoreFlyersBlockModel {
        Heading
        Text {
          Html
        }
      }
    }
  }
}
    `;

export const useGetStoreFlyersBlockQuery = <
      TData = GetStoreFlyersBlockQuery,
      TError = unknown
    >(
      variables: GetStoreFlyersBlockQueryVariables,
      options?: UseQueryOptions<GetStoreFlyersBlockQuery, TError, TData>
    ) => {
    
    return useQuery<GetStoreFlyersBlockQuery, TError, TData>(
      ['GetStoreFlyersBlock', variables],
      fetcher<GetStoreFlyersBlockQuery, GetStoreFlyersBlockQueryVariables>(GetStoreFlyersBlockDocument, variables),
      options
    )};

export const GetActivationPageUrlDocument = `
    query GetActivationPageUrl($locale: [Locales]!) {
  ActivationPageModel(locale: $locale) {
    items {
      Url
    }
  }
}
    `;

export const useGetActivationPageUrlQuery = <
      TData = GetActivationPageUrlQuery,
      TError = unknown
    >(
      variables: GetActivationPageUrlQueryVariables,
      options?: UseQueryOptions<GetActivationPageUrlQuery, TError, TData>
    ) => {
    
    return useQuery<GetActivationPageUrlQuery, TError, TData>(
      ['GetActivationPageUrl', variables],
      fetcher<GetActivationPageUrlQuery, GetActivationPageUrlQueryVariables>(GetActivationPageUrlDocument, variables),
      options
    )};

export const MyPagesPageDocument = `
    query MyPagesPage($id: Int!, $locale: [Locales]!, $features: [String!]!) {
  MyPagesPageModel(
    where: {_and: [{ContentLink: {Id: {eq: $id}}}, {_or: [{IncludedFeature: {in: $features}}, {IncludedFeature: {eq: ""}}, {IncludedFeature: {exist: false}}]}]}
    locale: $locale
  ) {
    items {
      Headline
      IncludedFeature
      MainBody {
        Html
        Structure
      }
      MainContentArea {
        ContentLink {
          Expanded {
            ...MyPagesContentArea
            ...TabBlock
          }
        }
      }
    }
  }
}
    ${MyPagesContentAreaFragmentDoc}
${MyPagesBlockFragmentDoc}
${PopupBlockFragmentDoc}
${HeroBlockFragmentDoc}
${ContentReferenceFragmentDoc}
${ImageDetailsFragmentDoc}
${VideoDetailsFragmentDoc}
${ButtonLinkBlockFragmentDoc}
${ExtendedLinkBlockFragmentDoc}
${CompanyRegistrationsBlockFragmentDoc}
${EmbedVideoBlockFragmentDoc}
${StandardBlockFragmentDoc}
${AssociationBattleBlockFragmentDoc}
${FeatureBlockFragmentDoc}
${DepositLabelOrderBlockFragmentDoc}
${DepositLabelOrderHistoryBlockFragmentDoc}
${SwishCertificateBlockFragmentDoc}
${SwishStoreRegistrationBlockFragmentDoc}
${TabBlockFragmentDoc}`;

export const useMyPagesPageQuery = <
      TData = MyPagesPageQuery,
      TError = unknown
    >(
      variables: MyPagesPageQueryVariables,
      options?: UseQueryOptions<MyPagesPageQuery, TError, TData>
    ) => {
    
    return useQuery<MyPagesPageQuery, TError, TData>(
      ['MyPagesPage', variables],
      fetcher<MyPagesPageQuery, MyPagesPageQueryVariables>(MyPagesPageDocument, variables),
      options
    )};

export const GetMyPagesStartPageDocument = `
    query GetMyPagesStartPage($id: Int!, $locale: [Locales]!) {
  MyPagesStartPageModel(where: {ContentLink: {Id: {eq: $id}}}, locale: $locale) {
    items {
      Headline
      MainBody {
        Html
      }
      MainContentArea {
        ContentLink {
          Expanded {
            ...MyPagesContentArea
          }
        }
      }
      SecondaryContentArea {
        ContentLink {
          Expanded {
            __typename
            ...MyPagesBlock
            ...PopupBlock
            ...HeroBlock
            ...ExtendedLinkBlock
            ...EmbedVideoBlock
            ...StandardBlock
            ...AssociationBattleBlock
            ...FeatureBlock
            ...DepositLabelOrderBlock
          }
        }
      }
      LinksContentArea {
        ContentLink {
          Expanded {
            __typename
            ...ILinkable
          }
        }
      }
      NewsContainer {
        Id
      }
    }
  }
}
    ${MyPagesContentAreaFragmentDoc}
${MyPagesBlockFragmentDoc}
${PopupBlockFragmentDoc}
${HeroBlockFragmentDoc}
${ContentReferenceFragmentDoc}
${ImageDetailsFragmentDoc}
${VideoDetailsFragmentDoc}
${ButtonLinkBlockFragmentDoc}
${ExtendedLinkBlockFragmentDoc}
${CompanyRegistrationsBlockFragmentDoc}
${EmbedVideoBlockFragmentDoc}
${StandardBlockFragmentDoc}
${AssociationBattleBlockFragmentDoc}
${FeatureBlockFragmentDoc}
${DepositLabelOrderBlockFragmentDoc}
${DepositLabelOrderHistoryBlockFragmentDoc}
${SwishCertificateBlockFragmentDoc}
${SwishStoreRegistrationBlockFragmentDoc}
${ILinkableFragmentDoc}`;

export const useGetMyPagesStartPageQuery = <
      TData = GetMyPagesStartPageQuery,
      TError = unknown
    >(
      variables: GetMyPagesStartPageQueryVariables,
      options?: UseQueryOptions<GetMyPagesStartPageQuery, TError, TData>
    ) => {
    
    return useQuery<GetMyPagesStartPageQuery, TError, TData>(
      ['GetMyPagesStartPage', variables],
      fetcher<GetMyPagesStartPageQuery, GetMyPagesStartPageQueryVariables>(GetMyPagesStartPageDocument, variables),
      options
    )};

export const GetNewsContainerAndChildrenDocument = `
    query GetNewsContainerAndChildren($id: Int!, $locale: [Locales]!) {
  NewsContainerPageModel(
    locale: $locale
    limit: 1
    where: {ContentLink: {Id: {eq: $id}}}
  ) {
    items {
      Name
      NewsPagesLinksColorTheme
      Button {
        ButtonClass
        LinkText
        VideoUrl
        PopupContent {
          Html
        }
        DocumentLink {
          Expanded {
            Url
            ContentLink {
              Id
            }
          }
        }
        ExternalLink
        Link {
          Expanded {
            RelativePath
            ContentLink {
              Id
            }
          }
        }
      }
      _children {
        NewsPageModel(orderBy: {Date: DESC}) {
          items {
            Date
            Name
            MenuIcon
            RelativePath
            TeaserText
          }
        }
      }
    }
  }
}
    `;

export const useGetNewsContainerAndChildrenQuery = <
      TData = GetNewsContainerAndChildrenQuery,
      TError = unknown
    >(
      variables: GetNewsContainerAndChildrenQueryVariables,
      options?: UseQueryOptions<GetNewsContainerAndChildrenQuery, TError, TData>
    ) => {
    
    return useQuery<GetNewsContainerAndChildrenQuery, TError, TData>(
      ['GetNewsContainerAndChildren', variables],
      fetcher<GetNewsContainerAndChildrenQuery, GetNewsContainerAndChildrenQueryVariables>(GetNewsContainerAndChildrenDocument, variables),
      options
    )};

export const PexMapBlockDocument = `
    query PexMapBlock($id: Int!, $locale: [Locales]!) {
  Content(locale: $locale, limit: 1, where: {ContentLink: {Id: {eq: $id}}}) {
    items {
      _id
      Name
      ContentLink {
        Id
        WorkId
        Url
      }
      ... on PexMapBlockModel {
        AvailableRecyclingAlternatives
        PreSelectedRecyclingAlternatives
        ShowSearch
        RecycleAlternativesLabel
        RecycleAlternativesDialogContent {
          Html
        }
      }
    }
  }
}
    `;

export const usePexMapBlockQuery = <
      TData = PexMapBlockQuery,
      TError = unknown
    >(
      variables: PexMapBlockQueryVariables,
      options?: UseQueryOptions<PexMapBlockQuery, TError, TData>
    ) => {
    
    return useQuery<PexMapBlockQuery, TError, TData>(
      ['PexMapBlock', variables],
      fetcher<PexMapBlockQuery, PexMapBlockQueryVariables>(PexMapBlockDocument, variables),
      options
    )};

export const GetRecyclingStoreTopListBlockDocument = `
    query GetRecyclingStoreTopListBlock($id: Int!, $locale: [Locales]!) {
  RecyclingStoreTopListBlockModel(
    locale: $locale
    limit: 1
    where: {ContentLink: {Id: {eq: $id}}}
  ) {
    items {
      _id
      Name
      ContentLink {
        Id
        WorkId
        Url
      }
      Heading
      TopListDescription {
        Html
      }
    }
  }
}
    `;

export const useGetRecyclingStoreTopListBlockQuery = <
      TData = GetRecyclingStoreTopListBlockQuery,
      TError = unknown
    >(
      variables: GetRecyclingStoreTopListBlockQueryVariables,
      options?: UseQueryOptions<GetRecyclingStoreTopListBlockQuery, TError, TData>
    ) => {
    
    return useQuery<GetRecyclingStoreTopListBlockQuery, TError, TData>(
      ['GetRecyclingStoreTopListBlock', variables],
      fetcher<GetRecyclingStoreTopListBlockQuery, GetRecyclingStoreTopListBlockQueryVariables>(GetRecyclingStoreTopListBlockDocument, variables),
      options
    )};

export const CompensationBlockDocument = `
    query CompensationBlock($id: Int!, $locale: [Locales]!) {
  CompensationBlockModel(
    locale: $locale
    limit: 1
    where: {ContentLink: {Id: {eq: $id}}}
  ) {
    items {
      Heading
      Payments
      ConfirmationText {
        Html
      }
    }
  }
}
    `;

export const useCompensationBlockQuery = <
      TData = CompensationBlockQuery,
      TError = unknown
    >(
      variables: CompensationBlockQueryVariables,
      options?: UseQueryOptions<CompensationBlockQuery, TError, TData>
    ) => {
    
    return useQuery<CompensationBlockQuery, TError, TData>(
      ['CompensationBlock', variables],
      fetcher<CompensationBlockQuery, CompensationBlockQueryVariables>(CompensationBlockDocument, variables),
      options
    )};

export const ExtraPickupFormBlockDocument = `
    query ExtraPickupFormBlock($id: Int!, $locale: [Locales]!) {
  ExtraPickupFormBlockModel(
    locale: $locale
    limit: 1
    where: {ContentLink: {Id: {eq: $id}}}
  ) {
    items {
      Heading
      ConfirmationText {
        Html
      }
    }
  }
}
    `;

export const useExtraPickupFormBlockQuery = <
      TData = ExtraPickupFormBlockQuery,
      TError = unknown
    >(
      variables: ExtraPickupFormBlockQueryVariables,
      options?: UseQueryOptions<ExtraPickupFormBlockQuery, TError, TData>
    ) => {
    
    return useQuery<ExtraPickupFormBlockQuery, TError, TData>(
      ['ExtraPickupFormBlock', variables],
      fetcher<ExtraPickupFormBlockQuery, ExtraPickupFormBlockQueryVariables>(ExtraPickupFormBlockDocument, variables),
      options
    )};

export const SwishFormBlockDocument = `
    query SwishFormBlock($id: Int!, $locale: [Locales]!) {
  Content(locale: $locale, limit: 1, where: {ContentLink: {Id: {eq: $id}}}) {
    items {
      _id
      Name
      ContentLink {
        Id
        WorkId
        GuidValue
        ProviderName
        Url
      }
      ... on SwishFormBlockModel {
        Heading
      }
    }
  }
}
    `;

export const useSwishFormBlockQuery = <
      TData = SwishFormBlockQuery,
      TError = unknown
    >(
      variables: SwishFormBlockQueryVariables,
      options?: UseQueryOptions<SwishFormBlockQuery, TError, TData>
    ) => {
    
    return useQuery<SwishFormBlockQuery, TError, TData>(
      ['SwishFormBlock', variables],
      fetcher<SwishFormBlockQuery, SwishFormBlockQueryVariables>(SwishFormBlockDocument, variables),
      options
    )};

export const GetAtoZItemsDocument = `
    query GetAtoZItems($locale: [Locales]!, $skip: Int!) {
  Content(locale: $locale, limit: 100, skip: $skip) {
    items {
      ... on StandardPageModel {
        Name
        RelativePath
      }
      ... on StartPageModel {
        Name
        RelativePath
      }
      ... on FaqItemPageModel {
        Name
        RelativePath
      }
      ... on FaqListPageModel {
        Name
        RelativePath
      }
      ... on MainMenuPageModel {
        Name
        RelativePath
      }
    }
    total(all: true)
  }
}
    `;

export const useGetAtoZItemsQuery = <
      TData = GetAtoZItemsQuery,
      TError = unknown
    >(
      variables: GetAtoZItemsQueryVariables,
      options?: UseQueryOptions<GetAtoZItemsQuery, TError, TData>
    ) => {
    
    return useQuery<GetAtoZItemsQuery, TError, TData>(
      ['GetAtoZItems', variables],
      fetcher<GetAtoZItemsQuery, GetAtoZItemsQueryVariables>(GetAtoZItemsDocument, variables),
      options
    )};

export const GetConnectedProducersBlockDocument = `
    query getConnectedProducersBlock($id: Int!, $locale: [Locales]!) {
  ConnectedProducersListBlockModel(
    locale: $locale
    limit: 1
    where: {ContentLink: {Id: {eq: $id}}}
  ) {
    items {
      Heading
    }
  }
}
    `;

export const useGetConnectedProducersBlockQuery = <
      TData = GetConnectedProducersBlockQuery,
      TError = unknown
    >(
      variables: GetConnectedProducersBlockQueryVariables,
      options?: UseQueryOptions<GetConnectedProducersBlockQuery, TError, TData>
    ) => {
    
    return useQuery<GetConnectedProducersBlockQuery, TError, TData>(
      ['getConnectedProducersBlock', variables],
      fetcher<GetConnectedProducersBlockQuery, GetConnectedProducersBlockQueryVariables>(GetConnectedProducersBlockDocument, variables),
      options
    )};

export const EanCheckBlockDocument = `
    query EanCheckBlock($id: Int!, $locale: [Locales]!) {
  Content(locale: $locale, limit: 1, where: {ContentLink: {Id: {eq: $id}}}) {
    items {
      _id
      Name
      ContentLink {
        Id
        WorkId
        GuidValue
        ProviderName
        Url
      }
      ... on EanCheckBlockModel {
        Heading
        Image {
          ...ContentReference
          Expanded {
            ...ImageDetails
          }
        }
      }
    }
  }
}
    ${ContentReferenceFragmentDoc}
${ImageDetailsFragmentDoc}`;

export const useEanCheckBlockQuery = <
      TData = EanCheckBlockQuery,
      TError = unknown
    >(
      variables: EanCheckBlockQueryVariables,
      options?: UseQueryOptions<EanCheckBlockQuery, TError, TData>
    ) => {
    
    return useQuery<EanCheckBlockQuery, TError, TData>(
      ['EanCheckBlock', variables],
      fetcher<EanCheckBlockQuery, EanCheckBlockQueryVariables>(EanCheckBlockDocument, variables),
      options
    )};

export const GetExternalVideoDocument = `
    query GetExternalVideo($id: Int!, $locale: [Locales]!) {
  Content(locale: $locale, where: {ContentLink: {Id: {eq: $id}}}) {
    items {
      __typename
      ...EmbedVideoBlock
      ...ButtonLinkBlock
    }
  }
}
    ${EmbedVideoBlockFragmentDoc}
${ContentReferenceFragmentDoc}
${ImageDetailsFragmentDoc}
${ButtonLinkBlockFragmentDoc}`;

export const useGetExternalVideoQuery = <
      TData = GetExternalVideoQuery,
      TError = unknown
    >(
      variables: GetExternalVideoQueryVariables,
      options?: UseQueryOptions<GetExternalVideoQuery, TError, TData>
    ) => {
    
    return useQuery<GetExternalVideoQuery, TError, TData>(
      ['GetExternalVideo', variables],
      fetcher<GetExternalVideoQuery, GetExternalVideoQueryVariables>(GetExternalVideoDocument, variables),
      options
    )};

export const GetFaqCategoriesDocument = `
    query GetFaqCategories($id: Int!, $locale: [Locales]!) {
  FaqListPageModel(locale: $locale, where: {ContentLink: {Id: {eq: $id}}}) {
    items {
      _children {
        FaqCategoryPageModel {
          items {
            Name
            ContentLink {
              Id
            }
            _children {
              FaqItemPageModel {
                items {
                  ContentLink {
                    Id
                  }
                  Name
                  RelativePath
                  TeaserText
                  Question
                  Answer {
                    Html
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export const useGetFaqCategoriesQuery = <
      TData = GetFaqCategoriesQuery,
      TError = unknown
    >(
      variables: GetFaqCategoriesQueryVariables,
      options?: UseQueryOptions<GetFaqCategoriesQuery, TError, TData>
    ) => {
    
    return useQuery<GetFaqCategoriesQuery, TError, TData>(
      ['GetFaqCategories', variables],
      fetcher<GetFaqCategoriesQuery, GetFaqCategoriesQueryVariables>(GetFaqCategoriesDocument, variables),
      options
    )};

export const GetHeroDocument = `
    query GetHero($id: Int!, $locale: [Locales]!) {
  Content(locale: $locale, where: {ContentLink: {Id: {eq: $id}}}) {
    items {
      __typename
      ...ImageDetails
      ...VideoDetails
      ...HeroBlock
    }
  }
}
    ${ImageDetailsFragmentDoc}
${VideoDetailsFragmentDoc}
${ContentReferenceFragmentDoc}
${HeroBlockFragmentDoc}
${ButtonLinkBlockFragmentDoc}`;

export const useGetHeroQuery = <
      TData = GetHeroQuery,
      TError = unknown
    >(
      variables: GetHeroQueryVariables,
      options?: UseQueryOptions<GetHeroQuery, TError, TData>
    ) => {
    
    return useQuery<GetHeroQuery, TError, TData>(
      ['GetHero', variables],
      fetcher<GetHeroQuery, GetHeroQueryVariables>(GetHeroDocument, variables),
      options
    )};

export const GetMyPagesContainerPageUrlDocument = `
    query GetMyPagesContainerPageUrl($locale: [Locales]!) {
  MyPagesContainerPageModel(locale: $locale) {
    items {
      RelativePath
    }
  }
}
    `;

export const useGetMyPagesContainerPageUrlQuery = <
      TData = GetMyPagesContainerPageUrlQuery,
      TError = unknown
    >(
      variables: GetMyPagesContainerPageUrlQueryVariables,
      options?: UseQueryOptions<GetMyPagesContainerPageUrlQuery, TError, TData>
    ) => {
    
    return useQuery<GetMyPagesContainerPageUrlQuery, TError, TData>(
      ['GetMyPagesContainerPageUrl', variables],
      fetcher<GetMyPagesContainerPageUrlQuery, GetMyPagesContainerPageUrlQueryVariables>(GetMyPagesContainerPageUrlDocument, variables),
      options
    )};

export const GetStartPageModelDocument = `
    query GetStartPageModel($locale: [Locales]!) {
  StartPageModel(locale: $locale) {
    items {
      Name
      PopularSearchTerms
      SearchResultPage {
        Expanded {
          ContentLink {
            Url
          }
        }
      }
      StandardTermsAndConditions {
        Html
      }
      StandardTermsAndConditionsButtons {
        ContentLink {
          Id
          Expanded {
            ...ButtonLinkBlock
          }
        }
      }
      MapsApiKey
    }
  }
}
    ${ButtonLinkBlockFragmentDoc}`;

export const useGetStartPageModelQuery = <
      TData = GetStartPageModelQuery,
      TError = unknown
    >(
      variables: GetStartPageModelQueryVariables,
      options?: UseQueryOptions<GetStartPageModelQuery, TError, TData>
    ) => {
    
    return useQuery<GetStartPageModelQuery, TError, TData>(
      ['GetStartPageModel', variables],
      fetcher<GetStartPageModelQuery, GetStartPageModelQueryVariables>(GetStartPageModelDocument, variables),
      options
    )};

export const GetNominationBlockDocument = `
    query GetNominationBlock($id: Int!, $locale: [Locales]!) {
  Content(locale: $locale, limit: 1, where: {ContentLink: {Id: {eq: $id}}}) {
    items {
      _id
      Name
      ContentLink {
        Id
        WorkId
        GuidValue
        ProviderName
        Url
      }
      ... on NominationBlockModel {
        Heading
        NominationPreamble {
          Html
        }
        Image {
          ...ContentReference
          Expanded {
            ...ImageDetails
          }
        }
        NominationDescription {
          Html
        }
        SecondaryDescription {
          Html
        }
      }
    }
  }
}
    ${ContentReferenceFragmentDoc}
${ImageDetailsFragmentDoc}`;

export const useGetNominationBlockQuery = <
      TData = GetNominationBlockQuery,
      TError = unknown
    >(
      variables: GetNominationBlockQueryVariables,
      options?: UseQueryOptions<GetNominationBlockQuery, TError, TData>
    ) => {
    
    return useQuery<GetNominationBlockQuery, TError, TData>(
      ['GetNominationBlock', variables],
      fetcher<GetNominationBlockQuery, GetNominationBlockQueryVariables>(GetNominationBlockDocument, variables),
      options
    )};
